export const MapData = {
    data : {
            "type": "Topology",
            "objects": {
              "collection": {
                "type": "GeometryCollection",
                "geometries": [
                  {
                    "type": "MultiPolygon",
                    "properties": {
                      "scalerank": 0,
                      "featurecla": "Admin-0 map subunit",
                      "labelrank": 3,
                      "sovereignt": "Angola",
                      "sov_a3": "AGO",
                      "adm0_dif": 0,
                      "level": 2,
                      "type": "Sovereign country",
                      "admin": "Angola",
                      "adm0_a3": "AGO",
                      "geou_dif": 0,
                      "geounit": "Angola",
                      "gu_a3": "AGO",
                      "su_dif": 0,
                      "subunit": "Angola",
                      "su_a3": "AGO",
                      "brk_diff": 0,
                      "name": "Angola",
                      "name_long": "Angola",
                      "brk_a3": "AGO",
                      "brk_name": "Angola",
                      "brk_group": "",
                      "abbrev": "Ang.",
                      "postal": "AO",
                      "formal_en": "People's Republic of Angola",
                      "formal_fr": "",
                      "note_adm0": "",
                      "note_brk": "",
                      "name_sort": "Angola",
                      "name_alt": "",
                      "mapcolor7": 3,
                      "mapcolor8": 2,
                      "mapcolor9": 6,
                      "mapcolor13": 1,
                      "pop_est": 12799293,
                      "gdp_md_est": 110300,
                      "pop_year": -99,
                      "lastcensus": 1970,
                      "gdp_year": -99,
                      "economy": "7. Least developed region",
                      "income_grp": "3. Upper middle income",
                      "wikipedia": -99,
                      "fips_10": "",
                      "iso_a2": "AO",
                      "iso_a3": "AGO",
                      "iso_n3": "024",
                      "un_a3": "024",
                      "wb_a2": "AO",
                      "wb_a3": "AGO",
                      "woe_id": -99,
                      "adm0_a3_is": "AGO",
                      "adm0_a3_us": "AGO",
                      "adm0_a3_un": -99,
                      "adm0_a3_wb": -99,
                      "continent": "Africa",
                      "region_un": "Africa",
                      "subregion": "Middle Africa",
                      "region_wb": "Sub-Saharan Africa",
                      "name_len": 6,
                      "long_len": 6,
                      "abbrev_len": 4,
                      "tiny": -99,
                      "homepart": 1
                    },
                    "arcs": [
                      [
                        [
                          0
                        ]
                      ],
                      [
                        [
                          1,
                          2,
                          3,
                          4
                        ]
                      ],
                      [
                        [
                          5,
                          6,
                          7
                        ]
                      ]
                    ]
                  },
                  {
                    "type": "Polygon",
                    "properties": {
                      "scalerank": 0,
                      "featurecla": "Admin-0 map subunit",
                      "labelrank": 6,
                      "sovereignt": "Burundi",
                      "sov_a3": "BDI",
                      "adm0_dif": 0,
                      "level": 2,
                      "type": "Sovereign country",
                      "admin": "Burundi",
                      "adm0_a3": "BDI",
                      "geou_dif": 0,
                      "geounit": "Burundi",
                      "gu_a3": "BDI",
                      "su_dif": 0,
                      "subunit": "Burundi",
                      "su_a3": "BDI",
                      "brk_diff": 0,
                      "name": "Burundi",
                      "name_long": "Burundi",
                      "brk_a3": "BDI",
                      "brk_name": "Burundi",
                      "brk_group": "",
                      "abbrev": "Bur.",
                      "postal": "BI",
                      "formal_en": "Republic of Burundi",
                      "formal_fr": "",
                      "note_adm0": "",
                      "note_brk": "",
                      "name_sort": "Burundi",
                      "name_alt": "",
                      "mapcolor7": 2,
                      "mapcolor8": 2,
                      "mapcolor9": 5,
                      "mapcolor13": 8,
                      "pop_est": 8988091,
                      "gdp_md_est": 3102,
                      "pop_year": -99,
                      "lastcensus": 2008,
                      "gdp_year": -99,
                      "economy": "7. Least developed region",
                      "income_grp": "5. Low income",
                      "wikipedia": -99,
                      "fips_10": "",
                      "iso_a2": "BI",
                      "iso_a3": "BDI",
                      "iso_n3": 108,
                      "un_a3": 108,
                      "wb_a2": "BI",
                      "wb_a3": "BDI",
                      "woe_id": -99,
                      "adm0_a3_is": "BDI",
                      "adm0_a3_us": "BDI",
                      "adm0_a3_un": -99,
                      "adm0_a3_wb": -99,
                      "continent": "Africa",
                      "region_un": "Africa",
                      "subregion": "Eastern Africa",
                      "region_wb": "Sub-Saharan Africa",
                      "name_len": 7,
                      "long_len": 7,
                      "abbrev_len": 4,
                      "tiny": -99,
                      "homepart": 1
                    },
                    "arcs": [
                      [
                        8,
                        9,
                        10
                      ]
                    ]
                  },
                  {
                    "type": "Polygon",
                    "properties": {
                      "scalerank": 0,
                      "featurecla": "Admin-0 map subunit",
                      "labelrank": 5,
                      "sovereignt": "Benin",
                      "sov_a3": "BEN",
                      "adm0_dif": 0,
                      "level": 2,
                      "type": "Sovereign country",
                      "admin": "Benin",
                      "adm0_a3": "BEN",
                      "geou_dif": 0,
                      "geounit": "Benin",
                      "gu_a3": "BEN",
                      "su_dif": 0,
                      "subunit": "Benin",
                      "su_a3": "BEN",
                      "brk_diff": 0,
                      "name": "Benin",
                      "name_long": "Benin",
                      "brk_a3": "BEN",
                      "brk_name": "Benin",
                      "brk_group": "",
                      "abbrev": "Benin",
                      "postal": "BJ",
                      "formal_en": "Republic of Benin",
                      "formal_fr": "",
                      "note_adm0": "",
                      "note_brk": "",
                      "name_sort": "Benin",
                      "name_alt": "",
                      "mapcolor7": 1,
                      "mapcolor8": 2,
                      "mapcolor9": 2,
                      "mapcolor13": 12,
                      "pop_est": 8791832,
                      "gdp_md_est": 12830,
                      "pop_year": -99,
                      "lastcensus": 2002,
                      "gdp_year": -99,
                      "economy": "7. Least developed region",
                      "income_grp": "5. Low income",
                      "wikipedia": -99,
                      "fips_10": "",
                      "iso_a2": "BJ",
                      "iso_a3": "BEN",
                      "iso_n3": 204,
                      "un_a3": 204,
                      "wb_a2": "BJ",
                      "wb_a3": "BEN",
                      "woe_id": -99,
                      "adm0_a3_is": "BEN",
                      "adm0_a3_us": "BEN",
                      "adm0_a3_un": -99,
                      "adm0_a3_wb": -99,
                      "continent": "Africa",
                      "region_un": "Africa",
                      "subregion": "Western Africa",
                      "region_wb": "Sub-Saharan Africa",
                      "name_len": 5,
                      "long_len": 5,
                      "abbrev_len": 5,
                      "tiny": -99,
                      "homepart": 1
                    },
                    "arcs": [
                      [
                        11,
                        12,
                        13,
                        14,
                        15
                      ]
                    ]
                  },
                  {
                    "type": "Polygon",
                    "properties": {
                      "scalerank": 0,
                      "featurecla": "Admin-0 map subunit",
                      "labelrank": 3,
                      "sovereignt": "Burkina Faso",
                      "sov_a3": "BFA",
                      "adm0_dif": 0,
                      "level": 2,
                      "type": "Sovereign country",
                      "admin": "Burkina Faso",
                      "adm0_a3": "BFA",
                      "geou_dif": 0,
                      "geounit": "Burkina Faso",
                      "gu_a3": "BFA",
                      "su_dif": 0,
                      "subunit": "Burkina Faso",
                      "su_a3": "BFA",
                      "brk_diff": 0,
                      "name": "Burkina Faso",
                      "name_long": "Burkina Faso",
                      "brk_a3": "BFA",
                      "brk_name": "Burkina Faso",
                      "brk_group": "",
                      "abbrev": "B.F.",
                      "postal": "BF",
                      "formal_en": "Burkina Faso",
                      "formal_fr": "",
                      "note_adm0": "",
                      "note_brk": "",
                      "name_sort": "Burkina Faso",
                      "name_alt": "",
                      "mapcolor7": 2,
                      "mapcolor8": 1,
                      "mapcolor9": 5,
                      "mapcolor13": 11,
                      "pop_est": 15746232,
                      "gdp_md_est": 17820,
                      "pop_year": -99,
                      "lastcensus": 2006,
                      "gdp_year": -99,
                      "economy": "7. Least developed region",
                      "income_grp": "5. Low income",
                      "wikipedia": -99,
                      "fips_10": "",
                      "iso_a2": "BF",
                      "iso_a3": "BFA",
                      "iso_n3": 854,
                      "un_a3": 854,
                      "wb_a2": "BF",
                      "wb_a3": "BFA",
                      "woe_id": -99,
                      "adm0_a3_is": "BFA",
                      "adm0_a3_us": "BFA",
                      "adm0_a3_un": -99,
                      "adm0_a3_wb": -99,
                      "continent": "Africa",
                      "region_un": "Africa",
                      "subregion": "Western Africa",
                      "region_wb": "Sub-Saharan Africa",
                      "name_len": 12,
                      "long_len": 12,
                      "abbrev_len": 4,
                      "tiny": -99,
                      "homepart": 1
                    },
                    "arcs": [
                      [
                        16,
                        -15,
                        17,
                        18,
                        19,
                        20
                      ]
                    ]
                  },
                  {
                    "type": "Polygon",
                    "properties": {
                      "scalerank": 6,
                      "featurecla": "Admin-0 map subunit",
                      "labelrank": 6,
                      "sovereignt": "France",
                      "sov_a3": "FR1",
                      "adm0_dif": 1,
                      "level": 4,
                      "type": "Geo subunit",
                      "admin": "French Southern and Antarctic Lands",
                      "adm0_a3": "ATF",
                      "geou_dif": 0,
                      "geounit": "French Southern and Antarctic Lands",
                      "gu_a3": "ATF",
                      "su_dif": 1,
                      "subunit": "Bassas da India",
                      "su_a3": "BSI",
                      "brk_diff": 1,
                      "name": "Bassas da India",
                      "name_long": "Bassas da India",
                      "brk_a3": "B27",
                      "brk_name": "Bassas da India",
                      "brk_group": "",
                      "abbrev": "B.dI.",
                      "postal": "BI",
                      "formal_en": "Bassas da India",
                      "formal_fr": "Basse de Judie",
                      "note_adm0": "Fr.",
                      "note_brk": "Admin. by France; Claimed by Madagascar",
                      "name_sort": "Bassas da India",
                      "name_alt": "",
                      "mapcolor7": 7,
                      "mapcolor8": 5,
                      "mapcolor9": 9,
                      "mapcolor13": 11,
                      "pop_est": -99,
                      "gdp_md_est": -99,
                      "pop_year": -99,
                      "lastcensus": -99,
                      "gdp_year": -99,
                      "economy": -99,
                      "income_grp": -99,
                      "wikipedia": -99,
                      "fips_10": "",
                      "iso_a2": -99,
                      "iso_a3": -99,
                      "iso_n3": -99,
                      "un_a3": "-099",
                      "wb_a2": -99,
                      "wb_a3": -99,
                      "woe_id": -99,
                      "adm0_a3_is": "ATF",
                      "adm0_a3_us": "ATF",
                      "adm0_a3_un": -99,
                      "adm0_a3_wb": -99,
                      "continent": "Africa",
                      "region_un": "Africa",
                      "subregion": "Eastern Africa",
                      "region_wb": "Sub-Saharan Africa",
                      "name_len": 15,
                      "long_len": 15,
                      "abbrev_len": 5,
                      "tiny": -99,
                      "homepart": -99
                    },
                    "arcs": [
                      [
                        21
                      ]
                    ]
                  },
                  {
                    "type": "Polygon",
                    "properties": {
                      "scalerank": 0,
                      "featurecla": "Admin-0 map subunit",
                      "labelrank": 4,
                      "sovereignt": "Botswana",
                      "sov_a3": "BWA",
                      "adm0_dif": 0,
                      "level": 2,
                      "type": "Sovereign country",
                      "admin": "Botswana",
                      "adm0_a3": "BWA",
                      "geou_dif": 0,
                      "geounit": "Botswana",
                      "gu_a3": "BWA",
                      "su_dif": 0,
                      "subunit": "Botswana",
                      "su_a3": "BWA",
                      "brk_diff": 0,
                      "name": "Botswana",
                      "name_long": "Botswana",
                      "brk_a3": "BWA",
                      "brk_name": "Botswana",
                      "brk_group": "",
                      "abbrev": "Bwa.",
                      "postal": "BW",
                      "formal_en": "Republic of Botswana",
                      "formal_fr": "",
                      "note_adm0": "",
                      "note_brk": "",
                      "name_sort": "Botswana",
                      "name_alt": "",
                      "mapcolor7": 6,
                      "mapcolor8": 5,
                      "mapcolor9": 7,
                      "mapcolor13": 3,
                      "pop_est": 1990876,
                      "gdp_md_est": 27060,
                      "pop_year": -99,
                      "lastcensus": 2011,
                      "gdp_year": -99,
                      "economy": "6. Developing region",
                      "income_grp": "3. Upper middle income",
                      "wikipedia": -99,
                      "fips_10": "",
                      "iso_a2": "BW",
                      "iso_a3": "BWA",
                      "iso_n3": "072",
                      "un_a3": "072",
                      "wb_a2": "BW",
                      "wb_a3": "BWA",
                      "woe_id": -99,
                      "adm0_a3_is": "BWA",
                      "adm0_a3_us": "BWA",
                      "adm0_a3_un": -99,
                      "adm0_a3_wb": -99,
                      "continent": "Africa",
                      "region_un": "Africa",
                      "subregion": "Southern Africa",
                      "region_wb": "Sub-Saharan Africa",
                      "name_len": 8,
                      "long_len": 8,
                      "abbrev_len": 4,
                      "tiny": -99,
                      "homepart": 1
                    },
                    "arcs": [
                      [
                        22,
                        23,
                        24
                      ]
                    ]
                  },
                  {
                    "type": "Polygon",
                    "properties": {
                      "scalerank": 0,
                      "featurecla": "Admin-0 map subunit",
                      "labelrank": 4,
                      "sovereignt": "Central African Republic",
                      "sov_a3": "CAF",
                      "adm0_dif": 0,
                      "level": 2,
                      "type": "Sovereign country",
                      "admin": "Central African Republic",
                      "adm0_a3": "CAF",
                      "geou_dif": 0,
                      "geounit": "Central African Republic",
                      "gu_a3": "CAF",
                      "su_dif": 0,
                      "subunit": "Central African Republic",
                      "su_a3": "CAF",
                      "brk_diff": 0,
                      "name": "Central African Rep.",
                      "name_long": "Central African Republic",
                      "brk_a3": "CAF",
                      "brk_name": "Central African Rep.",
                      "brk_group": "",
                      "abbrev": "C.A.R.",
                      "postal": "CF",
                      "formal_en": "Central African Republic",
                      "formal_fr": "",
                      "note_adm0": "",
                      "note_brk": "",
                      "name_sort": "Central African Republic",
                      "name_alt": "",
                      "mapcolor7": 5,
                      "mapcolor8": 6,
                      "mapcolor9": 6,
                      "mapcolor13": 9,
                      "pop_est": 4511488,
                      "gdp_md_est": 3198,
                      "pop_year": -99,
                      "lastcensus": 2003,
                      "gdp_year": -99,
                      "economy": "7. Least developed region",
                      "income_grp": "5. Low income",
                      "wikipedia": -99,
                      "fips_10": "",
                      "iso_a2": "CF",
                      "iso_a3": "CAF",
                      "iso_n3": 140,
                      "un_a3": 140,
                      "wb_a2": "CF",
                      "wb_a3": "CAF",
                      "woe_id": -99,
                      "adm0_a3_is": "CAF",
                      "adm0_a3_us": "CAF",
                      "adm0_a3_un": -99,
                      "adm0_a3_wb": -99,
                      "continent": "Africa",
                      "region_un": "Africa",
                      "subregion": "Middle Africa",
                      "region_wb": "Sub-Saharan Africa",
                      "name_len": 20,
                      "long_len": 24,
                      "abbrev_len": 6,
                      "tiny": -99,
                      "homepart": 1
                    },
                    "arcs": [
                      [
                        25,
                        26,
                        27,
                        28,
                        29,
                        30
                      ]
                    ]
                  },
                  {
                    "type": "MultiPolygon",
                    "properties": {
                      "scalerank": 0,
                      "featurecla": "Admin-0 map subunit",
                      "labelrank": 3,
                      "sovereignt": "Ivory Coast",
                      "sov_a3": "CIV",
                      "adm0_dif": 0,
                      "level": 2,
                      "type": "Sovereign country",
                      "admin": "Ivory Coast",
                      "adm0_a3": "CIV",
                      "geou_dif": 0,
                      "geounit": "Ivory Coast",
                      "gu_a3": "CIV",
                      "su_dif": 0,
                      "subunit": "Ivory Coast",
                      "su_a3": "CIV",
                      "brk_diff": 0,
                      "name": "Côte d'Ivoire",
                      "name_long": "Côte d'Ivoire",
                      "brk_a3": "CIV",
                      "brk_name": "Côte d'Ivoire",
                      "brk_group": "",
                      "abbrev": "I.C.",
                      "postal": "CI",
                      "formal_en": "Republic of Ivory Coast",
                      "formal_fr": "Republic of Cote D'Ivoire",
                      "note_adm0": "",
                      "note_brk": "",
                      "name_sort": "Côte d'Ivoire",
                      "name_alt": "",
                      "mapcolor7": 4,
                      "mapcolor8": 6,
                      "mapcolor9": 3,
                      "mapcolor13": 3,
                      "pop_est": 20617068,
                      "gdp_md_est": 33850,
                      "pop_year": -99,
                      "lastcensus": 1998,
                      "gdp_year": -99,
                      "economy": "6. Developing region",
                      "income_grp": "4. Lower middle income",
                      "wikipedia": -99,
                      "fips_10": "",
                      "iso_a2": "CI",
                      "iso_a3": "CIV",
                      "iso_n3": 384,
                      "un_a3": 384,
                      "wb_a2": "CI",
                      "wb_a3": "CIV",
                      "woe_id": -99,
                      "adm0_a3_is": "CIV",
                      "adm0_a3_us": "CIV",
                      "adm0_a3_un": -99,
                      "adm0_a3_wb": -99,
                      "continent": "Africa",
                      "region_un": "Africa",
                      "subregion": "Western Africa",
                      "region_wb": "Sub-Saharan Africa",
                      "name_len": 13,
                      "long_len": 13,
                      "abbrev_len": 4,
                      "tiny": -99,
                      "homepart": 1
                    },
                    "arcs": [
                      [
                        [
                          31,
                          32
                        ]
                      ],
                      [
                        [
                          -20,
                          33,
                          34,
                          35,
                          36,
                          37
                        ]
                      ]
                    ]
                  },
                  {
                    "type": "Polygon",
                    "properties": {
                      "scalerank": 0,
                      "featurecla": "Admin-0 map subunit",
                      "labelrank": 3,
                      "sovereignt": "Cameroon",
                      "sov_a3": "CMR",
                      "adm0_dif": 0,
                      "level": 2,
                      "type": "Sovereign country",
                      "admin": "Cameroon",
                      "adm0_a3": "CMR",
                      "geou_dif": 0,
                      "geounit": "Cameroon",
                      "gu_a3": "CMR",
                      "su_dif": 0,
                      "subunit": "Cameroon",
                      "su_a3": "CMR",
                      "brk_diff": 0,
                      "name": "Cameroon",
                      "name_long": "Cameroon",
                      "brk_a3": "CMR",
                      "brk_name": "Cameroon",
                      "brk_group": "",
                      "abbrev": "Cam.",
                      "postal": "CM",
                      "formal_en": "Republic of Cameroon",
                      "formal_fr": "",
                      "note_adm0": "",
                      "note_brk": "",
                      "name_sort": "Cameroon",
                      "name_alt": "",
                      "mapcolor7": 1,
                      "mapcolor8": 4,
                      "mapcolor9": 1,
                      "mapcolor13": 3,
                      "pop_est": 18879301,
                      "gdp_md_est": 42750,
                      "pop_year": -99,
                      "lastcensus": 2005,
                      "gdp_year": -99,
                      "economy": "6. Developing region",
                      "income_grp": "4. Lower middle income",
                      "wikipedia": -99,
                      "fips_10": "",
                      "iso_a2": "CM",
                      "iso_a3": "CMR",
                      "iso_n3": 120,
                      "un_a3": 120,
                      "wb_a2": "CM",
                      "wb_a3": "CMR",
                      "woe_id": -99,
                      "adm0_a3_is": "CMR",
                      "adm0_a3_us": "CMR",
                      "adm0_a3_un": -99,
                      "adm0_a3_wb": -99,
                      "continent": "Africa",
                      "region_un": "Africa",
                      "subregion": "Middle Africa",
                      "region_wb": "Sub-Saharan Africa",
                      "name_len": 8,
                      "long_len": 8,
                      "abbrev_len": 4,
                      "tiny": -99,
                      "homepart": 1
                    },
                    "arcs": [
                      [
                        -30,
                        38,
                        39,
                        40,
                        41,
                        42,
                        43
                      ]
                    ]
                  },
                  {
                    "type": "MultiPolygon",
                    "properties": {
                      "scalerank": 0,
                      "featurecla": "Admin-0 map subunit",
                      "labelrank": 2,
                      "sovereignt": "Democratic Republic of the Congo",
                      "sov_a3": "COD",
                      "adm0_dif": 0,
                      "level": 2,
                      "type": "Sovereign country",
                      "admin": "Democratic Republic of the Congo",
                      "adm0_a3": "COD",
                      "geou_dif": 0,
                      "geounit": "Democratic Republic of the Congo",
                      "gu_a3": "COD",
                      "su_dif": 0,
                      "subunit": "Democratic Republic of the Congo",
                      "su_a3": "COD",
                      "brk_diff": 0,
                      "name": "Dem. Rep. Congo",
                      "name_long": "Democratic Republic of the Congo",
                      "brk_a3": "COD",
                      "brk_name": "Democratic Republic of the Congo",
                      "brk_group": "",
                      "abbrev": "D.R.C.",
                      "postal": "DRC",
                      "formal_en": "Democratic Republic of the Congo",
                      "formal_fr": "",
                      "note_adm0": "",
                      "note_brk": "",
                      "name_sort": "Congo, Dem. Rep.",
                      "name_alt": "",
                      "mapcolor7": 4,
                      "mapcolor8": 4,
                      "mapcolor9": 4,
                      "mapcolor13": 7,
                      "pop_est": 68692542,
                      "gdp_md_est": 20640,
                      "pop_year": -99,
                      "lastcensus": 1984,
                      "gdp_year": -99,
                      "economy": "7. Least developed region",
                      "income_grp": "5. Low income",
                      "wikipedia": -99,
                      "fips_10": "",
                      "iso_a2": "CD",
                      "iso_a3": "COD",
                      "iso_n3": 180,
                      "un_a3": 180,
                      "wb_a2": "ZR",
                      "wb_a3": "ZAR",
                      "woe_id": -99,
                      "adm0_a3_is": "COD",
                      "adm0_a3_us": "COD",
                      "adm0_a3_un": -99,
                      "adm0_a3_wb": -99,
                      "continent": "Africa",
                      "region_un": "Africa",
                      "subregion": "Middle Africa",
                      "region_wb": "Sub-Saharan Africa",
                      "name_len": 15,
                      "long_len": 32,
                      "abbrev_len": 6,
                      "tiny": -99,
                      "homepart": 1
                    },
                    "arcs": [
                      [
                        [
                          44
                        ]
                      ],
                      [
                        [
                          45,
                          46,
                          47,
                          48,
                          49,
                          50,
                          51,
                          -10,
                          52,
                          53,
                          -5,
                          54,
                          -6,
                          55,
                          -28
                        ]
                      ]
                    ]
                  },
                  {
                    "type": "Polygon",
                    "properties": {
                      "scalerank": 0,
                      "featurecla": "Admin-0 map subunit",
                      "labelrank": 4,
                      "sovereignt": "Republic of Congo",
                      "sov_a3": "COG",
                      "adm0_dif": 0,
                      "level": 2,
                      "type": "Sovereign country",
                      "admin": "Republic of Congo",
                      "adm0_a3": "COG",
                      "geou_dif": 0,
                      "geounit": "Republic of Congo",
                      "gu_a3": "COG",
                      "su_dif": 0,
                      "subunit": "Republic of Congo",
                      "su_a3": "COG",
                      "brk_diff": 0,
                      "name": "Congo",
                      "name_long": "Republic of Congo",
                      "brk_a3": "COG",
                      "brk_name": "Republic of Congo",
                      "brk_group": "",
                      "abbrev": "Rep. Congo",
                      "postal": "CG",
                      "formal_en": "Republic of Congo",
                      "formal_fr": "",
                      "note_adm0": "",
                      "note_brk": "",
                      "name_sort": "Congo, Rep.",
                      "name_alt": "",
                      "mapcolor7": 2,
                      "mapcolor8": 1,
                      "mapcolor9": 3,
                      "mapcolor13": 10,
                      "pop_est": 4012809,
                      "gdp_md_est": 15350,
                      "pop_year": -99,
                      "lastcensus": 2007,
                      "gdp_year": -99,
                      "economy": "6. Developing region",
                      "income_grp": "4. Lower middle income",
                      "wikipedia": -99,
                      "fips_10": "",
                      "iso_a2": "CG",
                      "iso_a3": "COG",
                      "iso_n3": 178,
                      "un_a3": 178,
                      "wb_a2": "CG",
                      "wb_a3": "COG",
                      "woe_id": -99,
                      "adm0_a3_is": "COG",
                      "adm0_a3_us": "COG",
                      "adm0_a3_un": -99,
                      "adm0_a3_wb": -99,
                      "continent": "Africa",
                      "region_un": "Africa",
                      "subregion": "Middle Africa",
                      "region_wb": "Sub-Saharan Africa",
                      "name_len": 5,
                      "long_len": 17,
                      "abbrev_len": 10,
                      "tiny": -99,
                      "homepart": 1
                    },
                    "arcs": [
                      [
                        -56,
                        -8,
                        56,
                        57,
                        -39,
                        -29
                      ]
                    ]
                  },
                  {
                    "type": "MultiPolygon",
                    "properties": {
                      "scalerank": 3,
                      "featurecla": "Admin-0 map subunit",
                      "labelrank": 6,
                      "sovereignt": "Comoros",
                      "sov_a3": "COM",
                      "adm0_dif": 0,
                      "level": 2,
                      "type": "Sovereign country",
                      "admin": "Comoros",
                      "adm0_a3": "COM",
                      "geou_dif": 0,
                      "geounit": "Comoros",
                      "gu_a3": "COM",
                      "su_dif": 0,
                      "subunit": "Comoros",
                      "su_a3": "COM",
                      "brk_diff": 0,
                      "name": "Comoros",
                      "name_long": "Comoros",
                      "brk_a3": "COM",
                      "brk_name": "Comoros",
                      "brk_group": "",
                      "abbrev": "Com.",
                      "postal": "KM",
                      "formal_en": "Union of the Comoros",
                      "formal_fr": "",
                      "note_adm0": "",
                      "note_brk": "",
                      "name_sort": "Comoros",
                      "name_alt": "",
                      "mapcolor7": 2,
                      "mapcolor8": 1,
                      "mapcolor9": 4,
                      "mapcolor13": 10,
                      "pop_est": 752438,
                      "gdp_md_est": 751.2,
                      "pop_year": -99,
                      "lastcensus": 2003,
                      "gdp_year": -99,
                      "economy": "7. Least developed region",
                      "income_grp": "5. Low income",
                      "wikipedia": -99,
                      "fips_10": "",
                      "iso_a2": "KM",
                      "iso_a3": "COM",
                      "iso_n3": 174,
                      "un_a3": 174,
                      "wb_a2": "KM",
                      "wb_a3": "COM",
                      "woe_id": -99,
                      "adm0_a3_is": "COM",
                      "adm0_a3_us": "COM",
                      "adm0_a3_un": -99,
                      "adm0_a3_wb": -99,
                      "continent": "Africa",
                      "region_un": "Africa",
                      "subregion": "Eastern Africa",
                      "region_wb": "Sub-Saharan Africa",
                      "name_len": 7,
                      "long_len": 7,
                      "abbrev_len": 4,
                      "tiny": 2,
                      "homepart": 1
                    },
                    "arcs": [
                      [
                        [
                          58
                        ]
                      ],
                      [
                        [
                          59
                        ]
                      ],
                      [
                        [
                          60
                        ]
                      ]
                    ]
                  },
                  {
                    "type": "MultiPolygon",
                    "properties": {
                      "scalerank": 3,
                      "featurecla": "Admin-0 map subunit",
                      "labelrank": 4,
                      "sovereignt": "Cape Verde",
                      "sov_a3": "CPV",
                      "adm0_dif": 0,
                      "level": 2,
                      "type": "Sovereign country",
                      "admin": "Cape Verde",
                      "adm0_a3": "CPV",
                      "geou_dif": 0,
                      "geounit": "Cape Verde",
                      "gu_a3": "CPV",
                      "su_dif": 0,
                      "subunit": "Cape Verde",
                      "su_a3": "CPV",
                      "brk_diff": 0,
                      "name": "Cape Verde",
                      "name_long": "Cape Verde",
                      "brk_a3": "CPV",
                      "brk_name": "Cape Verde",
                      "brk_group": "",
                      "abbrev": "C.Vd.",
                      "postal": "CV",
                      "formal_en": "Republic of Cape Verde",
                      "formal_fr": "",
                      "note_adm0": "",
                      "note_brk": "",
                      "name_sort": "Cape Verde",
                      "name_alt": "",
                      "mapcolor7": 1,
                      "mapcolor8": 1,
                      "mapcolor9": 4,
                      "mapcolor13": 11,
                      "pop_est": 429474,
                      "gdp_md_est": 1626,
                      "pop_year": -99,
                      "lastcensus": 2010,
                      "gdp_year": -99,
                      "economy": "6. Developing region",
                      "income_grp": "4. Lower middle income",
                      "wikipedia": -99,
                      "fips_10": "",
                      "iso_a2": "CV",
                      "iso_a3": "CPV",
                      "iso_n3": 132,
                      "un_a3": 132,
                      "wb_a2": "CV",
                      "wb_a3": "CPV",
                      "woe_id": -99,
                      "adm0_a3_is": "CPV",
                      "adm0_a3_us": "CPV",
                      "adm0_a3_un": -99,
                      "adm0_a3_wb": -99,
                      "continent": "Africa",
                      "region_un": "Africa",
                      "subregion": "Western Africa",
                      "region_wb": "Sub-Saharan Africa",
                      "name_len": 10,
                      "long_len": 10,
                      "abbrev_len": 5,
                      "tiny": -99,
                      "homepart": 1
                    },
                    "arcs": [
                      [
                        [
                          61
                        ]
                      ],
                      [
                        [
                          62
                        ]
                      ],
                      [
                        [
                          63
                        ]
                      ],
                      [
                        [
                          64
                        ]
                      ],
                      [
                        [
                          65
                        ]
                      ],
                      [
                        [
                          66
                        ]
                      ],
                      [
                        [
                          67
                        ]
                      ],
                      [
                        [
                          68
                        ]
                      ],
                      [
                        [
                          69
                        ]
                      ]
                    ]
                  },
                  {
                    "type": "Polygon",
                    "properties": {
                      "scalerank": 0,
                      "featurecla": "Admin-0 map subunit",
                      "labelrank": 5,
                      "sovereignt": "Djibouti",
                      "sov_a3": "DJI",
                      "adm0_dif": 0,
                      "level": 2,
                      "type": "Sovereign country",
                      "admin": "Djibouti",
                      "adm0_a3": "DJI",
                      "geou_dif": 0,
                      "geounit": "Djibouti",
                      "gu_a3": "DJI",
                      "su_dif": 0,
                      "subunit": "Djibouti",
                      "su_a3": "DJI",
                      "brk_diff": 0,
                      "name": "Djibouti",
                      "name_long": "Djibouti",
                      "brk_a3": "DJI",
                      "brk_name": "Djibouti",
                      "brk_group": "",
                      "abbrev": "Dji.",
                      "postal": "DJ",
                      "formal_en": "Republic of Djibouti",
                      "formal_fr": "",
                      "note_adm0": "",
                      "note_brk": "",
                      "name_sort": "Djibouti",
                      "name_alt": "",
                      "mapcolor7": 1,
                      "mapcolor8": 2,
                      "mapcolor9": 4,
                      "mapcolor13": 8,
                      "pop_est": 516055,
                      "gdp_md_est": 1885,
                      "pop_year": -99,
                      "lastcensus": 2009,
                      "gdp_year": -99,
                      "economy": "7. Least developed region",
                      "income_grp": "4. Lower middle income",
                      "wikipedia": -99,
                      "fips_10": "",
                      "iso_a2": "DJ",
                      "iso_a3": "DJI",
                      "iso_n3": 262,
                      "un_a3": 262,
                      "wb_a2": "DJ",
                      "wb_a3": "DJI",
                      "woe_id": -99,
                      "adm0_a3_is": "DJI",
                      "adm0_a3_us": "DJI",
                      "adm0_a3_un": -99,
                      "adm0_a3_wb": -99,
                      "continent": "Africa",
                      "region_un": "Africa",
                      "subregion": "Eastern Africa",
                      "region_wb": "Middle East & North Africa",
                      "name_len": 8,
                      "long_len": 8,
                      "abbrev_len": 4,
                      "tiny": -99,
                      "homepart": 1
                    },
                    "arcs": [
                      [
                        70,
                        71,
                        72,
                        73
                      ]
                    ]
                  },
                  {
                    "type": "Polygon",
                    "properties": {
                      "scalerank": 0,
                      "featurecla": "Admin-0 map subunit",
                      "labelrank": 3,
                      "sovereignt": "Algeria",
                      "sov_a3": "DZA",
                      "adm0_dif": 0,
                      "level": 2,
                      "type": "Sovereign country",
                      "admin": "Algeria",
                      "adm0_a3": "DZA",
                      "geou_dif": 0,
                      "geounit": "Algeria",
                      "gu_a3": "DZA",
                      "su_dif": 0,
                      "subunit": "Algeria",
                      "su_a3": "DZA",
                      "brk_diff": 0,
                      "name": "Algeria",
                      "name_long": "Algeria",
                      "brk_a3": "DZA",
                      "brk_name": "Algeria",
                      "brk_group": "",
                      "abbrev": "Alg.",
                      "postal": "DZ",
                      "formal_en": "People's Democratic Republic of Algeria",
                      "formal_fr": "",
                      "note_adm0": "",
                      "note_brk": "",
                      "name_sort": "Algeria",
                      "name_alt": "",
                      "mapcolor7": 5,
                      "mapcolor8": 1,
                      "mapcolor9": 6,
                      "mapcolor13": 3,
                      "pop_est": 34178188,
                      "gdp_md_est": 232900,
                      "pop_year": -99,
                      "lastcensus": 2008,
                      "gdp_year": -99,
                      "economy": "6. Developing region",
                      "income_grp": "3. Upper middle income",
                      "wikipedia": -99,
                      "fips_10": "",
                      "iso_a2": "DZ",
                      "iso_a3": "DZA",
                      "iso_n3": "012",
                      "un_a3": "012",
                      "wb_a2": "DZ",
                      "wb_a3": "DZA",
                      "woe_id": -99,
                      "adm0_a3_is": "DZA",
                      "adm0_a3_us": "DZA",
                      "adm0_a3_un": -99,
                      "adm0_a3_wb": -99,
                      "continent": "Africa",
                      "region_un": "Africa",
                      "subregion": "Northern Africa",
                      "region_wb": "Middle East & North Africa",
                      "name_len": 7,
                      "long_len": 7,
                      "abbrev_len": 4,
                      "tiny": -99,
                      "homepart": 1
                    },
                    "arcs": [
                      [
                        74,
                        75,
                        76,
                        77,
                        78,
                        79,
                        80,
                        81
                      ]
                    ]
                  },
                  {
                    "type": "MultiPolygon",
                    "properties": {
                      "scalerank": 0,
                      "featurecla": "Admin-0 map subunit",
                      "labelrank": 2,
                      "sovereignt": "Egypt",
                      "sov_a3": "EGY",
                      "adm0_dif": 0,
                      "level": 2,
                      "type": "Sovereign country",
                      "admin": "Egypt",
                      "adm0_a3": "EGY",
                      "geou_dif": 0,
                      "geounit": "Egypt",
                      "gu_a3": "EGY",
                      "su_dif": 0,
                      "subunit": "Egypt",
                      "su_a3": "EGY",
                      "brk_diff": 0,
                      "name": "Egypt",
                      "name_long": "Egypt",
                      "brk_a3": "EGY",
                      "brk_name": "Egypt",
                      "brk_group": "",
                      "abbrev": "Egypt",
                      "postal": "EG",
                      "formal_en": "Arab Republic of Egypt",
                      "formal_fr": "",
                      "note_adm0": "",
                      "note_brk": "",
                      "name_sort": "Egypt, Arab Rep.",
                      "name_alt": "",
                      "mapcolor7": 4,
                      "mapcolor8": 6,
                      "mapcolor9": 7,
                      "mapcolor13": 2,
                      "pop_est": 83082869,
                      "gdp_md_est": 443700,
                      "pop_year": -99,
                      "lastcensus": 2006,
                      "gdp_year": -99,
                      "economy": "5. Emerging region: G20",
                      "income_grp": "4. Lower middle income",
                      "wikipedia": -99,
                      "fips_10": "",
                      "iso_a2": "EG",
                      "iso_a3": "EGY",
                      "iso_n3": 818,
                      "un_a3": 818,
                      "wb_a2": "EG",
                      "wb_a3": "EGY",
                      "woe_id": -99,
                      "adm0_a3_is": "EGY",
                      "adm0_a3_us": "EGY",
                      "adm0_a3_un": -99,
                      "adm0_a3_wb": -99,
                      "continent": "Africa",
                      "region_un": "Africa",
                      "subregion": "Northern Africa",
                      "region_wb": "Middle East & North Africa",
                      "name_len": 5,
                      "long_len": 5,
                      "abbrev_len": 5,
                      "tiny": -99,
                      "homepart": 1
                    },
                    "arcs": [
                      [
                        [
                          82
                        ]
                      ],
                      [
                        [
                          83
                        ]
                      ],
                      [
                        [
                          84
                        ]
                      ],
                      [
                        [
                          85
                        ]
                      ],
                      [
                        [
                          86
                        ]
                      ],
                      [
                        [
                          87
                        ]
                      ],
                      [
                        [
                          88
                        ]
                      ],
                      [
                        [
                          89,
                          90,
                          91
                        ]
                      ]
                    ]
                  },
                  {
                    "type": "MultiPolygon",
                    "properties": {
                      "scalerank": 0,
                      "featurecla": "Admin-0 map subunit",
                      "labelrank": 4,
                      "sovereignt": "Eritrea",
                      "sov_a3": "ERI",
                      "adm0_dif": 0,
                      "level": 2,
                      "type": "Sovereign country",
                      "admin": "Eritrea",
                      "adm0_a3": "ERI",
                      "geou_dif": 0,
                      "geounit": "Eritrea",
                      "gu_a3": "ERI",
                      "su_dif": 0,
                      "subunit": "Eritrea",
                      "su_a3": "ERI",
                      "brk_diff": 0,
                      "name": "Eritrea",
                      "name_long": "Eritrea",
                      "brk_a3": "ERI",
                      "brk_name": "Eritrea",
                      "brk_group": "",
                      "abbrev": "Erit.",
                      "postal": "ER",
                      "formal_en": "State of Eritrea",
                      "formal_fr": "",
                      "note_adm0": "",
                      "note_brk": "",
                      "name_sort": "Eritrea",
                      "name_alt": "",
                      "mapcolor7": 3,
                      "mapcolor8": 1,
                      "mapcolor9": 2,
                      "mapcolor13": 12,
                      "pop_est": 5647168,
                      "gdp_md_est": 3945,
                      "pop_year": -99,
                      "lastcensus": 1984,
                      "gdp_year": -99,
                      "economy": "7. Least developed region",
                      "income_grp": "5. Low income",
                      "wikipedia": -99,
                      "fips_10": "",
                      "iso_a2": "ER",
                      "iso_a3": "ERI",
                      "iso_n3": 232,
                      "un_a3": 232,
                      "wb_a2": "ER",
                      "wb_a3": "ERI",
                      "woe_id": -99,
                      "adm0_a3_is": "ERI",
                      "adm0_a3_us": "ERI",
                      "adm0_a3_un": -99,
                      "adm0_a3_wb": -99,
                      "continent": "Africa",
                      "region_un": "Africa",
                      "subregion": "Eastern Africa",
                      "region_wb": "Sub-Saharan Africa",
                      "name_len": 7,
                      "long_len": 7,
                      "abbrev_len": 5,
                      "tiny": -99,
                      "homepart": 1
                    },
                    "arcs": [
                      [
                        [
                          92
                        ]
                      ],
                      [
                        [
                          93
                        ]
                      ],
                      [
                        [
                          -73,
                          94,
                          95,
                          96
                        ]
                      ]
                    ]
                  },
                  {
                    "type": "MultiPolygon",
                    "properties": {
                      "scalerank": 3,
                      "featurecla": "Admin-0 map subunit",
                      "labelrank": 5,
                      "sovereignt": "Spain",
                      "sov_a3": "ESP",
                      "adm0_dif": 0,
                      "level": 4,
                      "type": "Geo subunit",
                      "admin": "Spain",
                      "adm0_a3": "ESP",
                      "geou_dif": 0,
                      "geounit": "Spain",
                      "gu_a3": "ESP",
                      "su_dif": 1,
                      "subunit": "Canary Islands",
                      "su_a3": "ESC",
                      "brk_diff": 0,
                      "name": "Canary Is.",
                      "name_long": "Canary Islands",
                      "brk_a3": "ESC",
                      "brk_name": "Canary Is.",
                      "brk_group": "",
                      "abbrev": "Can. Is.",
                      "postal": "CI",
                      "formal_en": "",
                      "formal_fr": "",
                      "note_adm0": "Sp.",
                      "note_brk": "",
                      "name_sort": "Canary Islands",
                      "name_alt": "",
                      "mapcolor7": 4,
                      "mapcolor8": 5,
                      "mapcolor9": 5,
                      "mapcolor13": 5,
                      "pop_est": 2098593,
                      "gdp_md_est": 72654.55481,
                      "pop_year": -99,
                      "lastcensus": -99,
                      "gdp_year": -99,
                      "economy": -99,
                      "income_grp": -99,
                      "wikipedia": -99,
                      "fips_10": "",
                      "iso_a2": -99,
                      "iso_a3": -99,
                      "iso_n3": -99,
                      "un_a3": "-099",
                      "wb_a2": -99,
                      "wb_a3": -99,
                      "woe_id": -99,
                      "adm0_a3_is": "ESP",
                      "adm0_a3_us": "ESP",
                      "adm0_a3_un": -99,
                      "adm0_a3_wb": -99,
                      "continent": "Africa",
                      "region_un": "Europe",
                      "subregion": "Southern Europe",
                      "region_wb": "Europe & Central Asia",
                      "name_len": 10,
                      "long_len": 14,
                      "abbrev_len": 8,
                      "tiny": -99,
                      "homepart": -99
                    },
                    "arcs": [
                      [
                        [
                          97
                        ]
                      ],
                      [
                        [
                          98
                        ]
                      ],
                      [
                        [
                          99
                        ]
                      ],
                      [
                        [
                          100
                        ]
                      ],
                      [
                        [
                          101
                        ]
                      ],
                      [
                        [
                          102
                        ]
                      ],
                      [
                        [
                          103
                        ]
                      ],
                      [
                        [
                          104
                        ]
                      ]
                    ]
                  },
                  {
                    "type": "Polygon",
                    "properties": {
                      "scalerank": 0,
                      "featurecla": "Admin-0 map subunit",
                      "labelrank": 2,
                      "sovereignt": "Ethiopia",
                      "sov_a3": "ETH",
                      "adm0_dif": 0,
                      "level": 2,
                      "type": "Sovereign country",
                      "admin": "Ethiopia",
                      "adm0_a3": "ETH",
                      "geou_dif": 0,
                      "geounit": "Ethiopia",
                      "gu_a3": "ETH",
                      "su_dif": 0,
                      "subunit": "Ethiopia",
                      "su_a3": "ETH",
                      "brk_diff": 0,
                      "name": "Ethiopia",
                      "name_long": "Ethiopia",
                      "brk_a3": "ETH",
                      "brk_name": "Ethiopia",
                      "brk_group": "",
                      "abbrev": "Eth.",
                      "postal": "ET",
                      "formal_en": "Federal Democratic Republic of Ethiopia",
                      "formal_fr": "",
                      "note_adm0": "",
                      "note_brk": "",
                      "name_sort": "Ethiopia",
                      "name_alt": "",
                      "mapcolor7": 4,
                      "mapcolor8": 4,
                      "mapcolor9": 1,
                      "mapcolor13": 13,
                      "pop_est": 85237338,
                      "gdp_md_est": 68770,
                      "pop_year": -99,
                      "lastcensus": 2007,
                      "gdp_year": -99,
                      "economy": "7. Least developed region",
                      "income_grp": "5. Low income",
                      "wikipedia": -99,
                      "fips_10": "",
                      "iso_a2": "ET",
                      "iso_a3": "ETH",
                      "iso_n3": 231,
                      "un_a3": 231,
                      "wb_a2": "ET",
                      "wb_a3": "ETH",
                      "woe_id": -99,
                      "adm0_a3_is": "ETH",
                      "adm0_a3_us": "ETH",
                      "adm0_a3_un": -99,
                      "adm0_a3_wb": -99,
                      "continent": "Africa",
                      "region_un": "Africa",
                      "subregion": "Eastern Africa",
                      "region_wb": "Sub-Saharan Africa",
                      "name_len": 8,
                      "long_len": 8,
                      "abbrev_len": 4,
                      "tiny": -99,
                      "homepart": 1
                    },
                    "arcs": [
                      [
                        -72,
                        105,
                        106,
                        107,
                        108,
                        109,
                        110,
                        -95
                      ]
                    ]
                  },
                  {
                    "type": "Polygon",
                    "properties": {
                      "scalerank": 6,
                      "featurecla": "Admin-0 map subunit",
                      "labelrank": 6,
                      "sovereignt": "France",
                      "sov_a3": "FR1",
                      "adm0_dif": 1,
                      "level": 4,
                      "type": "Geo subunit",
                      "admin": "French Southern and Antarctic Lands",
                      "adm0_a3": "ATF",
                      "geou_dif": 0,
                      "geounit": "French Southern and Antarctic Lands",
                      "gu_a3": "ATF",
                      "su_dif": 1,
                      "subunit": "Europa I.",
                      "su_a3": "EUI",
                      "brk_diff": 1,
                      "name": "Europa Island",
                      "name_long": "Europa Island",
                      "brk_a3": "B26",
                      "brk_name": "Europa Island",
                      "brk_group": "",
                      "abbrev": "E.I.",
                      "postal": "EI",
                      "formal_en": "",
                      "formal_fr": "",
                      "note_adm0": "Fr.",
                      "note_brk": "Admin. by France; Claimed by Madagascar",
                      "name_sort": "Europa Island",
                      "name_alt": "",
                      "mapcolor7": 7,
                      "mapcolor8": 5,
                      "mapcolor9": 9,
                      "mapcolor13": 11,
                      "pop_est": 60,
                      "gdp_md_est": 6.857143,
                      "pop_year": -99,
                      "lastcensus": -99,
                      "gdp_year": -99,
                      "economy": -99,
                      "income_grp": -99,
                      "wikipedia": -99,
                      "fips_10": "",
                      "iso_a2": -99,
                      "iso_a3": -99,
                      "iso_n3": -99,
                      "un_a3": "-099",
                      "wb_a2": -99,
                      "wb_a3": -99,
                      "woe_id": -99,
                      "adm0_a3_is": "ATF",
                      "adm0_a3_us": "ATF",
                      "adm0_a3_un": -99,
                      "adm0_a3_wb": -99,
                      "continent": "Africa",
                      "region_un": "Africa",
                      "subregion": "Eastern Africa",
                      "region_wb": "Sub-Saharan Africa",
                      "name_len": 13,
                      "long_len": 13,
                      "abbrev_len": 4,
                      "tiny": -99,
                      "homepart": -99
                    },
                    "arcs": [
                      [
                        111
                      ]
                    ]
                  },
                  {
                    "type": "MultiPolygon",
                    "properties": {
                      "scalerank": 0,
                      "featurecla": "Admin-0 map subunit",
                      "labelrank": 4,
                      "sovereignt": "Gabon",
                      "sov_a3": "GAB",
                      "adm0_dif": 0,
                      "level": 2,
                      "type": "Sovereign country",
                      "admin": "Gabon",
                      "adm0_a3": "GAB",
                      "geou_dif": 0,
                      "geounit": "Gabon",
                      "gu_a3": "GAB",
                      "su_dif": 0,
                      "subunit": "Gabon",
                      "su_a3": "GAB",
                      "brk_diff": 0,
                      "name": "Gabon",
                      "name_long": "Gabon",
                      "brk_a3": "GAB",
                      "brk_name": "Gabon",
                      "brk_group": "",
                      "abbrev": "Gabon",
                      "postal": "GA",
                      "formal_en": "Gabonese Republic",
                      "formal_fr": "",
                      "note_adm0": "",
                      "note_brk": "",
                      "name_sort": "Gabon",
                      "name_alt": "",
                      "mapcolor7": 6,
                      "mapcolor8": 2,
                      "mapcolor9": 5,
                      "mapcolor13": 5,
                      "pop_est": 1514993,
                      "gdp_md_est": 21110,
                      "pop_year": -99,
                      "lastcensus": 2003,
                      "gdp_year": -99,
                      "economy": "6. Developing region",
                      "income_grp": "3. Upper middle income",
                      "wikipedia": -99,
                      "fips_10": "",
                      "iso_a2": "GA",
                      "iso_a3": "GAB",
                      "iso_n3": 266,
                      "un_a3": 266,
                      "wb_a2": "GA",
                      "wb_a3": "GAB",
                      "woe_id": -99,
                      "adm0_a3_is": "GAB",
                      "adm0_a3_us": "GAB",
                      "adm0_a3_un": -99,
                      "adm0_a3_wb": -99,
                      "continent": "Africa",
                      "region_un": "Africa",
                      "subregion": "Middle Africa",
                      "region_wb": "Sub-Saharan Africa",
                      "name_len": 5,
                      "long_len": 5,
                      "abbrev_len": 5,
                      "tiny": 3,
                      "homepart": 1
                    },
                    "arcs": [
                      [
                        [
                          112
                        ]
                      ],
                      [
                        [
                          113
                        ]
                      ],
                      [
                        [
                          -58,
                          114,
                          115,
                          -40
                        ]
                      ]
                    ]
                  },
                  {
                    "type": "Polygon",
                    "properties": {
                      "scalerank": 0,
                      "featurecla": "Admin-0 map subunit",
                      "labelrank": 3,
                      "sovereignt": "Ghana",
                      "sov_a3": "GHA",
                      "adm0_dif": 0,
                      "level": 2,
                      "type": "Sovereign country",
                      "admin": "Ghana",
                      "adm0_a3": "GHA",
                      "geou_dif": 0,
                      "geounit": "Ghana",
                      "gu_a3": "GHA",
                      "su_dif": 0,
                      "subunit": "Ghana",
                      "su_a3": "GHA",
                      "brk_diff": 0,
                      "name": "Ghana",
                      "name_long": "Ghana",
                      "brk_a3": "GHA",
                      "brk_name": "Ghana",
                      "brk_group": "",
                      "abbrev": "Ghana",
                      "postal": "GH",
                      "formal_en": "Republic of Ghana",
                      "formal_fr": "",
                      "note_adm0": "",
                      "note_brk": "",
                      "name_sort": "Ghana",
                      "name_alt": "",
                      "mapcolor7": 5,
                      "mapcolor8": 3,
                      "mapcolor9": 1,
                      "mapcolor13": 4,
                      "pop_est": 23832495,
                      "gdp_md_est": 34200,
                      "pop_year": -99,
                      "lastcensus": 2010,
                      "gdp_year": -99,
                      "economy": "6. Developing region",
                      "income_grp": "4. Lower middle income",
                      "wikipedia": -99,
                      "fips_10": "",
                      "iso_a2": "GH",
                      "iso_a3": "GHA",
                      "iso_n3": 288,
                      "un_a3": 288,
                      "wb_a2": "GH",
                      "wb_a3": "GHA",
                      "woe_id": -99,
                      "adm0_a3_is": "GHA",
                      "adm0_a3_us": "GHA",
                      "adm0_a3_un": -99,
                      "adm0_a3_wb": -99,
                      "continent": "Africa",
                      "region_un": "Africa",
                      "subregion": "Western Africa",
                      "region_wb": "Sub-Saharan Africa",
                      "name_len": 5,
                      "long_len": 5,
                      "abbrev_len": 5,
                      "tiny": -99,
                      "homepart": 1
                    },
                    "arcs": [
                      [
                        116,
                        117,
                        -32,
                        118,
                        -34,
                        -19
                      ]
                    ]
                  },
                  {
                    "type": "Polygon",
                    "properties": {
                      "scalerank": 0,
                      "featurecla": "Admin-0 map subunit",
                      "labelrank": 3,
                      "sovereignt": "Guinea",
                      "sov_a3": "GIN",
                      "adm0_dif": 0,
                      "level": 2,
                      "type": "Sovereign country",
                      "admin": "Guinea",
                      "adm0_a3": "GIN",
                      "geou_dif": 0,
                      "geounit": "Guinea",
                      "gu_a3": "GIN",
                      "su_dif": 0,
                      "subunit": "Guinea",
                      "su_a3": "GIN",
                      "brk_diff": 0,
                      "name": "Guinea",
                      "name_long": "Guinea",
                      "brk_a3": "GIN",
                      "brk_name": "Guinea",
                      "brk_group": "",
                      "abbrev": "Gin.",
                      "postal": "GN",
                      "formal_en": "Republic of Guinea",
                      "formal_fr": "",
                      "note_adm0": "",
                      "note_brk": "",
                      "name_sort": "Guinea",
                      "name_alt": "",
                      "mapcolor7": 6,
                      "mapcolor8": 3,
                      "mapcolor9": 7,
                      "mapcolor13": 2,
                      "pop_est": 10057975,
                      "gdp_md_est": 10600,
                      "pop_year": -99,
                      "lastcensus": 1996,
                      "gdp_year": -99,
                      "economy": "7. Least developed region",
                      "income_grp": "5. Low income",
                      "wikipedia": -99,
                      "fips_10": "",
                      "iso_a2": "GN",
                      "iso_a3": "GIN",
                      "iso_n3": 324,
                      "un_a3": 324,
                      "wb_a2": "GN",
                      "wb_a3": "GIN",
                      "woe_id": -99,
                      "adm0_a3_is": "GIN",
                      "adm0_a3_us": "GIN",
                      "adm0_a3_un": -99,
                      "adm0_a3_wb": -99,
                      "continent": "Africa",
                      "region_un": "Africa",
                      "subregion": "Western Africa",
                      "region_wb": "Sub-Saharan Africa",
                      "name_len": 6,
                      "long_len": 6,
                      "abbrev_len": 4,
                      "tiny": -99,
                      "homepart": 1
                    },
                    "arcs": [
                      [
                        119,
                        -37,
                        120,
                        121,
                        122,
                        123,
                        124
                      ]
                    ]
                  },
                  {
                    "type": "Polygon",
                    "properties": {
                      "scalerank": 0,
                      "featurecla": "Admin-0 map subunit",
                      "labelrank": 6,
                      "sovereignt": "Gambia",
                      "sov_a3": "GMB",
                      "adm0_dif": 0,
                      "level": 2,
                      "type": "Sovereign country",
                      "admin": "Gambia",
                      "adm0_a3": "GMB",
                      "geou_dif": 0,
                      "geounit": "Gambia",
                      "gu_a3": "GMB",
                      "su_dif": 0,
                      "subunit": "Gambia",
                      "su_a3": "GMB",
                      "brk_diff": 0,
                      "name": "Gambia",
                      "name_long": "The Gambia",
                      "brk_a3": "GMB",
                      "brk_name": "Gambia",
                      "brk_group": "",
                      "abbrev": "Gambia",
                      "postal": "GM",
                      "formal_en": "Republic of the Gambia",
                      "formal_fr": "",
                      "note_adm0": "",
                      "note_brk": "",
                      "name_sort": "Gambia, The",
                      "name_alt": "",
                      "mapcolor7": 1,
                      "mapcolor8": 4,
                      "mapcolor9": 1,
                      "mapcolor13": 8,
                      "pop_est": 1782893,
                      "gdp_md_est": 2272,
                      "pop_year": -99,
                      "lastcensus": 2003,
                      "gdp_year": -99,
                      "economy": "7. Least developed region",
                      "income_grp": "5. Low income",
                      "wikipedia": -99,
                      "fips_10": "",
                      "iso_a2": "GM",
                      "iso_a3": "GMB",
                      "iso_n3": 270,
                      "un_a3": 270,
                      "wb_a2": "GM",
                      "wb_a3": "GMB",
                      "woe_id": -99,
                      "adm0_a3_is": "GMB",
                      "adm0_a3_us": "GMB",
                      "adm0_a3_un": -99,
                      "adm0_a3_wb": -99,
                      "continent": "Africa",
                      "region_un": "Africa",
                      "subregion": "Western Africa",
                      "region_wb": "Sub-Saharan Africa",
                      "name_len": 6,
                      "long_len": 10,
                      "abbrev_len": 6,
                      "tiny": -99,
                      "homepart": 1
                    },
                    "arcs": [
                      [
                        125,
                        126
                      ]
                    ]
                  },
                  {
                    "type": "Polygon",
                    "properties": {
                      "scalerank": 6,
                      "featurecla": "Admin-0 map subunit",
                      "labelrank": 7,
                      "sovereignt": "Equatorial Guinea",
                      "sov_a3": "GNQ",
                      "adm0_dif": 0,
                      "level": 4,
                      "type": "Geo subunit",
                      "admin": "Equatorial Guinea",
                      "adm0_a3": "GNQ",
                      "geou_dif": 0,
                      "geounit": "Equatorial Guinea",
                      "gu_a3": "GNQ",
                      "su_dif": 1,
                      "subunit": "Annobon",
                      "su_a3": "GNA",
                      "brk_diff": 0,
                      "name": "Annob�n",
                      "name_long": "Annob�n",
                      "brk_a3": "GNA",
                      "brk_name": "Annobon",
                      "brk_group": "",
                      "abbrev": "Ann.",
                      "postal": "AN",
                      "formal_en": "",
                      "formal_fr": "",
                      "note_adm0": "Eq. G.",
                      "note_brk": "",
                      "name_sort": "Annob�n",
                      "name_alt": "",
                      "mapcolor7": 4,
                      "mapcolor8": 1,
                      "mapcolor9": 4,
                      "mapcolor13": 8,
                      "pop_est": 5000,
                      "gdp_md_est": 108.037166,
                      "pop_year": -99,
                      "lastcensus": -99,
                      "gdp_year": -99,
                      "economy": -99,
                      "income_grp": -99,
                      "wikipedia": -99,
                      "fips_10": "",
                      "iso_a2": -99,
                      "iso_a3": -99,
                      "iso_n3": -99,
                      "un_a3": "-099",
                      "wb_a2": -99,
                      "wb_a3": -99,
                      "woe_id": -99,
                      "adm0_a3_is": "GNQ",
                      "adm0_a3_us": "GNQ",
                      "adm0_a3_un": -99,
                      "adm0_a3_wb": -99,
                      "continent": "Africa",
                      "region_un": "Africa",
                      "subregion": "Middle Africa",
                      "region_wb": "Sub-Saharan Africa",
                      "name_len": 7,
                      "long_len": 7,
                      "abbrev_len": 4,
                      "tiny": -99,
                      "homepart": -99
                    },
                    "arcs": [
                      [
                        127
                      ]
                    ]
                  },
                  {
                    "type": "MultiPolygon",
                    "properties": {
                      "scalerank": 0,
                      "featurecla": "Admin-0 map subunit",
                      "labelrank": 6,
                      "sovereignt": "Guinea Bissau",
                      "sov_a3": "GNB",
                      "adm0_dif": 0,
                      "level": 2,
                      "type": "Sovereign country",
                      "admin": "Guinea Bissau",
                      "adm0_a3": "GNB",
                      "geou_dif": 0,
                      "geounit": "Guinea Bissau",
                      "gu_a3": "GNB",
                      "su_dif": 0,
                      "subunit": "Guinea Bissau",
                      "su_a3": "GNB",
                      "brk_diff": 0,
                      "name": "Guinea-Bissau",
                      "name_long": "Guinea-Bissau",
                      "brk_a3": "GNB",
                      "brk_name": "Guinea-Bissau",
                      "brk_group": "",
                      "abbrev": "GnB.",
                      "postal": "GW",
                      "formal_en": "Republic of Guinea-Bissau",
                      "formal_fr": "",
                      "note_adm0": "",
                      "note_brk": "",
                      "name_sort": "Guinea-Bissau",
                      "name_alt": "",
                      "mapcolor7": 3,
                      "mapcolor8": 5,
                      "mapcolor9": 3,
                      "mapcolor13": 4,
                      "pop_est": 1533964,
                      "gdp_md_est": 904.2,
                      "pop_year": -99,
                      "lastcensus": 2009,
                      "gdp_year": -99,
                      "economy": "7. Least developed region",
                      "income_grp": "5. Low income",
                      "wikipedia": -99,
                      "fips_10": "",
                      "iso_a2": "GW",
                      "iso_a3": "GNB",
                      "iso_n3": 624,
                      "un_a3": 624,
                      "wb_a2": "GW",
                      "wb_a3": "GNB",
                      "woe_id": -99,
                      "adm0_a3_is": "GNB",
                      "adm0_a3_us": "GNB",
                      "adm0_a3_un": -99,
                      "adm0_a3_wb": -99,
                      "continent": "Africa",
                      "region_un": "Africa",
                      "subregion": "Western Africa",
                      "region_wb": "Sub-Saharan Africa",
                      "name_len": 13,
                      "long_len": 13,
                      "abbrev_len": 4,
                      "tiny": -99,
                      "homepart": 1
                    },
                    "arcs": [
                      [
                        [
                          128
                        ]
                      ],
                      [
                        [
                          129
                        ]
                      ],
                      [
                        [
                          130
                        ]
                      ],
                      [
                        [
                          131
                        ]
                      ],
                      [
                        [
                          132
                        ]
                      ],
                      [
                        [
                          133
                        ]
                      ],
                      [
                        [
                          134
                        ]
                      ],
                      [
                        [
                          135
                        ]
                      ],
                      [
                        [
                          136
                        ]
                      ],
                      [
                        [
                          137
                        ]
                      ],
                      [
                        [
                          138
                        ]
                      ],
                      [
                        [
                          139
                        ]
                      ],
                      [
                        [
                          140,
                          141,
                          -124
                        ]
                      ]
                    ]
                  },
                  {
                    "type": "Polygon",
                    "properties": {
                      "scalerank": 3,
                      "featurecla": "Admin-0 map subunit",
                      "labelrank": 7,
                      "sovereignt": "Equatorial Guinea",
                      "sov_a3": "GNQ",
                      "adm0_dif": 0,
                      "level": 4,
                      "type": "Geo subunit",
                      "admin": "Equatorial Guinea",
                      "adm0_a3": "GNQ",
                      "geou_dif": 0,
                      "geounit": "Equatorial Guinea",
                      "gu_a3": "GNQ",
                      "su_dif": 1,
                      "subunit": "Bioko",
                      "su_a3": "GNK",
                      "brk_diff": 0,
                      "name": "Bioko",
                      "name_long": "Bioko",
                      "brk_a3": "GNK",
                      "brk_name": "Bioko",
                      "brk_group": "",
                      "abbrev": "Bioko",
                      "postal": "BO",
                      "formal_en": "",
                      "formal_fr": "",
                      "note_adm0": "Eq. G.",
                      "note_brk": "",
                      "name_sort": "Bioko",
                      "name_alt": "",
                      "mapcolor7": 4,
                      "mapcolor8": 1,
                      "mapcolor9": 4,
                      "mapcolor13": 8,
                      "pop_est": 124000,
                      "gdp_md_est": 2679.321717,
                      "pop_year": -99,
                      "lastcensus": -99,
                      "gdp_year": -99,
                      "economy": -99,
                      "income_grp": -99,
                      "wikipedia": -99,
                      "fips_10": "",
                      "iso_a2": -99,
                      "iso_a3": -99,
                      "iso_n3": -99,
                      "un_a3": "-099",
                      "wb_a2": -99,
                      "wb_a3": -99,
                      "woe_id": -99,
                      "adm0_a3_is": "GNQ",
                      "adm0_a3_us": "GNQ",
                      "adm0_a3_un": -99,
                      "adm0_a3_wb": -99,
                      "continent": "Africa",
                      "region_un": "Africa",
                      "subregion": "Middle Africa",
                      "region_wb": "Sub-Saharan Africa",
                      "name_len": 5,
                      "long_len": 5,
                      "abbrev_len": 5,
                      "tiny": -99,
                      "homepart": -99
                    },
                    "arcs": [
                      [
                        142
                      ]
                    ]
                  },
                  {
                    "type": "Polygon",
                    "properties": {
                      "scalerank": 0,
                      "featurecla": "Admin-0 map subunit",
                      "labelrank": 5,
                      "sovereignt": "Equatorial Guinea",
                      "sov_a3": "GNQ",
                      "adm0_dif": 0,
                      "level": 4,
                      "type": "Geo subunit",
                      "admin": "Equatorial Guinea",
                      "adm0_a3": "GNQ",
                      "geou_dif": 0,
                      "geounit": "Equatorial Guinea",
                      "gu_a3": "GNQ",
                      "su_dif": 1,
                      "subunit": "Rio Muni",
                      "su_a3": "GNR",
                      "brk_diff": 0,
                      "name": "R�o Muni",
                      "name_long": "R�o Muni",
                      "brk_a3": "GNR",
                      "brk_name": "Rio Muni",
                      "brk_group": "",
                      "abbrev": "Rio M.",
                      "postal": "RM",
                      "formal_en": "",
                      "formal_fr": "",
                      "note_adm0": "",
                      "note_brk": "",
                      "name_sort": "R�o Muni",
                      "name_alt": "",
                      "mapcolor7": 4,
                      "mapcolor8": 1,
                      "mapcolor9": 4,
                      "mapcolor13": 8,
                      "pop_est": 300000,
                      "gdp_md_est": 6482.229961,
                      "pop_year": 0,
                      "lastcensus": -99,
                      "gdp_year": -99,
                      "economy": -99,
                      "income_grp": -99,
                      "wikipedia": 0,
                      "fips_10": "",
                      "iso_a2": -99,
                      "iso_a3": -99,
                      "iso_n3": -99,
                      "un_a3": "-099",
                      "wb_a2": -99,
                      "wb_a3": -99,
                      "woe_id": -99,
                      "adm0_a3_is": "GNQ",
                      "adm0_a3_us": "GNQ",
                      "adm0_a3_un": -99,
                      "adm0_a3_wb": -99,
                      "continent": "Africa",
                      "region_un": "Africa",
                      "subregion": "Middle Africa",
                      "region_wb": "Sub-Saharan Africa",
                      "name_len": 8,
                      "long_len": 8,
                      "abbrev_len": 6,
                      "tiny": -99,
                      "homepart": -99
                    },
                    "arcs": [
                      [
                        -116,
                        143,
                        -41
                      ]
                    ]
                  },
                  {
                    "type": "Polygon",
                    "properties": {
                      "scalerank": 6,
                      "featurecla": "Admin-0 map subunit",
                      "labelrank": 6,
                      "sovereignt": "France",
                      "sov_a3": "FR1",
                      "adm0_dif": 1,
                      "level": 4,
                      "type": "Geo subunit",
                      "admin": "French Southern and Antarctic Lands",
                      "adm0_a3": "ATF",
                      "geou_dif": 0,
                      "geounit": "French Southern and Antarctic Lands",
                      "gu_a3": "ATF",
                      "su_dif": 1,
                      "subunit": "Juan De Nova Island",
                      "su_a3": "JUI",
                      "brk_diff": 1,
                      "name": "Juan De Nova I.",
                      "name_long": "Juan De Nova Island",
                      "brk_a3": "B23",
                      "brk_name": "Juan De Nova I.",
                      "brk_group": "",
                      "abbrev": "J.dN.",
                      "postal": "JN",
                      "formal_en": "",
                      "formal_fr": "",
                      "note_adm0": "Fr.",
                      "note_brk": "Admin. by France; Claimed by Madagascar",
                      "name_sort": "Juan De Nova Island",
                      "name_alt": "",
                      "mapcolor7": 7,
                      "mapcolor8": 5,
                      "mapcolor9": 9,
                      "mapcolor13": 11,
                      "pop_est": 20,
                      "gdp_md_est": 2.285714,
                      "pop_year": -99,
                      "lastcensus": -99,
                      "gdp_year": -99,
                      "economy": -99,
                      "income_grp": -99,
                      "wikipedia": -99,
                      "fips_10": "",
                      "iso_a2": -99,
                      "iso_a3": -99,
                      "iso_n3": -99,
                      "un_a3": "-099",
                      "wb_a2": -99,
                      "wb_a3": -99,
                      "woe_id": -99,
                      "adm0_a3_is": "ATF",
                      "adm0_a3_us": "ATF",
                      "adm0_a3_un": -99,
                      "adm0_a3_wb": -99,
                      "continent": "Africa",
                      "region_un": "Africa",
                      "subregion": "Eastern Africa",
                      "region_wb": "Sub-Saharan Africa",
                      "name_len": 15,
                      "long_len": 19,
                      "abbrev_len": 5,
                      "tiny": -99,
                      "homepart": -99
                    },
                    "arcs": [
                      [
                        144
                      ]
                    ]
                  },
                  {
                    "type": "MultiPolygon",
                    "properties": {
                      "scalerank": 0,
                      "featurecla": "Admin-0 map subunit",
                      "labelrank": 2,
                      "sovereignt": "Kenya",
                      "sov_a3": "KEN",
                      "adm0_dif": 0,
                      "level": 2,
                      "type": "Sovereign country",
                      "admin": "Kenya",
                      "adm0_a3": "KEN",
                      "geou_dif": 0,
                      "geounit": "Kenya",
                      "gu_a3": "KEN",
                      "su_dif": 0,
                      "subunit": "Kenya",
                      "su_a3": "KEN",
                      "brk_diff": 0,
                      "name": "Kenya",
                      "name_long": "Kenya",
                      "brk_a3": "KEN",
                      "brk_name": "Kenya",
                      "brk_group": "",
                      "abbrev": "Ken.",
                      "postal": "KE",
                      "formal_en": "Republic of Kenya",
                      "formal_fr": "",
                      "note_adm0": "",
                      "note_brk": "",
                      "name_sort": "Kenya",
                      "name_alt": "",
                      "mapcolor7": 5,
                      "mapcolor8": 2,
                      "mapcolor9": 7,
                      "mapcolor13": 3,
                      "pop_est": 39002772,
                      "gdp_md_est": 61510,
                      "pop_year": -99,
                      "lastcensus": 2009,
                      "gdp_year": -99,
                      "economy": "5. Emerging region: G20",
                      "income_grp": "5. Low income",
                      "wikipedia": -99,
                      "fips_10": "",
                      "iso_a2": "KE",
                      "iso_a3": "KEN",
                      "iso_n3": 404,
                      "un_a3": 404,
                      "wb_a2": "KE",
                      "wb_a3": "KEN",
                      "woe_id": -99,
                      "adm0_a3_is": "KEN",
                      "adm0_a3_us": "KEN",
                      "adm0_a3_un": -99,
                      "adm0_a3_wb": -99,
                      "continent": "Africa",
                      "region_un": "Africa",
                      "subregion": "Eastern Africa",
                      "region_wb": "Sub-Saharan Africa",
                      "name_len": 5,
                      "long_len": 5,
                      "abbrev_len": 4,
                      "tiny": -99,
                      "homepart": 1
                    },
                    "arcs": [
                      [
                        [
                          145
                        ]
                      ],
                      [
                        [
                          -109,
                          146,
                          147,
                          148,
                          149,
                          150
                        ]
                      ]
                    ]
                  },
                  {
                    "type": "Polygon",
                    "properties": {
                      "scalerank": 0,
                      "featurecla": "Admin-0 map subunit",
                      "labelrank": 4,
                      "sovereignt": "Liberia",
                      "sov_a3": "LBR",
                      "adm0_dif": 0,
                      "level": 2,
                      "type": "Sovereign country",
                      "admin": "Liberia",
                      "adm0_a3": "LBR",
                      "geou_dif": 0,
                      "geounit": "Liberia",
                      "gu_a3": "LBR",
                      "su_dif": 0,
                      "subunit": "Liberia",
                      "su_a3": "LBR",
                      "brk_diff": 0,
                      "name": "Liberia",
                      "name_long": "Liberia",
                      "brk_a3": "LBR",
                      "brk_name": "Liberia",
                      "brk_group": "",
                      "abbrev": "Liberia",
                      "postal": "LR",
                      "formal_en": "Republic of Liberia",
                      "formal_fr": "",
                      "note_adm0": "",
                      "note_brk": "",
                      "name_sort": "Liberia",
                      "name_alt": "",
                      "mapcolor7": 2,
                      "mapcolor8": 3,
                      "mapcolor9": 4,
                      "mapcolor13": 9,
                      "pop_est": 3441790,
                      "gdp_md_est": 1526,
                      "pop_year": -99,
                      "lastcensus": 2008,
                      "gdp_year": -99,
                      "economy": "7. Least developed region",
                      "income_grp": "5. Low income",
                      "wikipedia": -99,
                      "fips_10": "",
                      "iso_a2": "LR",
                      "iso_a3": "LBR",
                      "iso_n3": 430,
                      "un_a3": 430,
                      "wb_a2": "LR",
                      "wb_a3": "LBR",
                      "woe_id": -99,
                      "adm0_a3_is": "LBR",
                      "adm0_a3_us": "LBR",
                      "adm0_a3_un": -99,
                      "adm0_a3_wb": -99,
                      "continent": "Africa",
                      "region_un": "Africa",
                      "subregion": "Western Africa",
                      "region_wb": "Sub-Saharan Africa",
                      "name_len": 7,
                      "long_len": 7,
                      "abbrev_len": 7,
                      "tiny": -99,
                      "homepart": 1
                    },
                    "arcs": [
                      [
                        -36,
                        151,
                        152,
                        -121
                      ]
                    ]
                  },
                  {
                    "type": "Polygon",
                    "properties": {
                      "scalerank": 0,
                      "featurecla": "Admin-0 map subunit",
                      "labelrank": 3,
                      "sovereignt": "Libya",
                      "sov_a3": "LBY",
                      "adm0_dif": 0,
                      "level": 2,
                      "type": "Sovereign country",
                      "admin": "Libya",
                      "adm0_a3": "LBY",
                      "geou_dif": 0,
                      "geounit": "Libya",
                      "gu_a3": "LBY",
                      "su_dif": 0,
                      "subunit": "Libya",
                      "su_a3": "LBY",
                      "brk_diff": 0,
                      "name": "Libya",
                      "name_long": "Libya",
                      "brk_a3": "LBY",
                      "brk_name": "Libya",
                      "brk_group": "",
                      "abbrev": "Libya",
                      "postal": "LY",
                      "formal_en": "Libya",
                      "formal_fr": "",
                      "note_adm0": "",
                      "note_brk": "",
                      "name_sort": "Libya",
                      "name_alt": "",
                      "mapcolor7": 1,
                      "mapcolor8": 2,
                      "mapcolor9": 2,
                      "mapcolor13": 11,
                      "pop_est": 6310434,
                      "gdp_md_est": 88830,
                      "pop_year": -99,
                      "lastcensus": 2006,
                      "gdp_year": -99,
                      "economy": "6. Developing region",
                      "income_grp": "3. Upper middle income",
                      "wikipedia": -99,
                      "fips_10": "",
                      "iso_a2": "LY",
                      "iso_a3": "LBY",
                      "iso_n3": 434,
                      "un_a3": 434,
                      "wb_a2": "LY",
                      "wb_a3": "LBY",
                      "woe_id": -99,
                      "adm0_a3_is": "LBY",
                      "adm0_a3_us": "LBY",
                      "adm0_a3_un": -99,
                      "adm0_a3_wb": -99,
                      "continent": "Africa",
                      "region_un": "Africa",
                      "subregion": "Northern Africa",
                      "region_wb": "Middle East & North Africa",
                      "name_len": 5,
                      "long_len": 5,
                      "abbrev_len": 5,
                      "tiny": -99,
                      "homepart": 1
                    },
                    "arcs": [
                      [
                        -91,
                        153,
                        154,
                        155,
                        -76,
                        156,
                        157
                      ]
                    ]
                  },
                  {
                    "type": "Polygon",
                    "properties": {
                      "scalerank": 0,
                      "featurecla": "Admin-0 map subunit",
                      "labelrank": 6,
                      "sovereignt": "Lesotho",
                      "sov_a3": "LSO",
                      "adm0_dif": 0,
                      "level": 2,
                      "type": "Sovereign country",
                      "admin": "Lesotho",
                      "adm0_a3": "LSO",
                      "geou_dif": 0,
                      "geounit": "Lesotho",
                      "gu_a3": "LSO",
                      "su_dif": 0,
                      "subunit": "Lesotho",
                      "su_a3": "LSO",
                      "brk_diff": 0,
                      "name": "Lesotho",
                      "name_long": "Lesotho",
                      "brk_a3": "LSO",
                      "brk_name": "Lesotho",
                      "brk_group": "",
                      "abbrev": "Les.",
                      "postal": "LS",
                      "formal_en": "Kingdom of Lesotho",
                      "formal_fr": "",
                      "note_adm0": "",
                      "note_brk": "",
                      "name_sort": "Lesotho",
                      "name_alt": "",
                      "mapcolor7": 1,
                      "mapcolor8": 5,
                      "mapcolor9": 2,
                      "mapcolor13": 8,
                      "pop_est": 2130819,
                      "gdp_md_est": 3293,
                      "pop_year": -99,
                      "lastcensus": 2006,
                      "gdp_year": -99,
                      "economy": "7. Least developed region",
                      "income_grp": "4. Lower middle income",
                      "wikipedia": -99,
                      "fips_10": "",
                      "iso_a2": "LS",
                      "iso_a3": "LSO",
                      "iso_n3": 426,
                      "un_a3": 426,
                      "wb_a2": "LS",
                      "wb_a3": "LSO",
                      "woe_id": -99,
                      "adm0_a3_is": "LSO",
                      "adm0_a3_us": "LSO",
                      "adm0_a3_un": -99,
                      "adm0_a3_wb": -99,
                      "continent": "Africa",
                      "region_un": "Africa",
                      "subregion": "Southern Africa",
                      "region_wb": "Sub-Saharan Africa",
                      "name_len": 7,
                      "long_len": 7,
                      "abbrev_len": 4,
                      "tiny": -99,
                      "homepart": 1
                    },
                    "arcs": [
                      [
                        158
                      ]
                    ]
                  },
                  {
                    "type": "Polygon",
                    "properties": {
                      "scalerank": 0,
                      "featurecla": "Admin-0 map subunit",
                      "labelrank": 3,
                      "sovereignt": "Morocco",
                      "sov_a3": "MAR",
                      "adm0_dif": 0,
                      "level": 2,
                      "type": "Sovereign country",
                      "admin": "Morocco",
                      "adm0_a3": "MAR",
                      "geou_dif": 0,
                      "geounit": "Morocco",
                      "gu_a3": "MAR",
                      "su_dif": 0,
                      "subunit": "Morocco",
                      "su_a3": "MAR",
                      "brk_diff": 0,
                      "name": "Morocco",
                      "name_long": "Morocco",
                      "brk_a3": "MAR",
                      "brk_name": "Morocco",
                      "brk_group": "",
                      "abbrev": "Mor.",
                      "postal": "MA",
                      "formal_en": "Kingdom of Morocco",
                      "formal_fr": "",
                      "note_adm0": "",
                      "note_brk": "",
                      "name_sort": "Morocco",
                      "name_alt": "",
                      "mapcolor7": 2,
                      "mapcolor8": 2,
                      "mapcolor9": 3,
                      "mapcolor13": 9,
                      "pop_est": 34859364,
                      "gdp_md_est": 136600,
                      "pop_year": -99,
                      "lastcensus": 2004,
                      "gdp_year": -99,
                      "economy": "6. Developing region",
                      "income_grp": "4. Lower middle income",
                      "wikipedia": -99,
                      "fips_10": "",
                      "iso_a2": "MA",
                      "iso_a3": "MAR",
                      "iso_n3": 504,
                      "un_a3": 504,
                      "wb_a2": "MA",
                      "wb_a3": "MAR",
                      "woe_id": -99,
                      "adm0_a3_is": "MAR",
                      "adm0_a3_us": "MAR",
                      "adm0_a3_un": -99,
                      "adm0_a3_wb": -99,
                      "continent": "Africa",
                      "region_un": "Africa",
                      "subregion": "Northern Africa",
                      "region_wb": "Middle East & North Africa",
                      "name_len": 7,
                      "long_len": 7,
                      "abbrev_len": 4,
                      "tiny": -99,
                      "homepart": 1
                    },
                    "arcs": [
                      [
                        159,
                        160,
                        161,
                        162,
                        -81,
                        163,
                        164
                      ]
                    ]
                  },
                  {
                    "type": "MultiPolygon",
                    "properties": {
                      "scalerank": 0,
                      "featurecla": "Admin-0 map subunit",
                      "labelrank": 3,
                      "sovereignt": "Madagascar",
                      "sov_a3": "MDG",
                      "adm0_dif": 0,
                      "level": 2,
                      "type": "Sovereign country",
                      "admin": "Madagascar",
                      "adm0_a3": "MDG",
                      "geou_dif": 0,
                      "geounit": "Madagascar",
                      "gu_a3": "MDG",
                      "su_dif": 0,
                      "subunit": "Madagascar",
                      "su_a3": "MDG",
                      "brk_diff": 0,
                      "name": "Madagascar",
                      "name_long": "Madagascar",
                      "brk_a3": "MDG",
                      "brk_name": "Madagascar",
                      "brk_group": "",
                      "abbrev": "Mad.",
                      "postal": "MG",
                      "formal_en": "Republic of Madagascar",
                      "formal_fr": "",
                      "note_adm0": "",
                      "note_brk": "",
                      "name_sort": "Madagascar",
                      "name_alt": "",
                      "mapcolor7": 6,
                      "mapcolor8": 5,
                      "mapcolor9": 2,
                      "mapcolor13": 3,
                      "pop_est": 20653556,
                      "gdp_md_est": 20130,
                      "pop_year": -99,
                      "lastcensus": 1993,
                      "gdp_year": -99,
                      "economy": "7. Least developed region",
                      "income_grp": "5. Low income",
                      "wikipedia": -99,
                      "fips_10": "",
                      "iso_a2": "MG",
                      "iso_a3": "MDG",
                      "iso_n3": 450,
                      "un_a3": 450,
                      "wb_a2": "MG",
                      "wb_a3": "MDG",
                      "woe_id": -99,
                      "adm0_a3_is": "MDG",
                      "adm0_a3_us": "MDG",
                      "adm0_a3_un": -99,
                      "adm0_a3_wb": -99,
                      "continent": "Africa",
                      "region_un": "Africa",
                      "subregion": "Eastern Africa",
                      "region_wb": "Sub-Saharan Africa",
                      "name_len": 10,
                      "long_len": 10,
                      "abbrev_len": 4,
                      "tiny": -99,
                      "homepart": 1
                    },
                    "arcs": [
                      [
                        [
                          165
                        ]
                      ],
                      [
                        [
                          166
                        ]
                      ],
                      [
                        [
                          167
                        ]
                      ]
                    ]
                  },
                  {
                    "type": "Polygon",
                    "properties": {
                      "scalerank": 0,
                      "featurecla": "Admin-0 map subunit",
                      "labelrank": 3,
                      "sovereignt": "Mali",
                      "sov_a3": "MLI",
                      "adm0_dif": 0,
                      "level": 2,
                      "type": "Sovereign country",
                      "admin": "Mali",
                      "adm0_a3": "MLI",
                      "geou_dif": 0,
                      "geounit": "Mali",
                      "gu_a3": "MLI",
                      "su_dif": 0,
                      "subunit": "Mali",
                      "su_a3": "MLI",
                      "brk_diff": 0,
                      "name": "Mali",
                      "name_long": "Mali",
                      "brk_a3": "MLI",
                      "brk_name": "Mali",
                      "brk_group": "",
                      "abbrev": "Mali",
                      "postal": "ML",
                      "formal_en": "Republic of Mali",
                      "formal_fr": "",
                      "note_adm0": "",
                      "note_brk": "",
                      "name_sort": "Mali",
                      "name_alt": "",
                      "mapcolor7": 1,
                      "mapcolor8": 4,
                      "mapcolor9": 1,
                      "mapcolor13": 7,
                      "pop_est": 12666987,
                      "gdp_md_est": 14590,
                      "pop_year": -99,
                      "lastcensus": 2009,
                      "gdp_year": -99,
                      "economy": "7. Least developed region",
                      "income_grp": "5. Low income",
                      "wikipedia": -99,
                      "fips_10": "",
                      "iso_a2": "ML",
                      "iso_a3": "MLI",
                      "iso_n3": 466,
                      "un_a3": 466,
                      "wb_a2": "ML",
                      "wb_a3": "MLI",
                      "woe_id": -99,
                      "adm0_a3_is": "MLI",
                      "adm0_a3_us": "MLI",
                      "adm0_a3_un": -99,
                      "adm0_a3_wb": -99,
                      "continent": "Africa",
                      "region_un": "Africa",
                      "subregion": "Western Africa",
                      "region_wb": "Sub-Saharan Africa",
                      "name_len": 4,
                      "long_len": 4,
                      "abbrev_len": 4,
                      "tiny": -99,
                      "homepart": 1
                    },
                    "arcs": [
                      [
                        -78,
                        168,
                        -21,
                        -38,
                        -120,
                        169,
                        170
                      ]
                    ]
                  },
                  {
                    "type": "MultiPolygon",
                    "properties": {
                      "scalerank": 0,
                      "featurecla": "Admin-0 map subunit",
                      "labelrank": 3,
                      "sovereignt": "Mozambique",
                      "sov_a3": "MOZ",
                      "adm0_dif": 0,
                      "level": 2,
                      "type": "Sovereign country",
                      "admin": "Mozambique",
                      "adm0_a3": "MOZ",
                      "geou_dif": 0,
                      "geounit": "Mozambique",
                      "gu_a3": "MOZ",
                      "su_dif": 0,
                      "subunit": "Mozambique",
                      "su_a3": "MOZ",
                      "brk_diff": 0,
                      "name": "Mozambique",
                      "name_long": "Mozambique",
                      "brk_a3": "MOZ",
                      "brk_name": "Mozambique",
                      "brk_group": "",
                      "abbrev": "Moz.",
                      "postal": "MZ",
                      "formal_en": "Republic of Mozambique",
                      "formal_fr": "",
                      "note_adm0": "",
                      "note_brk": "",
                      "name_sort": "Mozambique",
                      "name_alt": "",
                      "mapcolor7": 4,
                      "mapcolor8": 2,
                      "mapcolor9": 1,
                      "mapcolor13": 4,
                      "pop_est": 21669278,
                      "gdp_md_est": 18940,
                      "pop_year": -99,
                      "lastcensus": 2007,
                      "gdp_year": -99,
                      "economy": "7. Least developed region",
                      "income_grp": "5. Low income",
                      "wikipedia": -99,
                      "fips_10": "",
                      "iso_a2": "MZ",
                      "iso_a3": "MOZ",
                      "iso_n3": 508,
                      "un_a3": 508,
                      "wb_a2": "MZ",
                      "wb_a3": "MOZ",
                      "woe_id": -99,
                      "adm0_a3_is": "MOZ",
                      "adm0_a3_us": "MOZ",
                      "adm0_a3_un": -99,
                      "adm0_a3_wb": -99,
                      "continent": "Africa",
                      "region_un": "Africa",
                      "subregion": "Eastern Africa",
                      "region_wb": "Sub-Saharan Africa",
                      "name_len": 10,
                      "long_len": 10,
                      "abbrev_len": 4,
                      "tiny": -99,
                      "homepart": 1
                    },
                    "arcs": [
                      [
                        [
                          171
                        ]
                      ],
                      [
                        [
                          172
                        ]
                      ],
                      [
                        [
                          173
                        ]
                      ],
                      [
                        [
                          174,
                          175,
                          176,
                          177,
                          178,
                          179,
                          180,
                          181
                        ],
                        [
                          182
                        ],
                        [
                          183
                        ]
                      ]
                    ]
                  },
                  {
                    "type": "MultiPolygon",
                    "properties": {
                      "scalerank": 0,
                      "featurecla": "Admin-0 map subunit",
                      "labelrank": 3,
                      "sovereignt": "Mauritania",
                      "sov_a3": "MRT",
                      "adm0_dif": 0,
                      "level": 2,
                      "type": "Sovereign country",
                      "admin": "Mauritania",
                      "adm0_a3": "MRT",
                      "geou_dif": 0,
                      "geounit": "Mauritania",
                      "gu_a3": "MRT",
                      "su_dif": 0,
                      "subunit": "Mauritania",
                      "su_a3": "MRT",
                      "brk_diff": 0,
                      "name": "Mauritania",
                      "name_long": "Mauritania",
                      "brk_a3": "MRT",
                      "brk_name": "Mauritania",
                      "brk_group": "",
                      "abbrev": "Mrt.",
                      "postal": "MR",
                      "formal_en": "Islamic Republic of Mauritania",
                      "formal_fr": "",
                      "note_adm0": "",
                      "note_brk": "",
                      "name_sort": "Mauritania",
                      "name_alt": "",
                      "mapcolor7": 3,
                      "mapcolor8": 3,
                      "mapcolor9": 2,
                      "mapcolor13": 1,
                      "pop_est": 3129486,
                      "gdp_md_est": 6308,
                      "pop_year": -99,
                      "lastcensus": 2000,
                      "gdp_year": -99,
                      "economy": "7. Least developed region",
                      "income_grp": "5. Low income",
                      "wikipedia": -99,
                      "fips_10": "",
                      "iso_a2": "MR",
                      "iso_a3": "MRT",
                      "iso_n3": 478,
                      "un_a3": 478,
                      "wb_a2": "MR",
                      "wb_a3": "MRT",
                      "woe_id": -99,
                      "adm0_a3_is": "MRT",
                      "adm0_a3_us": "MRT",
                      "adm0_a3_un": -99,
                      "adm0_a3_wb": -99,
                      "continent": "Africa",
                      "region_un": "Africa",
                      "subregion": "Western Africa",
                      "region_wb": "Sub-Saharan Africa",
                      "name_len": 10,
                      "long_len": 10,
                      "abbrev_len": 4,
                      "tiny": -99,
                      "homepart": 1
                    },
                    "arcs": [
                      [
                        [
                          184
                        ]
                      ],
                      [
                        [
                          185
                        ]
                      ],
                      [
                        [
                          186
                        ]
                      ],
                      [
                        [
                          187
                        ]
                      ],
                      [
                        [
                          188,
                          189,
                          190,
                          -79,
                          -171
                        ]
                      ]
                    ]
                  },
                  {
                    "type": "MultiPolygon",
                    "properties": {
                      "scalerank": 0,
                      "featurecla": "Admin-0 map subunit",
                      "labelrank": 6,
                      "sovereignt": "Malawi",
                      "sov_a3": "MWI",
                      "adm0_dif": 0,
                      "level": 2,
                      "type": "Sovereign country",
                      "admin": "Malawi",
                      "adm0_a3": "MWI",
                      "geou_dif": 0,
                      "geounit": "Malawi",
                      "gu_a3": "MWI",
                      "su_dif": 0,
                      "subunit": "Malawi",
                      "su_a3": "MWI",
                      "brk_diff": 0,
                      "name": "Malawi",
                      "name_long": "Malawi",
                      "brk_a3": "MWI",
                      "brk_name": "Malawi",
                      "brk_group": "",
                      "abbrev": "Mal.",
                      "postal": "MW",
                      "formal_en": "Republic of Malawi",
                      "formal_fr": "",
                      "note_adm0": "",
                      "note_brk": "",
                      "name_sort": "Malawi",
                      "name_alt": "",
                      "mapcolor7": 1,
                      "mapcolor8": 3,
                      "mapcolor9": 4,
                      "mapcolor13": 5,
                      "pop_est": 14268711,
                      "gdp_md_est": 11810,
                      "pop_year": -99,
                      "lastcensus": 2008,
                      "gdp_year": -99,
                      "economy": "7. Least developed region",
                      "income_grp": "5. Low income",
                      "wikipedia": -99,
                      "fips_10": "",
                      "iso_a2": "MW",
                      "iso_a3": "MWI",
                      "iso_n3": 454,
                      "un_a3": 454,
                      "wb_a2": "MW",
                      "wb_a3": "MWI",
                      "woe_id": -99,
                      "adm0_a3_is": "MWI",
                      "adm0_a3_us": "MWI",
                      "adm0_a3_un": -99,
                      "adm0_a3_wb": -99,
                      "continent": "Africa",
                      "region_un": "Africa",
                      "subregion": "Eastern Africa",
                      "region_wb": "Sub-Saharan Africa",
                      "name_len": 6,
                      "long_len": 6,
                      "abbrev_len": 4,
                      "tiny": -99,
                      "homepart": 1
                    },
                    "arcs": [
                      [
                        [
                          -184
                        ]
                      ],
                      [
                        [
                          -183
                        ]
                      ],
                      [
                        [
                          -180,
                          191,
                          192
                        ]
                      ]
                    ]
                  },
                  {
                    "type": "MultiPolygon",
                    "properties": {
                      "scalerank": 3,
                      "featurecla": "Admin-0 map subunit",
                      "labelrank": 4,
                      "sovereignt": "France",
                      "sov_a3": "FR1",
                      "adm0_dif": 1,
                      "level": 3,
                      "type": "Geo unit",
                      "admin": "France",
                      "adm0_a3": "FRA",
                      "geou_dif": 1,
                      "geounit": "Mayotte",
                      "gu_a3": "MYT",
                      "su_dif": 0,
                      "subunit": "Mayotte",
                      "su_a3": "MYT",
                      "brk_diff": 1,
                      "name": "Mayotte",
                      "name_long": "Mayotte",
                      "brk_a3": "B22",
                      "brk_name": "Mayotte",
                      "brk_group": "",
                      "abbrev": "Myt.",
                      "postal": "YT",
                      "formal_en": "Territorial Collectivity of Mayotte",
                      "formal_fr": "",
                      "note_adm0": "Fr.",
                      "note_brk": "Admin. by France; Claimed by Comoros",
                      "name_sort": "Mayotte",
                      "name_alt": "",
                      "mapcolor7": 7,
                      "mapcolor8": 5,
                      "mapcolor9": 9,
                      "mapcolor13": 11,
                      "pop_est": 223765,
                      "gdp_md_est": 953.6,
                      "pop_year": -99,
                      "lastcensus": -99,
                      "gdp_year": -99,
                      "economy": "1. Developed region: G7",
                      "income_grp": "4. Lower middle income",
                      "wikipedia": -99,
                      "fips_10": "",
                      "iso_a2": "YT",
                      "iso_a3": "MYT",
                      "iso_n3": 175,
                      "un_a3": 175,
                      "wb_a2": -99,
                      "wb_a3": -99,
                      "woe_id": -99,
                      "adm0_a3_is": "MYT",
                      "adm0_a3_us": "FRA",
                      "adm0_a3_un": -99,
                      "adm0_a3_wb": -99,
                      "continent": "Africa",
                      "region_un": "Africa",
                      "subregion": "Eastern Africa",
                      "region_wb": "Sub-Saharan Africa",
                      "name_len": 7,
                      "long_len": 7,
                      "abbrev_len": 4,
                      "tiny": -99,
                      "homepart": -99
                    },
                    "arcs": [
                      [
                        [
                          193
                        ]
                      ],
                      [
                        [
                          194
                        ]
                      ]
                    ]
                  },
                  {
                    "type": "Polygon",
                    "properties": {
                      "scalerank": 0,
                      "featurecla": "Admin-0 map subunit",
                      "labelrank": 3,
                      "sovereignt": "Namibia",
                      "sov_a3": "NAM",
                      "adm0_dif": 0,
                      "level": 2,
                      "type": "Sovereign country",
                      "admin": "Namibia",
                      "adm0_a3": "NAM",
                      "geou_dif": 0,
                      "geounit": "Namibia",
                      "gu_a3": "NAM",
                      "su_dif": 0,
                      "subunit": "Namibia",
                      "su_a3": "NAM",
                      "brk_diff": 0,
                      "name": "Namibia",
                      "name_long": "Namibia",
                      "brk_a3": "NAM",
                      "brk_name": "Namibia",
                      "brk_group": "",
                      "abbrev": "Nam.",
                      "postal": "NA",
                      "formal_en": "Republic of Namibia",
                      "formal_fr": "",
                      "note_adm0": "",
                      "note_brk": "",
                      "name_sort": "Namibia",
                      "name_alt": "",
                      "mapcolor7": 4,
                      "mapcolor8": 1,
                      "mapcolor9": 1,
                      "mapcolor13": 7,
                      "pop_est": 2108665,
                      "gdp_md_est": 13250,
                      "pop_year": -99,
                      "lastcensus": 2001,
                      "gdp_year": -99,
                      "economy": "6. Developing region",
                      "income_grp": "3. Upper middle income",
                      "wikipedia": -99,
                      "fips_10": "",
                      "iso_a2": "NA",
                      "iso_a3": "NAM",
                      "iso_n3": 516,
                      "un_a3": 516,
                      "wb_a2": "NA",
                      "wb_a3": "NAM",
                      "woe_id": -99,
                      "adm0_a3_is": "NAM",
                      "adm0_a3_us": "NAM",
                      "adm0_a3_un": -99,
                      "adm0_a3_wb": -99,
                      "continent": "Africa",
                      "region_un": "Africa",
                      "subregion": "Southern Africa",
                      "region_wb": "Sub-Saharan Africa",
                      "name_len": 7,
                      "long_len": 7,
                      "abbrev_len": 4,
                      "tiny": -99,
                      "homepart": 1
                    },
                    "arcs": [
                      [
                        195,
                        -25,
                        196,
                        197,
                        -3
                      ]
                    ]
                  },
                  {
                    "type": "Polygon",
                    "properties": {
                      "scalerank": 0,
                      "featurecla": "Admin-0 map subunit",
                      "labelrank": 3,
                      "sovereignt": "Niger",
                      "sov_a3": "NER",
                      "adm0_dif": 0,
                      "level": 2,
                      "type": "Sovereign country",
                      "admin": "Niger",
                      "adm0_a3": "NER",
                      "geou_dif": 0,
                      "geounit": "Niger",
                      "gu_a3": "NER",
                      "su_dif": 0,
                      "subunit": "Niger",
                      "su_a3": "NER",
                      "brk_diff": 0,
                      "name": "Niger",
                      "name_long": "Niger",
                      "brk_a3": "NER",
                      "brk_name": "Niger",
                      "brk_group": "",
                      "abbrev": "Niger",
                      "postal": "NE",
                      "formal_en": "Republic of Niger",
                      "formal_fr": "",
                      "note_adm0": "",
                      "note_brk": "",
                      "name_sort": "Niger",
                      "name_alt": "",
                      "mapcolor7": 4,
                      "mapcolor8": 5,
                      "mapcolor9": 3,
                      "mapcolor13": 13,
                      "pop_est": 15306252,
                      "gdp_md_est": 10040,
                      "pop_year": -99,
                      "lastcensus": 2001,
                      "gdp_year": -99,
                      "economy": "7. Least developed region",
                      "income_grp": "5. Low income",
                      "wikipedia": -99,
                      "fips_10": "",
                      "iso_a2": "NE",
                      "iso_a3": "NER",
                      "iso_n3": 562,
                      "un_a3": 562,
                      "wb_a2": "NE",
                      "wb_a3": "NER",
                      "woe_id": -99,
                      "adm0_a3_is": "NER",
                      "adm0_a3_us": "NER",
                      "adm0_a3_un": -99,
                      "adm0_a3_wb": -99,
                      "continent": "Africa",
                      "region_un": "Africa",
                      "subregion": "Western Africa",
                      "region_wb": "Sub-Saharan Africa",
                      "name_len": 5,
                      "long_len": 5,
                      "abbrev_len": 5,
                      "tiny": -99,
                      "homepart": 1
                    },
                    "arcs": [
                      [
                        198,
                        199,
                        -16,
                        -17,
                        -169,
                        -77,
                        -156
                      ]
                    ]
                  },
                  {
                    "type": "MultiPolygon",
                    "properties": {
                      "scalerank": 0,
                      "featurecla": "Admin-0 map subunit",
                      "labelrank": 2,
                      "sovereignt": "Nigeria",
                      "sov_a3": "NGA",
                      "adm0_dif": 0,
                      "level": 2,
                      "type": "Sovereign country",
                      "admin": "Nigeria",
                      "adm0_a3": "NGA",
                      "geou_dif": 0,
                      "geounit": "Nigeria",
                      "gu_a3": "NGA",
                      "su_dif": 0,
                      "subunit": "Nigeria",
                      "su_a3": "NGA",
                      "brk_diff": 0,
                      "name": "Nigeria",
                      "name_long": "Nigeria",
                      "brk_a3": "NGA",
                      "brk_name": "Nigeria",
                      "brk_group": "",
                      "abbrev": "Nigeria",
                      "postal": "NG",
                      "formal_en": "Federal Republic of Nigeria",
                      "formal_fr": "",
                      "note_adm0": "",
                      "note_brk": "",
                      "name_sort": "Nigeria",
                      "name_alt": "",
                      "mapcolor7": 3,
                      "mapcolor8": 2,
                      "mapcolor9": 5,
                      "mapcolor13": 2,
                      "pop_est": 149229090,
                      "gdp_md_est": 335400,
                      "pop_year": -99,
                      "lastcensus": 2006,
                      "gdp_year": -99,
                      "economy": "5. Emerging region: G20",
                      "income_grp": "4. Lower middle income",
                      "wikipedia": -99,
                      "fips_10": "",
                      "iso_a2": "NG",
                      "iso_a3": "NGA",
                      "iso_n3": 566,
                      "un_a3": 566,
                      "wb_a2": "NG",
                      "wb_a3": "NGA",
                      "woe_id": -99,
                      "adm0_a3_is": "NGA",
                      "adm0_a3_us": "NGA",
                      "adm0_a3_un": -99,
                      "adm0_a3_wb": -99,
                      "continent": "Africa",
                      "region_un": "Africa",
                      "subregion": "Western Africa",
                      "region_wb": "Sub-Saharan Africa",
                      "name_len": 7,
                      "long_len": 7,
                      "abbrev_len": 7,
                      "tiny": -99,
                      "homepart": 1
                    },
                    "arcs": [
                      [
                        [
                          200
                        ]
                      ],
                      [
                        [
                          201
                        ]
                      ],
                      [
                        [
                          202,
                          -43,
                          203,
                          -12,
                          -200
                        ]
                      ]
                    ]
                  },
                  {
                    "type": "MultiPolygon",
                    "properties": {
                      "scalerank": 3,
                      "featurecla": "Admin-0 map subunit",
                      "labelrank": 6,
                      "sovereignt": "Portugal",
                      "sov_a3": "PRT",
                      "adm0_dif": 0,
                      "level": 3,
                      "type": "Geo unit",
                      "admin": "Portugal",
                      "adm0_a3": "PRT",
                      "geou_dif": 1,
                      "geounit": "Madeira",
                      "gu_a3": "PMD",
                      "su_dif": 0,
                      "subunit": "Madeira",
                      "su_a3": "PMD",
                      "brk_diff": 0,
                      "name": "Madeira",
                      "name_long": "Madeira",
                      "brk_a3": "PMD",
                      "brk_name": "Madeira",
                      "brk_group": "",
                      "abbrev": "Mad.",
                      "postal": "MD",
                      "formal_en": "",
                      "formal_fr": "",
                      "note_adm0": "Port.",
                      "note_brk": "",
                      "name_sort": "Madeira",
                      "name_alt": "",
                      "mapcolor7": 1,
                      "mapcolor8": 7,
                      "mapcolor9": 1,
                      "mapcolor13": 4,
                      "pop_est": 267785,
                      "gdp_md_est": 6414,
                      "pop_year": 0,
                      "lastcensus": -99,
                      "gdp_year": 0,
                      "economy": "2. Developed region: nonG7",
                      "income_grp": "1. High income: OECD",
                      "wikipedia": 0,
                      "fips_10": "",
                      "iso_a2": -99,
                      "iso_a3": -99,
                      "iso_n3": -99,
                      "un_a3": "-099",
                      "wb_a2": -99,
                      "wb_a3": -99,
                      "woe_id": -99,
                      "adm0_a3_is": -99,
                      "adm0_a3_us": "PRT",
                      "adm0_a3_un": -99,
                      "adm0_a3_wb": -99,
                      "continent": "Africa",
                      "region_un": "Europe",
                      "subregion": "Southern Europe",
                      "region_wb": "Europe & Central Asia",
                      "name_len": 7,
                      "long_len": 7,
                      "abbrev_len": 4,
                      "tiny": -99,
                      "homepart": -99
                    },
                    "arcs": [
                      [
                        [
                          204
                        ]
                      ],
                      [
                        [
                          205
                        ]
                      ],
                      [
                        [
                          206
                        ]
                      ],
                      [
                        [
                          207
                        ]
                      ],
                      [
                        [
                          208
                        ]
                      ]
                    ]
                  },
                  {
                    "type": "Polygon",
                    "properties": {
                      "scalerank": 0,
                      "featurecla": "Admin-0 map subunit",
                      "labelrank": 3,
                      "sovereignt": "Rwanda",
                      "sov_a3": "RWA",
                      "adm0_dif": 0,
                      "level": 2,
                      "type": "Sovereign country",
                      "admin": "Rwanda",
                      "adm0_a3": "RWA",
                      "geou_dif": 0,
                      "geounit": "Rwanda",
                      "gu_a3": "RWA",
                      "su_dif": 0,
                      "subunit": "Rwanda",
                      "su_a3": "RWA",
                      "brk_diff": 0,
                      "name": "Rwanda",
                      "name_long": "Rwanda",
                      "brk_a3": "RWA",
                      "brk_name": "Rwanda",
                      "brk_group": "",
                      "abbrev": "Rwa.",
                      "postal": "RW",
                      "formal_en": "Republic of Rwanda",
                      "formal_fr": "",
                      "note_adm0": "",
                      "note_brk": "",
                      "name_sort": "Rwanda",
                      "name_alt": "",
                      "mapcolor7": 5,
                      "mapcolor8": 2,
                      "mapcolor9": 3,
                      "mapcolor13": 10,
                      "pop_est": 10473282,
                      "gdp_md_est": 9706,
                      "pop_year": -99,
                      "lastcensus": 2002,
                      "gdp_year": -99,
                      "economy": "7. Least developed region",
                      "income_grp": "5. Low income",
                      "wikipedia": -99,
                      "fips_10": "",
                      "iso_a2": "RW",
                      "iso_a3": "RWA",
                      "iso_n3": 646,
                      "un_a3": 646,
                      "wb_a2": "RW",
                      "wb_a3": "RWA",
                      "woe_id": -99,
                      "adm0_a3_is": "RWA",
                      "adm0_a3_us": "RWA",
                      "adm0_a3_un": -99,
                      "adm0_a3_wb": -99,
                      "continent": "Africa",
                      "region_un": "Africa",
                      "subregion": "Eastern Africa",
                      "region_wb": "Sub-Saharan Africa",
                      "name_len": 6,
                      "long_len": 6,
                      "abbrev_len": 4,
                      "tiny": -99,
                      "homepart": 1
                    },
                    "arcs": [
                      [
                        209,
                        -11,
                        -52,
                        210
                      ]
                    ]
                  },
                  {
                    "type": "Polygon",
                    "properties": {
                      "scalerank": 0,
                      "featurecla": "Admin-0 map subunit",
                      "labelrank": 7,
                      "sovereignt": "Western Sahara",
                      "sov_a3": "SAH",
                      "adm0_dif": 0,
                      "level": 2,
                      "type": "Indeterminate",
                      "admin": "Western Sahara",
                      "adm0_a3": "SAH",
                      "geou_dif": 0,
                      "geounit": "Western Sahara",
                      "gu_a3": "SAH",
                      "su_dif": 0,
                      "subunit": "Western Sahara",
                      "su_a3": "SAH",
                      "brk_diff": 1,
                      "name": "W. Sahara",
                      "name_long": "Western Sahara",
                      "brk_a3": "B28",
                      "brk_name": "W. Sahara",
                      "brk_group": "",
                      "abbrev": "W. Sah.",
                      "postal": "WS",
                      "formal_en": "Sahrawi Arab Democratic Republic",
                      "formal_fr": "",
                      "note_adm0": "Self admin.",
                      "note_brk": "Self admin.; Claimed by Morocco",
                      "name_sort": "Western Sahara",
                      "name_alt": "",
                      "mapcolor7": 4,
                      "mapcolor8": 7,
                      "mapcolor9": 4,
                      "mapcolor13": 4,
                      "pop_est": -99,
                      "gdp_md_est": -99,
                      "pop_year": -99,
                      "lastcensus": -99,
                      "gdp_year": -99,
                      "economy": "7. Least developed region",
                      "income_grp": "5. Low income",
                      "wikipedia": -99,
                      "fips_10": "",
                      "iso_a2": "EH",
                      "iso_a3": "ESH",
                      "iso_n3": 732,
                      "un_a3": 732,
                      "wb_a2": -99,
                      "wb_a3": -99,
                      "woe_id": -99,
                      "adm0_a3_is": "MAR",
                      "adm0_a3_us": "SAH",
                      "adm0_a3_un": -99,
                      "adm0_a3_wb": -99,
                      "continent": "Africa",
                      "region_un": "Africa",
                      "subregion": "Northern Africa",
                      "region_wb": "Middle East & North Africa",
                      "name_len": 9,
                      "long_len": 14,
                      "abbrev_len": 7,
                      "tiny": -99,
                      "homepart": 1
                    },
                    "arcs": [
                      [
                        -80,
                        -191,
                        211,
                        -164
                      ]
                    ]
                  },
                  {
                    "type": "MultiPolygon",
                    "properties": {
                      "scalerank": 0,
                      "featurecla": "Admin-0 map subunit",
                      "labelrank": 3,
                      "sovereignt": "Sudan",
                      "sov_a3": "SDN",
                      "adm0_dif": 0,
                      "level": 2,
                      "type": "Sovereign country",
                      "admin": "Sudan",
                      "adm0_a3": "SDN",
                      "geou_dif": 0,
                      "geounit": "Sudan",
                      "gu_a3": "SDN",
                      "su_dif": 0,
                      "subunit": "Sudan",
                      "su_a3": "SDN",
                      "brk_diff": 0,
                      "name": "Sudan",
                      "name_long": "Sudan",
                      "brk_a3": "SDN",
                      "brk_name": "Sudan",
                      "brk_group": "",
                      "abbrev": "Sudan",
                      "postal": "SD",
                      "formal_en": "Republic of the Sudan",
                      "formal_fr": "",
                      "note_adm0": "",
                      "note_brk": "",
                      "name_sort": "Sudan",
                      "name_alt": "",
                      "mapcolor7": 2,
                      "mapcolor8": 6,
                      "mapcolor9": 4,
                      "mapcolor13": 1,
                      "pop_est": 25946220,
                      "gdp_md_est": 88080,
                      "pop_year": -99,
                      "lastcensus": 2008,
                      "gdp_year": -99,
                      "economy": "6. Developing region",
                      "income_grp": "4. Lower middle income",
                      "wikipedia": -99,
                      "fips_10": "",
                      "iso_a2": "SD",
                      "iso_a3": "SDN",
                      "iso_n3": 729,
                      "un_a3": 729,
                      "wb_a2": "SD",
                      "wb_a3": "SDN",
                      "woe_id": -99,
                      "adm0_a3_is": "SDN",
                      "adm0_a3_us": "SDN",
                      "adm0_a3_un": -99,
                      "adm0_a3_wb": -99,
                      "continent": "Africa",
                      "region_un": "Africa",
                      "subregion": "Northern Africa",
                      "region_wb": "Sub-Saharan Africa",
                      "name_len": 5,
                      "long_len": 5,
                      "abbrev_len": 5,
                      "tiny": -99,
                      "homepart": 1
                    },
                    "arcs": [
                      [
                        [
                          212
                        ]
                      ],
                      [
                        [
                          213,
                          -96,
                          -111,
                          214,
                          -26,
                          215,
                          -154,
                          -90
                        ]
                      ]
                    ]
                  },
                  {
                    "type": "Polygon",
                    "properties": {
                      "scalerank": 0,
                      "featurecla": "Admin-0 map subunit",
                      "labelrank": 3,
                      "sovereignt": "South Sudan",
                      "sov_a3": "SDS",
                      "adm0_dif": 0,
                      "level": 2,
                      "type": "Sovereign country",
                      "admin": "South Sudan",
                      "adm0_a3": "SDS",
                      "geou_dif": 0,
                      "geounit": "South Sudan",
                      "gu_a3": "SDS",
                      "su_dif": 0,
                      "subunit": "South Sudan",
                      "su_a3": "SDS",
                      "brk_diff": 0,
                      "name": "S. Sudan",
                      "name_long": "South Sudan",
                      "brk_a3": "SDS",
                      "brk_name": "S. Sudan",
                      "brk_group": "",
                      "abbrev": "S. Sud.",
                      "postal": "SS",
                      "formal_en": "Republic of South Sudan",
                      "formal_fr": "",
                      "note_adm0": "",
                      "note_brk": "",
                      "name_sort": "South Sudan",
                      "name_alt": "",
                      "mapcolor7": 1,
                      "mapcolor8": 3,
                      "mapcolor9": 3,
                      "mapcolor13": 5,
                      "pop_est": 10625176,
                      "gdp_md_est": 13227,
                      "pop_year": -99,
                      "lastcensus": 2008,
                      "gdp_year": -99,
                      "economy": "7. Least developed region",
                      "income_grp": "5. Low income",
                      "wikipedia": -99,
                      "fips_10": "",
                      "iso_a2": "SS",
                      "iso_a3": "SSD",
                      "iso_n3": 728,
                      "un_a3": 728,
                      "wb_a2": "SS",
                      "wb_a3": "SSD",
                      "woe_id": -99,
                      "adm0_a3_is": "SSD",
                      "adm0_a3_us": "SDS",
                      "adm0_a3_un": -99,
                      "adm0_a3_wb": -99,
                      "continent": "Africa",
                      "region_un": "Africa",
                      "subregion": "Eastern Africa",
                      "region_wb": "Sub-Saharan Africa",
                      "name_len": 8,
                      "long_len": 11,
                      "abbrev_len": 7,
                      "tiny": -99,
                      "homepart": 1
                    },
                    "arcs": [
                      [
                        -110,
                        -151,
                        216,
                        -48,
                        46,
                        -46,
                        -27,
                        -215
                      ]
                    ]
                  },
                  {
                    "type": "Polygon",
                    "properties": {
                      "scalerank": 0,
                      "featurecla": "Admin-0 map subunit",
                      "labelrank": 7,
                      "sovereignt": "Spain",
                      "sov_a3": "ESP",
                      "adm0_dif": 0,
                      "level": 4,
                      "type": "Geo subunit",
                      "admin": "Spain",
                      "adm0_a3": "ESP",
                      "geou_dif": 0,
                      "geounit": "Spain",
                      "gu_a3": "ESP",
                      "su_dif": 1,
                      "subunit": "Ceuta",
                      "su_a3": "SEC",
                      "brk_diff": 1,
                      "name": "Ceuta",
                      "name_long": "Ceuta",
                      "brk_a3": "B60",
                      "brk_name": "Ceuta",
                      "brk_group": "",
                      "abbrev": "Ceut.",
                      "postal": "CT",
                      "formal_en": "",
                      "formal_fr": "",
                      "note_adm0": "Sp.",
                      "note_brk": "",
                      "name_sort": "Ceuta",
                      "name_alt": "",
                      "mapcolor7": 4,
                      "mapcolor8": 5,
                      "mapcolor9": 5,
                      "mapcolor13": 5,
                      "pop_est": 75276,
                      "gdp_md_est": 2606.100501,
                      "pop_year": -99,
                      "lastcensus": -99,
                      "gdp_year": -99,
                      "economy": -99,
                      "income_grp": -99,
                      "wikipedia": -99,
                      "fips_10": "",
                      "iso_a2": -99,
                      "iso_a3": -99,
                      "iso_n3": -99,
                      "un_a3": "-099",
                      "wb_a2": -99,
                      "wb_a3": -99,
                      "woe_id": -99,
                      "adm0_a3_is": "ESP",
                      "adm0_a3_us": "ESP",
                      "adm0_a3_un": -99,
                      "adm0_a3_wb": -99,
                      "continent": "Africa",
                      "region_un": "Africa",
                      "subregion": "Northern Africa",
                      "region_wb": "Europe & Central Asia",
                      "name_len": 5,
                      "long_len": 5,
                      "abbrev_len": 5,
                      "tiny": -99,
                      "homepart": -99
                    },
                    "arcs": [
                      [
                        -160,
                        217
                      ]
                    ]
                  },
                  {
                    "type": "Polygon",
                    "properties": {
                      "scalerank": 0,
                      "featurecla": "Admin-0 map subunit",
                      "labelrank": 7,
                      "sovereignt": "Spain",
                      "sov_a3": "ESP",
                      "adm0_dif": 0,
                      "level": 4,
                      "type": "Geo subunit",
                      "admin": "Spain",
                      "adm0_a3": "ESP",
                      "geou_dif": 0,
                      "geounit": "Spain",
                      "gu_a3": "ESP",
                      "su_dif": 1,
                      "subunit": "Melilla",
                      "su_a3": "SEM",
                      "brk_diff": 1,
                      "name": "Melilla",
                      "name_long": "Melilla",
                      "brk_a3": "B61",
                      "brk_name": "Melilla",
                      "brk_group": "",
                      "abbrev": "Mel.",
                      "postal": "ML",
                      "formal_en": "",
                      "formal_fr": "",
                      "note_adm0": "Sp.",
                      "note_brk": "",
                      "name_sort": "Melilla",
                      "name_alt": "",
                      "mapcolor7": 4,
                      "mapcolor8": 5,
                      "mapcolor9": 5,
                      "mapcolor13": 5,
                      "pop_est": 73460,
                      "gdp_md_est": 2543.229486,
                      "pop_year": -99,
                      "lastcensus": -99,
                      "gdp_year": -99,
                      "economy": -99,
                      "income_grp": -99,
                      "wikipedia": -99,
                      "fips_10": "",
                      "iso_a2": "ES-ML",
                      "iso_a3": -99,
                      "iso_n3": -99,
                      "un_a3": "-099",
                      "wb_a2": -99,
                      "wb_a3": -99,
                      "woe_id": -99,
                      "adm0_a3_is": "ESP",
                      "adm0_a3_us": "ESP",
                      "adm0_a3_un": -99,
                      "adm0_a3_wb": -99,
                      "continent": "Africa",
                      "region_un": "Africa",
                      "subregion": "Northern Africa",
                      "region_wb": "Europe & Central Asia",
                      "name_len": 7,
                      "long_len": 7,
                      "abbrev_len": 4,
                      "tiny": -99,
                      "homepart": -99
                    },
                    "arcs": [
                      [
                        -162,
                        218
                      ]
                    ]
                  },
                  {
                    "type": "Polygon",
                    "properties": {
                      "scalerank": 0,
                      "featurecla": "Admin-0 map subunit",
                      "labelrank": 3,
                      "sovereignt": "Senegal",
                      "sov_a3": "SEN",
                      "adm0_dif": 0,
                      "level": 2,
                      "type": "Sovereign country",
                      "admin": "Senegal",
                      "adm0_a3": "SEN",
                      "geou_dif": 0,
                      "geounit": "Senegal",
                      "gu_a3": "SEN",
                      "su_dif": 0,
                      "subunit": "Senegal",
                      "su_a3": "SEN",
                      "brk_diff": 0,
                      "name": "Senegal",
                      "name_long": "Senegal",
                      "brk_a3": "SEN",
                      "brk_name": "Senegal",
                      "brk_group": "",
                      "abbrev": "Sen.",
                      "postal": "SN",
                      "formal_en": "Republic of Senegal",
                      "formal_fr": "",
                      "note_adm0": "",
                      "note_brk": "",
                      "name_sort": "Senegal",
                      "name_alt": "",
                      "mapcolor7": 2,
                      "mapcolor8": 6,
                      "mapcolor9": 5,
                      "mapcolor13": 5,
                      "pop_est": 13711597,
                      "gdp_md_est": 21980,
                      "pop_year": -99,
                      "lastcensus": 2002,
                      "gdp_year": -99,
                      "economy": "7. Least developed region",
                      "income_grp": "4. Lower middle income",
                      "wikipedia": -99,
                      "fips_10": "",
                      "iso_a2": "SN",
                      "iso_a3": "SEN",
                      "iso_n3": 686,
                      "un_a3": 686,
                      "wb_a2": "SN",
                      "wb_a3": "SEN",
                      "woe_id": -99,
                      "adm0_a3_is": "SEN",
                      "adm0_a3_us": "SEN",
                      "adm0_a3_un": -99,
                      "adm0_a3_wb": -99,
                      "continent": "Africa",
                      "region_un": "Africa",
                      "subregion": "Western Africa",
                      "region_wb": "Sub-Saharan Africa",
                      "name_len": 7,
                      "long_len": 7,
                      "abbrev_len": 4,
                      "tiny": -99,
                      "homepart": 1
                    },
                    "arcs": [
                      [
                        -170,
                        -125,
                        -142,
                        219,
                        -127,
                        220,
                        -189
                      ]
                    ]
                  },
                  {
                    "type": "MultiPolygon",
                    "properties": {
                      "scalerank": 0,
                      "featurecla": "Admin-0 map subunit",
                      "labelrank": 4,
                      "sovereignt": "Sierra Leone",
                      "sov_a3": "SLE",
                      "adm0_dif": 0,
                      "level": 2,
                      "type": "Sovereign country",
                      "admin": "Sierra Leone",
                      "adm0_a3": "SLE",
                      "geou_dif": 0,
                      "geounit": "Sierra Leone",
                      "gu_a3": "SLE",
                      "su_dif": 0,
                      "subunit": "Sierra Leone",
                      "su_a3": "SLE",
                      "brk_diff": 0,
                      "name": "Sierra Leone",
                      "name_long": "Sierra Leone",
                      "brk_a3": "SLE",
                      "brk_name": "Sierra Leone",
                      "brk_group": "",
                      "abbrev": "S.L.",
                      "postal": "SL",
                      "formal_en": "Republic of Sierra Leone",
                      "formal_fr": "",
                      "note_adm0": "",
                      "note_brk": "",
                      "name_sort": "Sierra Leone",
                      "name_alt": "",
                      "mapcolor7": 1,
                      "mapcolor8": 4,
                      "mapcolor9": 1,
                      "mapcolor13": 7,
                      "pop_est": 6440053,
                      "gdp_md_est": 4285,
                      "pop_year": -99,
                      "lastcensus": 2004,
                      "gdp_year": -99,
                      "economy": "7. Least developed region",
                      "income_grp": "5. Low income",
                      "wikipedia": -99,
                      "fips_10": "",
                      "iso_a2": "SL",
                      "iso_a3": "SLE",
                      "iso_n3": 694,
                      "un_a3": 694,
                      "wb_a2": "SL",
                      "wb_a3": "SLE",
                      "woe_id": -99,
                      "adm0_a3_is": "SLE",
                      "adm0_a3_us": "SLE",
                      "adm0_a3_un": -99,
                      "adm0_a3_wb": -99,
                      "continent": "Africa",
                      "region_un": "Africa",
                      "subregion": "Western Africa",
                      "region_wb": "Sub-Saharan Africa",
                      "name_len": 12,
                      "long_len": 12,
                      "abbrev_len": 4,
                      "tiny": -99,
                      "homepart": 1
                    },
                    "arcs": [
                      [
                        [
                          221
                        ]
                      ],
                      [
                        [
                          -153,
                          222,
                          -122
                        ]
                      ]
                    ]
                  },
                  {
                    "type": "Polygon",
                    "properties": {
                      "scalerank": 0,
                      "featurecla": "Admin-0 map subunit",
                      "labelrank": 5,
                      "sovereignt": "Somaliland",
                      "sov_a3": "SOL",
                      "adm0_dif": 0,
                      "level": 2,
                      "type": "Indeterminate",
                      "admin": "Somaliland",
                      "adm0_a3": "SOL",
                      "geou_dif": 0,
                      "geounit": "Somaliland",
                      "gu_a3": "SOL",
                      "su_dif": 0,
                      "subunit": "Somaliland",
                      "su_a3": "SOL",
                      "brk_diff": 1,
                      "name": "Somaliland",
                      "name_long": "Somaliland",
                      "brk_a3": "B30",
                      "brk_name": "Somaliland",
                      "brk_group": "",
                      "abbrev": "Solnd.",
                      "postal": "SL",
                      "formal_en": "Republic of Somaliland",
                      "formal_fr": "",
                      "note_adm0": "Self admin.",
                      "note_brk": "Self admin.; Claimed by Somalia",
                      "name_sort": "Somaliland",
                      "name_alt": "",
                      "mapcolor7": 3,
                      "mapcolor8": 6,
                      "mapcolor9": 5,
                      "mapcolor13": 2,
                      "pop_est": 3500000,
                      "gdp_md_est": 12250,
                      "pop_year": -99,
                      "lastcensus": -99,
                      "gdp_year": -99,
                      "economy": "6. Developing region",
                      "income_grp": "4. Lower middle income",
                      "wikipedia": -99,
                      "fips_10": "",
                      "iso_a2": -99,
                      "iso_a3": -99,
                      "iso_n3": -99,
                      "un_a3": "-099",
                      "wb_a2": -99,
                      "wb_a3": -99,
                      "woe_id": -99,
                      "adm0_a3_is": "SOM",
                      "adm0_a3_us": "SOM",
                      "adm0_a3_un": -99,
                      "adm0_a3_wb": -99,
                      "continent": "Africa",
                      "region_un": "Africa",
                      "subregion": "Eastern Africa",
                      "region_wb": "Sub-Saharan Africa",
                      "name_len": 10,
                      "long_len": 10,
                      "abbrev_len": 6,
                      "tiny": -99,
                      "homepart": 1
                    },
                    "arcs": [
                      [
                        223,
                        -106,
                        -71,
                        224
                      ]
                    ]
                  },
                  {
                    "type": "Polygon",
                    "properties": {
                      "scalerank": 0,
                      "featurecla": "Admin-0 map subunit",
                      "labelrank": 2,
                      "sovereignt": "Somalia",
                      "sov_a3": "SOM",
                      "adm0_dif": 0,
                      "level": 3,
                      "type": "Geo unit",
                      "admin": "Somalia",
                      "adm0_a3": "SOM",
                      "geou_dif": 1,
                      "geounit": "Puntland",
                      "gu_a3": "SOP",
                      "su_dif": 0,
                      "subunit": "Puntland",
                      "su_a3": "SOP",
                      "brk_diff": 0,
                      "name": "Puntland",
                      "name_long": "Puntland",
                      "brk_a3": "SOP",
                      "brk_name": "Puntland",
                      "brk_group": "",
                      "abbrev": "Punt.",
                      "postal": "PL",
                      "formal_en": "Puntland State of Somalia",
                      "formal_fr": "",
                      "note_adm0": "Somalia",
                      "note_brk": "",
                      "name_sort": "Puntland",
                      "name_alt": "",
                      "mapcolor7": 2,
                      "mapcolor8": 8,
                      "mapcolor9": 6,
                      "mapcolor13": 7,
                      "pop_est": 3900000,
                      "gdp_md_est": 2191.167896,
                      "pop_year": 0,
                      "lastcensus": -99,
                      "gdp_year": 2012,
                      "economy": "7. Least developed region",
                      "income_grp": "5. Low income",
                      "wikipedia": 0,
                      "fips_10": "",
                      "iso_a2": -99,
                      "iso_a3": -99,
                      "iso_n3": -99,
                      "un_a3": "-099",
                      "wb_a2": -99,
                      "wb_a3": -99,
                      "woe_id": -99,
                      "adm0_a3_is": "SOM",
                      "adm0_a3_us": "SOM",
                      "adm0_a3_un": -99,
                      "adm0_a3_wb": -99,
                      "continent": "Africa",
                      "region_un": "Africa",
                      "subregion": "Eastern Africa",
                      "region_wb": "Sub-Saharan Africa",
                      "name_len": 8,
                      "long_len": 8,
                      "abbrev_len": 5,
                      "tiny": -99,
                      "homepart": -99
                    },
                    "arcs": [
                      [
                        225,
                        -107,
                        -224,
                        226
                      ]
                    ]
                  },
                  {
                    "type": "Polygon",
                    "properties": {
                      "scalerank": 0,
                      "featurecla": "Admin-0 map subunit",
                      "labelrank": 3,
                      "sovereignt": "Somalia",
                      "sov_a3": "SOM",
                      "adm0_dif": 0,
                      "level": 3,
                      "type": "Geo unit",
                      "admin": "Somalia",
                      "adm0_a3": "SOM",
                      "geou_dif": 1,
                      "geounit": "Somalia",
                      "gu_a3": "SOX",
                      "su_dif": 0,
                      "subunit": "Somalia",
                      "su_a3": "SOX",
                      "brk_diff": 0,
                      "name": "Somalia",
                      "name_long": "Somalia",
                      "brk_a3": "SOX",
                      "brk_name": "Somalia",
                      "brk_group": "",
                      "abbrev": "Som.",
                      "postal": "SO",
                      "formal_en": "",
                      "formal_fr": "",
                      "note_adm0": "",
                      "note_brk": "",
                      "name_sort": "Somalia",
                      "name_alt": "",
                      "mapcolor7": 2,
                      "mapcolor8": 8,
                      "mapcolor9": 6,
                      "mapcolor13": 7,
                      "pop_est": 5932017,
                      "gdp_md_est": 3332.832104,
                      "pop_year": 2012,
                      "lastcensus": -99,
                      "gdp_year": 2012,
                      "economy": "7. Least developed region",
                      "income_grp": "5. Low income",
                      "wikipedia": -99,
                      "fips_10": "",
                      "iso_a2": -99,
                      "iso_a3": -99,
                      "iso_n3": -99,
                      "un_a3": "-099",
                      "wb_a2": -99,
                      "wb_a3": -99,
                      "woe_id": -99,
                      "adm0_a3_is": "SOM",
                      "adm0_a3_us": "SOM",
                      "adm0_a3_un": -99,
                      "adm0_a3_wb": -99,
                      "continent": "Africa",
                      "region_un": "Africa",
                      "subregion": "Eastern Africa",
                      "region_wb": "Sub-Saharan Africa",
                      "name_len": 7,
                      "long_len": 7,
                      "abbrev_len": 4,
                      "tiny": -99,
                      "homepart": 1
                    },
                    "arcs": [
                      [
                        227,
                        -147,
                        -108,
                        -226
                      ]
                    ]
                  },
                  {
                    "type": "Polygon",
                    "properties": {
                      "scalerank": 3,
                      "featurecla": "Admin-0 map subunit",
                      "labelrank": 6,
                      "sovereignt": "Sao Tome and Principe",
                      "sov_a3": "STP",
                      "adm0_dif": 0,
                      "level": 4,
                      "type": "Geo subunit",
                      "admin": "Sao Tome and Principe",
                      "adm0_a3": "STP",
                      "geou_dif": 0,
                      "geounit": "Sao Tome and Principe",
                      "gu_a3": "STP",
                      "su_dif": 1,
                      "subunit": "Principe",
                      "su_a3": "STA",
                      "brk_diff": 0,
                      "name": "Principe",
                      "name_long": "Principe",
                      "brk_a3": "STA",
                      "brk_name": "Principe",
                      "brk_group": "",
                      "abbrev": "Prin.",
                      "postal": "PR",
                      "formal_en": "",
                      "formal_fr": "",
                      "note_adm0": "",
                      "note_brk": "",
                      "name_sort": "Principe",
                      "name_alt": "",
                      "mapcolor7": 1,
                      "mapcolor8": 6,
                      "mapcolor9": 1,
                      "mapcolor13": 7,
                      "pop_est": 5000,
                      "gdp_md_est": 6.500407,
                      "pop_year": -99,
                      "lastcensus": -99,
                      "gdp_year": 0,
                      "economy": -99,
                      "income_grp": -99,
                      "wikipedia": 0,
                      "fips_10": "",
                      "iso_a2": -99,
                      "iso_a3": -99,
                      "iso_n3": -99,
                      "un_a3": "-099",
                      "wb_a2": -99,
                      "wb_a3": -99,
                      "woe_id": -99,
                      "adm0_a3_is": "STP",
                      "adm0_a3_us": "STP",
                      "adm0_a3_un": -99,
                      "adm0_a3_wb": -99,
                      "continent": "Africa",
                      "region_un": "Africa",
                      "subregion": "Middle Africa",
                      "region_wb": "Sub-Saharan Africa",
                      "name_len": 8,
                      "long_len": 8,
                      "abbrev_len": 5,
                      "tiny": -99,
                      "homepart": 1
                    },
                    "arcs": [
                      [
                        228
                      ]
                    ]
                  },
                  {
                    "type": "Polygon",
                    "properties": {
                      "scalerank": 3,
                      "featurecla": "Admin-0 map subunit",
                      "labelrank": 6,
                      "sovereignt": "Sao Tome and Principe",
                      "sov_a3": "STP",
                      "adm0_dif": 0,
                      "level": 4,
                      "type": "Geo subunit",
                      "admin": "Sao Tome and Principe",
                      "adm0_a3": "STP",
                      "geou_dif": 0,
                      "geounit": "Sao Tome and Principe",
                      "gu_a3": "STP",
                      "su_dif": 1,
                      "subunit": "Sao Tome",
                      "su_a3": "STS",
                      "brk_diff": 0,
                      "name": "Sao Tome",
                      "name_long": "Sao Tome",
                      "brk_a3": "STS",
                      "brk_name": "Sao Tome",
                      "brk_group": "",
                      "abbrev": "SaoT.",
                      "postal": "ST",
                      "formal_en": "",
                      "formal_fr": "",
                      "note_adm0": "",
                      "note_brk": "",
                      "name_sort": "Sao Tome",
                      "name_alt": "",
                      "mapcolor7": 1,
                      "mapcolor8": 6,
                      "mapcolor9": 1,
                      "mapcolor13": 7,
                      "pop_est": 157000,
                      "gdp_md_est": 204.112771,
                      "pop_year": -99,
                      "lastcensus": -99,
                      "gdp_year": 0,
                      "economy": -99,
                      "income_grp": -99,
                      "wikipedia": 0,
                      "fips_10": "",
                      "iso_a2": -99,
                      "iso_a3": -99,
                      "iso_n3": -99,
                      "un_a3": "-099",
                      "wb_a2": -99,
                      "wb_a3": -99,
                      "woe_id": -99,
                      "adm0_a3_is": "STP",
                      "adm0_a3_us": "STP",
                      "adm0_a3_un": -99,
                      "adm0_a3_wb": -99,
                      "continent": "Africa",
                      "region_un": "Africa",
                      "subregion": "Middle Africa",
                      "region_wb": "Sub-Saharan Africa",
                      "name_len": 8,
                      "long_len": 8,
                      "abbrev_len": 5,
                      "tiny": -99,
                      "homepart": 1
                    },
                    "arcs": [
                      [
                        229
                      ]
                    ]
                  },
                  {
                    "type": "Polygon",
                    "properties": {
                      "scalerank": 0,
                      "featurecla": "Admin-0 map subunit",
                      "labelrank": 4,
                      "sovereignt": "Swaziland",
                      "sov_a3": "SWZ",
                      "adm0_dif": 0,
                      "level": 2,
                      "type": "Sovereign country",
                      "admin": "Swaziland",
                      "adm0_a3": "SWZ",
                      "geou_dif": 0,
                      "geounit": "Swaziland",
                      "gu_a3": "SWZ",
                      "su_dif": 0,
                      "subunit": "Swaziland",
                      "su_a3": "SWZ",
                      "brk_diff": 0,
                      "name": "Swaziland",
                      "name_long": "Swaziland",
                      "brk_a3": "SWZ",
                      "brk_name": "Swaziland",
                      "brk_group": "",
                      "abbrev": "Swz.",
                      "postal": "SW",
                      "formal_en": "Kingdom of Swaziland",
                      "formal_fr": "",
                      "note_adm0": "",
                      "note_brk": "",
                      "name_sort": "Swaziland",
                      "name_alt": "",
                      "mapcolor7": 3,
                      "mapcolor8": 6,
                      "mapcolor9": 2,
                      "mapcolor13": 5,
                      "pop_est": 1123913,
                      "gdp_md_est": 5702,
                      "pop_year": -99,
                      "lastcensus": 2007,
                      "gdp_year": -99,
                      "economy": "6. Developing region",
                      "income_grp": "4. Lower middle income",
                      "wikipedia": -99,
                      "fips_10": "",
                      "iso_a2": "SZ",
                      "iso_a3": "SWZ",
                      "iso_n3": 748,
                      "un_a3": 748,
                      "wb_a2": "SZ",
                      "wb_a3": "SWZ",
                      "woe_id": -99,
                      "adm0_a3_is": "SWZ",
                      "adm0_a3_us": "SWZ",
                      "adm0_a3_un": -99,
                      "adm0_a3_wb": -99,
                      "continent": "Africa",
                      "region_un": "Africa",
                      "subregion": "Southern Africa",
                      "region_wb": "Sub-Saharan Africa",
                      "name_len": 9,
                      "long_len": 9,
                      "abbrev_len": 4,
                      "tiny": -99,
                      "homepart": 1
                    },
                    "arcs": [
                      [
                        -176,
                        230
                      ]
                    ]
                  },
                  {
                    "type": "Polygon",
                    "properties": {
                      "scalerank": 0,
                      "featurecla": "Admin-0 map subunit",
                      "labelrank": 3,
                      "sovereignt": "Chad",
                      "sov_a3": "TCD",
                      "adm0_dif": 0,
                      "level": 2,
                      "type": "Sovereign country",
                      "admin": "Chad",
                      "adm0_a3": "TCD",
                      "geou_dif": 0,
                      "geounit": "Chad",
                      "gu_a3": "TCD",
                      "su_dif": 0,
                      "subunit": "Chad",
                      "su_a3": "TCD",
                      "brk_diff": 0,
                      "name": "Chad",
                      "name_long": "Chad",
                      "brk_a3": "TCD",
                      "brk_name": "Chad",
                      "brk_group": "",
                      "abbrev": "Chad",
                      "postal": "TD",
                      "formal_en": "Republic of Chad",
                      "formal_fr": "",
                      "note_adm0": "",
                      "note_brk": "",
                      "name_sort": "Chad",
                      "name_alt": "",
                      "mapcolor7": 6,
                      "mapcolor8": 1,
                      "mapcolor9": 8,
                      "mapcolor13": 6,
                      "pop_est": 10329208,
                      "gdp_md_est": 15860,
                      "pop_year": -99,
                      "lastcensus": 2009,
                      "gdp_year": -99,
                      "economy": "7. Least developed region",
                      "income_grp": "5. Low income",
                      "wikipedia": -99,
                      "fips_10": "",
                      "iso_a2": "TD",
                      "iso_a3": "TCD",
                      "iso_n3": 148,
                      "un_a3": 148,
                      "wb_a2": "TD",
                      "wb_a3": "TCD",
                      "woe_id": -99,
                      "adm0_a3_is": "TCD",
                      "adm0_a3_us": "TCD",
                      "adm0_a3_un": -99,
                      "adm0_a3_wb": -99,
                      "continent": "Africa",
                      "region_un": "Africa",
                      "subregion": "Middle Africa",
                      "region_wb": "Sub-Saharan Africa",
                      "name_len": 4,
                      "long_len": 4,
                      "abbrev_len": 4,
                      "tiny": -99,
                      "homepart": 1
                    },
                    "arcs": [
                      [
                        -216,
                        -31,
                        -44,
                        -203,
                        -199,
                        -155
                      ]
                    ]
                  },
                  {
                    "type": "Polygon",
                    "properties": {
                      "scalerank": 0,
                      "featurecla": "Admin-0 map subunit",
                      "labelrank": 6,
                      "sovereignt": "Togo",
                      "sov_a3": "TGO",
                      "adm0_dif": 0,
                      "level": 2,
                      "type": "Sovereign country",
                      "admin": "Togo",
                      "adm0_a3": "TGO",
                      "geou_dif": 0,
                      "geounit": "Togo",
                      "gu_a3": "TGO",
                      "su_dif": 0,
                      "subunit": "Togo",
                      "su_a3": "TGO",
                      "brk_diff": 0,
                      "name": "Togo",
                      "name_long": "Togo",
                      "brk_a3": "TGO",
                      "brk_name": "Togo",
                      "brk_group": "",
                      "abbrev": "Togo",
                      "postal": "TG",
                      "formal_en": "Togolese Republic",
                      "formal_fr": "R�publique Togolaise",
                      "note_adm0": "",
                      "note_brk": "",
                      "name_sort": "Togo",
                      "name_alt": "",
                      "mapcolor7": 3,
                      "mapcolor8": 1,
                      "mapcolor9": 3,
                      "mapcolor13": 5,
                      "pop_est": 6019877,
                      "gdp_md_est": 5118,
                      "pop_year": -99,
                      "lastcensus": 2010,
                      "gdp_year": -99,
                      "economy": "7. Least developed region",
                      "income_grp": "5. Low income",
                      "wikipedia": -99,
                      "fips_10": "",
                      "iso_a2": "TG",
                      "iso_a3": "TGO",
                      "iso_n3": 768,
                      "un_a3": 768,
                      "wb_a2": "TG",
                      "wb_a3": "TGO",
                      "woe_id": -99,
                      "adm0_a3_is": "TGO",
                      "adm0_a3_us": "TGO",
                      "adm0_a3_un": -99,
                      "adm0_a3_wb": -99,
                      "continent": "Africa",
                      "region_un": "Africa",
                      "subregion": "Western Africa",
                      "region_wb": "Sub-Saharan Africa",
                      "name_len": 4,
                      "long_len": 4,
                      "abbrev_len": 4,
                      "tiny": -99,
                      "homepart": 1
                    },
                    "arcs": [
                      [
                        -14,
                        231,
                        -117,
                        -18
                      ]
                    ]
                  },
                  {
                    "type": "MultiPolygon",
                    "properties": {
                      "scalerank": 0,
                      "featurecla": "Admin-0 map subunit",
                      "labelrank": 3,
                      "sovereignt": "Tunisia",
                      "sov_a3": "TUN",
                      "adm0_dif": 0,
                      "level": 2,
                      "type": "Sovereign country",
                      "admin": "Tunisia",
                      "adm0_a3": "TUN",
                      "geou_dif": 0,
                      "geounit": "Tunisia",
                      "gu_a3": "TUN",
                      "su_dif": 0,
                      "subunit": "Tunisia",
                      "su_a3": "TUN",
                      "brk_diff": 0,
                      "name": "Tunisia",
                      "name_long": "Tunisia",
                      "brk_a3": "TUN",
                      "brk_name": "Tunisia",
                      "brk_group": "",
                      "abbrev": "Tun.",
                      "postal": "TN",
                      "formal_en": "Republic of Tunisia",
                      "formal_fr": "",
                      "note_adm0": "",
                      "note_brk": "",
                      "name_sort": "Tunisia",
                      "name_alt": "",
                      "mapcolor7": 4,
                      "mapcolor8": 3,
                      "mapcolor9": 3,
                      "mapcolor13": 2,
                      "pop_est": 10486339,
                      "gdp_md_est": 81710,
                      "pop_year": -99,
                      "lastcensus": 2004,
                      "gdp_year": -99,
                      "economy": "6. Developing region",
                      "income_grp": "3. Upper middle income",
                      "wikipedia": -99,
                      "fips_10": "",
                      "iso_a2": "TN",
                      "iso_a3": "TUN",
                      "iso_n3": 788,
                      "un_a3": 788,
                      "wb_a2": "TN",
                      "wb_a3": "TUN",
                      "woe_id": -99,
                      "adm0_a3_is": "TUN",
                      "adm0_a3_us": "TUN",
                      "adm0_a3_un": -99,
                      "adm0_a3_wb": -99,
                      "continent": "Africa",
                      "region_un": "Africa",
                      "subregion": "Northern Africa",
                      "region_wb": "Middle East & North Africa",
                      "name_len": 7,
                      "long_len": 7,
                      "abbrev_len": 4,
                      "tiny": -99,
                      "homepart": 1
                    },
                    "arcs": [
                      [
                        [
                          232
                        ]
                      ],
                      [
                        [
                          233
                        ]
                      ],
                      [
                        [
                          234
                        ]
                      ],
                      [
                        [
                          -157,
                          -75,
                          235
                        ]
                      ]
                    ]
                  },
                  {
                    "type": "MultiPolygon",
                    "properties": {
                      "scalerank": 0,
                      "featurecla": "Admin-0 map subunit",
                      "labelrank": 3,
                      "sovereignt": "United Republic of Tanzania",
                      "sov_a3": "TZA",
                      "adm0_dif": 0,
                      "level": 2,
                      "type": "Sovereign country",
                      "admin": "United Republic of Tanzania",
                      "adm0_a3": "TZA",
                      "geou_dif": 0,
                      "geounit": "Tanzania",
                      "gu_a3": "TZA",
                      "su_dif": 0,
                      "subunit": "Tanzania",
                      "su_a3": "TZA",
                      "brk_diff": 0,
                      "name": "Tanzania",
                      "name_long": "Tanzania",
                      "brk_a3": "TZA",
                      "brk_name": "Tanzania",
                      "brk_group": "",
                      "abbrev": "Tanz.",
                      "postal": "TZ",
                      "formal_en": "United Republic of Tanzania",
                      "formal_fr": "",
                      "note_adm0": "",
                      "note_brk": "",
                      "name_sort": "Tanzania",
                      "name_alt": "",
                      "mapcolor7": 3,
                      "mapcolor8": 6,
                      "mapcolor9": 2,
                      "mapcolor13": 2,
                      "pop_est": 41048532,
                      "gdp_md_est": 54250,
                      "pop_year": -99,
                      "lastcensus": 2002,
                      "gdp_year": -99,
                      "economy": "7. Least developed region",
                      "income_grp": "5. Low income",
                      "wikipedia": -99,
                      "fips_10": "",
                      "iso_a2": "TZ",
                      "iso_a3": "TZA",
                      "iso_n3": 834,
                      "un_a3": 834,
                      "wb_a2": "TZ",
                      "wb_a3": "TZA",
                      "woe_id": -99,
                      "adm0_a3_is": "TZA",
                      "adm0_a3_us": "TZA",
                      "adm0_a3_un": -99,
                      "adm0_a3_wb": -99,
                      "continent": "Africa",
                      "region_un": "Africa",
                      "subregion": "Eastern Africa",
                      "region_wb": "Sub-Saharan Africa",
                      "name_len": 8,
                      "long_len": 8,
                      "abbrev_len": 5,
                      "tiny": -99,
                      "homepart": 1
                    },
                    "arcs": [
                      [
                        [
                          236
                        ]
                      ],
                      [
                        [
                          237
                        ]
                      ],
                      [
                        [
                          -149,
                          238,
                          -181,
                          -193,
                          239,
                          -53,
                          -9,
                          -210,
                          240
                        ]
                      ]
                    ]
                  },
                  {
                    "type": "MultiPolygon",
                    "properties": {
                      "scalerank": 3,
                      "featurecla": "Admin-0 map subunit",
                      "labelrank": 7,
                      "sovereignt": "United Republic of Tanzania",
                      "sov_a3": "TZA",
                      "adm0_dif": 0,
                      "level": 3,
                      "type": "Geo unit",
                      "admin": "United Republic of Tanzania",
                      "adm0_a3": "TZA",
                      "geou_dif": 1,
                      "geounit": "Zanzibar",
                      "gu_a3": "TZZ",
                      "su_dif": 0,
                      "subunit": "Zanzibar",
                      "su_a3": "TZZ",
                      "brk_diff": 0,
                      "name": "Zanzibar",
                      "name_long": "Zanzibar",
                      "brk_a3": "TZZ",
                      "brk_name": "Zanzibar",
                      "brk_group": "",
                      "abbrev": "Zan.",
                      "postal": "ZA",
                      "formal_en": "",
                      "formal_fr": "",
                      "note_adm0": "Tanz.",
                      "note_brk": "",
                      "name_sort": "Zanzibar",
                      "name_alt": "",
                      "mapcolor7": 3,
                      "mapcolor8": 6,
                      "mapcolor9": 2,
                      "mapcolor13": 2,
                      "pop_est": 1070000,
                      "gdp_md_est": 235.4,
                      "pop_year": 0,
                      "lastcensus": -99,
                      "gdp_year": 0,
                      "economy": "7. Least developed region",
                      "income_grp": "5. Low income",
                      "wikipedia": 0,
                      "fips_10": "",
                      "iso_a2": -99,
                      "iso_a3": -99,
                      "iso_n3": -99,
                      "un_a3": "-099",
                      "wb_a2": -99,
                      "wb_a3": -99,
                      "woe_id": -99,
                      "adm0_a3_is": "TZA",
                      "adm0_a3_us": "TZA",
                      "adm0_a3_un": -99,
                      "adm0_a3_wb": -99,
                      "continent": "Africa",
                      "region_un": "Africa",
                      "subregion": "Eastern Africa",
                      "region_wb": "Sub-Saharan Africa",
                      "name_len": 8,
                      "long_len": 8,
                      "abbrev_len": 4,
                      "tiny": -99,
                      "homepart": -99
                    },
                    "arcs": [
                      [
                        [
                          241
                        ]
                      ],
                      [
                        [
                          242
                        ]
                      ],
                      [
                        [
                          243
                        ]
                      ],
                      [
                        [
                          244
                        ]
                      ]
                    ]
                  },
                  {
                    "type": "Polygon",
                    "properties": {
                      "scalerank": 0,
                      "featurecla": "Admin-0 map subunit",
                      "labelrank": 3,
                      "sovereignt": "Uganda",
                      "sov_a3": "UGA",
                      "adm0_dif": 0,
                      "level": 2,
                      "type": "Sovereign country",
                      "admin": "Uganda",
                      "adm0_a3": "UGA",
                      "geou_dif": 0,
                      "geounit": "Uganda",
                      "gu_a3": "UGA",
                      "su_dif": 0,
                      "subunit": "Uganda",
                      "su_a3": "UGA",
                      "brk_diff": 0,
                      "name": "Uganda",
                      "name_long": "Uganda",
                      "brk_a3": "UGA",
                      "brk_name": "Uganda",
                      "brk_group": "",
                      "abbrev": "Uga.",
                      "postal": "UG",
                      "formal_en": "Republic of Uganda",
                      "formal_fr": "",
                      "note_adm0": "",
                      "note_brk": "",
                      "name_sort": "Uganda",
                      "name_alt": "",
                      "mapcolor7": 6,
                      "mapcolor8": 3,
                      "mapcolor9": 6,
                      "mapcolor13": 4,
                      "pop_est": 32369558,
                      "gdp_md_est": 39380,
                      "pop_year": -99,
                      "lastcensus": 2002,
                      "gdp_year": -99,
                      "economy": "7. Least developed region",
                      "income_grp": "5. Low income",
                      "wikipedia": -99,
                      "fips_10": "",
                      "iso_a2": "UG",
                      "iso_a3": "UGA",
                      "iso_n3": 800,
                      "un_a3": 800,
                      "wb_a2": "UG",
                      "wb_a3": "UGA",
                      "woe_id": -99,
                      "adm0_a3_is": "UGA",
                      "adm0_a3_us": "UGA",
                      "adm0_a3_un": -99,
                      "adm0_a3_wb": -99,
                      "continent": "Africa",
                      "region_un": "Africa",
                      "subregion": "Eastern Africa",
                      "region_wb": "Sub-Saharan Africa",
                      "name_len": 6,
                      "long_len": 6,
                      "abbrev_len": 4,
                      "tiny": -99,
                      "homepart": 1
                    },
                    "arcs": [
                      [
                        -241,
                        -211,
                        -51,
                        49,
                        -49,
                        -217,
                        -150
                      ]
                    ]
                  },
                  {
                    "type": "Polygon",
                    "properties": {
                      "scalerank": 0,
                      "featurecla": "Admin-0 map subunit",
                      "labelrank": 2,
                      "sovereignt": "South Africa",
                      "sov_a3": "ZAF",
                      "adm0_dif": 0,
                      "level": 4,
                      "type": "Geo subunit",
                      "admin": "South Africa",
                      "adm0_a3": "ZAF",
                      "geou_dif": 0,
                      "geounit": "South Africa",
                      "gu_a3": "ZAF",
                      "su_dif": 1,
                      "subunit": "South Africa",
                      "su_a3": "ZAX",
                      "brk_diff": 0,
                      "name": "South Africa",
                      "name_long": "South Africa",
                      "brk_a3": "ZAX",
                      "brk_name": "South Africa",
                      "brk_group": "",
                      "abbrev": "S.Af.",
                      "postal": "SA",
                      "formal_en": "",
                      "formal_fr": "",
                      "note_adm0": "",
                      "note_brk": "",
                      "name_sort": "South Africa",
                      "name_alt": "",
                      "mapcolor7": 2,
                      "mapcolor8": 3,
                      "mapcolor9": 4,
                      "mapcolor13": 2,
                      "pop_est": 49052489,
                      "gdp_md_est": 491000,
                      "pop_year": -99,
                      "lastcensus": -99,
                      "gdp_year": -99,
                      "economy": -99,
                      "income_grp": -99,
                      "wikipedia": -99,
                      "fips_10": "",
                      "iso_a2": -99,
                      "iso_a3": -99,
                      "iso_n3": -99,
                      "un_a3": "-099",
                      "wb_a2": -99,
                      "wb_a3": -99,
                      "woe_id": -99,
                      "adm0_a3_is": "ZAF",
                      "adm0_a3_us": "ZAF",
                      "adm0_a3_un": -99,
                      "adm0_a3_wb": -99,
                      "continent": "Africa",
                      "region_un": "Africa",
                      "subregion": "Southern Africa",
                      "region_wb": "Sub-Saharan Africa",
                      "name_len": 12,
                      "long_len": 12,
                      "abbrev_len": 5,
                      "tiny": -99,
                      "homepart": 1
                    },
                    "arcs": [
                      [
                        -177,
                        -231,
                        -175,
                        245,
                        -197,
                        -24,
                        246
                      ],
                      [
                        -159
                      ]
                    ]
                  },
                  {
                    "type": "Polygon",
                    "properties": {
                      "scalerank": 0,
                      "featurecla": "Admin-0 map subunit",
                      "labelrank": 3,
                      "sovereignt": "Zambia",
                      "sov_a3": "ZMB",
                      "adm0_dif": 0,
                      "level": 2,
                      "type": "Sovereign country",
                      "admin": "Zambia",
                      "adm0_a3": "ZMB",
                      "geou_dif": 0,
                      "geounit": "Zambia",
                      "gu_a3": "ZMB",
                      "su_dif": 0,
                      "subunit": "Zambia",
                      "su_a3": "ZMB",
                      "brk_diff": 0,
                      "name": "Zambia",
                      "name_long": "Zambia",
                      "brk_a3": "ZMB",
                      "brk_name": "Zambia",
                      "brk_group": "",
                      "abbrev": "Zambia",
                      "postal": "ZM",
                      "formal_en": "Republic of Zambia",
                      "formal_fr": "",
                      "note_adm0": "",
                      "note_brk": "",
                      "name_sort": "Zambia",
                      "name_alt": "",
                      "mapcolor7": 5,
                      "mapcolor8": 8,
                      "mapcolor9": 5,
                      "mapcolor13": 13,
                      "pop_est": 11862740,
                      "gdp_md_est": 17500,
                      "pop_year": -99,
                      "lastcensus": 2010,
                      "gdp_year": -99,
                      "economy": "7. Least developed region",
                      "income_grp": "4. Lower middle income",
                      "wikipedia": -99,
                      "fips_10": "",
                      "iso_a2": "ZM",
                      "iso_a3": "ZMB",
                      "iso_n3": 894,
                      "un_a3": 894,
                      "wb_a2": "ZM",
                      "wb_a3": "ZMB",
                      "woe_id": -99,
                      "adm0_a3_is": "ZMB",
                      "adm0_a3_us": "ZMB",
                      "adm0_a3_un": -99,
                      "adm0_a3_wb": -99,
                      "continent": "Africa",
                      "region_un": "Africa",
                      "subregion": "Eastern Africa",
                      "region_wb": "Sub-Saharan Africa",
                      "name_len": 6,
                      "long_len": 6,
                      "abbrev_len": 6,
                      "tiny": -99,
                      "homepart": 1
                    },
                    "arcs": [
                      [
                        -192,
                        -179,
                        247,
                        -196,
                        -2,
                        -54,
                        -240
                      ]
                    ]
                  },
                  {
                    "type": "Polygon",
                    "properties": {
                      "scalerank": 0,
                      "featurecla": "Admin-0 map subunit",
                      "labelrank": 3,
                      "sovereignt": "Zimbabwe",
                      "sov_a3": "ZWE",
                      "adm0_dif": 0,
                      "level": 2,
                      "type": "Sovereign country",
                      "admin": "Zimbabwe",
                      "adm0_a3": "ZWE",
                      "geou_dif": 0,
                      "geounit": "Zimbabwe",
                      "gu_a3": "ZWE",
                      "su_dif": 0,
                      "subunit": "Zimbabwe",
                      "su_a3": "ZWE",
                      "brk_diff": 0,
                      "name": "Zimbabwe",
                      "name_long": "Zimbabwe",
                      "brk_a3": "ZWE",
                      "brk_name": "Zimbabwe",
                      "brk_group": "",
                      "abbrev": "Zimb.",
                      "postal": "ZW",
                      "formal_en": "Republic of Zimbabwe",
                      "formal_fr": "",
                      "note_adm0": "",
                      "note_brk": "",
                      "name_sort": "Zimbabwe",
                      "name_alt": "",
                      "mapcolor7": 1,
                      "mapcolor8": 5,
                      "mapcolor9": 3,
                      "mapcolor13": 9,
                      "pop_est": 12619600,
                      "gdp_md_est": 9323,
                      "pop_year": 0,
                      "lastcensus": 2002,
                      "gdp_year": 0,
                      "economy": "5. Emerging region: G20",
                      "income_grp": "5. Low income",
                      "wikipedia": -99,
                      "fips_10": "",
                      "iso_a2": "ZW",
                      "iso_a3": "ZWE",
                      "iso_n3": 716,
                      "un_a3": 716,
                      "wb_a2": "ZW",
                      "wb_a3": "ZWE",
                      "woe_id": -99,
                      "adm0_a3_is": "ZWE",
                      "adm0_a3_us": "ZWE",
                      "adm0_a3_un": -99,
                      "adm0_a3_wb": -99,
                      "continent": "Africa",
                      "region_un": "Africa",
                      "subregion": "Eastern Africa",
                      "region_wb": "Sub-Saharan Africa",
                      "name_len": 8,
                      "long_len": 8,
                      "abbrev_len": 5,
                      "tiny": -99,
                      "homepart": 1
                    },
                    "arcs": [
                      [
                        -178,
                        -247,
                        -23,
                        -248
                      ]
                    ]
                  }
                ]
              }
            },
            "arcs": [
              [
                [
                  4831,
                  2512
                ],
                [
                  1,
                  -2
                ],
                [
                  -3,
                  3
                ],
                [
                  -2,
                  4
                ],
                [
                  -4,
                  14
                ],
                [
                  0,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  3,
                  3
                ],
                [
                  2,
                  -1
                ],
                [
                  0,
                  -7
                ],
                [
                  1,
                  -3
                ],
                [
                  0,
                  -6
                ],
                [
                  0,
                  -5
                ],
                [
                  1,
                  -5
                ]
              ],
              [
                [
                  6424,
                  3318
                ],
                [
                  1,
                  -6
                ],
                [
                  1,
                  -3
                ],
                [
                  2,
                  -4
                ],
                [
                  1,
                  -2
                ],
                [
                  -1,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -8
                ],
                [
                  -1,
                  -5
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  0
                ],
                [
                  0,
                  -20
                ],
                [
                  1,
                  -4
                ],
                [
                  5,
                  -13
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -4,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -4
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -4,
                  -5
                ],
                [
                  -2,
                  -6
                ],
                [
                  -1,
                  -3
                ],
                [
                  0,
                  -3
                ],
                [
                  1,
                  -3
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -4
                ],
                [
                  0,
                  -10
                ],
                [
                  1,
                  -4
                ],
                [
                  0,
                  -1
                ],
                [
                  -3,
                  -7
                ],
                [
                  -1,
                  -18
                ],
                [
                  -1,
                  -19
                ],
                [
                  1,
                  -6
                ],
                [
                  3,
                  -4
                ],
                [
                  3,
                  -4
                ],
                [
                  2,
                  -4
                ],
                [
                  0,
                  -8
                ],
                [
                  1,
                  -6
                ],
                [
                  0,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  -4,
                  -7
                ],
                [
                  -6,
                  -9
                ],
                [
                  -2,
                  -4
                ],
                [
                  -2,
                  -9
                ],
                [
                  -3,
                  -11
                ],
                [
                  -2,
                  -6
                ],
                [
                  -1,
                  -5
                ],
                [
                  1,
                  -5
                ],
                [
                  3,
                  -4
                ],
                [
                  7,
                  -7
                ],
                [
                  3,
                  -4
                ],
                [
                  2,
                  -5
                ],
                [
                  1,
                  -5
                ],
                [
                  -4,
                  0
                ],
                [
                  -16,
                  0
                ],
                [
                  -16,
                  0
                ],
                [
                  -16,
                  0
                ],
                [
                  -16,
                  0
                ],
                [
                  -17,
                  0
                ],
                [
                  -16,
                  0
                ],
                [
                  -16,
                  0
                ],
                [
                  -16,
                  0
                ],
                [
                  -16,
                  0
                ],
                [
                  -17,
                  0
                ],
                [
                  -16,
                  0
                ],
                [
                  -16,
                  0
                ],
                [
                  -16,
                  0
                ],
                [
                  -16,
                  0
                ],
                [
                  -17,
                  0
                ],
                [
                  -16,
                  0
                ],
                [
                  0,
                  -21
                ],
                [
                  0,
                  -20
                ],
                [
                  0,
                  -21
                ],
                [
                  0,
                  -21
                ],
                [
                  0,
                  -13
                ],
                [
                  0,
                  -8
                ],
                [
                  0,
                  -21
                ],
                [
                  0,
                  -21
                ],
                [
                  0,
                  -21
                ],
                [
                  0,
                  -21
                ],
                [
                  0,
                  -20
                ],
                [
                  0,
                  -21
                ],
                [
                  0,
                  -21
                ],
                [
                  0,
                  -21
                ],
                [
                  0,
                  -21
                ],
                [
                  0,
                  -21
                ],
                [
                  1,
                  -21
                ],
                [
                  0,
                  -5
                ],
                [
                  0,
                  -3
                ],
                [
                  0,
                  -4
                ],
                [
                  0,
                  -7
                ],
                [
                  -1,
                  -14
                ],
                [
                  0,
                  -14
                ],
                [
                  0,
                  -14
                ],
                [
                  0,
                  -14
                ],
                [
                  0,
                  -6
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -9
                ],
                [
                  0,
                  -8
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -3
                ],
                [
                  3,
                  -5
                ],
                [
                  5,
                  -7
                ],
                [
                  -3,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  2,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -3
                ],
                [
                  0,
                  -1
                ],
                [
                  5,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -3
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -4
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  11,
                  -9
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -2
                ],
                [
                  10,
                  -15
                ],
                [
                  1,
                  -4
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  4,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -3
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  8,
                  -4
                ],
                [
                  2,
                  -1
                ],
                [
                  5,
                  -6
                ],
                [
                  3,
                  -4
                ],
                [
                  2,
                  -4
                ],
                [
                  1,
                  -6
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  4,
                  -2
                ],
                [
                  6,
                  -5
                ],
                [
                  3,
                  -2
                ],
                [
                  8,
                  -4
                ],
                [
                  6,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  5,
                  -6
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -4
                ],
                [
                  3,
                  -4
                ],
                [
                  3,
                  -4
                ],
                [
                  3,
                  -2
                ],
                [
                  6,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  2,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  4,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  3,
                  -2
                ],
                [
                  2,
                  -3
                ],
                [
                  3,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -2
                ]
              ],
              [
                [
                  6348,
                  2380
                ],
                [
                  -11,
                  -2
                ],
                [
                  -27,
                  -5
                ],
                [
                  -26,
                  -5
                ],
                [
                  -27,
                  -6
                ],
                [
                  -26,
                  -5
                ],
                [
                  -33,
                  -7
                ],
                [
                  -33,
                  -6
                ],
                [
                  -32,
                  -6
                ],
                [
                  -33,
                  -7
                ],
                [
                  -10,
                  -2
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  3
                ],
                [
                  -4,
                  2
                ],
                [
                  -7,
                  2
                ],
                [
                  -6,
                  4
                ],
                [
                  -2,
                  0
                ],
                [
                  -5,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -3,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  1
                ],
                [
                  -12,
                  -3
                ],
                [
                  -2,
                  -1
                ],
                [
                  -10,
                  -2
                ],
                [
                  -2,
                  -4
                ],
                [
                  -4,
                  -1
                ],
                [
                  -4,
                  -1
                ],
                [
                  -4,
                  -1
                ],
                [
                  -2,
                  3
                ],
                [
                  -4,
                  2
                ],
                [
                  -3,
                  1
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  -3,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -4,
                  1
                ],
                [
                  -6,
                  0
                ],
                [
                  -3,
                  -1
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  2
                ],
                [
                  -5,
                  3
                ],
                [
                  -1,
                  1
                ],
                [
                  -3,
                  3
                ],
                [
                  -3,
                  2
                ],
                [
                  -3,
                  2
                ],
                [
                  -3,
                  -1
                ],
                [
                  -5,
                  4
                ],
                [
                  -2,
                  1
                ],
                [
                  -4,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -5,
                  -4
                ],
                [
                  -3,
                  1
                ],
                [
                  -3,
                  0
                ],
                [
                  -4,
                  0
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -3,
                  0
                ],
                [
                  -8,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -5,
                  2
                ],
                [
                  -5,
                  3
                ],
                [
                  -20,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -3,
                  1
                ],
                [
                  -3,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  3
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -8,
                  -1
                ],
                [
                  -22,
                  -1
                ],
                [
                  -21,
                  7
                ],
                [
                  -2,
                  1
                ],
                [
                  -5,
                  -1
                ],
                [
                  -4,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -3,
                  0
                ],
                [
                  -4,
                  -2
                ],
                [
                  -11,
                  -1
                ],
                [
                  -17,
                  4
                ],
                [
                  -12,
                  5
                ],
                [
                  -5,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  4
                ],
                [
                  -8,
                  8
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  -7,
                  6
                ],
                [
                  -2,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -5,
                  9
                ],
                [
                  -3,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  -3,
                  5
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -7,
                  0
                ],
                [
                  -33,
                  0
                ],
                [
                  -18,
                  0
                ],
                [
                  -16,
                  0
                ],
                [
                  -33,
                  0
                ],
                [
                  -34,
                  0
                ],
                [
                  -11,
                  0
                ],
                [
                  -22,
                  0
                ],
                [
                  -33,
                  0
                ],
                [
                  -34,
                  0
                ],
                [
                  -33,
                  0
                ],
                [
                  -34,
                  0
                ],
                [
                  -33,
                  0
                ],
                [
                  -33,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -32,
                  0
                ],
                [
                  -33,
                  0
                ],
                [
                  -34,
                  0
                ],
                [
                  -33,
                  0
                ],
                [
                  -34,
                  1
                ],
                [
                  -8,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -3
                ],
                [
                  -3,
                  0
                ],
                [
                  -6,
                  1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -3,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -4,
                  0
                ],
                [
                  -1,
                  2
                ],
                [
                  -6,
                  8
                ],
                [
                  -2,
                  1
                ],
                [
                  -12,
                  7
                ],
                [
                  -13,
                  8
                ],
                [
                  -11,
                  9
                ],
                [
                  -11,
                  6
                ],
                [
                  1,
                  4
                ],
                [
                  -1,
                  3
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  6
                ],
                [
                  -2,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -4,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -4,
                  3
                ],
                [
                  -3,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -3,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -3,
                  -2
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -3,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -3,
                  2
                ],
                [
                  -2,
                  0
                ],
                [
                  -3,
                  -1
                ],
                [
                  -14,
                  -3
                ],
                [
                  -7,
                  -4
                ],
                [
                  -4,
                  -1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -4,
                  -2
                ],
                [
                  -6,
                  -2
                ],
                [
                  -5,
                  -4
                ],
                [
                  -2,
                  -2
                ],
                [
                  -3,
                  0
                ],
                [
                  -4,
                  -1
                ],
                [
                  -5,
                  -6
                ],
                [
                  -4,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -5,
                  1
                ],
                [
                  -7,
                  0
                ],
                [
                  -3,
                  1
                ],
                [
                  -3,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -8,
                  0
                ],
                [
                  -10,
                  -1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -5,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -6,
                  0
                ],
                [
                  -6,
                  -2
                ],
                [
                  -5,
                  -3
                ],
                [
                  -6,
                  -4
                ],
                [
                  -5,
                  -3
                ],
                [
                  -3,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  0
                ]
              ],
              [
                [
                  4835,
                  2434
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  5
                ],
                [
                  0,
                  19
                ],
                [
                  2,
                  12
                ],
                [
                  1,
                  10
                ],
                [
                  -2,
                  10
                ],
                [
                  0,
                  4
                ],
                [
                  3,
                  1
                ],
                [
                  0,
                  -6
                ],
                [
                  2,
                  -2
                ],
                [
                  2,
                  6
                ],
                [
                  0,
                  10
                ],
                [
                  1,
                  4
                ],
                [
                  -2,
                  13
                ],
                [
                  1,
                  14
                ],
                [
                  -5,
                  53
                ],
                [
                  0,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  6
                ],
                [
                  -3,
                  7
                ],
                [
                  -6,
                  10
                ],
                [
                  0,
                  6
                ],
                [
                  2,
                  8
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  7,
                  7
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  4
                ],
                [
                  0,
                  2
                ],
                [
                  3,
                  3
                ],
                [
                  8,
                  5
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  4
                ],
                [
                  2,
                  10
                ],
                [
                  2,
                  4
                ],
                [
                  -2,
                  4
                ],
                [
                  1,
                  4
                ],
                [
                  2,
                  8
                ],
                [
                  1,
                  16
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  4,
                  4
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  5
                ],
                [
                  3,
                  8
                ],
                [
                  1,
                  5
                ],
                [
                  0,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  8
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  4
                ],
                [
                  3,
                  4
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  0,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  3
                ],
                [
                  2,
                  11
                ],
                [
                  1,
                  11
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  4
                ],
                [
                  2,
                  5
                ],
                [
                  1,
                  9
                ],
                [
                  1,
                  9
                ],
                [
                  -1,
                  4
                ],
                [
                  -1,
                  5
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  2,
                  4
                ],
                [
                  1,
                  3
                ],
                [
                  3,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  3,
                  4
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  5
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  3,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  3
                ],
                [
                  1,
                  5
                ],
                [
                  1,
                  14
                ],
                [
                  -1,
                  14
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  5
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  4
                ],
                [
                  -1,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  4,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  8,
                  11
                ],
                [
                  4,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  3,
                  3
                ],
                [
                  8,
                  10
                ],
                [
                  1,
                  4
                ],
                [
                  0,
                  3
                ],
                [
                  -1,
                  4
                ],
                [
                  -2,
                  4
                ],
                [
                  -1,
                  4
                ],
                [
                  2,
                  4
                ],
                [
                  6,
                  6
                ],
                [
                  3,
                  2
                ],
                [
                  9,
                  9
                ],
                [
                  3,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  4
                ],
                [
                  1,
                  1
                ],
                [
                  4,
                  3
                ],
                [
                  2,
                  2
                ],
                [
                  3,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  3,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  4,
                  4
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  -2
                ],
                [
                  3,
                  -1
                ],
                [
                  4,
                  1
                ],
                [
                  4,
                  3
                ],
                [
                  6,
                  6
                ],
                [
                  3,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  5
                ],
                [
                  0,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  3,
                  4
                ],
                [
                  8,
                  8
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  2
                ],
                [
                  3,
                  5
                ],
                [
                  4,
                  5
                ],
                [
                  1,
                  2
                ],
                [
                  3,
                  11
                ],
                [
                  4,
                  8
                ],
                [
                  2,
                  4
                ],
                [
                  1,
                  10
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  2,
                  14
                ],
                [
                  1,
                  4
                ],
                [
                  0,
                  3
                ],
                [
                  -2,
                  25
                ],
                [
                  1,
                  15
                ],
                [
                  0,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  7
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  4
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  4
                ],
                [
                  3,
                  20
                ],
                [
                  0,
                  8
                ],
                [
                  0,
                  10
                ],
                [
                  0,
                  5
                ],
                [
                  -2,
                  5
                ],
                [
                  -12,
                  18
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  4,
                  5
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  -6,
                  4
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -12,
                  16
                ],
                [
                  -9,
                  7
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  10
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  3
                ],
                [
                  -7,
                  10
                ],
                [
                  -2,
                  3
                ],
                [
                  -1,
                  7
                ],
                [
                  -2,
                  3
                ],
                [
                  -5,
                  5
                ],
                [
                  -8,
                  13
                ],
                [
                  0,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  -1,
                  6
                ],
                [
                  -2,
                  6
                ],
                [
                  -4,
                  6
                ],
                [
                  -10,
                  13
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  3,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -4,
                  13
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  6
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  5
                ],
                [
                  -1,
                  3
                ],
                [
                  -2,
                  2
                ],
                [
                  -10,
                  18
                ],
                [
                  -4,
                  9
                ],
                [
                  -3,
                  4
                ],
                [
                  0,
                  7
                ],
                [
                  5,
                  11
                ],
                [
                  7,
                  10
                ],
                [
                  7,
                  3
                ],
                [
                  -3,
                  -5
                ],
                [
                  -10,
                  -8
                ],
                [
                  -4,
                  -12
                ],
                [
                  -1,
                  -3
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  1
                ],
                [
                  7,
                  13
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  4
                ],
                [
                  2,
                  3
                ],
                [
                  3,
                  4
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  4,
                  4
                ],
                [
                  2,
                  2
                ],
                [
                  3,
                  1
                ],
                [
                  -7,
                  -7
                ],
                [
                  -1,
                  -3
                ],
                [
                  1,
                  1
                ],
                [
                  5,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  8,
                  -2
                ],
                [
                  3,
                  2
                ],
                [
                  2,
                  7
                ],
                [
                  2,
                  5
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  -4,
                  6
                ],
                [
                  -2,
                  4
                ],
                [
                  -1,
                  9
                ],
                [
                  -2,
                  5
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  10
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  3
                ],
                [
                  -12,
                  20
                ],
                [
                  -2,
                  2
                ],
                [
                  -2,
                  6
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  4
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  5
                ],
                [
                  -2,
                  7
                ],
                [
                  -8,
                  16
                ],
                [
                  -18,
                  43
                ],
                [
                  -6,
                  15
                ],
                [
                  -4,
                  14
                ],
                [
                  -3,
                  4
                ],
                [
                  -2,
                  3
                ],
                [
                  -3,
                  3
                ],
                [
                  1,
                  5
                ],
                [
                  -1,
                  3
                ],
                [
                  -2,
                  28
                ],
                [
                  -1,
                  4
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -4,
                  -3
                ],
                [
                  -3,
                  2
                ],
                [
                  -9,
                  14
                ],
                [
                  -12,
                  11
                ],
                [
                  -9,
                  14
                ],
                [
                  -12,
                  23
                ],
                [
                  -4,
                  12
                ],
                [
                  -4,
                  7
                ],
                [
                  -3,
                  6
                ],
                [
                  -4,
                  4
                ],
                [
                  -3,
                  5
                ],
                [
                  -5,
                  10
                ],
                [
                  -1,
                  4
                ],
                [
                  2,
                  3
                ],
                [
                  3,
                  1
                ],
                [
                  3,
                  2
                ],
                [
                  -1,
                  -3
                ],
                [
                  0,
                  -4
                ],
                [
                  3,
                  1
                ],
                [
                  4,
                  1
                ],
                [
                  7,
                  0
                ],
                [
                  8,
                  2
                ],
                [
                  4,
                  3
                ],
                [
                  3,
                  1
                ],
                [
                  4,
                  1
                ],
                [
                  7,
                  4
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  3,
                  -1
                ],
                [
                  3,
                  -1
                ],
                [
                  3,
                  0
                ],
                [
                  4,
                  1
                ],
                [
                  6,
                  1
                ],
                [
                  6,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  6,
                  3
                ],
                [
                  3,
                  3
                ],
                [
                  2,
                  4
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  3,
                  1
                ],
                [
                  3,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  5,
                  -1
                ],
                [
                  1,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  5,
                  3
                ],
                [
                  2,
                  0
                ]
              ],
              [
                [
                  5020,
                  4013
                ],
                [
                  11,
                  -1
                ],
                [
                  5,
                  -1
                ],
                [
                  4,
                  -2
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  3
                ],
                [
                  1,
                  0
                ],
                [
                  5,
                  0
                ],
                [
                  10,
                  0
                ],
                [
                  4,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  10,
                  -1
                ],
                [
                  22,
                  2
                ],
                [
                  18,
                  1
                ],
                [
                  5,
                  -1
                ],
                [
                  3,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  15,
                  1
                ],
                [
                  3,
                  0
                ],
                [
                  8,
                  -3
                ],
                [
                  3,
                  0
                ],
                [
                  13,
                  -1
                ],
                [
                  12,
                  0
                ],
                [
                  6,
                  1
                ],
                [
                  8,
                  -2
                ],
                [
                  4,
                  0
                ],
                [
                  17,
                  3
                ],
                [
                  7,
                  0
                ],
                [
                  5,
                  0
                ],
                [
                  12,
                  0
                ],
                [
                  12,
                  0
                ],
                [
                  12,
                  1
                ],
                [
                  11,
                  0
                ],
                [
                  12,
                  0
                ],
                [
                  12,
                  0
                ],
                [
                  12,
                  1
                ],
                [
                  12,
                  0
                ],
                [
                  12,
                  0
                ],
                [
                  12,
                  0
                ],
                [
                  12,
                  0
                ],
                [
                  11,
                  1
                ],
                [
                  12,
                  0
                ],
                [
                  12,
                  0
                ],
                [
                  4,
                  0
                ],
                [
                  8,
                  0
                ],
                [
                  12,
                  0
                ],
                [
                  8,
                  1
                ],
                [
                  3,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  3,
                  -2
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  4,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  -1
                ],
                [
                  5,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  5,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  -3
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -9
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -2
                ],
                [
                  -3,
                  -3
                ],
                [
                  3,
                  0
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -3
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -3
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -3
                ],
                [
                  0,
                  -10
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -6
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  3,
                  0
                ],
                [
                  -1,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  -3
                ],
                [
                  0,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  2,
                  -4
                ],
                [
                  1,
                  -3
                ],
                [
                  0,
                  -5
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -2
                ],
                [
                  7,
                  -10
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  -2
                ],
                [
                  1,
                  -4
                ],
                [
                  1,
                  -8
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -3
                ],
                [
                  0,
                  -3
                ],
                [
                  -4,
                  1
                ],
                [
                  -1,
                  -3
                ],
                [
                  3,
                  -9
                ],
                [
                  0,
                  -8
                ],
                [
                  0,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -3
                ],
                [
                  1,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  4,
                  -2
                ],
                [
                  4,
                  -3
                ],
                [
                  3,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  3,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -3
                ],
                [
                  2,
                  -6
                ],
                [
                  2,
                  -3
                ],
                [
                  6,
                  -4
                ],
                [
                  3,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -3
                ],
                [
                  0,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  3,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  3,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  3,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  -5
                ],
                [
                  0,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  3,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -4
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  7,
                  -2
                ],
                [
                  4,
                  0
                ],
                [
                  11,
                  4
                ],
                [
                  4,
                  -1
                ],
                [
                  4,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  8,
                  5
                ],
                [
                  2,
                  0
                ],
                [
                  4,
                  0
                ],
                [
                  4,
                  -2
                ],
                [
                  7,
                  -6
                ],
                [
                  3,
                  -1
                ],
                [
                  12,
                  0
                ],
                [
                  -1,
                  4
                ],
                [
                  0,
                  3
                ],
                [
                  1,
                  4
                ],
                [
                  3,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  5,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  10,
                  -1
                ],
                [
                  6,
                  0
                ],
                [
                  5,
                  -2
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  8,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  -1,
                  5
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  10,
                  0
                ],
                [
                  10,
                  0
                ],
                [
                  9,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -4
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -3
                ],
                [
                  6,
                  0
                ],
                [
                  16,
                  0
                ],
                [
                  17,
                  0
                ],
                [
                  16,
                  0
                ],
                [
                  17,
                  0
                ],
                [
                  4,
                  0
                ],
                [
                  -3,
                  11
                ],
                [
                  -1,
                  3
                ],
                [
                  1,
                  5
                ],
                [
                  2,
                  6
                ],
                [
                  1,
                  4
                ],
                [
                  2,
                  9
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  4
                ],
                [
                  -1,
                  3
                ],
                [
                  -2,
                  4
                ],
                [
                  -1,
                  4
                ],
                [
                  1,
                  3
                ],
                [
                  9,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  6
                ],
                [
                  2,
                  2
                ],
                [
                  4,
                  3
                ],
                [
                  0,
                  5
                ],
                [
                  -3,
                  9
                ],
                [
                  -1,
                  5
                ],
                [
                  -1,
                  4
                ],
                [
                  2,
                  23
                ],
                [
                  1,
                  4
                ],
                [
                  1,
                  3
                ],
                [
                  4,
                  4
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  -3,
                  6
                ],
                [
                  7,
                  0
                ],
                [
                  5,
                  0
                ],
                [
                  6,
                  0
                ],
                [
                  5,
                  0
                ],
                [
                  6,
                  0
                ],
                [
                  5,
                  0
                ],
                [
                  6,
                  0
                ],
                [
                  5,
                  0
                ],
                [
                  6,
                  0
                ],
                [
                  5,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  4,
                  0
                ],
                [
                  5,
                  0
                ],
                [
                  6,
                  0
                ],
                [
                  5,
                  0
                ],
                [
                  6,
                  0
                ],
                [
                  5,
                  0
                ],
                [
                  6,
                  0
                ],
                [
                  6,
                  0
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  4
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  6,
                  0
                ],
                [
                  11,
                  0
                ],
                [
                  12,
                  0
                ],
                [
                  7,
                  0
                ],
                [
                  -3,
                  -8
                ],
                [
                  -3,
                  -10
                ],
                [
                  -3,
                  -5
                ],
                [
                  -2,
                  -8
                ],
                [
                  -1,
                  -6
                ],
                [
                  0,
                  -7
                ],
                [
                  0,
                  -7
                ],
                [
                  6,
                  0
                ],
                [
                  10,
                  0
                ],
                [
                  9,
                  0
                ],
                [
                  10,
                  0
                ],
                [
                  9,
                  0
                ],
                [
                  10,
                  0
                ],
                [
                  9,
                  0
                ],
                [
                  10,
                  0
                ],
                [
                  9,
                  0
                ],
                [
                  10,
                  0
                ],
                [
                  9,
                  0
                ],
                [
                  9,
                  0
                ],
                [
                  10,
                  1
                ],
                [
                  9,
                  0
                ],
                [
                  10,
                  0
                ],
                [
                  9,
                  0
                ],
                [
                  10,
                  0
                ],
                [
                  4,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  3,
                  -6
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  -2,
                  -3
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -5
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -5
                ],
                [
                  -2,
                  -5
                ],
                [
                  -1,
                  -3
                ],
                [
                  -1,
                  -5
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -6
                ],
                [
                  1,
                  -4
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  -2,
                  -3
                ],
                [
                  -1,
                  -1
                ],
                [
                  1,
                  -9
                ],
                [
                  0,
                  -3
                ],
                [
                  2,
                  -1
                ],
                [
                  4,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -3
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -3
                ],
                [
                  4,
                  -4
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -3
                ],
                [
                  0,
                  -6
                ],
                [
                  1,
                  -6
                ],
                [
                  1,
                  -3
                ],
                [
                  4,
                  -4
                ],
                [
                  2,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -2
                ],
                [
                  1,
                  -4
                ],
                [
                  4,
                  -5
                ],
                [
                  1,
                  -6
                ],
                [
                  -1,
                  -6
                ],
                [
                  -3,
                  -11
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  -3,
                  -4
                ],
                [
                  -1,
                  -4
                ],
                [
                  -2,
                  -10
                ],
                [
                  -1,
                  -9
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -5
                ],
                [
                  -1,
                  -3
                ],
                [
                  -1,
                  -11
                ],
                [
                  0,
                  -7
                ],
                [
                  -2,
                  -16
                ],
                [
                  2,
                  -14
                ],
                [
                  0,
                  -6
                ],
                [
                  -2,
                  -5
                ],
                [
                  -4,
                  -9
                ],
                [
                  -1,
                  -5
                ],
                [
                  -1,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  3,
                  -3
                ],
                [
                  0,
                  -1
                ],
                [
                  2,
                  -6
                ],
                [
                  2,
                  -12
                ],
                [
                  1,
                  -6
                ],
                [
                  3,
                  -5
                ],
                [
                  8,
                  -9
                ],
                [
                  2,
                  -6
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -5
                ],
                [
                  2,
                  -3
                ],
                [
                  7,
                  -10
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  5,
                  -3
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -5
                ],
                [
                  2,
                  -8
                ],
                [
                  2,
                  -6
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -5
                ],
                [
                  3,
                  -6
                ],
                [
                  3,
                  -6
                ],
                [
                  2,
                  -7
                ],
                [
                  3,
                  -6
                ],
                [
                  1,
                  -4
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -3,
                  -5
                ],
                [
                  -1,
                  -3
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -3
                ],
                [
                  0,
                  -6
                ],
                [
                  0,
                  -3
                ],
                [
                  0,
                  -3
                ],
                [
                  0,
                  -5
                ],
                [
                  2,
                  -3
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -6
                ],
                [
                  0,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -6,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  -3,
                  -3
                ],
                [
                  -3,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  2,
                  -2
                ],
                [
                  2,
                  -10
                ],
                [
                  0,
                  -5
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -3
                ],
                [
                  2,
                  -4
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -12
                ],
                [
                  0,
                  -6
                ],
                [
                  -2,
                  -6
                ],
                [
                  3,
                  0
                ],
                [
                  3,
                  2
                ],
                [
                  5,
                  6
                ],
                [
                  2,
                  2
                ],
                [
                  13,
                  4
                ],
                [
                  4,
                  4
                ],
                [
                  4,
                  11
                ],
                [
                  5,
                  0
                ],
                [
                  10,
                  -4
                ],
                [
                  5,
                  -2
                ],
                [
                  5,
                  -1
                ],
                [
                  5,
                  -1
                ],
                [
                  4,
                  1
                ],
                [
                  3,
                  2
                ],
                [
                  3,
                  2
                ],
                [
                  3,
                  1
                ],
                [
                  3,
                  0
                ],
                [
                  3,
                  -1
                ],
                [
                  5,
                  -4
                ],
                [
                  2,
                  -1
                ],
                [
                  5,
                  -1
                ],
                [
                  6,
                  0
                ],
                [
                  13,
                  3
                ],
                [
                  11,
                  2
                ],
                [
                  14,
                  8
                ],
                [
                  9,
                  5
                ],
                [
                  5,
                  2
                ],
                [
                  6,
                  0
                ],
                [
                  5,
                  0
                ],
                [
                  8,
                  -3
                ],
                [
                  11,
                  -3
                ],
                [
                  4,
                  0
                ],
                [
                  5,
                  0
                ],
                [
                  5,
                  -1
                ],
                [
                  6,
                  -1
                ],
                [
                  5,
                  -1
                ],
                [
                  4,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  3,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  2,
                  1
                ]
              ],
              [
                [
                  5005,
                  4182
                ],
                [
                  -1,
                  -4
                ],
                [
                  -4,
                  -1
                ],
                [
                  -26,
                  -7
                ],
                [
                  -4,
                  -2
                ],
                [
                  -2,
                  -3
                ],
                [
                  -2,
                  -3
                ],
                [
                  0,
                  -3
                ],
                [
                  -1,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  -6,
                  -3
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -3,
                  -1
                ],
                [
                  -5,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -3
                ],
                [
                  -2,
                  -5
                ],
                [
                  -5,
                  -3
                ],
                [
                  -11,
                  -4
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  8,
                  -3
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -5
                ],
                [
                  -1,
                  -10
                ],
                [
                  0,
                  -12
                ],
                [
                  -1,
                  -17
                ],
                [
                  0,
                  -17
                ],
                [
                  -1,
                  -9
                ],
                [
                  0,
                  -13
                ],
                [
                  -10,
                  0
                ],
                [
                  -12,
                  1
                ],
                [
                  -11,
                  -2
                ],
                [
                  -6,
                  -4
                ]
              ],
              [
                [
                  4893,
                  4026
                ],
                [
                  -6,
                  12
                ],
                [
                  -2,
                  8
                ],
                [
                  3,
                  9
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  4
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  5
                ],
                [
                  -2,
                  5
                ],
                [
                  -3,
                  9
                ],
                [
                  0,
                  4
                ],
                [
                  -5,
                  10
                ],
                [
                  -1,
                  6
                ],
                [
                  -7,
                  9
                ],
                [
                  -6,
                  11
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -4
                ],
                [
                  3,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  -1,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -3
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  3
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -3,
                  0
                ]
              ],
              [
                [
                  4867,
                  4129
                ],
                [
                  1,
                  2
                ],
                [
                  15,
                  13
                ],
                [
                  3,
                  6
                ],
                [
                  4,
                  14
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  5,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  5,
                  12
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  6
                ],
                [
                  1,
                  2
                ],
                [
                  4,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  9,
                  3
                ],
                [
                  15,
                  3
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  3,
                  5
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  3
                ],
                [
                  2,
                  3
                ],
                [
                  3,
                  2
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  -2
                ],
                [
                  2,
                  -2
                ],
                [
                  2,
                  -7
                ],
                [
                  3,
                  -3
                ],
                [
                  5,
                  -4
                ],
                [
                  8,
                  -11
                ],
                [
                  6,
                  -4
                ]
              ],
              [
                [
                  7282,
                  4492
                ],
                [
                  -4,
                  -6
                ],
                [
                  -2,
                  -3
                ],
                [
                  -5,
                  -12
                ],
                [
                  -1,
                  -5
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -3,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -3
                ],
                [
                  2,
                  -2
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  1
                ],
                [
                  5,
                  2
                ],
                [
                  3,
                  2
                ],
                [
                  -1,
                  -3
                ],
                [
                  -7,
                  -8
                ],
                [
                  -2,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -4
                ],
                [
                  -3,
                  -4
                ],
                [
                  -1,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  3,
                  -5
                ],
                [
                  2,
                  -2
                ],
                [
                  3,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  4
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  8,
                  -6
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  -3
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  6,
                  2
                ],
                [
                  3,
                  0
                ],
                [
                  -1,
                  -2
                ],
                [
                  -4,
                  -5
                ],
                [
                  -1,
                  -3
                ],
                [
                  1,
                  -2
                ],
                [
                  3,
                  -3
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -3
                ],
                [
                  -2,
                  -3
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  -4
                ],
                [
                  -3,
                  -2
                ],
                [
                  -4,
                  -1
                ],
                [
                  -3,
                  2
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -4,
                  -1
                ],
                [
                  -3,
                  -2
                ],
                [
                  -2,
                  -3
                ],
                [
                  -3,
                  -3
                ],
                [
                  1,
                  0
                ],
                [
                  4,
                  -2
                ],
                [
                  0,
                  -4
                ],
                [
                  -3,
                  -4
                ],
                [
                  -7,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -4,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -3,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -4,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  1,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -3
                ],
                [
                  -6,
                  -9
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -5,
                  2
                ],
                [
                  -4,
                  -2
                ],
                [
                  -5,
                  -10
                ],
                [
                  -6,
                  -7
                ],
                [
                  -2,
                  -3
                ],
                [
                  -2,
                  -10
                ],
                [
                  -2,
                  -5
                ],
                [
                  -1,
                  -1
                ],
                [
                  -3,
                  -6
                ],
                [
                  -4,
                  -5
                ],
                [
                  -9,
                  -7
                ],
                [
                  -1,
                  -3
                ],
                [
                  -3,
                  -8
                ],
                [
                  -2,
                  -2
                ],
                [
                  -3,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -5,
                  -3
                ],
                [
                  -4,
                  -4
                ],
                [
                  -7,
                  -4
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  1
                ],
                [
                  -5,
                  0
                ],
                [
                  -6,
                  2
                ],
                [
                  -31,
                  -1
                ]
              ],
              [
                [
                  7132,
                  4208
                ],
                [
                  -4,
                  34
                ],
                [
                  -1,
                  2
                ],
                [
                  -3,
                  14
                ],
                [
                  -8,
                  14
                ],
                [
                  -5,
                  6
                ],
                [
                  -2,
                  3
                ],
                [
                  -1,
                  3
                ],
                [
                  -2,
                  17
                ],
                [
                  2,
                  10
                ],
                [
                  1,
                  6
                ],
                [
                  0,
                  10
                ],
                [
                  -3,
                  36
                ],
                [
                  1,
                  4
                ],
                [
                  0,
                  2
                ],
                [
                  3,
                  3
                ],
                [
                  1,
                  0
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  9
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  8
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  3
                ],
                [
                  -1,
                  4
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  -1,
                  4
                ]
              ],
              [
                [
                  7082,
                  4448
                ],
                [
                  2,
                  14
                ],
                [
                  3,
                  3
                ],
                [
                  7,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  8,
                  -4
                ],
                [
                  3,
                  -1
                ],
                [
                  6,
                  0
                ],
                [
                  3,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  3,
                  -3
                ],
                [
                  1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -3
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -3
                ],
                [
                  3,
                  0
                ],
                [
                  6,
                  3
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  5,
                  -1
                ],
                [
                  3,
                  -2
                ],
                [
                  3,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  3,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  4,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  5,
                  -2
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  -1
                ],
                [
                  3,
                  0
                ],
                [
                  3,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  3
                ],
                [
                  2,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  14
                ],
                [
                  3,
                  11
                ],
                [
                  -1,
                  11
                ],
                [
                  1,
                  7
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  3,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  4,
                  -5
                ],
                [
                  2,
                  -2
                ],
                [
                  3,
                  -2
                ],
                [
                  3,
                  -1
                ],
                [
                  3,
                  0
                ],
                [
                  2,
                  2
                ],
                [
                  6,
                  7
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  -1
                ],
                [
                  4,
                  -2
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  -1
                ],
                [
                  4,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  7,
                  -7
                ],
                [
                  5,
                  -2
                ],
                [
                  4,
                  0
                ]
              ],
              [
                [
                  3771,
                  6445
                ],
                [
                  -3,
                  -3
                ],
                [
                  -9,
                  -16
                ],
                [
                  -1,
                  -6
                ],
                [
                  -1,
                  -2
                ],
                [
                  -3,
                  -8
                ],
                [
                  0,
                  -3
                ],
                [
                  2,
                  -4
                ],
                [
                  24,
                  -34
                ],
                [
                  3,
                  -4
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  -2,
                  -5
                ],
                [
                  0,
                  -3
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -3
                ],
                [
                  3,
                  -12
                ],
                [
                  0,
                  -4
                ],
                [
                  -3,
                  -7
                ],
                [
                  0,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -5
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -3
                ],
                [
                  0,
                  -4
                ],
                [
                  1,
                  -3
                ],
                [
                  0,
                  -5
                ],
                [
                  -1,
                  -3
                ],
                [
                  -4,
                  -7
                ],
                [
                  -1,
                  -4
                ],
                [
                  0,
                  -7
                ],
                [
                  -1,
                  -3
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -8,
                  5
                ],
                [
                  -3,
                  0
                ],
                [
                  -3,
                  0
                ],
                [
                  -2,
                  -3
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  -3,
                  -5
                ],
                [
                  -3,
                  -6
                ],
                [
                  0,
                  -3
                ],
                [
                  2,
                  -3
                ],
                [
                  9,
                  -10
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -3
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -3
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -12
                ],
                [
                  -2,
                  -3
                ],
                [
                  -4,
                  -5
                ],
                [
                  -3,
                  -7
                ],
                [
                  -3,
                  -2
                ],
                [
                  -8,
                  1
                ],
                [
                  -5,
                  -2
                ],
                [
                  -9,
                  -4
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -3
                ],
                [
                  -1,
                  -3
                ],
                [
                  1,
                  -3
                ],
                [
                  2,
                  -4
                ],
                [
                  1,
                  -4
                ],
                [
                  -1,
                  -4
                ],
                [
                  -5,
                  -2
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -3,
                  -1
                ],
                [
                  -1,
                  -3
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  -8,
                  -11
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -4
                ],
                [
                  -1,
                  -4
                ],
                [
                  1,
                  -4
                ],
                [
                  2,
                  -4
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -9
                ],
                [
                  -1,
                  -3
                ],
                [
                  -2,
                  -6
                ],
                [
                  -5,
                  -14
                ],
                [
                  -2,
                  -4
                ],
                [
                  -3,
                  -2
                ],
                [
                  -9,
                  -3
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -4,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -10,
                  1
                ],
                [
                  1,
                  -4
                ],
                [
                  0,
                  -9
                ],
                [
                  -1,
                  -4
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  -2,
                  -4
                ],
                [
                  -1,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  3,
                  -34
                ],
                [
                  0,
                  -4
                ],
                [
                  -1,
                  -5
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -3
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -6
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -4
                ],
                [
                  1,
                  -3
                ],
                [
                  2,
                  -6
                ],
                [
                  1,
                  -3
                ],
                [
                  0,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -9
                ],
                [
                  -2,
                  -8
                ],
                [
                  0,
                  -9
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -3
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -4
                ],
                [
                  3,
                  -4
                ],
                [
                  2,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -18
                ],
                [
                  -1,
                  -5
                ],
                [
                  1,
                  -5
                ],
                [
                  3,
                  -5
                ],
                [
                  4,
                  -5
                ],
                [
                  2,
                  -5
                ],
                [
                  0,
                  -6
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -3,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -2
                ],
                [
                  3,
                  -34
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  3,
                  -3
                ],
                [
                  1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -4,
                  -5
                ],
                [
                  1,
                  -5
                ],
                [
                  2,
                  -6
                ],
                [
                  0,
                  -5
                ],
                [
                  -1,
                  -6
                ],
                [
                  -1,
                  -3
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -6
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  -3
                ],
                [
                  0,
                  -3
                ],
                [
                  2,
                  -6
                ],
                [
                  -1,
                  -3
                ],
                [
                  -2,
                  -7
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -3
                ],
                [
                  -1,
                  -7
                ],
                [
                  0,
                  -8
                ]
              ],
              [
                [
                  3655,
                  5707
                ],
                [
                  -52,
                  -5
                ],
                [
                  -10,
                  -3
                ],
                [
                  -45,
                  -5
                ],
                [
                  -34,
                  -8
                ]
              ],
              [
                [
                  3514,
                  5686
                ],
                [
                  -1,
                  3
                ],
                [
                  2,
                  1
                ],
                [
                  17,
                  4
                ],
                [
                  3,
                  0
                ],
                [
                  -3,
                  11
                ],
                [
                  -2,
                  10
                ],
                [
                  -3,
                  6
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  3
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  1,
                  3
                ],
                [
                  2,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  4
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  6
                ],
                [
                  0,
                  2
                ],
                [
                  -2,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  3
                ],
                [
                  -3,
                  9
                ],
                [
                  10,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  0,
                  20
                ],
                [
                  0,
                  21
                ],
                [
                  0,
                  20
                ],
                [
                  0,
                  14
                ],
                [
                  0,
                  12
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  28
                ],
                [
                  0,
                  22
                ],
                [
                  0,
                  22
                ],
                [
                  0,
                  16
                ],
                [
                  -1,
                  11
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  4,
                  7
                ],
                [
                  1,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -3,
                  4
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  4
                ],
                [
                  0,
                  18
                ],
                [
                  0,
                  13
                ],
                [
                  0,
                  15
                ],
                [
                  -1,
                  18
                ],
                [
                  0,
                  3
                ],
                [
                  -1,
                  4
                ],
                [
                  -3,
                  5
                ],
                [
                  -8,
                  9
                ],
                [
                  -11,
                  11
                ],
                [
                  0,
                  1
                ],
                [
                  -3,
                  4
                ],
                [
                  -2,
                  6
                ],
                [
                  -1,
                  14
                ],
                [
                  -1,
                  4
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  7
                ],
                [
                  0,
                  11
                ],
                [
                  0,
                  15
                ],
                [
                  0,
                  10
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  5
                ],
                [
                  -14,
                  9
                ],
                [
                  -18,
                  13
                ],
                [
                  -11,
                  8
                ],
                [
                  -8,
                  5
                ],
                [
                  -12,
                  9
                ],
                [
                  -10,
                  7
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  2,
                  15
                ],
                [
                  1,
                  7
                ],
                [
                  1,
                  6
                ],
                [
                  -1,
                  12
                ],
                [
                  1,
                  5
                ],
                [
                  7,
                  7
                ],
                [
                  2,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  2,
                  4
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  1
                ],
                [
                  1,
                  3
                ],
                [
                  3,
                  9
                ]
              ],
              [
                [
                  3420,
                  6348
                ],
                [
                  4,
                  -3
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  4,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  4,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  -2
                ],
                [
                  2,
                  0
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  5
                ],
                [
                  -2,
                  4
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  4,
                  -2
                ],
                [
                  2,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  1,
                  3
                ],
                [
                  3,
                  1
                ],
                [
                  3,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  -1,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  0,
                  2
                ],
                [
                  2,
                  -1
                ],
                [
                  3,
                  0
                ],
                [
                  12,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  3,
                  0
                ],
                [
                  2,
                  -5
                ],
                [
                  3,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  6,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  5,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  5,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  -1
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  -1
                ],
                [
                  3,
                  -1
                ],
                [
                  5,
                  -2
                ],
                [
                  5,
                  -1
                ],
                [
                  4,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  17,
                  18
                ],
                [
                  10,
                  8
                ],
                [
                  7,
                  4
                ],
                [
                  2,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  2,
                  4
                ],
                [
                  5,
                  6
                ],
                [
                  1,
                  4
                ],
                [
                  5,
                  13
                ]
              ],
              [
                [
                  3614,
                  6473
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -4,
                  13
                ],
                [
                  -2,
                  8
                ],
                [
                  0,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  4,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  5,
                  1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  5,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  6,
                  -6
                ],
                [
                  3,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  5,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -3
                ],
                [
                  6,
                  -8
                ],
                [
                  22,
                  -21
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -3
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -3
                ],
                [
                  3,
                  -5
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  6,
                  -3
                ],
                [
                  5,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  4,
                  -7
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -1
                ]
              ],
              [
                [
                  3331,
                  6891
                ],
                [
                  1,
                  -3
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  0,
                  -4
                ],
                [
                  4,
                  -8
                ],
                [
                  0,
                  -4
                ],
                [
                  -8,
                  -26
                ],
                [
                  0,
                  -7
                ],
                [
                  4,
                  -7
                ],
                [
                  2,
                  -1
                ],
                [
                  19,
                  -18
                ],
                [
                  5,
                  -8
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -4
                ],
                [
                  0,
                  -1
                ],
                [
                  -3,
                  -5
                ],
                [
                  -1,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -3
                ],
                [
                  3,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -3
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  3,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  5,
                  -3
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  2,
                  -4
                ],
                [
                  4,
                  -1
                ],
                [
                  17,
                  1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  3,
                  -1
                ],
                [
                  5,
                  1
                ],
                [
                  6,
                  -2
                ],
                [
                  7,
                  -4
                ],
                [
                  5,
                  -6
                ],
                [
                  1,
                  -6
                ],
                [
                  2,
                  -5
                ],
                [
                  4,
                  -3
                ],
                [
                  14,
                  -7
                ],
                [
                  3,
                  -1
                ],
                [
                  5,
                  0
                ],
                [
                  3,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -3
                ],
                [
                  -4,
                  -2
                ],
                [
                  -2,
                  2
                ],
                [
                  -2,
                  2
                ],
                [
                  -3,
                  0
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -5
                ],
                [
                  -1,
                  0
                ],
                [
                  -3,
                  1
                ],
                [
                  -7,
                  2
                ],
                [
                  -10,
                  4
                ],
                [
                  -3,
                  1
                ],
                [
                  -2,
                  -6
                ],
                [
                  0,
                  -11
                ],
                [
                  0,
                  -13
                ],
                [
                  0,
                  -9
                ],
                [
                  0,
                  -3
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -3
                ],
                [
                  4,
                  -2
                ],
                [
                  9,
                  -1
                ],
                [
                  4,
                  -2
                ],
                [
                  7,
                  -6
                ],
                [
                  8,
                  -7
                ],
                [
                  10,
                  -8
                ],
                [
                  3,
                  -3
                ],
                [
                  11,
                  -10
                ],
                [
                  7,
                  -6
                ],
                [
                  9,
                  -8
                ],
                [
                  3,
                  -2
                ],
                [
                  5,
                  -1
                ],
                [
                  13,
                  -1
                ],
                [
                  17,
                  -2
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  3
                ],
                [
                  2,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  3
                ],
                [
                  2,
                  1
                ],
                [
                  12,
                  -1
                ],
                [
                  5,
                  -2
                ],
                [
                  4,
                  -4
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -8
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -3
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -7,
                  -1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -8,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  0,
                  -4
                ],
                [
                  2,
                  -5
                ],
                [
                  6,
                  -8
                ],
                [
                  10,
                  -15
                ],
                [
                  9,
                  -13
                ],
                [
                  10,
                  -15
                ],
                [
                  7,
                  -6
                ]
              ],
              [
                [
                  3420,
                  6348
                ],
                [
                  -17,
                  -1
                ],
                [
                  -12,
                  0
                ],
                [
                  -8,
                  -1
                ],
                [
                  -17,
                  -6
                ],
                [
                  2,
                  5
                ],
                [
                  -2,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -14,
                  3
                ],
                [
                  -12,
                  3
                ],
                [
                  -29,
                  6
                ],
                [
                  -16,
                  4
                ],
                [
                  -7,
                  1
                ],
                [
                  -7,
                  1
                ]
              ],
              [
                [
                  3281,
                  6367
                ],
                [
                  -18,
                  4
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  -6,
                  -5
                ],
                [
                  -3,
                  3
                ],
                [
                  -2,
                  2
                ],
                [
                  -3,
                  0
                ],
                [
                  -2,
                  -3
                ],
                [
                  -1,
                  -3
                ],
                [
                  0,
                  -3
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -4,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  -6,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -3
                ],
                [
                  -2,
                  -3
                ],
                [
                  -2,
                  -2
                ],
                [
                  -6,
                  6
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  -15,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -3,
                  -4
                ],
                [
                  -3,
                  0
                ],
                [
                  1,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -18,
                  2
                ],
                [
                  -3,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -16,
                  0
                ],
                [
                  -17,
                  0
                ],
                [
                  -3,
                  1
                ],
                [
                  -4,
                  2
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -17,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  -3
                ],
                [
                  -1,
                  -1
                ],
                [
                  -21,
                  0
                ],
                [
                  -28,
                  0
                ],
                [
                  -29,
                  0
                ],
                [
                  -32,
                  -1
                ],
                [
                  -25,
                  0
                ],
                [
                  -13,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -11,
                  1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -3
                ],
                [
                  -1,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  -3
                ],
                [
                  -2,
                  -6
                ],
                [
                  -2,
                  -4
                ],
                [
                  0,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  -4
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -3
                ],
                [
                  4,
                  -7
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -3
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -3
                ],
                [
                  1,
                  -1
                ],
                [
                  5,
                  -4
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  3,
                  0
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -3
                ],
                [
                  0,
                  -3
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -3,
                  -3
                ],
                [
                  -2,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  2,
                  -7
                ],
                [
                  0,
                  -11
                ],
                [
                  0,
                  -3
                ],
                [
                  3,
                  -5
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -4
                ],
                [
                  -1,
                  -6
                ],
                [
                  0,
                  -4
                ],
                [
                  3,
                  -5
                ],
                [
                  1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -5,
                  -5
                ],
                [
                  -2,
                  -5
                ],
                [
                  0,
                  -3
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  5,
                  -4
                ],
                [
                  5,
                  -7
                ]
              ],
              [
                [
                  2953,
                  6139
                ],
                [
                  -5,
                  -4
                ],
                [
                  -3,
                  -7
                ],
                [
                  -2,
                  -2
                ],
                [
                  -3,
                  0
                ],
                [
                  -3,
                  3
                ],
                [
                  -13,
                  18
                ],
                [
                  -7,
                  13
                ],
                [
                  -2,
                  7
                ],
                [
                  -2,
                  3
                ],
                [
                  -2,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -5,
                  -2
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  2
                ],
                [
                  -2,
                  4
                ],
                [
                  -1,
                  6
                ],
                [
                  -3,
                  4
                ],
                [
                  -3,
                  0
                ],
                [
                  -3,
                  0
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  3
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  -2
                ],
                [
                  -4,
                  -7
                ],
                [
                  -2,
                  -1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -2,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  3
                ],
                [
                  -2,
                  0
                ],
                [
                  -20,
                  2
                ],
                [
                  -8,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -6,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -3,
                  -3
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -9,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -5,
                  -4
                ],
                [
                  -3,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  -5,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -7,
                  2
                ],
                [
                  -3,
                  0
                ],
                [
                  -2,
                  -2
                ],
                [
                  -4,
                  -5
                ],
                [
                  -2,
                  -2
                ],
                [
                  -5,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  -4,
                  -4
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -4
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -4
                ],
                [
                  -1,
                  -1
                ],
                [
                  -4,
                  2
                ],
                [
                  -2,
                  0
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  4
                ],
                [
                  -1,
                  2
                ],
                [
                  -4,
                  1
                ],
                [
                  -4,
                  0
                ],
                [
                  -4,
                  0
                ],
                [
                  -2,
                  3
                ],
                [
                  0,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  3
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  1
                ],
                [
                  1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  3
                ],
                [
                  -2,
                  -1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  2
                ],
                [
                  -3,
                  0
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -3,
                  1
                ],
                [
                  -3,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  1
                ],
                [
                  -4,
                  4
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  6
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  3,
                  0
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  0,
                  3
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  2,
                  2
                ],
                [
                  3,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -3,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  -3,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  3
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  8
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  -7,
                  4
                ],
                [
                  -2,
                  -1
                ],
                [
                  -6,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -3,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  -2,
                  4
                ],
                [
                  -2,
                  3
                ],
                [
                  -2,
                  1
                ]
              ],
              [
                [
                  2584,
                  6269
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  7
                ],
                [
                  1,
                  1
                ],
                [
                  3,
                  5
                ],
                [
                  2,
                  8
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  7
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  8
                ],
                [
                  0,
                  2
                ],
                [
                  -2,
                  3
                ],
                [
                  -2,
                  10
                ],
                [
                  -2,
                  3
                ],
                [
                  -3,
                  0
                ],
                [
                  1,
                  3
                ],
                [
                  -1,
                  7
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  13,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  0,
                  5
                ],
                [
                  2,
                  3
                ],
                [
                  4,
                  5
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  -1,
                  14
                ],
                [
                  0,
                  3
                ],
                [
                  2,
                  2
                ],
                [
                  3,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  0,
                  12
                ],
                [
                  -1,
                  5
                ],
                [
                  -4,
                  3
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  6
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -3,
                  -1
                ],
                [
                  0,
                  1
                ],
                [
                  -4,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  4,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  3
                ],
                [
                  5,
                  5
                ],
                [
                  4,
                  4
                ],
                [
                  2,
                  2
                ],
                [
                  4,
                  1
                ],
                [
                  4,
                  3
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  5,
                  -1
                ],
                [
                  3,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  -1
                ],
                [
                  3,
                  0
                ],
                [
                  6,
                  2
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  -2
                ],
                [
                  2,
                  1
                ],
                [
                  4,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  3
                ],
                [
                  5,
                  2
                ],
                [
                  4,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  -3,
                  7
                ],
                [
                  11,
                  10
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  4,
                  1
                ],
                [
                  -1,
                  6
                ],
                [
                  -5,
                  12
                ],
                [
                  1,
                  3
                ],
                [
                  2,
                  3
                ],
                [
                  3,
                  2
                ],
                [
                  2,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -3,
                  6
                ],
                [
                  -2,
                  2
                ],
                [
                  -6,
                  5
                ],
                [
                  -1,
                  2
                ],
                [
                  1,
                  7
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  4,
                  1
                ],
                [
                  4,
                  1
                ],
                [
                  5,
                  1
                ],
                [
                  4,
                  -1
                ],
                [
                  3,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  3,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  3,
                  9
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  6
                ],
                [
                  0,
                  8
                ],
                [
                  -1,
                  4
                ],
                [
                  -2,
                  3
                ],
                [
                  -4,
                  3
                ],
                [
                  -2,
                  3
                ],
                [
                  -3,
                  8
                ],
                [
                  -4,
                  3
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  4
                ],
                [
                  2,
                  1
                ],
                [
                  9,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  -3,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  3
                ],
                [
                  2,
                  4
                ],
                [
                  2,
                  5
                ],
                [
                  1,
                  3
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  3
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  2,
                  3
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  3,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  -3
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  3,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  4,
                  -1
                ],
                [
                  6,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  10,
                  -8
                ],
                [
                  6,
                  -4
                ],
                [
                  10,
                  -8
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  5,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  -2,
                  5
                ],
                [
                  1,
                  4
                ],
                [
                  3,
                  1
                ],
                [
                  21,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  -5,
                  35
                ],
                [
                  2,
                  5
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  8
                ],
                [
                  -1,
                  3
                ],
                [
                  -2,
                  3
                ],
                [
                  2,
                  2
                ],
                [
                  4,
                  -1
                ],
                [
                  6,
                  -5
                ],
                [
                  3,
                  0
                ],
                [
                  3,
                  1
                ],
                [
                  3,
                  0
                ],
                [
                  3,
                  -2
                ],
                [
                  2,
                  -3
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  1
                ],
                [
                  4,
                  1
                ],
                [
                  5,
                  2
                ],
                [
                  -4,
                  13
                ],
                [
                  -1,
                  8
                ],
                [
                  3,
                  5
                ],
                [
                  2,
                  4
                ],
                [
                  5,
                  18
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  4,
                  5
                ],
                [
                  19,
                  12
                ],
                [
                  2,
                  2
                ],
                [
                  8,
                  9
                ],
                [
                  3,
                  2
                ],
                [
                  10,
                  7
                ],
                [
                  7,
                  1
                ],
                [
                  10,
                  -2
                ],
                [
                  31,
                  -15
                ],
                [
                  4,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  2
                ],
                [
                  7,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  3,
                  34
                ],
                [
                  1,
                  4
                ],
                [
                  4,
                  1
                ],
                [
                  6,
                  1
                ],
                [
                  11,
                  -1
                ],
                [
                  9,
                  0
                ],
                [
                  9,
                  2
                ],
                [
                  45,
                  31
                ],
                [
                  5,
                  2
                ],
                [
                  25,
                  7
                ],
                [
                  5,
                  2
                ],
                [
                  5,
                  3
                ],
                [
                  27,
                  24
                ],
                [
                  7,
                  8
                ],
                [
                  1,
                  1
                ],
                [
                  3,
                  2
                ],
                [
                  4,
                  1
                ],
                [
                  29,
                  0
                ],
                [
                  4,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  3,
                  -8
                ],
                [
                  1,
                  -2
                ],
                [
                  4,
                  0
                ],
                [
                  5,
                  2
                ],
                [
                  8,
                  6
                ],
                [
                  8,
                  1
                ],
                [
                  9,
                  -2
                ],
                [
                  17,
                  -8
                ],
                [
                  33,
                  -11
                ]
              ],
              [
                [
                  8477,
                  1853
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  0
                ]
              ],
              [
                [
                  6592,
                  2359
                ],
                [
                  -5,
                  -12
                ],
                [
                  0,
                  -4
                ],
                [
                  1,
                  -3
                ],
                [
                  4,
                  -9
                ],
                [
                  5,
                  -10
                ],
                [
                  4,
                  -4
                ],
                [
                  4,
                  -2
                ],
                [
                  4,
                  -4
                ],
                [
                  3,
                  -5
                ],
                [
                  4,
                  -10
                ],
                [
                  4,
                  -7
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -6
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -3
                ],
                [
                  8,
                  -9
                ],
                [
                  5,
                  -3
                ],
                [
                  2,
                  -2
                ],
                [
                  6,
                  -9
                ],
                [
                  4,
                  -3
                ],
                [
                  5,
                  -3
                ],
                [
                  3,
                  -3
                ],
                [
                  1,
                  -4
                ],
                [
                  1,
                  -11
                ],
                [
                  5,
                  -10
                ],
                [
                  16,
                  -15
                ],
                [
                  4,
                  -11
                ],
                [
                  -1,
                  -3
                ],
                [
                  -2,
                  -5
                ],
                [
                  0,
                  -3
                ],
                [
                  0,
                  -3
                ],
                [
                  1,
                  -3
                ],
                [
                  3,
                  -5
                ],
                [
                  4,
                  -5
                ],
                [
                  3,
                  -7
                ],
                [
                  13,
                  -35
                ],
                [
                  3,
                  -5
                ],
                [
                  5,
                  -3
                ],
                [
                  6,
                  -2
                ],
                [
                  7,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -3
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  4,
                  0
                ],
                [
                  3,
                  -2
                ],
                [
                  4,
                  -6
                ],
                [
                  2,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  6,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  5,
                  -3
                ],
                [
                  3,
                  -3
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -2
                ],
                [
                  3,
                  -1
                ],
                [
                  6,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  2,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  3,
                  -1
                ],
                [
                  3,
                  0
                ],
                [
                  5,
                  -1
                ],
                [
                  14,
                  -7
                ],
                [
                  5,
                  -1
                ],
                [
                  4,
                  0
                ],
                [
                  5,
                  -1
                ],
                [
                  4,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -3
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -3
                ],
                [
                  7,
                  -17
                ],
                [
                  2,
                  -16
                ],
                [
                  -2,
                  -20
                ],
                [
                  5,
                  2
                ],
                [
                  4,
                  1
                ],
                [
                  15,
                  0
                ],
                [
                  11,
                  -1
                ],
                [
                  7,
                  1
                ],
                [
                  5,
                  -2
                ],
                [
                  5,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -6
                ],
                [
                  -2,
                  -5
                ],
                [
                  -1,
                  -5
                ],
                [
                  3,
                  -11
                ],
                [
                  0,
                  -5
                ],
                [
                  -1,
                  -11
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -3
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -8
                ],
                [
                  0,
                  -3
                ],
                [
                  -2,
                  -7
                ],
                [
                  0,
                  -3
                ],
                [
                  1,
                  -2
                ],
                [
                  4,
                  -7
                ],
                [
                  2,
                  -2
                ],
                [
                  9,
                  -6
                ],
                [
                  4,
                  -5
                ],
                [
                  4,
                  -5
                ],
                [
                  4,
                  -6
                ],
                [
                  2,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -3
                ],
                [
                  4,
                  -8
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  3,
                  -1
                ],
                [
                  7,
                  0
                ],
                [
                  10,
                  -2
                ],
                [
                  15,
                  -1
                ],
                [
                  5,
                  -1
                ],
                [
                  5,
                  -1
                ],
                [
                  11,
                  -6
                ],
                [
                  3,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  5,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  5,
                  -1
                ],
                [
                  4,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  5,
                  -4
                ],
                [
                  6,
                  -2
                ],
                [
                  19,
                  -9
                ],
                [
                  4,
                  -1
                ],
                [
                  8,
                  0
                ],
                [
                  4,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  6,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  0,
                  -3
                ],
                [
                  -2,
                  -3
                ],
                [
                  -2,
                  -3
                ],
                [
                  -1,
                  -3
                ],
                [
                  -1,
                  -6
                ],
                [
                  1,
                  -6
                ],
                [
                  3,
                  -5
                ],
                [
                  4,
                  -5
                ],
                [
                  5,
                  -2
                ],
                [
                  4,
                  -1
                ],
                [
                  13,
                  0
                ],
                [
                  2,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -1
                ],
                [
                  10,
                  -8
                ]
              ],
              [
                [
                  7125,
                  1751
                ],
                [
                  -2,
                  -1
                ],
                [
                  -4,
                  0
                ],
                [
                  -7,
                  2
                ],
                [
                  -4,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -16,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -3,
                  -4
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -3,
                  -3
                ],
                [
                  -3,
                  -3
                ],
                [
                  1,
                  -10
                ],
                [
                  0,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -3,
                  -6
                ],
                [
                  -2,
                  -1
                ],
                [
                  -5,
                  0
                ],
                [
                  -3,
                  0
                ],
                [
                  -2,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  -3,
                  -1
                ],
                [
                  -3,
                  0
                ],
                [
                  -5,
                  -2
                ],
                [
                  -10,
                  -5
                ],
                [
                  -4,
                  -1
                ],
                [
                  -4,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -3,
                  0
                ],
                [
                  -3,
                  -3
                ],
                [
                  -2,
                  -1
                ],
                [
                  -8,
                  3
                ],
                [
                  -11,
                  -1
                ],
                [
                  -5,
                  -1
                ],
                [
                  -4,
                  -3
                ],
                [
                  -2,
                  -2
                ],
                [
                  -5,
                  -5
                ],
                [
                  -1,
                  -1
                ],
                [
                  -4,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -4,
                  -5
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -3,
                  -1
                ],
                [
                  -3,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -3
                ],
                [
                  0,
                  -3
                ],
                [
                  -2,
                  -3
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  0,
                  -3
                ],
                [
                  1,
                  -6
                ],
                [
                  -2,
                  -4
                ],
                [
                  -4,
                  -3
                ],
                [
                  -6,
                  -2
                ],
                [
                  -5,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -3,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -5
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  1
                ],
                [
                  -4,
                  4
                ],
                [
                  -5,
                  -4
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  -4
                ],
                [
                  -2,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -4
                ],
                [
                  -1,
                  -2
                ],
                [
                  -3,
                  -2
                ],
                [
                  -3,
                  -1
                ],
                [
                  -5,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  5
                ],
                [
                  -2,
                  -2
                ],
                [
                  -3,
                  -5
                ],
                [
                  -2,
                  -2
                ],
                [
                  -3,
                  -1
                ],
                [
                  -5,
                  -3
                ],
                [
                  -5,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  2,
                  -3
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -3
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -3,
                  -5
                ],
                [
                  -2,
                  -5
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  -4,
                  -6
                ],
                [
                  1,
                  -3
                ],
                [
                  -1,
                  -4
                ],
                [
                  -9,
                  -37
                ],
                [
                  0,
                  -6
                ],
                [
                  -2,
                  -12
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  -3,
                  -2
                ],
                [
                  -11,
                  -3
                ],
                [
                  -3,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -8,
                  -8
                ],
                [
                  -8,
                  -5
                ],
                [
                  -4,
                  -3
                ],
                [
                  -3,
                  -4
                ],
                [
                  -4,
                  -10
                ],
                [
                  -1,
                  -2
                ],
                [
                  -8,
                  -8
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -3,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  0
                ],
                [
                  -6,
                  -1
                ],
                [
                  -15,
                  -4
                ],
                [
                  -19,
                  -6
                ],
                [
                  -5,
                  -3
                ],
                [
                  -2,
                  -1
                ],
                [
                  -6,
                  0
                ],
                [
                  -5,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -4
                ],
                [
                  1,
                  -10
                ],
                [
                  0,
                  -5
                ],
                [
                  -2,
                  -5
                ],
                [
                  -3,
                  -8
                ],
                [
                  -1,
                  -5
                ],
                [
                  -4,
                  -7
                ],
                [
                  -2,
                  -9
                ],
                [
                  -12,
                  -25
                ],
                [
                  -4,
                  -18
                ],
                [
                  -1,
                  -3
                ],
                [
                  -6,
                  -14
                ],
                [
                  -3,
                  -8
                ],
                [
                  -17,
                  -13
                ],
                [
                  -9,
                  -4
                ],
                [
                  -27,
                  -3
                ],
                [
                  -6,
                  1
                ],
                [
                  -6,
                  2
                ],
                [
                  -5,
                  1
                ],
                [
                  -5,
                  -1
                ],
                [
                  -6,
                  -3
                ],
                [
                  -7,
                  -6
                ],
                [
                  -3,
                  -1
                ],
                [
                  -8,
                  -2
                ],
                [
                  -4,
                  0
                ],
                [
                  -3,
                  1
                ],
                [
                  -5,
                  1
                ],
                [
                  -9,
                  -1
                ],
                [
                  -5,
                  1
                ],
                [
                  -7,
                  4
                ],
                [
                  -9,
                  4
                ],
                [
                  -6,
                  2
                ],
                [
                  -3,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -4,
                  -1
                ],
                [
                  -6,
                  1
                ],
                [
                  -6,
                  4
                ],
                [
                  -9,
                  10
                ],
                [
                  -6,
                  3
                ],
                [
                  -7,
                  0
                ],
                [
                  -13,
                  -3
                ],
                [
                  -3,
                  -1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -6,
                  -1
                ],
                [
                  -3,
                  1
                ],
                [
                  -2,
                  3
                ],
                [
                  -6,
                  4
                ],
                [
                  -5,
                  6
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  1
                ],
                [
                  -7,
                  2
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -14,
                  10
                ],
                [
                  -3,
                  2
                ],
                [
                  -4,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  -2,
                  3
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -4,
                  -2
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -6,
                  2
                ],
                [
                  -7,
                  1
                ],
                [
                  -7,
                  0
                ],
                [
                  -6,
                  -2
                ],
                [
                  -10,
                  -4
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -3,
                  0
                ],
                [
                  -3,
                  -1
                ],
                [
                  -5,
                  -5
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  -6
                ],
                [
                  -2,
                  -1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -3,
                  -8
                ],
                [
                  -1,
                  -3
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -6,
                  -7
                ],
                [
                  -2,
                  -3
                ],
                [
                  -1,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  -3
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -3
                ],
                [
                  -1,
                  -3
                ],
                [
                  0,
                  -3
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -4,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  -6,
                  -8
                ],
                [
                  -1,
                  -1
                ],
                [
                  -3,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  -5
                ],
                [
                  -2,
                  -3
                ],
                [
                  -2,
                  -1
                ],
                [
                  -6,
                  1
                ],
                [
                  -4,
                  -1
                ],
                [
                  -3,
                  -2
                ],
                [
                  -5,
                  -6
                ],
                [
                  -6,
                  -7
                ],
                [
                  -4,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -6,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -3
                ],
                [
                  -5,
                  -5
                ],
                [
                  -3,
                  -5
                ],
                [
                  -4,
                  -11
                ],
                [
                  -5,
                  -7
                ],
                [
                  -7,
                  -6
                ],
                [
                  -7,
                  -5
                ],
                [
                  -8,
                  -2
                ],
                [
                  -13,
                  0
                ],
                [
                  -4,
                  0
                ],
                [
                  -4,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -6
                ],
                [
                  0,
                  -3
                ],
                [
                  -1,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  -8,
                  -5
                ],
                [
                  -3,
                  -1
                ],
                [
                  -3,
                  0
                ],
                [
                  -7,
                  2
                ],
                [
                  -11,
                  0
                ],
                [
                  -7,
                  3
                ],
                [
                  -3,
                  0
                ],
                [
                  -6,
                  0
                ],
                [
                  -11,
                  -3
                ],
                [
                  -1,
                  0
                ],
                [
                  -4,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -11,
                  -3
                ],
                [
                  -4,
                  -1
                ],
                [
                  -18,
                  4
                ],
                [
                  -5,
                  3
                ],
                [
                  -5,
                  2
                ],
                [
                  -8,
                  0
                ],
                [
                  -3,
                  -2
                ],
                [
                  -6,
                  -4
                ],
                [
                  -8,
                  -4
                ],
                [
                  -3,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  5
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  4
                ],
                [
                  -1,
                  5
                ],
                [
                  -1,
                  5
                ],
                [
                  0,
                  4
                ],
                [
                  3,
                  10
                ],
                [
                  0,
                  3
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  3
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  4
                ],
                [
                  0,
                  4
                ],
                [
                  2,
                  7
                ],
                [
                  1,
                  2
                ],
                [
                  3,
                  3
                ],
                [
                  2,
                  2
                ],
                [
                  4,
                  7
                ],
                [
                  8,
                  9
                ],
                [
                  3,
                  5
                ],
                [
                  2,
                  5
                ],
                [
                  6,
                  8
                ],
                [
                  0,
                  2
                ],
                [
                  -5,
                  8
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  10
                ],
                [
                  -1,
                  12
                ],
                [
                  -4,
                  8
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  0,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  -3,
                  9
                ],
                [
                  -1,
                  3
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  3,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  -1,
                  4
                ],
                [
                  -6,
                  5
                ],
                [
                  0,
                  4
                ],
                [
                  1,
                  2
                ],
                [
                  4,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  0,
                  3
                ],
                [
                  -1,
                  1
                ],
                [
                  -4,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  5
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  -3,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  4
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  -4,
                  5
                ],
                [
                  -4,
                  8
                ],
                [
                  -1,
                  2
                ],
                [
                  -17,
                  14
                ],
                [
                  -10,
                  6
                ],
                [
                  -1,
                  0
                ],
                [
                  -3,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  4
                ],
                [
                  -7,
                  5
                ],
                [
                  -2,
                  4
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  2
                ]
              ],
              [
                [
                  5905,
                  1395
                ],
                [
                  0,
                  24
                ],
                [
                  0,
                  24
                ],
                [
                  0,
                  24
                ],
                [
                  0,
                  23
                ],
                [
                  0,
                  24
                ],
                [
                  0,
                  4
                ],
                [
                  0,
                  20
                ],
                [
                  0,
                  24
                ],
                [
                  0,
                  24
                ],
                [
                  0,
                  9
                ],
                [
                  0,
                  15
                ],
                [
                  0,
                  23
                ],
                [
                  0,
                  24
                ],
                [
                  0,
                  24
                ],
                [
                  0,
                  21
                ],
                [
                  0,
                  21
                ],
                [
                  0,
                  21
                ],
                [
                  0,
                  21
                ],
                [
                  0,
                  11
                ],
                [
                  30,
                  0
                ],
                [
                  31,
                  0
                ],
                [
                  30,
                  0
                ],
                [
                  31,
                  0
                ],
                [
                  7,
                  0
                ],
                [
                  2,
                  6
                ],
                [
                  0,
                  5
                ],
                [
                  0,
                  8
                ],
                [
                  0,
                  8
                ],
                [
                  0,
                  8
                ],
                [
                  0,
                  8
                ],
                [
                  0,
                  8
                ],
                [
                  0,
                  8
                ],
                [
                  -1,
                  8
                ],
                [
                  0,
                  8
                ],
                [
                  0,
                  8
                ],
                [
                  0,
                  8
                ],
                [
                  0,
                  8
                ],
                [
                  0,
                  8
                ],
                [
                  0,
                  8
                ],
                [
                  0,
                  8
                ],
                [
                  0,
                  8
                ],
                [
                  0,
                  8
                ],
                [
                  0,
                  17
                ],
                [
                  0,
                  18
                ],
                [
                  0,
                  17
                ],
                [
                  0,
                  17
                ],
                [
                  0,
                  18
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  14
                ],
                [
                  0,
                  17
                ],
                [
                  0,
                  18
                ],
                [
                  0,
                  17
                ],
                [
                  0,
                  17
                ],
                [
                  0,
                  17
                ],
                [
                  0,
                  18
                ],
                [
                  0,
                  17
                ],
                [
                  0,
                  17
                ],
                [
                  0,
                  11
                ],
                [
                  -1,
                  7
                ],
                [
                  0,
                  17
                ],
                [
                  0,
                  6
                ],
                [
                  0,
                  5
                ],
                [
                  0,
                  6
                ],
                [
                  0,
                  6
                ],
                [
                  0,
                  5
                ],
                [
                  0,
                  6
                ],
                [
                  0,
                  6
                ],
                [
                  0,
                  5
                ],
                [
                  0,
                  6
                ],
                [
                  0,
                  6
                ],
                [
                  0,
                  5
                ],
                [
                  0,
                  6
                ],
                [
                  0,
                  6
                ],
                [
                  0,
                  5
                ],
                [
                  0,
                  6
                ],
                [
                  0,
                  6
                ],
                [
                  0,
                  3
                ],
                [
                  3,
                  1
                ],
                [
                  4,
                  0
                ],
                [
                  7,
                  0
                ],
                [
                  8,
                  0
                ],
                [
                  7,
                  1
                ],
                [
                  7,
                  0
                ],
                [
                  6,
                  0
                ],
                [
                  6,
                  1
                ],
                [
                  7,
                  0
                ],
                [
                  6,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  0
                ],
                [
                  11,
                  2
                ],
                [
                  11,
                  2
                ],
                [
                  10,
                  3
                ],
                [
                  11,
                  2
                ],
                [
                  11,
                  2
                ],
                [
                  11,
                  2
                ],
                [
                  11,
                  2
                ],
                [
                  11,
                  2
                ],
                [
                  11,
                  3
                ],
                [
                  11,
                  2
                ],
                [
                  11,
                  2
                ],
                [
                  11,
                  2
                ],
                [
                  11,
                  2
                ],
                [
                  11,
                  2
                ],
                [
                  11,
                  3
                ],
                [
                  11,
                  2
                ],
                [
                  12,
                  2
                ],
                [
                  15,
                  1
                ],
                [
                  11,
                  1
                ],
                [
                  9,
                  1
                ],
                [
                  5,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  -1,
                  -4
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -4
                ],
                [
                  4,
                  -4
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  -2
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  4,
                  -5
                ],
                [
                  1,
                  -3
                ],
                [
                  -2,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  3,
                  -6
                ],
                [
                  1,
                  -6
                ],
                [
                  1,
                  -2
                ],
                [
                  3,
                  1
                ],
                [
                  4,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  4
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  2
                ],
                [
                  13,
                  13
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  3,
                  4
                ],
                [
                  1,
                  1
                ],
                [
                  4,
                  3
                ],
                [
                  2,
                  2
                ],
                [
                  0,
                  5
                ],
                [
                  5,
                  3
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  4,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  4,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  5,
                  1
                ],
                [
                  4,
                  3
                ],
                [
                  6,
                  8
                ],
                [
                  5,
                  2
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  4,
                  7
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  4,
                  -1
                ],
                [
                  3,
                  0
                ],
                [
                  2,
                  -2
                ],
                [
                  2,
                  -4
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  4,
                  -5
                ],
                [
                  2,
                  1
                ],
                [
                  6,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  7,
                  8
                ],
                [
                  2,
                  2
                ],
                [
                  4,
                  3
                ],
                [
                  4,
                  4
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  3
                ],
                [
                  3,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  10,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  -1,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  4,
                  2
                ],
                [
                  1,
                  -2
                ],
                [
                  4,
                  0
                ],
                [
                  4,
                  2
                ],
                [
                  5,
                  4
                ],
                [
                  5,
                  0
                ],
                [
                  8,
                  -2
                ]
              ],
              [
                [
                  6280,
                  6338
                ],
                [
                  0,
                  -4
                ],
                [
                  19,
                  -29
                ],
                [
                  13,
                  -10
                ],
                [
                  24,
                  -24
                ],
                [
                  22,
                  -37
                ],
                [
                  21,
                  -37
                ],
                [
                  3,
                  -6
                ],
                [
                  4,
                  -24
                ],
                [
                  -1,
                  -5
                ],
                [
                  -1,
                  -4
                ],
                [
                  -5,
                  -8
                ],
                [
                  -2,
                  -4
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -4
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -4
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -3,
                  -11
                ],
                [
                  0,
                  -3
                ],
                [
                  1,
                  -4
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -5,
                  -7
                ],
                [
                  -3,
                  -3
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -4,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -3,
                  -18
                ],
                [
                  0,
                  -3
                ],
                [
                  2,
                  -3
                ],
                [
                  3,
                  -2
                ],
                [
                  4,
                  0
                ],
                [
                  5,
                  5
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  -3
                ],
                [
                  0,
                  -5
                ],
                [
                  -2,
                  -8
                ],
                [
                  -2,
                  -3
                ],
                [
                  -5,
                  -7
                ],
                [
                  -2,
                  -3
                ],
                [
                  0,
                  -4
                ],
                [
                  1,
                  -3
                ],
                [
                  2,
                  -3
                ],
                [
                  3,
                  -2
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  4,
                  1
                ],
                [
                  4,
                  -2
                ],
                [
                  2,
                  1
                ],
                [
                  4,
                  2
                ],
                [
                  5,
                  0
                ],
                [
                  8,
                  -2
                ],
                [
                  7,
                  1
                ],
                [
                  5,
                  -2
                ],
                [
                  3,
                  -1
                ],
                [
                  4,
                  1
                ],
                [
                  13,
                  -2
                ],
                [
                  8,
                  1
                ]
              ],
              [
                [
                  6451,
                  6029
                ],
                [
                  1,
                  0
                ],
                [
                  5,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  -3,
                  -4
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  3,
                  -3
                ],
                [
                  1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -5,
                  -4
                ],
                [
                  -1,
                  -1
                ],
                [
                  -8,
                  -13
                ],
                [
                  -1,
                  -5
                ],
                [
                  -1,
                  -4
                ],
                [
                  1,
                  -4
                ],
                [
                  3,
                  -4
                ],
                [
                  4,
                  -3
                ],
                [
                  3,
                  -2
                ],
                [
                  2,
                  0
                ],
                [
                  5,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  8,
                  3
                ],
                [
                  5,
                  1
                ],
                [
                  3,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  4,
                  -3
                ],
                [
                  4,
                  0
                ],
                [
                  9,
                  1
                ],
                [
                  8,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  -1
                ],
                [
                  4,
                  -2
                ],
                [
                  8,
                  -1
                ],
                [
                  4,
                  -2
                ],
                [
                  11,
                  -11
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -5
                ],
                [
                  2,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  6,
                  -7
                ],
                [
                  4,
                  -3
                ],
                [
                  4,
                  -2
                ],
                [
                  2,
                  0
                ],
                [
                  4,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  3,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -4
                ],
                [
                  2,
                  -4
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -6
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  -3
                ],
                [
                  -9,
                  -3
                ],
                [
                  -3,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -7
                ],
                [
                  8,
                  -4
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -4
                ],
                [
                  0,
                  -2
                ],
                [
                  2,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  7,
                  -4
                ],
                [
                  5,
                  -4
                ],
                [
                  3,
                  -2
                ],
                [
                  3,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  6,
                  -6
                ],
                [
                  2,
                  -1
                ],
                [
                  8,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  3,
                  -3
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  3,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  6,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -3
                ],
                [
                  0,
                  -1
                ],
                [
                  4,
                  -3
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  6,
                  -1
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -7
                ],
                [
                  1,
                  -3
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  3,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  4,
                  -6
                ],
                [
                  5,
                  -4
                ],
                [
                  3,
                  -2
                ],
                [
                  4,
                  -3
                ],
                [
                  8,
                  -3
                ],
                [
                  6,
                  -3
                ],
                [
                  0,
                  -4
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -5
                ],
                [
                  -4,
                  -6
                ],
                [
                  -2,
                  -5
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  3,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  -2
                ],
                [
                  2,
                  -2
                ],
                [
                  3,
                  -5
                ],
                [
                  2,
                  -1
                ],
                [
                  6,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  0,
                  -4
                ],
                [
                  0,
                  -3
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -3
                ],
                [
                  -2,
                  -2
                ],
                [
                  -3,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  -3
                ],
                [
                  0,
                  -3
                ],
                [
                  2,
                  1
                ],
                [
                  5,
                  4
                ],
                [
                  3,
                  -1
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -3
                ],
                [
                  2,
                  -2
                ],
                [
                  2,
                  -2
                ],
                [
                  7,
                  -3
                ],
                [
                  4,
                  0
                ],
                [
                  10,
                  0
                ],
                [
                  9,
                  -3
                ],
                [
                  2,
                  -2
                ],
                [
                  2,
                  -2
                ],
                [
                  0,
                  -6
                ],
                [
                  1,
                  -3
                ],
                [
                  4,
                  -1
                ],
                [
                  3,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  -3
                ],
                [
                  1,
                  -3
                ],
                [
                  3,
                  0
                ],
                [
                  6,
                  2
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -4
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  5,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  3,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -5,
                  -15
                ],
                [
                  -1,
                  -3
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -4
                ],
                [
                  1,
                  -7
                ],
                [
                  0,
                  -2
                ],
                [
                  4,
                  -8
                ],
                [
                  2,
                  -5
                ],
                [
                  2,
                  -3
                ],
                [
                  8,
                  -5
                ],
                [
                  3,
                  -4
                ],
                [
                  2,
                  -5
                ],
                [
                  4,
                  -3
                ],
                [
                  2,
                  -2
                ]
              ],
              [
                [
                  6877,
                  5527
                ],
                [
                  -4,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -3,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  -2,
                  0
                ],
                [
                  -3,
                  1
                ],
                [
                  -3,
                  1
                ],
                [
                  -10,
                  5
                ],
                [
                  -6,
                  2
                ],
                [
                  -5,
                  1
                ],
                [
                  -6,
                  -2
                ],
                [
                  -5,
                  -3
                ],
                [
                  -4,
                  -3
                ],
                [
                  -4,
                  -3
                ],
                [
                  -3,
                  -4
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -3
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  -3,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -5,
                  6
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -6,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -3,
                  0
                ],
                [
                  -3,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -3,
                  5
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -3,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  0
                ],
                [
                  -3,
                  0
                ],
                [
                  -3,
                  0
                ],
                [
                  -3,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  4
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  1,
                  -3
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  1
                ],
                [
                  -3,
                  3
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  0,
                  -3
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  -2,
                  2
                ],
                [
                  -3,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  4
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -4,
                  5
                ],
                [
                  -1,
                  1
                ],
                [
                  -3,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  -3,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -3,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -4,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  -6,
                  -3
                ],
                [
                  -3,
                  -1
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  -3,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  0,
                  -3
                ],
                [
                  -1,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  1,
                  -3
                ],
                [
                  3,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -3
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -6,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -8,
                  -1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -3
                ],
                [
                  0,
                  -3
                ],
                [
                  -1,
                  0
                ],
                [
                  -5,
                  1
                ],
                [
                  -5,
                  3
                ],
                [
                  -4,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  -3,
                  -1
                ],
                [
                  -5,
                  -3
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  2
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  0
                ],
                [
                  -9,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  3
                ],
                [
                  -2,
                  1
                ],
                [
                  -4,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  1
                ],
                [
                  -3,
                  2
                ],
                [
                  -3,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -3,
                  0
                ],
                [
                  -3,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  4
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  -3
                ],
                [
                  -1,
                  -3
                ],
                [
                  2,
                  -1
                ],
                [
                  3,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -3,
                  -2
                ],
                [
                  -9,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -4
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  3
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -3,
                  -5
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -3,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -4,
                  -3
                ],
                [
                  -6,
                  -3
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  -3,
                  0
                ],
                [
                  -6,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -3,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -5,
                  -4
                ],
                [
                  -3,
                  -1
                ],
                [
                  -6,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -5,
                  -3
                ],
                [
                  -6,
                  -1
                ],
                [
                  -3,
                  -2
                ],
                [
                  -8,
                  -6
                ],
                [
                  -2,
                  -1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -3,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -3,
                  0
                ],
                [
                  -2,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -3,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  4
                ],
                [
                  -4,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  4
                ],
                [
                  -2,
                  2
                ],
                [
                  -6,
                  -3
                ],
                [
                  -3,
                  0
                ],
                [
                  -3,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  -2,
                  3
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -3
                ],
                [
                  -2,
                  -4
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -4
                ],
                [
                  -1,
                  -3
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -3,
                  0
                ],
                [
                  -6,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -4
                ],
                [
                  1,
                  -4
                ],
                [
                  0,
                  -2
                ],
                [
                  3,
                  -3
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -4,
                  -8
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -3
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -3
                ],
                [
                  -2,
                  -2
                ],
                [
                  -5,
                  -3
                ],
                [
                  0,
                  -1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -16,
                  -1
                ],
                [
                  -12,
                  3
                ],
                [
                  -3,
                  2
                ],
                [
                  -3,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -3,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -3,
                  1
                ],
                [
                  -7,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  -4,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -3,
                  -1
                ],
                [
                  -7,
                  1
                ],
                [
                  -3,
                  0
                ],
                [
                  -2,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  -3,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  2
                ],
                [
                  -2,
                  0
                ],
                [
                  -5,
                  -1
                ],
                [
                  -5,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -12,
                  -7
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -6,
                  -1
                ],
                [
                  -3,
                  1
                ],
                [
                  -3,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -6,
                  5
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -3,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -4,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  5
                ],
                [
                  -1,
                  1
                ],
                [
                  -3,
                  0
                ],
                [
                  -12,
                  5
                ],
                [
                  -12,
                  3
                ],
                [
                  -5,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -4,
                  -1
                ],
                [
                  -10,
                  0
                ],
                [
                  -11,
                  -1
                ],
                [
                  -3,
                  0
                ],
                [
                  -3,
                  2
                ],
                [
                  -13,
                  14
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  -2,
                  3
                ],
                [
                  -3,
                  3
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -3,
                  6
                ],
                [
                  -2,
                  5
                ],
                [
                  -2,
                  2
                ],
                [
                  -3,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -6,
                  2
                ],
                [
                  -3,
                  2
                ],
                [
                  -2,
                  2
                ],
                [
                  -6,
                  8
                ],
                [
                  -3,
                  1
                ],
                [
                  -8,
                  4
                ],
                [
                  -4,
                  3
                ],
                [
                  -4,
                  3
                ],
                [
                  -3,
                  2
                ],
                [
                  -12,
                  3
                ],
                [
                  -3,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  4
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -6,
                  3
                ],
                [
                  -4,
                  1
                ],
                [
                  -3,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -15,
                  1
                ],
                [
                  -5,
                  2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -4,
                  -2
                ],
                [
                  -3,
                  0
                ],
                [
                  -9,
                  0
                ],
                [
                  -3,
                  0
                ],
                [
                  -1,
                  -2
                ],
                [
                  -3,
                  -4
                ],
                [
                  -12,
                  -8
                ],
                [
                  -6,
                  -3
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -4
                ],
                [
                  -2,
                  -3
                ],
                [
                  -2,
                  -1
                ],
                [
                  -6,
                  0
                ],
                [
                  -3,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -3,
                  -3
                ],
                [
                  -2,
                  -3
                ],
                [
                  -1,
                  -3
                ],
                [
                  -1,
                  -4
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -5
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  -3,
                  -2
                ],
                [
                  -4,
                  -8
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -4
                ],
                [
                  -4,
                  -4
                ],
                [
                  -3,
                  -5
                ],
                [
                  -7,
                  -17
                ],
                [
                  -3,
                  -5
                ],
                [
                  -4,
                  -3
                ],
                [
                  -6,
                  -2
                ],
                [
                  -3,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -3,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  1
                ],
                [
                  -3,
                  -3
                ],
                [
                  -1,
                  -4
                ],
                [
                  -1,
                  -3
                ],
                [
                  1,
                  -2
                ],
                [
                  4,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  5,
                  -10
                ],
                [
                  1,
                  -5
                ],
                [
                  2,
                  -12
                ],
                [
                  0,
                  -9
                ],
                [
                  0,
                  -3
                ],
                [
                  -1,
                  -3
                ],
                [
                  -3,
                  -5
                ],
                [
                  0,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -4
                ],
                [
                  -3,
                  -17
                ],
                [
                  5,
                  -33
                ]
              ],
              [
                [
                  5729,
                  5306
                ],
                [
                  -6,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  5
                ],
                [
                  -5,
                  9
                ],
                [
                  -2,
                  3
                ],
                [
                  -4,
                  3
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -10,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -4
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -3
                ],
                [
                  -3,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -3,
                  0
                ],
                [
                  -2,
                  2
                ],
                [
                  -2,
                  5
                ],
                [
                  -2,
                  3
                ],
                [
                  -4,
                  1
                ],
                [
                  -5,
                  0
                ],
                [
                  -4,
                  -1
                ],
                [
                  -4,
                  -2
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -5,
                  3
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  -1
                ],
                [
                  -5,
                  -2
                ],
                [
                  -3,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  3
                ],
                [
                  -2,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -3,
                  -1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -11,
                  0
                ],
                [
                  -5,
                  1
                ],
                [
                  -5,
                  2
                ],
                [
                  -4,
                  4
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -3,
                  0
                ],
                [
                  -3,
                  0
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -5,
                  -3
                ],
                [
                  -3,
                  -3
                ],
                [
                  -3,
                  -3
                ],
                [
                  -4,
                  0
                ],
                [
                  -4,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -6,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -4,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -3,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -4,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -3,
                  0
                ],
                [
                  -10,
                  2
                ],
                [
                  -3,
                  1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -6,
                  -1
                ],
                [
                  -6,
                  -4
                ],
                [
                  -4,
                  -5
                ],
                [
                  -2,
                  -6
                ],
                [
                  -1,
                  -12
                ],
                [
                  -3,
                  -9
                ],
                [
                  0,
                  -3
                ],
                [
                  -1,
                  -3
                ],
                [
                  -4,
                  -7
                ],
                [
                  -2,
                  -3
                ],
                [
                  0,
                  -3
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -3
                ],
                [
                  0,
                  -5
                ],
                [
                  -5,
                  -11
                ],
                [
                  0,
                  -6
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -2
                ],
                [
                  2,
                  -3
                ],
                [
                  -1,
                  -3
                ],
                [
                  -4,
                  -9
                ],
                [
                  -3,
                  -7
                ],
                [
                  -2,
                  -4
                ],
                [
                  -5,
                  -12
                ],
                [
                  -6,
                  -13
                ],
                [
                  -4,
                  -10
                ],
                [
                  -6,
                  -13
                ],
                [
                  -7,
                  -15
                ]
              ],
              [
                [
                  5412,
                  5135
                ],
                [
                  -2,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  3
                ],
                [
                  -2,
                  4
                ],
                [
                  -1,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  5
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  2,
                  4
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  3
                ],
                [
                  -2,
                  5
                ],
                [
                  -1,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  5
                ],
                [
                  0,
                  4
                ],
                [
                  4,
                  3
                ],
                [
                  1,
                  4
                ],
                [
                  0,
                  3
                ],
                [
                  -2,
                  4
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  5
                ],
                [
                  -3,
                  4
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  7
                ],
                [
                  -1,
                  3
                ],
                [
                  -2,
                  3
                ],
                [
                  -3,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -5,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -10,
                  11
                ],
                [
                  -12,
                  14
                ],
                [
                  -13,
                  15
                ],
                [
                  -14,
                  15
                ],
                [
                  -11,
                  12
                ],
                [
                  -9,
                  10
                ],
                [
                  -1,
                  2
                ],
                [
                  -10,
                  12
                ],
                [
                  -12,
                  17
                ],
                [
                  -7,
                  20
                ],
                [
                  2,
                  0
                ],
                [
                  4,
                  -2
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  1
                ],
                [
                  5,
                  2
                ],
                [
                  3,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  4
                ],
                [
                  0,
                  7
                ],
                [
                  -1,
                  9
                ],
                [
                  -1,
                  4
                ],
                [
                  -2,
                  3
                ],
                [
                  -5,
                  6
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  4
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -6,
                  2
                ],
                [
                  -20,
                  15
                ],
                [
                  -5,
                  5
                ],
                [
                  -4,
                  6
                ],
                [
                  -1,
                  7
                ],
                [
                  -1,
                  10
                ],
                [
                  -1,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  13
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  4
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  5
                ],
                [
                  -1,
                  5
                ],
                [
                  0,
                  7
                ],
                [
                  0,
                  3
                ],
                [
                  -1,
                  3
                ],
                [
                  -2,
                  3
                ],
                [
                  -2,
                  3
                ],
                [
                  -2,
                  1
                ],
                [
                  -6,
                  2
                ],
                [
                  -3,
                  2
                ],
                [
                  -2,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  4
                ],
                [
                  0,
                  3
                ],
                [
                  2,
                  4
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  4
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  -2,
                  3
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  3,
                  6
                ],
                [
                  1,
                  8
                ],
                [
                  1,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  14
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  3
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -4,
                  -3
                ],
                [
                  -2,
                  0
                ],
                [
                  -4,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  2
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  3,
                  3
                ],
                [
                  2,
                  1
                ],
                [
                  4,
                  4
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  5,
                  0
                ],
                [
                  19,
                  10
                ],
                [
                  2,
                  1
                ],
                [
                  5,
                  7
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  3,
                  4
                ],
                [
                  15,
                  36
                ],
                [
                  1,
                  3
                ],
                [
                  2,
                  3
                ],
                [
                  2,
                  1
                ],
                [
                  8,
                  4
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  6
                ],
                [
                  3,
                  6
                ],
                [
                  4,
                  12
                ],
                [
                  2,
                  8
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  8
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  3
                ],
                [
                  2,
                  7
                ],
                [
                  3,
                  3
                ],
                [
                  2,
                  1
                ],
                [
                  10,
                  6
                ],
                [
                  6,
                  5
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -3,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  7,
                  10
                ],
                [
                  1,
                  2
                ]
              ],
              [
                [
                  5319,
                  5867
                ],
                [
                  4,
                  -1
                ],
                [
                  5,
                  -1
                ],
                [
                  10,
                  2
                ],
                [
                  5,
                  -1
                ],
                [
                  7,
                  -6
                ],
                [
                  5,
                  -2
                ],
                [
                  5,
                  0
                ],
                [
                  17,
                  4
                ],
                [
                  2,
                  1
                ],
                [
                  4,
                  3
                ],
                [
                  2,
                  2
                ],
                [
                  3,
                  4
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  8,
                  2
                ],
                [
                  5,
                  1
                ],
                [
                  3,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  5,
                  4
                ],
                [
                  2,
                  1
                ],
                [
                  12,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  9
                ],
                [
                  1,
                  3
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  4
                ],
                [
                  0,
                  1
                ],
                [
                  3,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  5,
                  2
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -4
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  3,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -2
                ],
                [
                  5,
                  -1
                ],
                [
                  3,
                  -2
                ],
                [
                  3,
                  -2
                ],
                [
                  5,
                  -6
                ],
                [
                  3,
                  -5
                ],
                [
                  1,
                  -1
                ],
                [
                  3,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  5,
                  2
                ],
                [
                  6,
                  1
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  4,
                  -1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  3,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  5,
                  6
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  18,
                  6
                ],
                [
                  3,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  6,
                  -2
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  3
                ],
                [
                  2,
                  2
                ],
                [
                  3,
                  1
                ],
                [
                  5,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  3,
                  4
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  18,
                  -3
                ],
                [
                  6,
                  0
                ],
                [
                  5,
                  1
                ],
                [
                  10,
                  4
                ],
                [
                  12,
                  3
                ],
                [
                  57,
                  1
                ],
                [
                  11,
                  3
                ],
                [
                  3,
                  6
                ],
                [
                  1,
                  6
                ],
                [
                  2,
                  6
                ],
                [
                  5,
                  4
                ],
                [
                  5,
                  3
                ],
                [
                  8,
                  3
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  2
                ],
                [
                  5,
                  9
                ],
                [
                  5,
                  5
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  13,
                  16
                ],
                [
                  5,
                  11
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  3
                ],
                [
                  4,
                  3
                ],
                [
                  -2,
                  3
                ],
                [
                  -4,
                  3
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -16,
                  7
                ],
                [
                  -2,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -2,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  3,
                  5
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  3
                ],
                [
                  5,
                  2
                ],
                [
                  5,
                  2
                ],
                [
                  4,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  6,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  -2
                ],
                [
                  3,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  5,
                  2
                ],
                [
                  1,
                  -1
                ],
                [
                  10,
                  1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  3,
                  0
                ],
                [
                  4,
                  1
                ],
                [
                  4,
                  1
                ],
                [
                  4,
                  -2
                ],
                [
                  2,
                  1
                ],
                [
                  5,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  11,
                  -1
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  3,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  3,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  3,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  3
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  3,
                  -2
                ],
                [
                  3,
                  0
                ],
                [
                  10,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  -1
                ],
                [
                  3,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  2,
                  3
                ],
                [
                  4,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  3
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  -2
                ],
                [
                  0,
                  1
                ],
                [
                  3,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  6,
                  0
                ],
                [
                  -1,
                  5
                ],
                [
                  5,
                  3
                ],
                [
                  6,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  4
                ],
                [
                  1,
                  3
                ],
                [
                  3,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  5,
                  6
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  -1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  4
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  4
                ],
                [
                  0,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  -1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  5
                ],
                [
                  1,
                  2
                ],
                [
                  7,
                  5
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  7,
                  8
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  -1
                ],
                [
                  5,
                  -2
                ],
                [
                  2,
                  0
                ],
                [
                  4,
                  2
                ],
                [
                  5,
                  4
                ],
                [
                  3,
                  6
                ],
                [
                  7,
                  16
                ],
                [
                  4,
                  5
                ],
                [
                  4,
                  3
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  4,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  3
                ],
                [
                  3,
                  7
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  3
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  3
                ],
                [
                  -1,
                  5
                ],
                [
                  -1,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  5
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  3,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  3,
                  3
                ],
                [
                  4,
                  3
                ],
                [
                  3,
                  1
                ],
                [
                  7,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  3
                ],
                [
                  2,
                  1
                ],
                [
                  11,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  4,
                  -2
                ],
                [
                  2,
                  3
                ],
                [
                  1,
                  5
                ],
                [
                  4,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  3,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  3,
                  2
                ],
                [
                  3,
                  0
                ],
                [
                  4,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  -3
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  1
                ],
                [
                  3,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  5,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  5,
                  -1
                ],
                [
                  3,
                  -3
                ],
                [
                  8,
                  -3
                ],
                [
                  7,
                  0
                ]
              ],
              [
                [
                  2897,
                  5532
                ],
                [
                  0,
                  -2
                ]
              ],
              [
                [
                  2897,
                  5530
                ],
                [
                  -1,
                  0
                ],
                [
                  -5,
                  2
                ],
                [
                  -13,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  3,
                  2
                ],
                [
                  3,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  2,
                  0
                ]
              ],
              [
                [
                  2953,
                  6139
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -4
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -3
                ],
                [
                  0,
                  -3
                ],
                [
                  -1,
                  -3
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -2
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -3
                ],
                [
                  -4,
                  -2
                ],
                [
                  -2,
                  -3
                ],
                [
                  -2,
                  -4
                ],
                [
                  -3,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -7
                ],
                [
                  0,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  4,
                  -1
                ],
                [
                  3,
                  0
                ],
                [
                  3,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -3
                ],
                [
                  2,
                  -7
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  3,
                  -10
                ],
                [
                  0,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  -2
                ],
                [
                  6,
                  -39
                ],
                [
                  6,
                  -39
                ],
                [
                  -1,
                  -2
                ],
                [
                  -5,
                  -4
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -4
                ],
                [
                  1,
                  -3
                ],
                [
                  0,
                  -3
                ],
                [
                  -1,
                  -1
                ],
                [
                  -3,
                  -2
                ],
                [
                  -8,
                  -3
                ],
                [
                  -2,
                  -1
                ],
                [
                  -6,
                  -8
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -10
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -3,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -10,
                  -21
                ],
                [
                  -1,
                  -5
                ],
                [
                  -7,
                  -43
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  -6,
                  -8
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -7
                ],
                [
                  -1,
                  -1
                ],
                [
                  -6,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -15,
                  -27
                ],
                [
                  -2,
                  -6
                ],
                [
                  -1,
                  -5
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -4
                ],
                [
                  1,
                  -1
                ],
                [
                  -3,
                  -7
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  10,
                  -49
                ],
                [
                  2,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  4,
                  -4
                ],
                [
                  3,
                  -7
                ],
                [
                  4,
                  -23
                ],
                [
                  2,
                  -5
                ],
                [
                  5,
                  -10
                ],
                [
                  1,
                  -5
                ],
                [
                  0,
                  -5
                ],
                [
                  -1,
                  -16
                ],
                [
                  9,
                  1
                ],
                [
                  -2,
                  -9
                ],
                [
                  1,
                  -3
                ],
                [
                  3,
                  -2
                ],
                [
                  3,
                  0
                ],
                [
                  4,
                  3
                ],
                [
                  2,
                  1
                ],
                [
                  9,
                  -3
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -8
                ],
                [
                  2,
                  -10
                ],
                [
                  4,
                  -8
                ],
                [
                  0,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  0
                ],
                [
                  -5,
                  1
                ],
                [
                  0,
                  -9
                ],
                [
                  0,
                  -2
                ],
                [
                  2,
                  -3
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -3,
                  0
                ],
                [
                  -6,
                  0
                ]
              ],
              [
                [
                  2932,
                  5538
                ],
                [
                  0,
                  4
                ],
                [
                  -4,
                  1
                ],
                [
                  -6,
                  -1
                ],
                [
                  -3,
                  0
                ],
                [
                  1,
                  -3
                ],
                [
                  -1,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  -3,
                  -1
                ],
                [
                  -2,
                  1
                ],
                [
                  -7,
                  3
                ],
                [
                  -2,
                  2
                ],
                [
                  -3,
                  -1
                ],
                [
                  -5,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  3
                ],
                [
                  -2,
                  3
                ],
                [
                  -2,
                  3
                ],
                [
                  -3,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  4
                ],
                [
                  0,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  3
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  0
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  -4,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  1
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  -5,
                  -4
                ],
                [
                  -8,
                  1
                ],
                [
                  -33,
                  7
                ],
                [
                  -6,
                  0
                ],
                [
                  -4,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -6,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -6,
                  4
                ],
                [
                  -9,
                  1
                ],
                [
                  -4,
                  1
                ],
                [
                  -2,
                  3
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  4,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  -1
                ],
                [
                  5,
                  -3
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  4,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  3
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  5
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  3,
                  -2
                ],
                [
                  3,
                  -4
                ],
                [
                  2,
                  -3
                ],
                [
                  2,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  -3,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -2
                ],
                [
                  -3,
                  1
                ],
                [
                  -3,
                  2
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -4,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -3,
                  1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -3
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  -5,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -3
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  -3,
                  1
                ],
                [
                  -9,
                  0
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -3,
                  -2
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -3
                ],
                [
                  -3,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -4,
                  0
                ],
                [
                  4,
                  -3
                ],
                [
                  -3,
                  -2
                ],
                [
                  -5,
                  -2
                ],
                [
                  -3,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  4,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  5,
                  2
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  1
                ],
                [
                  7,
                  0
                ],
                [
                  4,
                  2
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  -1
                ],
                [
                  3,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  6,
                  1
                ],
                [
                  3,
                  2
                ],
                [
                  2,
                  0
                ],
                [
                  16,
                  1
                ],
                [
                  4,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  9,
                  -4
                ],
                [
                  -40,
                  -4
                ],
                [
                  -41,
                  -3
                ],
                [
                  -21,
                  -6
                ],
                [
                  -12,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -7,
                  1
                ],
                [
                  -2,
                  -1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  -4,
                  0
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  2,
                  2
                ],
                [
                  -2,
                  0
                ],
                [
                  -7,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  2
                ],
                [
                  -4,
                  2
                ],
                [
                  -4,
                  1
                ],
                [
                  -4,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -2
                ],
                [
                  -3,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -3,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  3
                ],
                [
                  -2,
                  -6
                ],
                [
                  -1,
                  -2
                ],
                [
                  -5,
                  7
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  1
                ],
                [
                  2,
                  -4
                ],
                [
                  5,
                  -2
                ],
                [
                  6,
                  -1
                ],
                [
                  6,
                  1
                ],
                [
                  -3,
                  2
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  -2
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  2
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  -1
                ],
                [
                  4,
                  0
                ],
                [
                  8,
                  -4
                ],
                [
                  3,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  4,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  -33,
                  -1
                ],
                [
                  -5,
                  -2
                ],
                [
                  -26,
                  -1
                ],
                [
                  -4,
                  0
                ],
                [
                  -3,
                  2
                ],
                [
                  -4,
                  -2
                ],
                [
                  3,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  -10,
                  -4
                ],
                [
                  -29,
                  -4
                ],
                [
                  -1,
                  -1
                ],
                [
                  -15,
                  -5
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -6,
                  -3
                ],
                [
                  -11,
                  -5
                ],
                [
                  -35,
                  -13
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -14,
                  -4
                ],
                [
                  -3,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -3,
                  -3
                ],
                [
                  -2,
                  -2
                ],
                [
                  -17,
                  -5
                ],
                [
                  -13,
                  -1
                ],
                [
                  -3,
                  -2
                ],
                [
                  -3,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -3,
                  -5
                ],
                [
                  -7,
                  -6
                ],
                [
                  -8,
                  -5
                ],
                [
                  -6,
                  -2
                ],
                [
                  -9,
                  -1
                ],
                [
                  -8,
                  -4
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -3
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -3,
                  -2
                ],
                [
                  -7,
                  -4
                ],
                [
                  -10,
                  -9
                ],
                [
                  -2,
                  -1
                ],
                [
                  -3,
                  0
                ],
                [
                  -6,
                  1
                ],
                [
                  -2,
                  0
                ]
              ],
              [
                [
                  2321,
                  5428
                ],
                [
                  -5,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  4
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  30
                ],
                [
                  -1,
                  7
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  4
                ],
                [
                  0,
                  1
                ],
                [
                  4,
                  4
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  -1,
                  8
                ],
                [
                  0,
                  2
                ],
                [
                  2,
                  3
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  3,
                  7
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  -1,
                  6
                ],
                [
                  2,
                  5
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  4,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  5
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  3,
                  -1
                ],
                [
                  -2,
                  3
                ],
                [
                  -2,
                  5
                ],
                [
                  -2,
                  4
                ],
                [
                  -2,
                  11
                ],
                [
                  0,
                  5
                ],
                [
                  1,
                  6
                ],
                [
                  -1,
                  5
                ],
                [
                  -4,
                  2
                ],
                [
                  -1,
                  -5
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  0
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -3,
                  1
                ],
                [
                  -3,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  -3
                ],
                [
                  -2,
                  -1
                ],
                [
                  -3,
                  4
                ],
                [
                  -1,
                  1
                ],
                [
                  -5,
                  3
                ],
                [
                  -2,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  4
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  4
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  3
                ],
                [
                  2,
                  6
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  3
                ],
                [
                  -6,
                  5
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -8,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -4,
                  0
                ],
                [
                  -6,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -3,
                  -2
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -10,
                  2
                ],
                [
                  -2,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  -2,
                  3
                ],
                [
                  -4,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -3
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  1
                ],
                [
                  -4,
                  5
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -3,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -3,
                  0
                ],
                [
                  4,
                  5
                ],
                [
                  2,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  2
                ],
                [
                  10,
                  8
                ],
                [
                  2,
                  3
                ],
                [
                  12,
                  14
                ],
                [
                  2,
                  3
                ],
                [
                  2,
                  4
                ],
                [
                  1,
                  4
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  2,
                  4
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  3,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  -2,
                  13
                ],
                [
                  -1,
                  4
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  4
                ],
                [
                  0,
                  2
                ],
                [
                  -3,
                  4
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  3
                ],
                [
                  -2,
                  13
                ],
                [
                  -3,
                  10
                ],
                [
                  -2,
                  5
                ],
                [
                  -5,
                  3
                ]
              ],
              [
                [
                  2198,
                  5872
                ],
                [
                  6,
                  6
                ],
                [
                  3,
                  1
                ],
                [
                  3,
                  -3
                ],
                [
                  2,
                  0
                ],
                [
                  5,
                  1
                ],
                [
                  4,
                  -1
                ],
                [
                  5,
                  -4
                ],
                [
                  5,
                  -2
                ],
                [
                  4,
                  4
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  3,
                  4
                ],
                [
                  2,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  4,
                  5
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  5
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -3,
                  3
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  6
                ],
                [
                  7,
                  10
                ],
                [
                  1,
                  6
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  5,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  3,
                  0
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  3
                ],
                [
                  -2,
                  3
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  5
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  -8,
                  -3
                ],
                [
                  -1,
                  0
                ],
                [
                  -13,
                  4
                ],
                [
                  -11,
                  7
                ],
                [
                  0,
                  2
                ],
                [
                  3,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  1,
                  8
                ],
                [
                  0,
                  3
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  7,
                  5
                ],
                [
                  2,
                  1
                ],
                [
                  4,
                  -1
                ],
                [
                  3,
                  0
                ],
                [
                  4,
                  2
                ],
                [
                  3,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  4,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  3,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  3,
                  0
                ],
                [
                  3,
                  -4
                ],
                [
                  4,
                  -8
                ],
                [
                  3,
                  -2
                ],
                [
                  3,
                  -1
                ],
                [
                  8,
                  1
                ],
                [
                  -3,
                  6
                ],
                [
                  -1,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  4
                ],
                [
                  0,
                  2
                ],
                [
                  -2,
                  6
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  5
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  1
                ],
                [
                  -3,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -4,
                  6
                ],
                [
                  0,
                  1
                ],
                [
                  -3,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -8,
                  2
                ],
                [
                  -3,
                  1
                ],
                [
                  -6,
                  1
                ],
                [
                  -1,
                  5
                ],
                [
                  2,
                  12
                ],
                [
                  1,
                  7
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  2,
                  2
                ],
                [
                  11,
                  7
                ],
                [
                  3,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  2,
                  2
                ],
                [
                  -2,
                  2
                ],
                [
                  -5,
                  4
                ],
                [
                  -3,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  4
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -7,
                  3
                ],
                [
                  0,
                  5
                ],
                [
                  5,
                  12
                ],
                [
                  0,
                  3
                ],
                [
                  3,
                  11
                ],
                [
                  0,
                  2
                ],
                [
                  -6,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -5,
                  -3
                ],
                [
                  -3,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -3,
                  0
                ],
                [
                  -3,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  -8,
                  12
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  5,
                  36
                ],
                [
                  -1,
                  3
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  2,
                  4
                ],
                [
                  2,
                  3
                ],
                [
                  3,
                  3
                ],
                [
                  6,
                  2
                ],
                [
                  3,
                  2
                ],
                [
                  3,
                  4
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  2
                ]
              ],
              [
                [
                  2262,
                  6233
                ],
                [
                  3,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  4,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  2
                ],
                [
                  3,
                  4
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  2,
                  3
                ],
                [
                  -2,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  2,
                  3
                ],
                [
                  -2,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  5,
                  -3
                ],
                [
                  3,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  3,
                  5
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  2,
                  -4
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  1
                ],
                [
                  4,
                  1
                ],
                [
                  3,
                  0
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -6
                ],
                [
                  0,
                  -3
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  0
                ],
                [
                  8,
                  -1
                ],
                [
                  10,
                  -1
                ],
                [
                  13,
                  -4
                ],
                [
                  2,
                  -1
                ],
                [
                  3,
                  -3
                ],
                [
                  2,
                  -3
                ],
                [
                  2,
                  -2
                ],
                [
                  3,
                  0
                ],
                [
                  3,
                  1
                ],
                [
                  3,
                  2
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  3
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  3,
                  11
                ],
                [
                  1,
                  2
                ],
                [
                  3,
                  0
                ],
                [
                  8,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  8,
                  4
                ],
                [
                  3,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  5,
                  -3
                ],
                [
                  3,
                  0
                ],
                [
                  3,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  4
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  4
                ],
                [
                  0,
                  7
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -5
                ],
                [
                  2,
                  -2
                ],
                [
                  3,
                  -2
                ],
                [
                  5,
                  -3
                ],
                [
                  2,
                  -1
                ],
                [
                  8,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  3,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  6
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  3,
                  -1
                ],
                [
                  3,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  2
                ],
                [
                  3,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  -1,
                  -6
                ],
                [
                  0,
                  -1
                ],
                [
                  3,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -3
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -3
                ],
                [
                  -2,
                  -4
                ],
                [
                  -1,
                  -2
                ],
                [
                  2,
                  -2
                ],
                [
                  -3,
                  -4
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -5
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -4
                ],
                [
                  2,
                  -1
                ],
                [
                  10,
                  -4
                ],
                [
                  11,
                  1
                ],
                [
                  3,
                  2
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  6,
                  -2
                ],
                [
                  2,
                  1
                ],
                [
                  -1,
                  8
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  3
                ],
                [
                  2,
                  1
                ],
                [
                  10,
                  6
                ],
                [
                  16,
                  3
                ],
                [
                  8,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  -2
                ],
                [
                  4,
                  -2
                ]
              ],
              [
                [
                  5412,
                  5135
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  -5,
                  -4
                ],
                [
                  -2,
                  2
                ],
                [
                  -3,
                  1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -3
                ],
                [
                  -1,
                  -4
                ],
                [
                  -1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  -2,
                  -3
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -5
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  3,
                  -5
                ],
                [
                  4,
                  -12
                ],
                [
                  3,
                  -15
                ],
                [
                  0,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -5,
                  -9
                ],
                [
                  -6,
                  7
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -3,
                  2
                ],
                [
                  -4,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -5,
                  7
                ],
                [
                  -1,
                  1
                ],
                [
                  -3,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -12,
                  2
                ],
                [
                  -11,
                  3
                ],
                [
                  -6,
                  1
                ],
                [
                  -6,
                  0
                ],
                [
                  -6,
                  -5
                ],
                [
                  -3,
                  0
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  0
                ],
                [
                  -3,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -5,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -3,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -4,
                  1
                ],
                [
                  -2,
                  -4
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  2
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -6,
                  5
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  -4
                ],
                [
                  -1,
                  0
                ],
                [
                  -3,
                  -1
                ],
                [
                  -5,
                  1
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  4
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  3
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  0
                ],
                [
                  -8,
                  -1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  -3,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  1,
                  -3
                ],
                [
                  -2,
                  0
                ],
                [
                  -3,
                  3
                ],
                [
                  -1,
                  1
                ],
                [
                  -4,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  -3,
                  2
                ],
                [
                  -4,
                  5
                ],
                [
                  -4,
                  1
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -10,
                  -2
                ],
                [
                  -3,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -3,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -8,
                  1
                ],
                [
                  -6,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  -14,
                  0
                ],
                [
                  -21,
                  0
                ],
                [
                  -23,
                  0
                ],
                [
                  -21,
                  1
                ],
                [
                  -5,
                  0
                ],
                [
                  -20,
                  0
                ],
                [
                  -23,
                  0
                ]
              ],
              [
                [
                  5034,
                  5124
                ],
                [
                  0,
                  4
                ],
                [
                  1,
                  4
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  -2,
                  2
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -4,
                  1
                ],
                [
                  -4,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -3,
                  -3
                ],
                [
                  -1,
                  -1
                ],
                [
                  -6,
                  0
                ],
                [
                  -4,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  1
                ],
                [
                  -4,
                  1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -3,
                  0
                ],
                [
                  -3,
                  2
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -3,
                  0
                ],
                [
                  -17,
                  2
                ],
                [
                  -3,
                  2
                ],
                [
                  -3,
                  1
                ],
                [
                  -3,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -7,
                  3
                ],
                [
                  -5,
                  0
                ],
                [
                  -7,
                  -2
                ],
                [
                  -3,
                  1
                ],
                [
                  -4,
                  3
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -5,
                  -2
                ],
                [
                  -3,
                  0
                ],
                [
                  -6,
                  0
                ],
                [
                  -5,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -8,
                  -1
                ],
                [
                  -10,
                  1
                ],
                [
                  -10,
                  -1
                ],
                [
                  -11,
                  0
                ],
                [
                  -5,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -6,
                  2
                ],
                [
                  -3,
                  3
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -3,
                  -1
                ],
                [
                  -35,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -3
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -1
                ]
              ],
              [
                [
                  4777,
                  5125
                ],
                [
                  -39,
                  0
                ],
                [
                  -39,
                  0
                ],
                [
                  -39,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -28,
                  0
                ],
                [
                  -9,
                  0
                ],
                [
                  -17,
                  0
                ],
                [
                  -3,
                  0
                ],
                [
                  -8,
                  5
                ],
                [
                  -2,
                  0
                ],
                [
                  -3,
                  1
                ],
                [
                  -3,
                  2
                ],
                [
                  -3,
                  3
                ],
                [
                  -2,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  3
                ],
                [
                  -2,
                  2
                ]
              ],
              [
                [
                  4579,
                  5149
                ],
                [
                  2,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  26
                ],
                [
                  4,
                  18
                ],
                [
                  2,
                  6
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  18
                ],
                [
                  2,
                  6
                ],
                [
                  2,
                  6
                ],
                [
                  2,
                  4
                ],
                [
                  3,
                  4
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  5
                ],
                [
                  -5,
                  20
                ],
                [
                  -3,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -4,
                  7
                ],
                [
                  -9,
                  13
                ],
                [
                  -6,
                  5
                ],
                [
                  -12,
                  9
                ],
                [
                  2,
                  1
                ],
                [
                  4,
                  1
                ],
                [
                  10,
                  9
                ],
                [
                  3,
                  1
                ],
                [
                  4,
                  0
                ],
                [
                  -5,
                  2
                ],
                [
                  -3,
                  -2
                ],
                [
                  -4,
                  -2
                ],
                [
                  -3,
                  -1
                ],
                [
                  -9,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  3,
                  1
                ],
                [
                  -4,
                  10
                ],
                [
                  -7,
                  9
                ],
                [
                  -1,
                  4
                ],
                [
                  -1,
                  3
                ],
                [
                  3,
                  -3
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  5,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -4,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  0,
                  3
                ],
                [
                  2,
                  3
                ],
                [
                  2,
                  3
                ],
                [
                  5,
                  -5
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  4
                ],
                [
                  4,
                  -3
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  2,
                  0
                ],
                [
                  -6,
                  2
                ],
                [
                  -3,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  3,
                  1
                ],
                [
                  4,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -13,
                  -2
                ],
                [
                  -3,
                  0
                ],
                [
                  -3,
                  2
                ],
                [
                  1,
                  4
                ],
                [
                  2,
                  3
                ],
                [
                  3,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  6,
                  9
                ],
                [
                  3,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  3
                ],
                [
                  -3,
                  -2
                ],
                [
                  -4,
                  -7
                ],
                [
                  -2,
                  -3
                ],
                [
                  -3,
                  -1
                ],
                [
                  -4,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  0,
                  3
                ],
                [
                  -2,
                  -2
                ],
                [
                  -3,
                  2
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  4
                ],
                [
                  1,
                  3
                ],
                [
                  -2,
                  2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -3,
                  -4
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -4
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -3
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  2
                ],
                [
                  -2,
                  3
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  3,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -4,
                  -1
                ],
                [
                  -3,
                  1
                ],
                [
                  -4,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -4,
                  2
                ],
                [
                  -2,
                  5
                ],
                [
                  1,
                  5
                ],
                [
                  2,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  -3,
                  0
                ],
                [
                  -1,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  -5,
                  -5
                ],
                [
                  -3,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -3,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -7,
                  5
                ],
                [
                  -11,
                  6
                ],
                [
                  -2,
                  1
                ],
                [
                  0,
                  4
                ],
                [
                  2,
                  8
                ],
                [
                  1,
                  4
                ],
                [
                  -4,
                  4
                ],
                [
                  -3,
                  5
                ],
                [
                  -3,
                  5
                ],
                [
                  -3,
                  20
                ],
                [
                  1,
                  3
                ],
                [
                  3,
                  6
                ],
                [
                  2,
                  4
                ],
                [
                  -3,
                  -4
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -3,
                  1
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -2
                ],
                [
                  5,
                  -6
                ],
                [
                  0,
                  -3
                ],
                [
                  0,
                  -3
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  -6,
                  5
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  -2,
                  -3
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  5
                ],
                [
                  -6,
                  9
                ],
                [
                  -1,
                  5
                ],
                [
                  -2,
                  -3
                ],
                [
                  1,
                  -4
                ],
                [
                  2,
                  -4
                ],
                [
                  3,
                  -13
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -4
                ],
                [
                  -3,
                  -2
                ],
                [
                  -16,
                  -1
                ],
                [
                  -2,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -3
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  2
                ],
                [
                  3,
                  5
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  3
                ],
                [
                  4,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  6
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  0
                ]
              ],
              [
                [
                  4422,
                  5492
                ],
                [
                  2,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  4,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  5,
                  9
                ],
                [
                  2,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  2,
                  6
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  4
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  3,
                  18
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  3
                ],
                [
                  2,
                  6
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  3
                ],
                [
                  2,
                  2
                ],
                [
                  3,
                  3
                ],
                [
                  2,
                  3
                ],
                [
                  0,
                  3
                ],
                [
                  -1,
                  4
                ],
                [
                  -2,
                  2
                ],
                [
                  -3,
                  3
                ],
                [
                  -3,
                  2
                ],
                [
                  -2,
                  4
                ],
                [
                  1,
                  2
                ],
                [
                  3,
                  2
                ],
                [
                  2,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  -2,
                  3
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  5,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  3,
                  2
                ],
                [
                  2,
                  -1
                ],
                [
                  3,
                  -1
                ],
                [
                  3,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  4
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  3,
                  5
                ],
                [
                  12,
                  13
                ],
                [
                  17,
                  15
                ],
                [
                  4,
                  5
                ],
                [
                  4,
                  8
                ],
                [
                  1,
                  3
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  4,
                  2
                ],
                [
                  4,
                  8
                ],
                [
                  4,
                  3
                ],
                [
                  1,
                  0
                ],
                [
                  5,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  3
                ],
                [
                  3,
                  6
                ],
                [
                  2,
                  1
                ],
                [
                  4,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  5,
                  0
                ],
                [
                  1,
                  2
                ],
                [
                  10,
                  33
                ],
                [
                  3,
                  3
                ],
                [
                  3,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  3,
                  -1
                ],
                [
                  3,
                  1
                ],
                [
                  32,
                  29
                ],
                [
                  3,
                  2
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -10
                ],
                [
                  2,
                  -3
                ],
                [
                  3,
                  -2
                ],
                [
                  3,
                  -1
                ],
                [
                  34,
                  0
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  3
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  11
                ],
                [
                  1,
                  5
                ],
                [
                  2,
                  5
                ],
                [
                  1,
                  4
                ],
                [
                  3,
                  -4
                ],
                [
                  1,
                  -6
                ],
                [
                  2,
                  -2
                ],
                [
                  3,
                  -2
                ],
                [
                  9,
                  -5
                ],
                [
                  11,
                  -4
                ],
                [
                  4,
                  -3
                ],
                [
                  3,
                  -6
                ],
                [
                  1,
                  -6
                ],
                [
                  2,
                  -6
                ],
                [
                  5,
                  -4
                ],
                [
                  12,
                  -3
                ],
                [
                  4,
                  -3
                ],
                [
                  3,
                  -6
                ],
                [
                  0,
                  -7
                ],
                [
                  0,
                  -5
                ],
                [
                  0,
                  -5
                ],
                [
                  2,
                  -11
                ],
                [
                  3,
                  -7
                ],
                [
                  2,
                  -2
                ],
                [
                  4,
                  0
                ],
                [
                  8,
                  1
                ],
                [
                  4,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  -1
                ],
                [
                  3,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  4,
                  2
                ],
                [
                  2,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  6
                ],
                [
                  2,
                  4
                ],
                [
                  3,
                  3
                ],
                [
                  5,
                  1
                ],
                [
                  4,
                  2
                ],
                [
                  3,
                  4
                ],
                [
                  4,
                  10
                ],
                [
                  0,
                  3
                ],
                [
                  1,
                  4
                ],
                [
                  -1,
                  3
                ],
                [
                  -3,
                  3
                ],
                [
                  -1,
                  2
                ],
                [
                  1,
                  4
                ],
                [
                  3,
                  3
                ],
                [
                  8,
                  8
                ],
                [
                  7,
                  5
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  6,
                  6
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  3
                ],
                [
                  -1,
                  3
                ],
                [
                  -6,
                  6
                ],
                [
                  -6,
                  10
                ],
                [
                  -2,
                  2
                ],
                [
                  -3,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  3,
                  2
                ],
                [
                  2,
                  3
                ],
                [
                  8,
                  12
                ],
                [
                  8,
                  8
                ],
                [
                  8,
                  9
                ],
                [
                  4,
                  5
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  3
                ],
                [
                  -2,
                  8
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  5,
                  9
                ],
                [
                  13,
                  19
                ],
                [
                  5,
                  6
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  6
                ],
                [
                  0,
                  5
                ],
                [
                  1,
                  3
                ],
                [
                  5,
                  8
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  3
                ],
                [
                  -3,
                  11
                ],
                [
                  0,
                  7
                ],
                [
                  1,
                  6
                ],
                [
                  3,
                  4
                ],
                [
                  3,
                  1
                ],
                [
                  5,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  4,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  4
                ],
                [
                  0,
                  2
                ],
                [
                  -3,
                  8
                ],
                [
                  -1,
                  2
                ],
                [
                  3,
                  -2
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  4,
                  -2
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  14,
                  7
                ],
                [
                  2,
                  3
                ],
                [
                  2,
                  5
                ],
                [
                  1,
                  4
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  4
                ],
                [
                  2,
                  6
                ],
                [
                  2,
                  26
                ],
                [
                  0,
                  5
                ],
                [
                  0,
                  6
                ],
                [
                  2,
                  7
                ],
                [
                  6,
                  11
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  6
                ],
                [
                  -1,
                  4
                ],
                [
                  -2,
                  2
                ],
                [
                  -3,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  7,
                  4
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  2
                ],
                [
                  4,
                  5
                ],
                [
                  2,
                  1
                ],
                [
                  9,
                  5
                ],
                [
                  10,
                  1
                ],
                [
                  8,
                  4
                ],
                [
                  4,
                  10
                ],
                [
                  1,
                  9
                ],
                [
                  1,
                  9
                ],
                [
                  2,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  -4,
                  4
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  3,
                  5
                ],
                [
                  1,
                  4
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  5
                ],
                [
                  0,
                  3
                ],
                [
                  2,
                  4
                ],
                [
                  4,
                  2
                ],
                [
                  11,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  3,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  3,
                  5
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  3,
                  9
                ],
                [
                  4,
                  26
                ],
                [
                  5,
                  17
                ],
                [
                  4,
                  8
                ],
                [
                  23,
                  35
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  5
                ],
                [
                  0,
                  3
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  5,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  2,
                  5
                ],
                [
                  4,
                  6
                ],
                [
                  4,
                  6
                ],
                [
                  5,
                  5
                ],
                [
                  5,
                  4
                ],
                [
                  4,
                  0
                ],
                [
                  5,
                  -1
                ],
                [
                  9,
                  -5
                ],
                [
                  3,
                  0
                ],
                [
                  3,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  2
                ],
                [
                  3,
                  4
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  12,
                  11
                ],
                [
                  2,
                  1
                ],
                [
                  8,
                  3
                ],
                [
                  3,
                  2
                ],
                [
                  5,
                  4
                ],
                [
                  2,
                  2
                ],
                [
                  7,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  4
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  3
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  2
                ],
                [
                  -3,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  5,
                  7
                ],
                [
                  1,
                  2
                ],
                [
                  3,
                  14
                ],
                [
                  1,
                  5
                ],
                [
                  1,
                  4
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  6
                ],
                [
                  0,
                  3
                ],
                [
                  2,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  2,
                  10
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  3
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  2
                ],
                [
                  -3,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -4,
                  3
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -4,
                  2
                ],
                [
                  -8,
                  2
                ],
                [
                  -27,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  5
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  11
                ],
                [
                  -7,
                  37
                ],
                [
                  -7,
                  37
                ]
              ],
              [
                [
                  5135,
                  6637
                ],
                [
                  46,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  6,
                  -10
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -3
                ],
                [
                  0,
                  -3
                ],
                [
                  -2,
                  -6
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  4,
                  -3
                ],
                [
                  3,
                  -2
                ],
                [
                  0,
                  -6
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  3,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  3,
                  -1
                ],
                [
                  3,
                  1
                ],
                [
                  3,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  -2,
                  -5
                ],
                [
                  2,
                  -2
                ],
                [
                  2,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  0
                ],
                [
                  5,
                  1
                ],
                [
                  1,
                  -3
                ],
                [
                  5,
                  -17
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  -1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  2,
                  -4
                ],
                [
                  2,
                  -10
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -9
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  3,
                  -3
                ],
                [
                  3,
                  -3
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  2
                ],
                [
                  3,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  3,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  -4,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -4
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  3,
                  0
                ],
                [
                  1,
                  -2
                ],
                [
                  3,
                  -8
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  2,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -3
                ],
                [
                  0,
                  -3
                ],
                [
                  0,
                  -3
                ],
                [
                  2,
                  -6
                ],
                [
                  2,
                  -2
                ],
                [
                  3,
                  -5
                ],
                [
                  2,
                  -5
                ],
                [
                  -2,
                  -3
                ],
                [
                  -6,
                  -7
                ],
                [
                  -1,
                  -3
                ],
                [
                  -1,
                  -3
                ],
                [
                  -1,
                  -7
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -3
                ],
                [
                  -3,
                  -4
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -9
                ],
                [
                  1,
                  -14
                ],
                [
                  1,
                  -12
                ],
                [
                  3,
                  -9
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  -1,
                  -4
                ],
                [
                  -2,
                  -6
                ],
                [
                  1,
                  -5
                ],
                [
                  10,
                  -20
                ],
                [
                  1,
                  -3
                ],
                [
                  0,
                  -3
                ],
                [
                  -2,
                  -2
                ],
                [
                  0,
                  -3
                ],
                [
                  -1,
                  -4
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  3,
                  -1
                ],
                [
                  1,
                  -3
                ],
                [
                  2,
                  -5
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  0,
                  -3
                ],
                [
                  0,
                  -3
                ],
                [
                  1,
                  -3
                ],
                [
                  2,
                  -3
                ],
                [
                  17,
                  -17
                ],
                [
                  5,
                  -7
                ],
                [
                  2,
                  -2
                ],
                [
                  6,
                  -6
                ],
                [
                  9,
                  -5
                ],
                [
                  4,
                  -2
                ],
                [
                  6,
                  -5
                ],
                [
                  -2,
                  -1
                ],
                [
                  -29,
                  -7
                ],
                [
                  -8,
                  0
                ],
                [
                  -22,
                  7
                ],
                [
                  -7,
                  0
                ],
                [
                  -6,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -4,
                  1
                ],
                [
                  -8,
                  2
                ],
                [
                  -6,
                  0
                ],
                [
                  -16,
                  -6
                ],
                [
                  -6,
                  1
                ],
                [
                  -38,
                  10
                ],
                [
                  -31,
                  -3
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -6,
                  -13
                ],
                [
                  -4,
                  -6
                ],
                [
                  -11,
                  -10
                ],
                [
                  -8,
                  -12
                ],
                [
                  0,
                  -2
                ],
                [
                  12,
                  -10
                ],
                [
                  37,
                  -45
                ],
                [
                  1,
                  -6
                ],
                [
                  3,
                  -4
                ],
                [
                  29,
                  -25
                ],
                [
                  28,
                  -24
                ],
                [
                  3,
                  -1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  5,
                  -4
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -2
                ],
                [
                  2,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  5,
                  -1
                ],
                [
                  3,
                  -1
                ],
                [
                  3,
                  -2
                ],
                [
                  2,
                  -2
                ],
                [
                  6,
                  -10
                ],
                [
                  7,
                  -8
                ],
                [
                  2,
                  -2
                ],
                [
                  4,
                  -8
                ],
                [
                  17,
                  -40
                ],
                [
                  8,
                  -30
                ],
                [
                  5,
                  -11
                ],
                [
                  6,
                  -5
                ],
                [
                  3,
                  0
                ],
                [
                  4,
                  -1
                ],
                [
                  3,
                  -1
                ],
                [
                  -1,
                  -14
                ],
                [
                  -1,
                  -8
                ],
                [
                  -4,
                  -8
                ],
                [
                  -5,
                  -7
                ]
              ],
              [
                [
                  4995,
                  4012
                ],
                [
                  -3,
                  -3
                ],
                [
                  -4,
                  -1
                ],
                [
                  -7,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -4,
                  -2
                ],
                [
                  -4,
                  -3
                ],
                [
                  -3,
                  -1
                ],
                [
                  -3,
                  0
                ],
                [
                  -2,
                  3
                ],
                [
                  2,
                  2
                ],
                [
                  4,
                  4
                ],
                [
                  4,
                  3
                ],
                [
                  4,
                  1
                ],
                [
                  6,
                  -1
                ],
                [
                  4,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  0
                ]
              ],
              [
                [
                  6877,
                  5527
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -6
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  4,
                  -3
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -3
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  3,
                  -1
                ],
                [
                  12,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -4
                ],
                [
                  1,
                  -5
                ],
                [
                  0,
                  -3
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -3
                ],
                [
                  -1,
                  -8
                ],
                [
                  0,
                  -6
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -3
                ],
                [
                  3,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -3
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  3,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  1
                ]
              ],
              [
                [
                  6939,
                  5457
                ],
                [
                  -1,
                  0
                ],
                [
                  1,
                  0
                ]
              ],
              [
                [
                  6939,
                  5457
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  7,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  -1,
                  -3
                ],
                [
                  -1,
                  -3
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  4,
                  -6
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  3
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -3
                ],
                [
                  4,
                  -5
                ],
                [
                  2,
                  -2
                ],
                [
                  2,
                  -2
                ],
                [
                  6,
                  -1
                ],
                [
                  5,
                  1
                ],
                [
                  6,
                  1
                ],
                [
                  4,
                  -4
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  3,
                  -1
                ],
                [
                  3,
                  0
                ],
                [
                  3,
                  2
                ],
                [
                  2,
                  3
                ],
                [
                  5,
                  7
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  6,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  3
                ],
                [
                  6,
                  11
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -3
                ],
                [
                  1,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  3,
                  -2
                ],
                [
                  2,
                  0
                ],
                [
                  4,
                  1
                ],
                [
                  6,
                  -1
                ],
                [
                  3,
                  1
                ],
                [
                  8,
                  2
                ],
                [
                  1,
                  -2
                ],
                [
                  6,
                  -4
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  1
                ],
                [
                  5,
                  -3
                ],
                [
                  2,
                  -1
                ],
                [
                  8,
                  -9
                ],
                [
                  3,
                  -1
                ],
                [
                  3,
                  0
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  3,
                  0
                ],
                [
                  3,
                  -1
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  2,
                  2
                ],
                [
                  6,
                  6
                ],
                [
                  2,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  5
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  4,
                  -2
                ],
                [
                  4,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  6,
                  -3
                ],
                [
                  1,
                  -1
                ],
                [
                  4,
                  -4
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  1
                ],
                [
                  0,
                  -1
                ],
                [
                  3,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -4
                ],
                [
                  0,
                  -6
                ],
                [
                  1,
                  -5
                ],
                [
                  4,
                  -3
                ],
                [
                  6,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  3,
                  -2
                ],
                [
                  3,
                  -3
                ],
                [
                  1,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  -2
                ],
                [
                  2,
                  -2
                ],
                [
                  3,
                  -7
                ],
                [
                  2,
                  -3
                ],
                [
                  2,
                  -1
                ],
                [
                  6,
                  -1
                ],
                [
                  3,
                  -2
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -3
                ],
                [
                  3,
                  -4
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  3,
                  -1
                ],
                [
                  8,
                  0
                ],
                [
                  9,
                  -3
                ],
                [
                  10,
                  -7
                ],
                [
                  5,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  3,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  -4
                ],
                [
                  3,
                  -20
                ],
                [
                  0,
                  -3
                ],
                [
                  -1,
                  -5
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  4,
                  3
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  4,
                  0
                ],
                [
                  3,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -5
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -2
                ],
                [
                  4,
                  -1
                ],
                [
                  2,
                  -3
                ],
                [
                  -1,
                  -7
                ],
                [
                  1,
                  -3
                ]
              ],
              [
                [
                  7319,
                  5308
                ],
                [
                  3,
                  1
                ],
                [
                  2,
                  3
                ],
                [
                  3,
                  0
                ],
                [
                  1,
                  -3
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -4
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -3
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -3
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -4,
                  -4
                ],
                [
                  -3,
                  -5
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  -5
                ],
                [
                  -6,
                  -17
                ],
                [
                  -2,
                  -6
                ],
                [
                  0,
                  -3
                ],
                [
                  0,
                  -3
                ],
                [
                  1,
                  -2
                ],
                [
                  6,
                  -4
                ],
                [
                  3,
                  -2
                ],
                [
                  3,
                  -6
                ],
                [
                  1,
                  -5
                ],
                [
                  0,
                  -6
                ],
                [
                  -3,
                  -9
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -5,
                  -12
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -3,
                  -5
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -3
                ],
                [
                  1,
                  -5
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  -3
                ],
                [
                  -1,
                  -3
                ],
                [
                  0,
                  -3
                ],
                [
                  2,
                  0
                ],
                [
                  9,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  2,
                  -2
                ],
                [
                  2,
                  -3
                ],
                [
                  2,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  4,
                  2
                ],
                [
                  2,
                  4
                ],
                [
                  2,
                  4
                ],
                [
                  5,
                  0
                ],
                [
                  2,
                  -2
                ],
                [
                  7,
                  -8
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  6,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  6,
                  3
                ],
                [
                  0,
                  -6
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -3
                ],
                [
                  2,
                  -2
                ],
                [
                  8,
                  -4
                ],
                [
                  1,
                  -3
                ]
              ],
              [
                [
                  7376,
                  5123
                ],
                [
                  1,
                  0
                ],
                [
                  -1,
                  0
                ]
              ],
              [
                [
                  7376,
                  5123
                ],
                [
                  -1,
                  -7
                ],
                [
                  -3,
                  -7
                ],
                [
                  -8,
                  -10
                ],
                [
                  -8,
                  -12
                ],
                [
                  -3,
                  -4
                ],
                [
                  -10,
                  -12
                ],
                [
                  -9,
                  -8
                ],
                [
                  -18,
                  -15
                ],
                [
                  -17,
                  -15
                ],
                [
                  -11,
                  -15
                ],
                [
                  -6,
                  -8
                ],
                [
                  -10,
                  -14
                ],
                [
                  -3,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -3,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -4,
                  -4
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -3
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -3
                ],
                [
                  1,
                  -5
                ],
                [
                  -1,
                  -3
                ],
                [
                  -3,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -3,
                  -5
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -14,
                  -4
                ],
                [
                  -6,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -3,
                  -6
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -7
                ],
                [
                  -2,
                  -12
                ],
                [
                  0,
                  -3
                ],
                [
                  3,
                  -11
                ],
                [
                  0,
                  -5
                ],
                [
                  -2,
                  -5
                ],
                [
                  0,
                  -1
                ],
                [
                  -3,
                  -3
                ],
                [
                  -7,
                  -8
                ],
                [
                  -1,
                  -3
                ],
                [
                  -1,
                  -3
                ],
                [
                  -4,
                  -22
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -6,
                  -9
                ],
                [
                  -1,
                  -3
                ],
                [
                  0,
                  -3
                ],
                [
                  1,
                  -6
                ],
                [
                  1,
                  -2
                ],
                [
                  -1,
                  -3
                ],
                [
                  -2,
                  -5
                ],
                [
                  -2,
                  -14
                ],
                [
                  -1,
                  -5
                ],
                [
                  -2,
                  -14
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  -18
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  2,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -9
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  -10
                ],
                [
                  0,
                  -3
                ],
                [
                  1,
                  -6
                ],
                [
                  0,
                  -3
                ],
                [
                  0,
                  -8
                ],
                [
                  0,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  -4,
                  -1
                ],
                [
                  -1,
                  -3
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -3
                ],
                [
                  1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -3
                ],
                [
                  2,
                  -5
                ],
                [
                  1,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  -2,
                  -9
                ],
                [
                  0,
                  -3
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -2
                ],
                [
                  0,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  2,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -3
                ],
                [
                  -1,
                  -8
                ]
              ],
              [
                [
                  7155,
                  4632
                ],
                [
                  -5,
                  -2
                ],
                [
                  -5,
                  -4
                ],
                [
                  -5,
                  -5
                ],
                [
                  -2,
                  -4
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -10,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  -2
                ],
                [
                  -4,
                  -8
                ],
                [
                  -1,
                  -2
                ],
                [
                  -6,
                  -6
                ],
                [
                  -2,
                  -2
                ],
                [
                  -3,
                  -6
                ],
                [
                  -3,
                  -5
                ],
                [
                  -5,
                  -9
                ],
                [
                  -2,
                  -6
                ],
                [
                  -1,
                  -5
                ],
                [
                  0,
                  -5
                ],
                [
                  4,
                  -21
                ],
                [
                  0,
                  -5
                ],
                [
                  -1,
                  -6
                ],
                [
                  -2,
                  -7
                ],
                [
                  -3,
                  -5
                ],
                [
                  -5,
                  -4
                ],
                [
                  -5,
                  -2
                ],
                [
                  -4,
                  1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  -3,
                  -1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  -3
                ],
                [
                  0,
                  -3
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -1
                ],
                [
                  -3,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -3
                ],
                [
                  -1,
                  -11
                ],
                [
                  1,
                  -1
                ],
                [
                  5,
                  -3
                ],
                [
                  2,
                  -1
                ],
                [
                  4,
                  0
                ],
                [
                  3,
                  -2
                ],
                [
                  2,
                  -2
                ]
              ],
              [
                [
                  7132,
                  4208
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -5
                ],
                [
                  -1,
                  -12
                ],
                [
                  -8,
                  -23
                ],
                [
                  -3,
                  -11
                ],
                [
                  1,
                  -12
                ],
                [
                  2,
                  -11
                ],
                [
                  0,
                  -1
                ],
                [
                  5,
                  -11
                ],
                [
                  10,
                  -20
                ],
                [
                  5,
                  -22
                ],
                [
                  13,
                  -32
                ],
                [
                  2,
                  -12
                ],
                [
                  -1,
                  -10
                ],
                [
                  -4,
                  -8
                ],
                [
                  -10,
                  -14
                ],
                [
                  -2,
                  -9
                ],
                [
                  0,
                  -5
                ],
                [
                  4,
                  -16
                ],
                [
                  2,
                  -16
                ],
                [
                  2,
                  -6
                ],
                [
                  3,
                  -6
                ],
                [
                  9,
                  -13
                ],
                [
                  7,
                  -18
                ],
                [
                  3,
                  -5
                ],
                [
                  4,
                  -5
                ],
                [
                  17,
                  -14
                ],
                [
                  13,
                  -7
                ],
                [
                  5,
                  -3
                ],
                [
                  11,
                  -9
                ],
                [
                  18,
                  -23
                ],
                [
                  8,
                  -13
                ],
                [
                  10,
                  -22
                ],
                [
                  5,
                  -18
                ],
                [
                  1,
                  -9
                ],
                [
                  3,
                  -13
                ],
                [
                  28,
                  -46
                ],
                [
                  10,
                  -24
                ],
                [
                  3,
                  -13
                ]
              ],
              [
                [
                  7308,
                  3689
                ],
                [
                  -22,
                  -3
                ],
                [
                  -34,
                  -6
                ],
                [
                  -26,
                  -4
                ],
                [
                  -35,
                  -5
                ],
                [
                  -34,
                  -6
                ],
                [
                  -2,
                  0
                ],
                [
                  -28,
                  -5
                ],
                [
                  -20,
                  -3
                ],
                [
                  -23,
                  -4
                ],
                [
                  -15,
                  -2
                ],
                [
                  -4,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  5,
                  -13
                ],
                [
                  -1,
                  -12
                ],
                [
                  -4,
                  -12
                ],
                [
                  -17,
                  -23
                ],
                [
                  -22,
                  -23
                ],
                [
                  -12,
                  -9
                ],
                [
                  -12,
                  -6
                ],
                [
                  -5,
                  -4
                ],
                [
                  -3,
                  -5
                ],
                [
                  2,
                  -5
                ],
                [
                  6,
                  -2
                ],
                [
                  6,
                  -2
                ],
                [
                  5,
                  -2
                ],
                [
                  3,
                  -4
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -2
                ],
                [
                  3,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  4,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -3
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -7
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -3
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -2
                ],
                [
                  3,
                  -4
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  -6
                ],
                [
                  -4,
                  -9
                ],
                [
                  0,
                  -3
                ],
                [
                  1,
                  -10
                ],
                [
                  -1,
                  -11
                ],
                [
                  -1,
                  -5
                ],
                [
                  -2,
                  -5
                ],
                [
                  -3,
                  -4
                ],
                [
                  -1,
                  -2
                ],
                [
                  4,
                  -4
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -3
                ],
                [
                  0,
                  -4
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  2,
                  -3
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  2,
                  -2
                ],
                [
                  3,
                  -4
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -3
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  3,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -3
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -4
                ],
                [
                  -1,
                  -3
                ],
                [
                  -1,
                  -1
                ],
                [
                  -3,
                  -2
                ],
                [
                  -1,
                  -3
                ],
                [
                  -1,
                  -4
                ],
                [
                  -1,
                  -3
                ],
                [
                  0,
                  -6
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -3,
                  -3
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  -4
                ],
                [
                  -2,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  2,
                  -7
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -5
                ],
                [
                  -2,
                  -5
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -3
                ],
                [
                  1,
                  -6
                ],
                [
                  -1,
                  0
                ],
                [
                  -3,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -7,
                  -10
                ],
                [
                  -1,
                  -3
                ],
                [
                  1,
                  -7
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -5
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -8
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -10
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -7
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  2,
                  -3
                ],
                [
                  0,
                  -1
                ],
                [
                  3,
                  2
                ],
                [
                  2,
                  -2
                ],
                [
                  3,
                  -5
                ],
                [
                  1,
                  -1
                ],
                [
                  7,
                  -4
                ],
                [
                  2,
                  0
                ],
                [
                  5,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -4
                ],
                [
                  0,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  5,
                  -3
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -3
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -2
                ],
                [
                  8,
                  -4
                ],
                [
                  3,
                  -4
                ],
                [
                  11,
                  -21
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  11,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  -3
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  5,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  5,
                  -3
                ],
                [
                  4,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -4,
                  6
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  6
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  6,
                  2
                ],
                [
                  3,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  1
                ],
                [
                  7,
                  3
                ],
                [
                  4,
                  3
                ],
                [
                  3,
                  1
                ],
                [
                  6,
                  1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -15
                ],
                [
                  0,
                  -16
                ],
                [
                  0,
                  -23
                ],
                [
                  0,
                  -21
                ],
                [
                  0,
                  -24
                ],
                [
                  0,
                  -21
                ],
                [
                  -1,
                  -19
                ],
                [
                  0,
                  -21
                ],
                [
                  0,
                  -15
                ],
                [
                  -2,
                  -5
                ],
                [
                  -2,
                  0
                ],
                [
                  -8,
                  0
                ],
                [
                  -5,
                  2
                ],
                [
                  -3,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  2
                ],
                [
                  -2,
                  2
                ],
                [
                  -3,
                  1
                ],
                [
                  -3,
                  0
                ],
                [
                  -3,
                  -1
                ],
                [
                  -7,
                  -7
                ],
                [
                  -3,
                  -2
                ],
                [
                  -18,
                  -7
                ],
                [
                  -8,
                  -6
                ],
                [
                  -3,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -3
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  -2,
                  2
                ],
                [
                  -3,
                  1
                ],
                [
                  -3,
                  0
                ],
                [
                  -3,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -3,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  -4,
                  4
                ],
                [
                  -2,
                  6
                ],
                [
                  -4,
                  20
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  4
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  5
                ],
                [
                  -1,
                  2
                ],
                [
                  -3,
                  2
                ],
                [
                  -8,
                  12
                ],
                [
                  -6,
                  5
                ],
                [
                  -6,
                  2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -4
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  8
                ],
                [
                  -2,
                  3
                ],
                [
                  -3,
                  3
                ],
                [
                  -3,
                  3
                ],
                [
                  -1,
                  4
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  -1,
                  3
                ],
                [
                  -5,
                  5
                ],
                [
                  -1,
                  3
                ],
                [
                  -3,
                  7
                ],
                [
                  -2,
                  3
                ],
                [
                  -10,
                  10
                ],
                [
                  -3,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -4,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -4,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  0
                ],
                [
                  -3,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -10,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -3,
                  1
                ],
                [
                  -1,
                  3
                ],
                [
                  0,
                  4
                ],
                [
                  -2,
                  2
                ],
                [
                  -8,
                  5
                ],
                [
                  -2,
                  1
                ],
                [
                  -4,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  -4,
                  -1
                ],
                [
                  -6,
                  0
                ],
                [
                  -6,
                  0
                ],
                [
                  -4,
                  1
                ],
                [
                  -5,
                  7
                ],
                [
                  -1,
                  0
                ],
                [
                  -7,
                  6
                ],
                [
                  -2,
                  3
                ],
                [
                  -6,
                  19
                ],
                [
                  -1,
                  6
                ],
                [
                  -6,
                  11
                ],
                [
                  -24,
                  16
                ],
                [
                  -4,
                  12
                ],
                [
                  1,
                  4
                ],
                [
                  -1,
                  7
                ],
                [
                  -1,
                  6
                ],
                [
                  -2,
                  4
                ],
                [
                  -1,
                  0
                ],
                [
                  -4,
                  -2
                ],
                [
                  -6,
                  0
                ],
                [
                  -5,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  -3,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  -2
                ],
                [
                  0,
                  -3
                ],
                [
                  2,
                  -5
                ],
                [
                  0,
                  -4
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  -3
                ],
                [
                  -2,
                  -6
                ],
                [
                  0,
                  -11
                ],
                [
                  -3,
                  -5
                ],
                [
                  -4,
                  -5
                ],
                [
                  -5,
                  -3
                ],
                [
                  -6,
                  -1
                ],
                [
                  -6,
                  0
                ],
                [
                  -3,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -3
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  0
                ],
                [
                  -3,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -5,
                  1
                ],
                [
                  -11,
                  1
                ],
                [
                  -4,
                  1
                ],
                [
                  -3,
                  2
                ],
                [
                  -2,
                  2
                ],
                [
                  -2,
                  2
                ],
                [
                  -3,
                  1
                ],
                [
                  -5,
                  0
                ],
                [
                  -5,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -3,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -3,
                  2
                ],
                [
                  -4,
                  -1
                ],
                [
                  -3,
                  2
                ],
                [
                  -3,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  -23,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  2
                ],
                [
                  -2,
                  4
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -7,
                  6
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -3,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  -7,
                  0
                ],
                [
                  -3,
                  1
                ],
                [
                  -5,
                  3
                ],
                [
                  -4,
                  4
                ],
                [
                  -4,
                  3
                ],
                [
                  -6,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -3,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  -7,
                  3
                ],
                [
                  -2,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -3,
                  11
                ],
                [
                  -1,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  3
                ],
                [
                  -3,
                  5
                ],
                [
                  -1,
                  3
                ],
                [
                  0,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  4
                ],
                [
                  0,
                  3
                ],
                [
                  -2,
                  2
                ],
                [
                  -4,
                  -1
                ],
                [
                  -12,
                  -7
                ],
                [
                  -8,
                  -1
                ],
                [
                  -19,
                  -2
                ],
                [
                  -5,
                  0
                ],
                [
                  -5,
                  -1
                ],
                [
                  -10,
                  -5
                ],
                [
                  -5,
                  -2
                ],
                [
                  -10,
                  0
                ],
                [
                  -5,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -3,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -3,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -6,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -3,
                  0
                ],
                [
                  -3,
                  2
                ],
                [
                  -4,
                  4
                ],
                [
                  -3,
                  2
                ],
                [
                  -3,
                  0
                ],
                [
                  -5,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  6,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  4,
                  7
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  -4,
                  3
                ],
                [
                  -3,
                  2
                ],
                [
                  -3,
                  2
                ],
                [
                  -3,
                  0
                ],
                [
                  -5,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -5,
                  2
                ],
                [
                  -2,
                  0
                ],
                [
                  -3,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  5
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  -3,
                  3
                ],
                [
                  -5,
                  2
                ],
                [
                  -6,
                  1
                ],
                [
                  -5,
                  0
                ]
              ],
              [
                [
                  5020,
                  4013
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -4,
                  -2
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -4,
                  1
                ],
                [
                  -7,
                  3
                ],
                [
                  -1,
                  1
                ],
                [
                  -5,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -4,
                  0
                ],
                [
                  -5,
                  -1
                ],
                [
                  -4,
                  -1
                ],
                [
                  -4,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -3,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  -3
                ],
                [
                  -3,
                  -4
                ],
                [
                  1,
                  -7
                ],
                [
                  -7,
                  -3
                ],
                [
                  -8,
                  1
                ],
                [
                  -7,
                  -4
                ],
                [
                  -10,
                  -3
                ],
                [
                  -4,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  3,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  4
                ],
                [
                  -9,
                  9
                ],
                [
                  -2,
                  3
                ],
                [
                  -5,
                  9
                ]
              ],
              [
                [
                  5005,
                  4182
                ],
                [
                  0,
                  5
                ],
                [
                  2,
                  3
                ],
                [
                  3,
                  1
                ],
                [
                  3,
                  -4
                ],
                [
                  1,
                  -2
                ],
                [
                  3,
                  -4
                ],
                [
                  1,
                  -4
                ],
                [
                  2,
                  -2
                ],
                [
                  3,
                  -2
                ],
                [
                  6,
                  -6
                ],
                [
                  2,
                  -1
                ],
                [
                  8,
                  -3
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -5
                ],
                [
                  3,
                  -6
                ],
                [
                  1,
                  1
                ],
                [
                  4,
                  5
                ],
                [
                  7,
                  5
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  4,
                  3
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  3,
                  -3
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  6
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  -2,
                  6
                ],
                [
                  0,
                  3
                ],
                [
                  2,
                  6
                ],
                [
                  1,
                  3
                ],
                [
                  -2,
                  13
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  9,
                  3
                ],
                [
                  2,
                  -1
                ],
                [
                  3,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -4
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  4,
                  1
                ],
                [
                  4,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  3
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  4,
                  6
                ],
                [
                  5,
                  2
                ],
                [
                  11,
                  1
                ],
                [
                  5,
                  2
                ],
                [
                  5,
                  3
                ],
                [
                  5,
                  4
                ],
                [
                  3,
                  2
                ],
                [
                  5,
                  2
                ],
                [
                  6,
                  3
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -4
                ],
                [
                  3,
                  -3
                ],
                [
                  4,
                  -3
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -3
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  -3
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -5,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -5
                ],
                [
                  2,
                  -3
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -4
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  -2,
                  -11
                ],
                [
                  0,
                  -4
                ],
                [
                  3,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  3
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  0
                ],
                [
                  1,
                  -2
                ],
                [
                  3,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  4,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  5,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  9,
                  6
                ],
                [
                  6,
                  3
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  10,
                  19
                ],
                [
                  10,
                  10
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  7,
                  3
                ],
                [
                  3,
                  3
                ],
                [
                  7,
                  11
                ],
                [
                  5,
                  7
                ],
                [
                  0,
                  2
                ],
                [
                  2,
                  3
                ],
                [
                  3,
                  1
                ],
                [
                  4,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  15,
                  8
                ],
                [
                  5,
                  2
                ],
                [
                  3,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  4,
                  14
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  19,
                  7
                ],
                [
                  6,
                  0
                ],
                [
                  5,
                  1
                ],
                [
                  6,
                  2
                ],
                [
                  5,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  3,
                  3
                ],
                [
                  2,
                  8
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  4,
                  7
                ],
                [
                  2,
                  7
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  3
                ],
                [
                  5,
                  11
                ],
                [
                  9,
                  11
                ],
                [
                  2,
                  6
                ],
                [
                  3,
                  7
                ],
                [
                  7,
                  12
                ],
                [
                  1,
                  4
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  3
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  6
                ],
                [
                  0,
                  3
                ],
                [
                  -1,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  8
                ],
                [
                  0,
                  7
                ],
                [
                  0,
                  7
                ],
                [
                  -1,
                  5
                ],
                [
                  0,
                  8
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  3,
                  10
                ],
                [
                  3,
                  21
                ],
                [
                  -4,
                  33
                ],
                [
                  -1,
                  7
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  6
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  4,
                  5
                ],
                [
                  3,
                  3
                ],
                [
                  4,
                  2
                ],
                [
                  7,
                  8
                ],
                [
                  5,
                  4
                ],
                [
                  9,
                  9
                ],
                [
                  2,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  10,
                  15
                ],
                [
                  2,
                  3
                ],
                [
                  1,
                  4
                ],
                [
                  0,
                  5
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  3,
                  4
                ],
                [
                  2,
                  3
                ],
                [
                  3,
                  7
                ],
                [
                  4,
                  6
                ],
                [
                  5,
                  10
                ],
                [
                  2,
                  3
                ],
                [
                  2,
                  5
                ],
                [
                  3,
                  6
                ],
                [
                  1,
                  4
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  3,
                  2
                ],
                [
                  6,
                  5
                ],
                [
                  4,
                  5
                ],
                [
                  5,
                  5
                ],
                [
                  3,
                  4
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  5,
                  1
                ],
                [
                  6,
                  2
                ],
                [
                  9,
                  3
                ],
                [
                  2,
                  1
                ],
                [
                  7,
                  1
                ],
                [
                  7,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  3,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  3,
                  3
                ],
                [
                  3,
                  3
                ],
                [
                  18,
                  23
                ],
                [
                  7,
                  9
                ],
                [
                  3,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  9,
                  8
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  -1,
                  25
                ],
                [
                  -3,
                  14
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  4
                ],
                [
                  5,
                  25
                ],
                [
                  3,
                  5
                ],
                [
                  10,
                  30
                ],
                [
                  11,
                  17
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  13
                ],
                [
                  -1,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  -2,
                  3
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  7
                ],
                [
                  -1,
                  3
                ],
                [
                  0,
                  4
                ],
                [
                  2,
                  10
                ],
                [
                  0,
                  4
                ],
                [
                  -4,
                  18
                ],
                [
                  0,
                  11
                ],
                [
                  -1,
                  10
                ],
                [
                  0,
                  3
                ],
                [
                  3,
                  5
                ],
                [
                  3,
                  3
                ],
                [
                  5,
                  10
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  8
                ],
                [
                  4,
                  16
                ],
                [
                  1,
                  5
                ],
                [
                  1,
                  3
                ],
                [
                  7,
                  18
                ],
                [
                  1,
                  3
                ],
                [
                  -1,
                  39
                ],
                [
                  0,
                  3
                ],
                [
                  1,
                  4
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  6
                ],
                [
                  1,
                  13
                ],
                [
                  -1,
                  5
                ],
                [
                  -1,
                  4
                ],
                [
                  0,
                  2
                ],
                [
                  5,
                  15
                ],
                [
                  1,
                  1
                ],
                [
                  4,
                  4
                ],
                [
                  0,
                  2
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  5
                ],
                [
                  2,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  8
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  3
                ],
                [
                  8,
                  7
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  10,
                  18
                ],
                [
                  3,
                  9
                ],
                [
                  1,
                  4
                ],
                [
                  0,
                  2
                ],
                [
                  3,
                  7
                ],
                [
                  3,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  4
                ],
                [
                  5,
                  13
                ],
                [
                  1,
                  3
                ],
                [
                  3,
                  2
                ],
                [
                  5,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  3
                ],
                [
                  2,
                  20
                ],
                [
                  -1,
                  18
                ],
                [
                  -1,
                  3
                ]
              ],
              [
                [
                  4867,
                  4129
                ],
                [
                  -2,
                  2
                ],
                [
                  -2,
                  2
                ],
                [
                  -3,
                  6
                ],
                [
                  -5,
                  6
                ],
                [
                  -3,
                  3
                ],
                [
                  -1,
                  4
                ],
                [
                  -7,
                  8
                ],
                [
                  -2,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  3
                ],
                [
                  -3,
                  5
                ],
                [
                  -6,
                  5
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  3,
                  0
                ],
                [
                  2,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  -3,
                  6
                ],
                [
                  -14,
                  15
                ],
                [
                  -14,
                  13
                ],
                [
                  -12,
                  11
                ],
                [
                  -6,
                  4
                ],
                [
                  -6,
                  6
                ],
                [
                  -3,
                  4
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -11,
                  10
                ],
                [
                  -13,
                  9
                ],
                [
                  -5,
                  3
                ],
                [
                  -3,
                  2
                ]
              ],
              [
                [
                  4750,
                  4279
                ],
                [
                  2,
                  4
                ],
                [
                  9,
                  25
                ],
                [
                  2,
                  4
                ],
                [
                  3,
                  4
                ],
                [
                  5,
                  3
                ],
                [
                  4,
                  3
                ],
                [
                  4,
                  3
                ],
                [
                  5,
                  1
                ],
                [
                  5,
                  2
                ],
                [
                  3,
                  4
                ],
                [
                  3,
                  4
                ],
                [
                  3,
                  2
                ],
                [
                  7,
                  -1
                ],
                [
                  5,
                  -3
                ],
                [
                  10,
                  -18
                ],
                [
                  2,
                  -3
                ],
                [
                  3,
                  -1
                ],
                [
                  7,
                  1
                ],
                [
                  3,
                  0
                ],
                [
                  7,
                  -2
                ],
                [
                  3,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  2
                ],
                [
                  2,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  -1,
                  3
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  1
                ],
                [
                  -3,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  0,
                  3
                ],
                [
                  8,
                  19
                ],
                [
                  1,
                  3
                ],
                [
                  6,
                  5
                ],
                [
                  2,
                  3
                ],
                [
                  -2,
                  4
                ],
                [
                  -5,
                  3
                ],
                [
                  -6,
                  1
                ],
                [
                  -5,
                  3
                ],
                [
                  -5,
                  4
                ],
                [
                  -3,
                  2
                ],
                [
                  -7,
                  3
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  9
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  4,
                  0
                ],
                [
                  3,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  -2,
                  3
                ],
                [
                  -10,
                  12
                ],
                [
                  -5,
                  7
                ],
                [
                  -2,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -4,
                  -1
                ],
                [
                  -5,
                  -4
                ],
                [
                  -3,
                  0
                ],
                [
                  0,
                  3
                ],
                [
                  1,
                  5
                ],
                [
                  0,
                  1
                ],
                [
                  10,
                  17
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  3
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  3
                ],
                [
                  -4,
                  6
                ],
                [
                  -1,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  8
                ],
                [
                  0,
                  3
                ],
                [
                  -3,
                  8
                ],
                [
                  1,
                  3
                ],
                [
                  5,
                  0
                ],
                [
                  7,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  4,
                  -3
                ],
                [
                  3,
                  -2
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  4,
                  5
                ],
                [
                  3,
                  1
                ],
                [
                  5,
                  1
                ],
                [
                  5,
                  2
                ],
                [
                  5,
                  2
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  5,
                  -6
                ],
                [
                  4,
                  -2
                ],
                [
                  4,
                  -1
                ],
                [
                  51,
                  12
                ],
                [
                  -1,
                  3
                ],
                [
                  1,
                  4
                ],
                [
                  2,
                  5
                ],
                [
                  1,
                  4
                ],
                [
                  -1,
                  6
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  4
                ],
                [
                  1,
                  2
                ],
                [
                  -5,
                  3
                ],
                [
                  -3,
                  4
                ],
                [
                  -1,
                  6
                ],
                [
                  -1,
                  15
                ],
                [
                  0,
                  2
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  3,
                  -3
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  6,
                  4
                ],
                [
                  2,
                  1
                ],
                [
                  6,
                  0
                ],
                [
                  5,
                  -3
                ],
                [
                  9,
                  -6
                ],
                [
                  1,
                  -1
                ],
                [
                  5,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -4
                ],
                [
                  3,
                  -10
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -3
                ],
                [
                  -1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  1
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -4
                ],
                [
                  2,
                  -2
                ],
                [
                  0,
                  -3
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  -1
                ],
                [
                  9,
                  -4
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  23,
                  -9
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  1
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  4,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  10,
                  10
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  3
                ],
                [
                  2,
                  4
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  2,
                  -3
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -6
                ],
                [
                  3,
                  -7
                ],
                [
                  2,
                  -2
                ],
                [
                  2,
                  -3
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -4
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -4
                ],
                [
                  -3,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -5
                ],
                [
                  0,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  3,
                  -1
                ],
                [
                  3,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  6,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  4
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  6,
                  2
                ],
                [
                  1,
                  -1
                ],
                [
                  -1,
                  5
                ],
                [
                  -10,
                  9
                ],
                [
                  -1,
                  4
                ],
                [
                  2,
                  2
                ],
                [
                  5,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  3,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  7
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  15,
                  6
                ],
                [
                  4,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  -1,
                  6
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  11
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  3,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  6
                ],
                [
                  -3,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  4,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  -2,
                  2
                ],
                [
                  2,
                  4
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  -1,
                  3
                ],
                [
                  -5,
                  4
                ],
                [
                  -2,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  4
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  -4,
                  11
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  6
                ],
                [
                  1,
                  3
                ],
                [
                  2,
                  3
                ],
                [
                  2,
                  3
                ],
                [
                  2,
                  3
                ],
                [
                  -1,
                  4
                ],
                [
                  -1,
                  4
                ],
                [
                  0,
                  3
                ],
                [
                  1,
                  4
                ],
                [
                  5,
                  12
                ],
                [
                  1,
                  4
                ],
                [
                  -1,
                  4
                ],
                [
                  -3,
                  7
                ],
                [
                  -2,
                  2
                ],
                [
                  -5,
                  4
                ],
                [
                  -3,
                  4
                ],
                [
                  -4,
                  3
                ],
                [
                  -5,
                  2
                ],
                [
                  -4,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  0,
                  5
                ],
                [
                  -1,
                  6
                ],
                [
                  -2,
                  5
                ],
                [
                  -2,
                  5
                ],
                [
                  -4,
                  3
                ],
                [
                  -4,
                  3
                ],
                [
                  -6,
                  1
                ],
                [
                  -4,
                  -2
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -4,
                  1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -6,
                  7
                ],
                [
                  0,
                  4
                ],
                [
                  2,
                  4
                ],
                [
                  5,
                  8
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  10
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  4
                ],
                [
                  -1,
                  4
                ],
                [
                  1,
                  3
                ],
                [
                  4,
                  7
                ],
                [
                  5,
                  11
                ],
                [
                  3,
                  3
                ],
                [
                  9,
                  6
                ],
                [
                  3,
                  3
                ],
                [
                  0,
                  3
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  3
                ],
                [
                  4,
                  5
                ],
                [
                  6,
                  1
                ],
                [
                  8,
                  -1
                ],
                [
                  6,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  10,
                  9
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  7
                ],
                [
                  4,
                  6
                ],
                [
                  6,
                  5
                ],
                [
                  4,
                  6
                ],
                [
                  -1,
                  6
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -3,
                  2
                ],
                [
                  -3,
                  2
                ],
                [
                  -2,
                  3
                ],
                [
                  -2,
                  3
                ],
                [
                  -1,
                  3
                ],
                [
                  -2,
                  8
                ],
                [
                  -2,
                  2
                ],
                [
                  -6,
                  3
                ],
                [
                  -2,
                  3
                ],
                [
                  -1,
                  4
                ],
                [
                  0,
                  10
                ],
                [
                  0,
                  4
                ],
                [
                  -2,
                  9
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -5,
                  2
                ],
                [
                  -3,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -5,
                  -2
                ],
                [
                  -3,
                  0
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -3,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -25,
                  2
                ],
                [
                  -2,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -3
                ],
                [
                  -1,
                  -4
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -3,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -3,
                  0
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -5,
                  -2
                ],
                [
                  -3,
                  -4
                ],
                [
                  -1,
                  -1
                ],
                [
                  -5,
                  -1
                ],
                [
                  -4,
                  0
                ],
                [
                  -4,
                  0
                ],
                [
                  -4,
                  2
                ],
                [
                  -2,
                  0
                ],
                [
                  -3,
                  0
                ],
                [
                  -3,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -3,
                  -3
                ],
                [
                  -2,
                  -1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -4,
                  0
                ],
                [
                  -3,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  3,
                  0
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  6
                ],
                [
                  0,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  7
                ],
                [
                  -3,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  3
                ],
                [
                  -2,
                  4
                ],
                [
                  2,
                  3
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  7
                ],
                [
                  0,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  -1,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  5
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  3
                ],
                [
                  1,
                  0
                ],
                [
                  4,
                  3
                ],
                [
                  2,
                  3
                ],
                [
                  0,
                  5
                ],
                [
                  0,
                  8
                ]
              ],
              [
                [
                  9013,
                  3110
                ],
                [
                  -3,
                  0
                ],
                [
                  -9,
                  2
                ],
                [
                  -9,
                  0
                ],
                [
                  -3,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  5
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  5,
                  -1
                ],
                [
                  3,
                  0
                ],
                [
                  6,
                  -5
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  7,
                  -5
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  -1
                ]
              ],
              [
                [
                  9096,
                  3150
                ],
                [
                  6,
                  -18
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -17
                ],
                [
                  -1,
                  -3
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -10,
                  7
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -5,
                  1
                ],
                [
                  -8,
                  5
                ],
                [
                  -1,
                  1
                ],
                [
                  -5,
                  3
                ],
                [
                  -2,
                  2
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  3,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  5,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  4,
                  -1
                ],
                [
                  3,
                  3
                ],
                [
                  2,
                  6
                ],
                [
                  0,
                  4
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -1
                ]
              ],
              [
                [
                  8963,
                  3172
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -7,
                  7
                ],
                [
                  -2,
                  1
                ],
                [
                  -6,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -3,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -3,
                  3
                ],
                [
                  -2,
                  3
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  3,
                  4
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  2,
                  24
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  3
                ],
                [
                  2,
                  3
                ],
                [
                  1,
                  0
                ],
                [
                  6,
                  2
                ],
                [
                  3,
                  1
                ],
                [
                  3,
                  -1
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  -3,
                  -26
                ],
                [
                  1,
                  -6
                ],
                [
                  6,
                  -9
                ],
                [
                  2,
                  -5
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -3
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  3,
                  -4
                ],
                [
                  0,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ]
              ],
              [
                [
                  88,
                  6881
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -3,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  -1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  2,
                  0
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -3
                ]
              ],
              [
                [
                  134,
                  6880
                ],
                [
                  -6,
                  -2
                ],
                [
                  -5,
                  0
                ],
                [
                  -4,
                  3
                ],
                [
                  -8,
                  6
                ],
                [
                  -2,
                  3
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  2,
                  4
                ],
                [
                  2,
                  3
                ],
                [
                  4,
                  2
                ],
                [
                  8,
                  4
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -5
                ],
                [
                  2,
                  -7
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -4,
                  -4
                ]
              ],
              [
                [
                  211,
                  6947
                ],
                [
                  0,
                  -1
                ],
                [
                  3,
                  2
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  2,
                  -2
                ],
                [
                  2,
                  -2
                ],
                [
                  4,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -3
                ],
                [
                  4,
                  -4
                ],
                [
                  3,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  5,
                  -11
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -3,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -3
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -4,
                  0
                ],
                [
                  -4,
                  1
                ],
                [
                  -3,
                  1
                ],
                [
                  -4,
                  1
                ],
                [
                  -5,
                  5
                ],
                [
                  -2,
                  2
                ],
                [
                  0,
                  5
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  5
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  -2,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  4,
                  3
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ]
              ],
              [
                [
                  284,
                  6947
                ],
                [
                  2,
                  -1
                ],
                [
                  3,
                  1
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -3
                ],
                [
                  1,
                  -8
                ],
                [
                  0,
                  -4
                ],
                [
                  -2,
                  -4
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  1
                ],
                [
                  -3,
                  3
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  3,
                  2
                ],
                [
                  2,
                  3
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  -1
                ],
                [
                  -1,
                  -1
                ]
              ],
              [
                [
                  327,
                  7070
                ],
                [
                  3,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  8,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -6
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -7,
                  -6
                ],
                [
                  -5,
                  -3
                ],
                [
                  -2,
                  0
                ],
                [
                  -8,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  -2,
                  0
                ],
                [
                  -5,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  3
                ],
                [
                  -2,
                  12
                ],
                [
                  1,
                  4
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  4,
                  -1
                ]
              ],
              [
                [
                  139,
                  7130
                ],
                [
                  1,
                  0
                ],
                [
                  8,
                  2
                ],
                [
                  1,
                  -1
                ],
                [
                  5,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  10,
                  -1
                ],
                [
                  3,
                  -1
                ],
                [
                  3,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -5
                ],
                [
                  -2,
                  0
                ],
                [
                  -9,
                  0
                ],
                [
                  -10,
                  5
                ],
                [
                  -5,
                  1
                ],
                [
                  -5,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  -4,
                  -7
                ],
                [
                  -1,
                  -6
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  5
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -3,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  8,
                  3
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  3,
                  -3
                ],
                [
                  2,
                  -1
                ]
              ],
              [
                [
                  321,
                  7140
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -3
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  10
                ],
                [
                  -2,
                  4
                ],
                [
                  -3,
                  -1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  5
                ],
                [
                  2,
                  2
                ],
                [
                  7,
                  4
                ],
                [
                  0,
                  -1
                ],
                [
                  3,
                  -3
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -8
                ],
                [
                  0,
                  -3
                ],
                [
                  1,
                  -1
                ]
              ],
              [
                [
                  56,
                  7169
                ],
                [
                  2,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  2,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  -3,
                  -1
                ],
                [
                  -4,
                  -1
                ],
                [
                  -3,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -9,
                  4
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  3
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  4,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  4,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -2
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  0
                ]
              ],
              [
                [
                  35,
                  7207
                ],
                [
                  2,
                  -1
                ],
                [
                  3,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -3
                ],
                [
                  3,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -5,
                  -5
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -8,
                  -4
                ],
                [
                  -4,
                  -4
                ],
                [
                  -2,
                  -3
                ],
                [
                  -4,
                  -3
                ],
                [
                  -5,
                  -1
                ],
                [
                  -5,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  9
                ],
                [
                  -2,
                  3
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  3,
                  4
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  3,
                  3
                ],
                [
                  2,
                  1
                ],
                [
                  4,
                  2
                ],
                [
                  3,
                  1
                ],
                [
                  7,
                  4
                ],
                [
                  3,
                  0
                ],
                [
                  1,
                  0
                ]
              ],
              [
                [
                  8934,
                  6416
                ],
                [
                  -7,
                  -11
                ],
                [
                  -34,
                  -56
                ]
              ],
              [
                [
                  8893,
                  6349
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -4,
                  1
                ],
                [
                  -5,
                  1
                ],
                [
                  -3,
                  0
                ],
                [
                  -2,
                  2
                ],
                [
                  -3,
                  8
                ],
                [
                  -3,
                  1
                ],
                [
                  -3,
                  0
                ],
                [
                  -9,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  -5,
                  0
                ],
                [
                  -12,
                  -4
                ],
                [
                  -9,
                  -6
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -3,
                  1
                ],
                [
                  -5,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -5,
                  -2
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -7,
                  1
                ],
                [
                  -7,
                  -1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -4,
                  -4
                ],
                [
                  -4,
                  -1
                ],
                [
                  -7,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -16,
                  4
                ],
                [
                  -3,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  3,
                  4
                ],
                [
                  1,
                  6
                ],
                [
                  0,
                  27
                ],
                [
                  -2,
                  15
                ],
                [
                  -3,
                  16
                ],
                [
                  0,
                  7
                ],
                [
                  4,
                  13
                ],
                [
                  2,
                  10
                ],
                [
                  2,
                  5
                ],
                [
                  2,
                  1
                ],
                [
                  5,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  5,
                  8
                ],
                [
                  11,
                  16
                ],
                [
                  5,
                  10
                ],
                [
                  2,
                  2
                ],
                [
                  3,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  5
                ],
                [
                  17,
                  25
                ],
                [
                  4,
                  9
                ],
                [
                  8,
                  11
                ]
              ],
              [
                [
                  8822,
                  6552
                ],
                [
                  7,
                  7
                ],
                [
                  2,
                  1
                ],
                [
                  4,
                  -1
                ],
                [
                  6,
                  -3
                ],
                [
                  20,
                  -19
                ],
                [
                  2,
                  3
                ],
                [
                  4,
                  1
                ],
                [
                  2,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  4,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  4
                ],
                [
                  -2,
                  4
                ],
                [
                  0,
                  4
                ],
                [
                  6,
                  6
                ],
                [
                  3,
                  7
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  28,
                  12
                ]
              ],
              [
                [
                  8918,
                  6585
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -3
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -3
                ],
                [
                  13,
                  -15
                ],
                [
                  3,
                  -5
                ],
                [
                  2,
                  -2
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  0,
                  -5
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -5
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -2
                ],
                [
                  4,
                  -7
                ],
                [
                  1,
                  -2
                ],
                [
                  -1,
                  -9
                ],
                [
                  1,
                  -10
                ],
                [
                  0,
                  -4
                ],
                [
                  -2,
                  -5
                ],
                [
                  -3,
                  -3
                ],
                [
                  -4,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -3,
                  0
                ],
                [
                  -4,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -6,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -5,
                  -3
                ],
                [
                  -10,
                  -12
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -7,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -3,
                  1
                ],
                [
                  -3,
                  0
                ],
                [
                  -12,
                  -5
                ],
                [
                  -3,
                  -2
                ],
                [
                  -3,
                  -3
                ],
                [
                  -9,
                  -18
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -4,
                  -2
                ],
                [
                  -2,
                  0
                ],
                [
                  -3,
                  1
                ],
                [
                  -3,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  -3
                ],
                [
                  0,
                  -4
                ],
                [
                  1,
                  -3
                ],
                [
                  4,
                  -1
                ],
                [
                  3,
                  -3
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  1,
                  3
                ],
                [
                  3,
                  1
                ],
                [
                  6,
                  3
                ],
                [
                  9,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  18,
                  0
                ],
                [
                  3,
                  1
                ],
                [
                  2,
                  -1
                ],
                [
                  3,
                  -1
                ],
                [
                  3,
                  0
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  0,
                  -2
                ],
                [
                  2,
                  -8
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  4,
                  -3
                ],
                [
                  2,
                  -2
                ]
              ],
              [
                [
                  4423,
                  9943
                ],
                [
                  1,
                  -4
                ],
                [
                  -1,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  4,
                  -6
                ],
                [
                  0,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -9,
                  -3
                ],
                [
                  -5,
                  -1
                ],
                [
                  -4,
                  0
                ],
                [
                  -6,
                  0
                ],
                [
                  -4,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  4,
                  -2
                ],
                [
                  3,
                  -3
                ],
                [
                  -1,
                  -5
                ],
                [
                  -3,
                  -5
                ],
                [
                  -3,
                  -2
                ],
                [
                  -16,
                  -9
                ],
                [
                  -8,
                  -2
                ],
                [
                  -4,
                  -2
                ],
                [
                  -3,
                  -4
                ],
                [
                  0,
                  -4
                ],
                [
                  5,
                  -2
                ],
                [
                  11,
                  -1
                ],
                [
                  3,
                  -2
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -6
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -6,
                  -15
                ],
                [
                  -1,
                  -5
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -3
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  -10
                ],
                [
                  -1,
                  -8
                ],
                [
                  0,
                  -2
                ],
                [
                  -3,
                  -8
                ],
                [
                  -1,
                  -11
                ],
                [
                  1,
                  -6
                ],
                [
                  1,
                  -5
                ],
                [
                  7,
                  -9
                ],
                [
                  2,
                  -5
                ],
                [
                  0,
                  -4
                ],
                [
                  2,
                  -11
                ],
                [
                  -1,
                  -4
                ],
                [
                  -4,
                  -10
                ],
                [
                  -2,
                  -5
                ],
                [
                  0,
                  -5
                ],
                [
                  1,
                  -6
                ],
                [
                  3,
                  -5
                ],
                [
                  5,
                  -2
                ],
                [
                  5,
                  -1
                ],
                [
                  5,
                  -3
                ],
                [
                  -1,
                  -3
                ],
                [
                  -8,
                  -11
                ],
                [
                  -7,
                  -6
                ],
                [
                  -1,
                  -5
                ],
                [
                  -3,
                  -10
                ],
                [
                  -3,
                  -7
                ],
                [
                  -1,
                  -6
                ],
                [
                  0,
                  -5
                ],
                [
                  3,
                  -14
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -4,
                  -4
                ],
                [
                  -2,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  3,
                  -5
                ],
                [
                  -1,
                  -1
                ],
                [
                  -4,
                  -3
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -3,
                  -2
                ],
                [
                  -5,
                  -4
                ],
                [
                  -1,
                  -1
                ],
                [
                  -12,
                  -5
                ],
                [
                  -6,
                  -3
                ],
                [
                  -11,
                  -5
                ],
                [
                  -5,
                  -3
                ],
                [
                  -3,
                  -5
                ],
                [
                  -5,
                  -16
                ],
                [
                  -1,
                  -3
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -8,
                  -2
                ],
                [
                  -5,
                  -2
                ],
                [
                  -4,
                  -3
                ],
                [
                  -3,
                  -4
                ],
                [
                  -5,
                  -5
                ],
                [
                  -3,
                  -2
                ],
                [
                  -2,
                  -4
                ],
                [
                  0,
                  -10
                ],
                [
                  -3,
                  -14
                ],
                [
                  1,
                  -6
                ],
                [
                  1,
                  -7
                ],
                [
                  1,
                  -3
                ],
                [
                  4,
                  -6
                ],
                [
                  1,
                  -7
                ],
                [
                  1,
                  -4
                ],
                [
                  9,
                  -13
                ],
                [
                  10,
                  -15
                ],
                [
                  2,
                  -6
                ],
                [
                  0,
                  -19
                ],
                [
                  2,
                  -6
                ],
                [
                  3,
                  -3
                ],
                [
                  5,
                  -2
                ],
                [
                  6,
                  0
                ],
                [
                  5,
                  -2
                ],
                [
                  14,
                  -9
                ],
                [
                  3,
                  -1
                ],
                [
                  3,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  1
                ],
                [
                  3,
                  -2
                ],
                [
                  12,
                  -17
                ],
                [
                  13,
                  -19
                ],
                [
                  2,
                  -4
                ],
                [
                  2,
                  -20
                ],
                [
                  1,
                  -14
                ],
                [
                  2,
                  -4
                ],
                [
                  0,
                  -1
                ],
                [
                  4,
                  -3
                ],
                [
                  16,
                  -9
                ],
                [
                  20,
                  -14
                ],
                [
                  28,
                  -18
                ],
                [
                  21,
                  -14
                ],
                [
                  2,
                  -2
                ],
                [
                  2,
                  -3
                ],
                [
                  2,
                  -10
                ],
                [
                  0,
                  -1
                ],
                [
                  4,
                  -15
                ],
                [
                  4,
                  -16
                ],
                [
                  4,
                  -15
                ],
                [
                  3,
                  -15
                ],
                [
                  4,
                  -15
                ],
                [
                  4,
                  -16
                ],
                [
                  3,
                  -15
                ],
                [
                  4,
                  -15
                ],
                [
                  4,
                  -15
                ],
                [
                  3,
                  -16
                ],
                [
                  4,
                  -15
                ],
                [
                  4,
                  -15
                ],
                [
                  3,
                  -15
                ],
                [
                  4,
                  -15
                ],
                [
                  4,
                  -16
                ],
                [
                  4,
                  -15
                ]
              ],
              [
                [
                  4543,
                  9013
                ],
                [
                  -31,
                  -15
                ],
                [
                  3,
                  -5
                ],
                [
                  8,
                  -9
                ],
                [
                  7,
                  -7
                ],
                [
                  16,
                  -23
                ],
                [
                  16,
                  -27
                ],
                [
                  10,
                  -33
                ],
                [
                  10,
                  -33
                ],
                [
                  3,
                  -22
                ],
                [
                  1,
                  -26
                ],
                [
                  -3,
                  -23
                ],
                [
                  -7,
                  -49
                ],
                [
                  2,
                  -8
                ],
                [
                  19,
                  -47
                ],
                [
                  0,
                  -6
                ],
                [
                  -1,
                  -1
                ],
                [
                  -9,
                  -28
                ],
                [
                  -2,
                  -2
                ],
                [
                  -4,
                  -2
                ],
                [
                  -3,
                  -2
                ],
                [
                  1,
                  -3
                ],
                [
                  2,
                  -3
                ],
                [
                  1,
                  -3
                ],
                [
                  -1,
                  -3
                ],
                [
                  -6,
                  -6
                ],
                [
                  -2,
                  -3
                ],
                [
                  -1,
                  -8
                ],
                [
                  -3,
                  -5
                ],
                [
                  0,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  11,
                  -37
                ],
                [
                  2,
                  -14
                ],
                [
                  2,
                  -3
                ],
                [
                  1,
                  -1
                ],
                [
                  6,
                  -3
                ],
                [
                  2,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  -3,
                  -15
                ],
                [
                  0,
                  -5
                ],
                [
                  1,
                  -4
                ],
                [
                  1,
                  -2
                ],
                [
                  -6,
                  -18
                ],
                [
                  -2,
                  -3
                ],
                [
                  -46,
                  -21
                ],
                [
                  0,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -5,
                  -4
                ],
                [
                  -2,
                  -6
                ],
                [
                  -2,
                  -2
                ],
                [
                  -3,
                  -7
                ],
                [
                  3,
                  -7
                ],
                [
                  18,
                  -25
                ],
                [
                  20,
                  -26
                ],
                [
                  16,
                  -22
                ],
                [
                  20,
                  -27
                ],
                [
                  5,
                  -9
                ],
                [
                  2,
                  -8
                ],
                [
                  0,
                  -19
                ],
                [
                  1,
                  -19
                ],
                [
                  0,
                  -19
                ],
                [
                  2,
                  -4
                ],
                [
                  19,
                  -11
                ],
                [
                  3,
                  -4
                ],
                [
                  2,
                  -13
                ],
                [
                  2,
                  -5
                ],
                [
                  2,
                  -2
                ],
                [
                  17,
                  -14
                ],
                [
                  3,
                  0
                ],
                [
                  5,
                  0
                ],
                [
                  15,
                  6
                ],
                [
                  14,
                  5
                ],
                [
                  3,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  25,
                  -9
                ],
                [
                  31,
                  -10
                ],
                [
                  41,
                  -13
                ],
                [
                  6,
                  -2
                ],
                [
                  4,
                  -2
                ],
                [
                  3,
                  -4
                ],
                [
                  9,
                  -18
                ],
                [
                  10,
                  -19
                ],
                [
                  14,
                  -29
                ],
                [
                  10,
                  -18
                ],
                [
                  10,
                  -20
                ]
              ],
              [
                [
                  4862,
                  8083
                ],
                [
                  -9,
                  -5
                ],
                [
                  -9,
                  -6
                ],
                [
                  -9,
                  -6
                ],
                [
                  -9,
                  -5
                ],
                [
                  -9,
                  -6
                ],
                [
                  -9,
                  -5
                ],
                [
                  -8,
                  -6
                ],
                [
                  -9,
                  -5
                ],
                [
                  -9,
                  -6
                ],
                [
                  -9,
                  -5
                ],
                [
                  -9,
                  -6
                ],
                [
                  -9,
                  -6
                ],
                [
                  -9,
                  -5
                ],
                [
                  -9,
                  -6
                ],
                [
                  -8,
                  -5
                ],
                [
                  -9,
                  -6
                ],
                [
                  -9,
                  -5
                ],
                [
                  -9,
                  -6
                ],
                [
                  -9,
                  -6
                ],
                [
                  -9,
                  -5
                ],
                [
                  -9,
                  -6
                ],
                [
                  -8,
                  -5
                ],
                [
                  -9,
                  -6
                ],
                [
                  -9,
                  -5
                ],
                [
                  -9,
                  -6
                ],
                [
                  -9,
                  -5
                ],
                [
                  -9,
                  -6
                ],
                [
                  -9,
                  -6
                ],
                [
                  -8,
                  -5
                ],
                [
                  -9,
                  -6
                ],
                [
                  -9,
                  -5
                ],
                [
                  -9,
                  -6
                ],
                [
                  -9,
                  -5
                ],
                [
                  -9,
                  -6
                ],
                [
                  -9,
                  -5
                ],
                [
                  -9,
                  -6
                ],
                [
                  -8,
                  -6
                ],
                [
                  -9,
                  -5
                ],
                [
                  -9,
                  -6
                ],
                [
                  -9,
                  -5
                ],
                [
                  -9,
                  -6
                ],
                [
                  -9,
                  -5
                ],
                [
                  -9,
                  -6
                ],
                [
                  -8,
                  -5
                ],
                [
                  -9,
                  -6
                ],
                [
                  -9,
                  -6
                ],
                [
                  -9,
                  -5
                ],
                [
                  -9,
                  -6
                ],
                [
                  -9,
                  -5
                ],
                [
                  -9,
                  -6
                ],
                [
                  -8,
                  -5
                ],
                [
                  -9,
                  -6
                ],
                [
                  -9,
                  -6
                ],
                [
                  -9,
                  -5
                ],
                [
                  -9,
                  -6
                ],
                [
                  -9,
                  -5
                ],
                [
                  -9,
                  -6
                ],
                [
                  -8,
                  -5
                ],
                [
                  -9,
                  -6
                ],
                [
                  -9,
                  -5
                ],
                [
                  -9,
                  -6
                ],
                [
                  -9,
                  -6
                ],
                [
                  -9,
                  -5
                ],
                [
                  -9,
                  -6
                ],
                [
                  -17,
                  -10
                ],
                [
                  -13,
                  -12
                ],
                [
                  -9,
                  -8
                ],
                [
                  -9,
                  -8
                ],
                [
                  -10,
                  -8
                ],
                [
                  -9,
                  -8
                ],
                [
                  -10,
                  -9
                ],
                [
                  -5,
                  -4
                ],
                [
                  -7,
                  -7
                ],
                [
                  -9,
                  -7
                ],
                [
                  -8,
                  -8
                ],
                [
                  -8,
                  -7
                ],
                [
                  -8,
                  -8
                ],
                [
                  -8,
                  -7
                ],
                [
                  -9,
                  -8
                ],
                [
                  -8,
                  -7
                ],
                [
                  -8,
                  -8
                ],
                [
                  -8,
                  -7
                ],
                [
                  -8,
                  -8
                ],
                [
                  -9,
                  -8
                ],
                [
                  -8,
                  -7
                ],
                [
                  -8,
                  -8
                ],
                [
                  -8,
                  -7
                ],
                [
                  -9,
                  -8
                ],
                [
                  -8,
                  -7
                ],
                [
                  -10,
                  -9
                ],
                [
                  -6,
                  -4
                ],
                [
                  -5,
                  -3
                ],
                [
                  -17,
                  -3
                ],
                [
                  -13,
                  -3
                ],
                [
                  -29,
                  -6
                ],
                [
                  -28,
                  -5
                ],
                [
                  -13,
                  -3
                ],
                [
                  -25,
                  -5
                ],
                [
                  -24,
                  -5
                ],
                [
                  -25,
                  -5
                ],
                [
                  -25,
                  -5
                ]
              ],
              [
                [
                  3853,
                  7477
                ],
                [
                  -22,
                  -4
                ],
                [
                  -22,
                  -5
                ],
                [
                  -13,
                  -2
                ],
                [
                  -9,
                  -2
                ],
                [
                  -23,
                  -5
                ],
                [
                  -13,
                  -2
                ],
                [
                  -11,
                  -3
                ],
                [
                  -3,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -3,
                  2
                ],
                [
                  -8,
                  7
                ],
                [
                  -6,
                  3
                ],
                [
                  -3,
                  2
                ],
                [
                  -2,
                  2
                ],
                [
                  -3,
                  2
                ],
                [
                  -2,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  3
                ],
                [
                  2,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  3,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  6
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  3,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  3
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  5
                ],
                [
                  0,
                  5
                ],
                [
                  3,
                  28
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -4,
                  1
                ],
                [
                  -3,
                  1
                ],
                [
                  -7,
                  6
                ],
                [
                  -17,
                  8
                ],
                [
                  -35,
                  7
                ],
                [
                  -7,
                  1
                ],
                [
                  -12,
                  2
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -5,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -4,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -5,
                  10
                ],
                [
                  -5,
                  6
                ],
                [
                  -4,
                  5
                ],
                [
                  -8,
                  6
                ],
                [
                  -3,
                  2
                ],
                [
                  -2,
                  0
                ],
                [
                  -3,
                  0
                ],
                [
                  -3,
                  -2
                ],
                [
                  -5,
                  -5
                ],
                [
                  -3,
                  -2
                ],
                [
                  -2,
                  1
                ],
                [
                  -9,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -3,
                  -3
                ],
                [
                  -1,
                  0
                ],
                [
                  -3,
                  0
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  -2,
                  3
                ],
                [
                  -2,
                  2
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -3,
                  1
                ],
                [
                  -3,
                  1
                ],
                [
                  -15,
                  13
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  10
                ],
                [
                  -1,
                  5
                ],
                [
                  -3,
                  4
                ],
                [
                  -8,
                  7
                ],
                [
                  -5,
                  2
                ],
                [
                  -5,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  -3,
                  0
                ],
                [
                  -5,
                  1
                ],
                [
                  -6,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  3
                ],
                [
                  -3,
                  5
                ],
                [
                  -1,
                  1
                ],
                [
                  -3,
                  1
                ],
                [
                  -3,
                  0
                ],
                [
                  -5,
                  -1
                ],
                [
                  -3,
                  0
                ],
                [
                  -3,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  3
                ],
                [
                  3,
                  13
                ],
                [
                  1,
                  15
                ],
                [
                  0,
                  3
                ],
                [
                  -2,
                  9
                ],
                [
                  -2,
                  2
                ],
                [
                  -15,
                  11
                ],
                [
                  -11,
                  8
                ],
                [
                  -12,
                  8
                ],
                [
                  -11,
                  8
                ],
                [
                  -11,
                  7
                ],
                [
                  -12,
                  8
                ],
                [
                  -11,
                  8
                ],
                [
                  -11,
                  8
                ],
                [
                  -11,
                  8
                ],
                [
                  -12,
                  8
                ],
                [
                  -11,
                  8
                ],
                [
                  -11,
                  7
                ],
                [
                  -10,
                  7
                ],
                [
                  -2,
                  1
                ],
                [
                  -11,
                  8
                ],
                [
                  -11,
                  8
                ],
                [
                  -11,
                  8
                ],
                [
                  -12,
                  8
                ],
                [
                  -11,
                  7
                ],
                [
                  -11,
                  8
                ],
                [
                  -12,
                  8
                ],
                [
                  -11,
                  8
                ],
                [
                  -11,
                  8
                ],
                [
                  -11,
                  8
                ],
                [
                  -12,
                  8
                ],
                [
                  -11,
                  7
                ],
                [
                  -11,
                  8
                ],
                [
                  -12,
                  8
                ],
                [
                  -11,
                  8
                ],
                [
                  -11,
                  8
                ],
                [
                  -11,
                  8
                ],
                [
                  -12,
                  8
                ],
                [
                  -11,
                  7
                ],
                [
                  -11,
                  8
                ],
                [
                  -12,
                  8
                ],
                [
                  -11,
                  8
                ],
                [
                  -11,
                  8
                ],
                [
                  -11,
                  8
                ],
                [
                  -12,
                  7
                ],
                [
                  -11,
                  8
                ],
                [
                  -11,
                  8
                ],
                [
                  -12,
                  8
                ],
                [
                  -11,
                  8
                ],
                [
                  -11,
                  8
                ],
                [
                  -11,
                  8
                ],
                [
                  -12,
                  7
                ],
                [
                  -11,
                  8
                ],
                [
                  -11,
                  8
                ],
                [
                  -12,
                  8
                ],
                [
                  -11,
                  8
                ],
                [
                  -10,
                  7
                ],
                [
                  -11,
                  7
                ],
                [
                  -10,
                  7
                ],
                [
                  -10,
                  8
                ],
                [
                  -11,
                  7
                ],
                [
                  -10,
                  7
                ],
                [
                  -10,
                  7
                ],
                [
                  -11,
                  8
                ],
                [
                  -10,
                  7
                ],
                [
                  -11,
                  7
                ],
                [
                  -10,
                  7
                ],
                [
                  -10,
                  7
                ],
                [
                  -11,
                  8
                ],
                [
                  -10,
                  7
                ],
                [
                  -11,
                  7
                ],
                [
                  -10,
                  7
                ],
                [
                  -14,
                  10
                ],
                [
                  -10,
                  7
                ],
                [
                  -10,
                  7
                ],
                [
                  -10,
                  6
                ],
                [
                  -10,
                  7
                ]
              ],
              [
                [
                  2675,
                  8288
                ],
                [
                  -23,
                  15
                ],
                [
                  -22,
                  15
                ],
                [
                  -23,
                  14
                ],
                [
                  -23,
                  15
                ],
                [
                  -15,
                  10
                ],
                [
                  -4,
                  2
                ],
                [
                  -18,
                  12
                ],
                [
                  -22,
                  13
                ],
                [
                  -22,
                  14
                ],
                [
                  -22,
                  14
                ],
                [
                  -25,
                  16
                ],
                [
                  -26,
                  16
                ],
                [
                  -26,
                  16
                ],
                [
                  -26,
                  16
                ],
                [
                  -26,
                  16
                ],
                [
                  -25,
                  16
                ],
                [
                  -26,
                  17
                ],
                [
                  -26,
                  16
                ],
                [
                  -26,
                  16
                ],
                [
                  -25,
                  16
                ],
                [
                  -26,
                  16
                ],
                [
                  -26,
                  16
                ]
              ],
              [
                [
                  2172,
                  8605
                ],
                [
                  0,
                  13
                ],
                [
                  0,
                  13
                ],
                [
                  0,
                  13
                ],
                [
                  0,
                  13
                ]
              ],
              [
                [
                  2172,
                  8657
                ],
                [
                  0,
                  9
                ],
                [
                  0,
                  8
                ],
                [
                  0,
                  8
                ],
                [
                  0,
                  8
                ],
                [
                  0,
                  9
                ],
                [
                  0,
                  8
                ],
                [
                  0,
                  8
                ],
                [
                  0,
                  9
                ],
                [
                  0,
                  8
                ],
                [
                  0,
                  8
                ],
                [
                  0,
                  9
                ],
                [
                  0,
                  8
                ],
                [
                  0,
                  8
                ],
                [
                  0,
                  9
                ],
                [
                  0,
                  8
                ],
                [
                  0,
                  8
                ],
                [
                  0,
                  6
                ],
                [
                  1,
                  4
                ],
                [
                  1,
                  3
                ],
                [
                  2,
                  2
                ],
                [
                  17,
                  8
                ],
                [
                  6,
                  5
                ],
                [
                  6,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  5,
                  8
                ],
                [
                  2,
                  1
                ],
                [
                  5,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  8,
                  8
                ],
                [
                  9,
                  6
                ],
                [
                  15,
                  6
                ],
                [
                  4,
                  3
                ],
                [
                  12,
                  10
                ],
                [
                  14,
                  9
                ],
                [
                  8,
                  7
                ],
                [
                  6,
                  3
                ],
                [
                  2,
                  1
                ],
                [
                  8,
                  8
                ],
                [
                  4,
                  2
                ],
                [
                  7,
                  -1
                ],
                [
                  5,
                  0
                ],
                [
                  3,
                  -1
                ],
                [
                  3,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  15,
                  -1
                ],
                [
                  11,
                  11
                ],
                [
                  15,
                  6
                ],
                [
                  10,
                  1
                ],
                [
                  15,
                  -1
                ],
                [
                  22,
                  -8
                ],
                [
                  11,
                  9
                ],
                [
                  18,
                  2
                ],
                [
                  20,
                  5
                ],
                [
                  18,
                  2
                ],
                [
                  19,
                  0
                ],
                [
                  16,
                  0
                ],
                [
                  16,
                  3
                ],
                [
                  16,
                  2
                ],
                [
                  5,
                  -13
                ],
                [
                  11,
                  -4
                ],
                [
                  12,
                  4
                ],
                [
                  14,
                  17
                ],
                [
                  12,
                  17
                ],
                [
                  9,
                  17
                ],
                [
                  13,
                  12
                ],
                [
                  13,
                  9
                ],
                [
                  15,
                  12
                ],
                [
                  11,
                  7
                ],
                [
                  13,
                  7
                ],
                [
                  20,
                  8
                ],
                [
                  18,
                  13
                ],
                [
                  14,
                  18
                ],
                [
                  13,
                  7
                ],
                [
                  16,
                  3
                ],
                [
                  20,
                  1
                ],
                [
                  21,
                  5
                ],
                [
                  25,
                  12
                ],
                [
                  -1,
                  9
                ],
                [
                  -1,
                  8
                ],
                [
                  7,
                  6
                ],
                [
                  7,
                  11
                ],
                [
                  -7,
                  10
                ],
                [
                  0,
                  3
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  -2,
                  1
                ],
                [
                  -4,
                  2
                ],
                [
                  -3,
                  2
                ],
                [
                  -3,
                  5
                ],
                [
                  -2,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -4,
                  -3
                ],
                [
                  -3,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  1,
                  3
                ],
                [
                  3,
                  4
                ],
                [
                  0,
                  4
                ],
                [
                  -1,
                  10
                ],
                [
                  1,
                  3
                ],
                [
                  2,
                  1
                ],
                [
                  7,
                  5
                ],
                [
                  9,
                  1
                ],
                [
                  2,
                  36
                ],
                [
                  9,
                  4
                ],
                [
                  6,
                  -1
                ],
                [
                  4,
                  0
                ],
                [
                  39,
                  6
                ],
                [
                  28,
                  8
                ],
                [
                  22,
                  3
                ],
                [
                  -5,
                  14
                ],
                [
                  -9,
                  21
                ],
                [
                  8,
                  4
                ],
                [
                  24,
                  2
                ],
                [
                  23,
                  6
                ],
                [
                  18,
                  -1
                ],
                [
                  8,
                  0
                ],
                [
                  10,
                  -1
                ],
                [
                  10,
                  0
                ],
                [
                  11,
                  -1
                ],
                [
                  11,
                  0
                ],
                [
                  11,
                  -1
                ],
                [
                  12,
                  0
                ],
                [
                  11,
                  -1
                ],
                [
                  11,
                  0
                ],
                [
                  10,
                  0
                ],
                [
                  9,
                  -1
                ],
                [
                  8,
                  0
                ],
                [
                  6,
                  0
                ],
                [
                  5,
                  -1
                ],
                [
                  3,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  10,
                  0
                ],
                [
                  5,
                  1
                ],
                [
                  3,
                  5
                ],
                [
                  -1,
                  3
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -5,
                  -2
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  3
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  13
                ],
                [
                  2,
                  5
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  3
                ],
                [
                  2,
                  1
                ],
                [
                  6,
                  1
                ],
                [
                  5,
                  1
                ],
                [
                  4,
                  3
                ],
                [
                  7,
                  8
                ],
                [
                  -2,
                  3
                ],
                [
                  -36,
                  25
                ],
                [
                  -8,
                  3
                ],
                [
                  -5,
                  3
                ],
                [
                  -17,
                  27
                ],
                [
                  5,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  3
                ],
                [
                  -1,
                  3
                ],
                [
                  -2,
                  2
                ],
                [
                  -3,
                  3
                ],
                [
                  -4,
                  2
                ],
                [
                  -3,
                  4
                ],
                [
                  -1,
                  4
                ],
                [
                  -3,
                  4
                ],
                [
                  -6,
                  6
                ],
                [
                  -1,
                  4
                ],
                [
                  0,
                  14
                ],
                [
                  1,
                  4
                ],
                [
                  2,
                  3
                ],
                [
                  2,
                  8
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  4
                ],
                [
                  -1,
                  5
                ],
                [
                  -6,
                  12
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -5,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  4
                ],
                [
                  -1,
                  7
                ],
                [
                  0,
                  6
                ],
                [
                  6,
                  23
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  -10,
                  26
                ],
                [
                  -3,
                  6
                ],
                [
                  -5,
                  5
                ],
                [
                  14,
                  15
                ],
                [
                  -1,
                  1
                ],
                [
                  -5,
                  1
                ],
                [
                  -16,
                  14
                ],
                [
                  1,
                  3
                ],
                [
                  7,
                  9
                ],
                [
                  3,
                  6
                ],
                [
                  2,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  -14,
                  8
                ],
                [
                  -4,
                  4
                ],
                [
                  -7,
                  3
                ],
                [
                  -2,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -6,
                  0
                ],
                [
                  -4,
                  3
                ],
                [
                  -4,
                  3
                ],
                [
                  -5,
                  3
                ],
                [
                  -4,
                  2
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  4
                ],
                [
                  -1,
                  5
                ]
              ],
              [
                [
                  3013,
                  9686
                ],
                [
                  3,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  4,
                  2
                ],
                [
                  4,
                  -1
                ],
                [
                  5,
                  -2
                ],
                [
                  4,
                  -1
                ],
                [
                  9,
                  1
                ],
                [
                  3,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  12,
                  3
                ],
                [
                  4,
                  3
                ],
                [
                  1,
                  0
                ],
                [
                  4,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  5,
                  5
                ],
                [
                  8,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  15,
                  12
                ],
                [
                  3,
                  1
                ],
                [
                  12,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  3,
                  3
                ],
                [
                  3,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  6
                ],
                [
                  2,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  5,
                  11
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  3,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  5
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  2
                ],
                [
                  4,
                  4
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  5,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  5,
                  3
                ],
                [
                  3,
                  5
                ],
                [
                  3,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  5,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  4
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  6,
                  11
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  -1
                ],
                [
                  1,
                  1
                ],
                [
                  6,
                  2
                ],
                [
                  3,
                  1
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  3,
                  -2
                ],
                [
                  3,
                  -2
                ],
                [
                  9,
                  -1
                ],
                [
                  6,
                  -2
                ],
                [
                  3,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  4,
                  1
                ],
                [
                  6,
                  3
                ],
                [
                  5,
                  3
                ],
                [
                  4,
                  4
                ],
                [
                  5,
                  8
                ],
                [
                  1,
                  3
                ],
                [
                  5,
                  9
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  6,
                  5
                ],
                [
                  2,
                  2
                ],
                [
                  9,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  3,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  6,
                  0
                ],
                [
                  3,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  9,
                  6
                ],
                [
                  5,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  3,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  10,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  4,
                  3
                ],
                [
                  8,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  3,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  6,
                  1
                ],
                [
                  5,
                  3
                ],
                [
                  9,
                  0
                ],
                [
                  3,
                  1
                ],
                [
                  5,
                  2
                ],
                [
                  3,
                  1
                ],
                [
                  6,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  3,
                  1
                ],
                [
                  7,
                  3
                ],
                [
                  3,
                  1
                ],
                [
                  2,
                  -1
                ],
                [
                  6,
                  -2
                ],
                [
                  3,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  5,
                  1
                ],
                [
                  24,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  7,
                  1
                ],
                [
                  7,
                  1
                ],
                [
                  6,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  11,
                  2
                ],
                [
                  33,
                  8
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  0
                ],
                [
                  3,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  18,
                  1
                ],
                [
                  5,
                  1
                ],
                [
                  12,
                  9
                ],
                [
                  9,
                  4
                ],
                [
                  3,
                  2
                ],
                [
                  3,
                  4
                ],
                [
                  1,
                  2
                ],
                [
                  3,
                  3
                ],
                [
                  8,
                  5
                ],
                [
                  5,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  -1
                ],
                [
                  5,
                  -2
                ],
                [
                  3,
                  -4
                ],
                [
                  4,
                  -2
                ],
                [
                  5,
                  -2
                ],
                [
                  4,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  4,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  1,
                  0
                ],
                [
                  9,
                  -3
                ],
                [
                  5,
                  -1
                ],
                [
                  15,
                  -1
                ],
                [
                  3,
                  0
                ],
                [
                  5,
                  2
                ],
                [
                  3,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  5,
                  2
                ],
                [
                  8,
                  7
                ],
                [
                  4,
                  2
                ],
                [
                  11,
                  3
                ],
                [
                  6,
                  1
                ],
                [
                  5,
                  -1
                ],
                [
                  5,
                  -3
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  1
                ],
                [
                  5,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  6,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  6,
                  3
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  -2
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  4,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  16,
                  2
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  5,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  4,
                  2
                ],
                [
                  2,
                  0
                ],
                [
                  4,
                  0
                ],
                [
                  10,
                  -1
                ],
                [
                  9,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  21,
                  -8
                ],
                [
                  3,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  3,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  -3,
                  -7
                ],
                [
                  1,
                  -2
                ],
                [
                  3,
                  -2
                ],
                [
                  16,
                  -7
                ],
                [
                  4,
                  -1
                ],
                [
                  5,
                  0
                ],
                [
                  8,
                  1
                ],
                [
                  8,
                  2
                ],
                [
                  4,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  5,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  5
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  3,
                  1
                ],
                [
                  5,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  4,
                  4
                ],
                [
                  4,
                  1
                ],
                [
                  3,
                  0
                ],
                [
                  9,
                  -2
                ],
                [
                  5,
                  1
                ],
                [
                  22,
                  4
                ],
                [
                  21,
                  7
                ],
                [
                  5,
                  2
                ],
                [
                  3,
                  4
                ],
                [
                  0,
                  3
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  2,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  5,
                  3
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  5,
                  2
                ],
                [
                  5,
                  1
                ],
                [
                  6,
                  0
                ],
                [
                  6,
                  -1
                ],
                [
                  4,
                  -3
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -5
                ],
                [
                  2,
                  -3
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  -1
                ],
                [
                  3,
                  -1
                ],
                [
                  3,
                  0
                ],
                [
                  19,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  4,
                  -2
                ],
                [
                  5,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  12,
                  3
                ],
                [
                  3,
                  2
                ],
                [
                  2,
                  -1
                ],
                [
                  4,
                  -1
                ],
                [
                  3,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  6,
                  4
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -5,
                  5
                ],
                [
                  -4,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  -1
                ],
                [
                  3,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  4,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  5,
                  -3
                ],
                [
                  4,
                  -4
                ],
                [
                  4,
                  -3
                ],
                [
                  6,
                  -1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  6,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  -1,
                  -3
                ],
                [
                  -1,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  2,
                  -2
                ],
                [
                  -2,
                  -4
                ],
                [
                  5,
                  -3
                ],
                [
                  7,
                  -2
                ],
                [
                  6,
                  -1
                ],
                [
                  18,
                  4
                ],
                [
                  3,
                  2
                ],
                [
                  3,
                  2
                ],
                [
                  18,
                  7
                ],
                [
                  2,
                  -1
                ],
                [
                  3,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  6,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  5,
                  0
                ],
                [
                  4,
                  0
                ],
                [
                  14,
                  5
                ]
              ],
              [
                [
                  7731,
                  8528
                ],
                [
                  0,
                  -3
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -3,
                  8
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  -6
                ],
                [
                  1,
                  -3
                ]
              ],
              [
                [
                  7732,
                  8636
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -3,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  -3,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -3,
                  -2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  -1
                ]
              ],
              [
                [
                  7826,
                  8693
                ],
                [
                  -4,
                  -2
                ],
                [
                  -3,
                  1
                ],
                [
                  -2,
                  3
                ],
                [
                  3,
                  3
                ],
                [
                  6,
                  0
                ],
                [
                  0,
                  -5
                ]
              ],
              [
                [
                  7802,
                  8704
                ],
                [
                  -4,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  3,
                  -1
                ],
                [
                  3,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  3,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -5,
                  0
                ],
                [
                  -5,
                  0
                ],
                [
                  -4,
                  2
                ],
                [
                  -2,
                  3
                ],
                [
                  -1,
                  0
                ],
                [
                  1,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ]
              ],
              [
                [
                  7599,
                  9131
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ]
              ],
              [
                [
                  7657,
                  9144
                ],
                [
                  5,
                  -5
                ],
                [
                  -2,
                  2
                ],
                [
                  -21,
                  8
                ],
                [
                  -3,
                  1
                ],
                [
                  4,
                  0
                ],
                [
                  6,
                  -3
                ],
                [
                  3,
                  -1
                ],
                [
                  4,
                  -1
                ],
                [
                  4,
                  -1
                ]
              ],
              [
                [
                  7614,
                  9153
                ],
                [
                  21,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -4,
                  1
                ],
                [
                  -4,
                  0
                ],
                [
                  -4,
                  1
                ],
                [
                  -4,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -4,
                  -1
                ],
                [
                  -15,
                  -8
                ],
                [
                  -3,
                  -2
                ],
                [
                  2,
                  2
                ],
                [
                  3,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  7,
                  3
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  2
                ]
              ],
              [
                [
                  8106,
                  7872
                ],
                [
                  -30,
                  0
                ],
                [
                  -30,
                  0
                ],
                [
                  -31,
                  0
                ],
                [
                  -30,
                  0
                ],
                [
                  -30,
                  0
                ],
                [
                  -31,
                  0
                ],
                [
                  -30,
                  0
                ],
                [
                  -30,
                  0
                ],
                [
                  -31,
                  0
                ],
                [
                  -30,
                  0
                ],
                [
                  -30,
                  0
                ],
                [
                  -31,
                  0
                ],
                [
                  -30,
                  0
                ],
                [
                  -30,
                  0
                ],
                [
                  -30,
                  0
                ],
                [
                  -28,
                  0
                ],
                [
                  -3,
                  0
                ],
                [
                  -13,
                  0
                ],
                [
                  -13,
                  0
                ],
                [
                  -14,
                  0
                ],
                [
                  -13,
                  0
                ],
                [
                  -13,
                  0
                ],
                [
                  -14,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -11,
                  0
                ],
                [
                  -13,
                  0
                ],
                [
                  -14,
                  0
                ],
                [
                  -13,
                  0
                ],
                [
                  -13,
                  0
                ],
                [
                  -14,
                  0
                ],
                [
                  -13,
                  0
                ],
                [
                  -13,
                  0
                ],
                [
                  -14,
                  0
                ],
                [
                  -13,
                  0
                ],
                [
                  -4,
                  0
                ],
                [
                  -7,
                  0
                ],
                [
                  4,
                  13
                ],
                [
                  3,
                  8
                ],
                [
                  0,
                  4
                ],
                [
                  -1,
                  3
                ],
                [
                  -3,
                  3
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -3,
                  -1
                ],
                [
                  -3,
                  -4
                ],
                [
                  -6,
                  -12
                ],
                [
                  0,
                  -1
                ],
                [
                  -7,
                  -13
                ],
                [
                  -2,
                  -1
                ],
                [
                  -5,
                  0
                ],
                [
                  -12,
                  0
                ],
                [
                  -13,
                  0
                ],
                [
                  -13,
                  0
                ],
                [
                  -12,
                  0
                ],
                [
                  -13,
                  0
                ],
                [
                  -13,
                  0
                ],
                [
                  -12,
                  0
                ],
                [
                  -13,
                  0
                ],
                [
                  -13,
                  0
                ],
                [
                  -12,
                  0
                ],
                [
                  -13,
                  0
                ],
                [
                  -13,
                  0
                ],
                [
                  -12,
                  0
                ],
                [
                  -13,
                  0
                ],
                [
                  -13,
                  0
                ],
                [
                  -12,
                  0
                ],
                [
                  -13,
                  0
                ],
                [
                  -13,
                  0
                ],
                [
                  -12,
                  0
                ],
                [
                  -13,
                  0
                ],
                [
                  -13,
                  0
                ],
                [
                  -12,
                  0
                ],
                [
                  -13,
                  0
                ],
                [
                  -13,
                  0
                ],
                [
                  -12,
                  0
                ],
                [
                  -13,
                  0
                ],
                [
                  -13,
                  0
                ],
                [
                  -13,
                  0
                ],
                [
                  -12,
                  0
                ],
                [
                  -13,
                  0
                ],
                [
                  -13,
                  0
                ],
                [
                  -12,
                  0
                ],
                [
                  -13,
                  0
                ],
                [
                  -13,
                  0
                ],
                [
                  -12,
                  0
                ],
                [
                  -13,
                  0
                ],
                [
                  -13,
                  0
                ],
                [
                  -12,
                  0
                ],
                [
                  -13,
                  0
                ],
                [
                  -13,
                  0
                ],
                [
                  -12,
                  0
                ],
                [
                  -13,
                  0
                ],
                [
                  -13,
                  0
                ],
                [
                  -12,
                  0
                ],
                [
                  -13,
                  0
                ],
                [
                  -13,
                  0
                ],
                [
                  -12,
                  0
                ],
                [
                  -13,
                  0
                ],
                [
                  -13,
                  0
                ],
                [
                  -12,
                  0
                ],
                [
                  -13,
                  0
                ],
                [
                  -13,
                  0
                ],
                [
                  -12,
                  0
                ],
                [
                  -13,
                  0
                ],
                [
                  -13,
                  0
                ],
                [
                  -12,
                  0
                ],
                [
                  -13,
                  0
                ],
                [
                  -13,
                  0
                ],
                [
                  -12,
                  0
                ],
                [
                  -13,
                  0
                ],
                [
                  -13,
                  0
                ],
                [
                  -12,
                  0
                ],
                [
                  -13,
                  0
                ],
                [
                  -13,
                  0
                ]
              ],
              [
                [
                  6556,
                  7872
                ],
                [
                  0,
                  41
                ],
                [
                  0,
                  40
                ],
                [
                  0,
                  41
                ],
                [
                  0,
                  40
                ],
                [
                  0,
                  40
                ],
                [
                  0,
                  41
                ],
                [
                  0,
                  40
                ],
                [
                  0,
                  41
                ],
                [
                  0,
                  40
                ],
                [
                  0,
                  41
                ],
                [
                  0,
                  40
                ],
                [
                  0,
                  40
                ],
                [
                  0,
                  41
                ],
                [
                  0,
                  40
                ],
                [
                  0,
                  41
                ],
                [
                  0,
                  40
                ],
                [
                  0,
                  27
                ],
                [
                  0,
                  26
                ],
                [
                  0,
                  13
                ],
                [
                  0,
                  47
                ],
                [
                  0,
                  21
                ],
                [
                  0,
                  5
                ],
                [
                  0,
                  49
                ],
                [
                  0,
                  11
                ],
                [
                  0,
                  54
                ],
                [
                  0,
                  56
                ],
                [
                  0,
                  23
                ],
                [
                  0,
                  17
                ],
                [
                  -1,
                  8
                ],
                [
                  -2,
                  7
                ],
                [
                  -11,
                  25
                ],
                [
                  -1,
                  4
                ],
                [
                  0,
                  6
                ],
                [
                  1,
                  10
                ],
                [
                  0,
                  3
                ],
                [
                  -2,
                  6
                ],
                [
                  -7,
                  10
                ],
                [
                  -1,
                  6
                ],
                [
                  3,
                  7
                ],
                [
                  0,
                  3
                ],
                [
                  -1,
                  3
                ],
                [
                  -11,
                  26
                ],
                [
                  -4,
                  6
                ],
                [
                  -1,
                  3
                ],
                [
                  0,
                  6
                ],
                [
                  2,
                  4
                ],
                [
                  6,
                  9
                ],
                [
                  2,
                  5
                ],
                [
                  1,
                  2
                ],
                [
                  3,
                  4
                ],
                [
                  4,
                  4
                ],
                [
                  8,
                  11
                ],
                [
                  3,
                  4
                ],
                [
                  1,
                  5
                ],
                [
                  0,
                  3
                ],
                [
                  4,
                  9
                ],
                [
                  2,
                  8
                ],
                [
                  1,
                  6
                ],
                [
                  2,
                  4
                ],
                [
                  1,
                  5
                ],
                [
                  -2,
                  6
                ],
                [
                  -6,
                  11
                ],
                [
                  -1,
                  7
                ],
                [
                  -5,
                  8
                ],
                [
                  -1,
                  3
                ],
                [
                  -3,
                  15
                ],
                [
                  0,
                  11
                ],
                [
                  -1,
                  12
                ],
                [
                  0,
                  5
                ],
                [
                  2,
                  5
                ],
                [
                  21,
                  15
                ],
                [
                  4,
                  12
                ],
                [
                  4,
                  5
                ],
                [
                  8,
                  6
                ]
              ],
              [
                [
                  6578,
                  9211
                ],
                [
                  0,
                  -1
                ],
                [
                  2,
                  -9
                ],
                [
                  1,
                  -5
                ],
                [
                  2,
                  -3
                ],
                [
                  3,
                  0
                ],
                [
                  7,
                  -1
                ],
                [
                  5,
                  -2
                ],
                [
                  3,
                  0
                ],
                [
                  6,
                  1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  4,
                  1
                ],
                [
                  3,
                  0
                ],
                [
                  22,
                  6
                ],
                [
                  24,
                  7
                ],
                [
                  6,
                  1
                ],
                [
                  13,
                  -1
                ],
                [
                  51,
                  -13
                ],
                [
                  38,
                  -4
                ],
                [
                  2,
                  -2
                ],
                [
                  2,
                  0
                ],
                [
                  6,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  9,
                  -4
                ],
                [
                  6,
                  -2
                ],
                [
                  6,
                  0
                ],
                [
                  4,
                  2
                ],
                [
                  3,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  3,
                  -2
                ],
                [
                  8,
                  -2
                ],
                [
                  9,
                  -1
                ],
                [
                  3,
                  -1
                ],
                [
                  3,
                  -1
                ],
                [
                  2,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  8,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -4
                ],
                [
                  1,
                  -2
                ],
                [
                  3,
                  -2
                ],
                [
                  4,
                  -2
                ],
                [
                  4,
                  -2
                ],
                [
                  8,
                  -1
                ],
                [
                  4,
                  -1
                ],
                [
                  3,
                  0
                ],
                [
                  3,
                  1
                ],
                [
                  6,
                  -3
                ],
                [
                  8,
                  1
                ],
                [
                  15,
                  7
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -5
                ],
                [
                  1,
                  -4
                ],
                [
                  0,
                  -1
                ],
                [
                  4,
                  -2
                ],
                [
                  6,
                  -1
                ],
                [
                  23,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  4,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  5,
                  -2
                ],
                [
                  3,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  6,
                  2
                ],
                [
                  3,
                  1
                ],
                [
                  3,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  4,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  3,
                  -1
                ],
                [
                  23,
                  -7
                ],
                [
                  4,
                  -3
                ],
                [
                  3,
                  -1
                ],
                [
                  3,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -4
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  3,
                  0
                ],
                [
                  22,
                  -11
                ],
                [
                  21,
                  1
                ],
                [
                  4,
                  0
                ],
                [
                  18,
                  8
                ],
                [
                  19,
                  9
                ],
                [
                  7,
                  5
                ],
                [
                  5,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  19,
                  13
                ],
                [
                  2,
                  3
                ],
                [
                  4,
                  0
                ],
                [
                  4,
                  1
                ],
                [
                  6,
                  5
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  2
                ],
                [
                  6,
                  4
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  4
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  4,
                  2
                ],
                [
                  -1,
                  -4
                ],
                [
                  4,
                  -3
                ],
                [
                  1,
                  0
                ],
                [
                  4,
                  -1
                ],
                [
                  5,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  6,
                  3
                ],
                [
                  -1,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  4,
                  4
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  3
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -8,
                  -1
                ],
                [
                  0,
                  1
                ],
                [
                  5,
                  2
                ],
                [
                  5,
                  2
                ],
                [
                  8,
                  6
                ],
                [
                  2,
                  5
                ],
                [
                  2,
                  5
                ],
                [
                  1,
                  6
                ],
                [
                  -1,
                  5
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -2
                ],
                [
                  3,
                  -1
                ],
                [
                  -4,
                  3
                ],
                [
                  -2,
                  4
                ],
                [
                  1,
                  2
                ],
                [
                  5,
                  -2
                ],
                [
                  3,
                  -3
                ],
                [
                  4,
                  -1
                ],
                [
                  5,
                  -1
                ],
                [
                  6,
                  1
                ],
                [
                  18,
                  5
                ],
                [
                  39,
                  12
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -12,
                  -4
                ],
                [
                  -10,
                  -5
                ],
                [
                  -7,
                  -3
                ],
                [
                  -6,
                  -4
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -5,
                  -3
                ],
                [
                  -3,
                  -1
                ],
                [
                  -5,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  3,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  3,
                  0
                ],
                [
                  4,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  -2
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  3,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  5,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  3
                ],
                [
                  -1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  4,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  -3,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  -1
                ],
                [
                  -3,
                  4
                ],
                [
                  -5,
                  3
                ],
                [
                  -6,
                  3
                ],
                [
                  -6,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  4,
                  2
                ],
                [
                  11,
                  1
                ],
                [
                  4,
                  0
                ],
                [
                  12,
                  -4
                ],
                [
                  17,
                  -7
                ],
                [
                  3,
                  -1
                ],
                [
                  6,
                  -4
                ],
                [
                  13,
                  -6
                ],
                [
                  5,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  4,
                  0
                ],
                [
                  19,
                  6
                ],
                [
                  12,
                  6
                ],
                [
                  5,
                  1
                ],
                [
                  5,
                  0
                ],
                [
                  4,
                  -2
                ],
                [
                  2,
                  -4
                ],
                [
                  1,
                  -1
                ],
                [
                  4,
                  -5
                ],
                [
                  1,
                  -4
                ],
                [
                  2,
                  -3
                ],
                [
                  5,
                  -3
                ],
                [
                  1,
                  -1
                ],
                [
                  3,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  3,
                  -3
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  5,
                  -3
                ],
                [
                  1,
                  -1
                ],
                [
                  -4,
                  1
                ],
                [
                  -13,
                  7
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -3,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  -6,
                  7
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  3,
                  0
                ],
                [
                  -1,
                  -2
                ],
                [
                  2,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  -2,
                  -3
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  3,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  -1,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  2
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  2
                ],
                [
                  3,
                  2
                ],
                [
                  2,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -2
                ],
                [
                  2,
                  1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -3,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  2,
                  -1
                ],
                [
                  3,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  -1,
                  2
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  -3,
                  2
                ],
                [
                  4,
                  0
                ],
                [
                  1,
                  4
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  3
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  3,
                  0
                ],
                [
                  5,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  4,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -3
                ],
                [
                  6,
                  -5
                ],
                [
                  2,
                  -2
                ],
                [
                  4,
                  -5
                ],
                [
                  3,
                  -3
                ],
                [
                  4,
                  -2
                ],
                [
                  4,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  5,
                  0
                ],
                [
                  6,
                  1
                ],
                [
                  9,
                  2
                ],
                [
                  12,
                  5
                ],
                [
                  2,
                  2
                ],
                [
                  6,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  -4,
                  -1
                ],
                [
                  -7,
                  -5
                ],
                [
                  -5,
                  -1
                ],
                [
                  -7,
                  -3
                ],
                [
                  -11,
                  -3
                ],
                [
                  6,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  3,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  8,
                  5
                ],
                [
                  7,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -4,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  5,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  5,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -3,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -3,
                  0
                ],
                [
                  -3,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  3,
                  0
                ],
                [
                  3,
                  2
                ],
                [
                  1,
                  3
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  -4,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  5,
                  -5
                ],
                [
                  1,
                  -3
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -3
                ],
                [
                  5,
                  2
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  7,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  14,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  0,
                  2
                ],
                [
                  2,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  5,
                  -3
                ],
                [
                  3,
                  0
                ],
                [
                  9,
                  -1
                ],
                [
                  3,
                  -1
                ],
                [
                  0,
                  1
                ],
                [
                  3,
                  -1
                ],
                [
                  4,
                  0
                ],
                [
                  27,
                  7
                ],
                [
                  25,
                  9
                ],
                [
                  20,
                  11
                ],
                [
                  3,
                  -5
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -7
                ],
                [
                  1,
                  -4
                ],
                [
                  6,
                  -14
                ],
                [
                  4,
                  -12
                ],
                [
                  5,
                  -12
                ],
                [
                  6,
                  -16
                ],
                [
                  8,
                  -19
                ],
                [
                  3,
                  -11
                ],
                [
                  0,
                  -6
                ],
                [
                  1,
                  -3
                ],
                [
                  2,
                  -2
                ],
                [
                  2,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  -2,
                  -4
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  7,
                  -6
                ],
                [
                  2,
                  -2
                ],
                [
                  4,
                  -11
                ],
                [
                  8,
                  -21
                ],
                [
                  5,
                  -13
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  1,
                  -8
                ],
                [
                  6,
                  -14
                ],
                [
                  5,
                  -13
                ],
                [
                  3,
                  -15
                ],
                [
                  0,
                  -9
                ],
                [
                  1,
                  -4
                ],
                [
                  3,
                  -5
                ],
                [
                  1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -3,
                  -4
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -7
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -8
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -3,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -3
                ],
                [
                  0,
                  -8
                ],
                [
                  -3,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -3
                ],
                [
                  -3,
                  -4
                ],
                [
                  -2,
                  -6
                ],
                [
                  -5,
                  -7
                ],
                [
                  -2,
                  -4
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  2,
                  -5
                ],
                [
                  -2,
                  -2
                ],
                [
                  -3,
                  -2
                ],
                [
                  -2,
                  -3
                ],
                [
                  1,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -7
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -2
                ],
                [
                  -2,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -3
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -3
                ],
                [
                  2,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -5
                ],
                [
                  -2,
                  -4
                ],
                [
                  3,
                  -3
                ],
                [
                  -3,
                  -10
                ],
                [
                  1,
                  -1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -4
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -4
                ],
                [
                  -1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  4,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  -3,
                  3
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -12,
                  2
                ],
                [
                  -3,
                  1
                ],
                [
                  -9,
                  10
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -7,
                  6
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  4
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  1
                ],
                [
                  -4,
                  4
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  0,
                  3
                ],
                [
                  -6,
                  4
                ],
                [
                  0,
                  2
                ],
                [
                  -2,
                  2
                ],
                [
                  -2,
                  2
                ],
                [
                  -2,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  7
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  2
                ],
                [
                  -3,
                  4
                ],
                [
                  -1,
                  2
                ],
                [
                  -17,
                  10
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -3,
                  5
                ],
                [
                  -3,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -9,
                  6
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  -1,
                  4
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  3,
                  -2
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  -1,
                  5
                ],
                [
                  -1,
                  3
                ],
                [
                  -2,
                  4
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  7
                ],
                [
                  1,
                  3
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  6
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  -1,
                  4
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  2
                ],
                [
                  -4,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  3
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -6,
                  6
                ],
                [
                  -2,
                  0
                ],
                [
                  -3,
                  2
                ],
                [
                  -3,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  0,
                  2
                ],
                [
                  -3,
                  5
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  5
                ],
                [
                  0,
                  2
                ],
                [
                  -4,
                  2
                ],
                [
                  -6,
                  4
                ],
                [
                  1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  1,
                  5
                ],
                [
                  1,
                  6
                ],
                [
                  -2,
                  6
                ],
                [
                  -4,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -3,
                  3
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -3,
                  3
                ],
                [
                  -3,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  4
                ],
                [
                  -2,
                  3
                ],
                [
                  -5,
                  4
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  -2
                ],
                [
                  -3,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -3
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  3,
                  -1
                ],
                [
                  -3,
                  -2
                ],
                [
                  -11,
                  -14
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  -3,
                  -6
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -6
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -3
                ],
                [
                  2,
                  -1
                ],
                [
                  6,
                  -4
                ],
                [
                  2,
                  -2
                ],
                [
                  6,
                  -6
                ],
                [
                  4,
                  -3
                ],
                [
                  4,
                  -3
                ],
                [
                  3,
                  -4
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -5
                ],
                [
                  2,
                  -4
                ],
                [
                  2,
                  -3
                ],
                [
                  -1,
                  -3
                ],
                [
                  4,
                  -14
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -3
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  -1,
                  -4
                ],
                [
                  0,
                  -5
                ],
                [
                  1,
                  -2
                ],
                [
                  4,
                  -3
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  3,
                  -3
                ],
                [
                  6,
                  -7
                ],
                [
                  4,
                  -1
                ],
                [
                  3,
                  -3
                ],
                [
                  2,
                  -4
                ],
                [
                  6,
                  -21
                ],
                [
                  0,
                  -3
                ],
                [
                  2,
                  0
                ],
                [
                  6,
                  -3
                ],
                [
                  3,
                  -3
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -3
                ],
                [
                  4,
                  -6
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  6,
                  -5
                ],
                [
                  2,
                  -3
                ],
                [
                  0,
                  -3
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  3,
                  -4
                ],
                [
                  7,
                  -7
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  5,
                  -5
                ],
                [
                  3,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -2
                ],
                [
                  3,
                  -1
                ],
                [
                  6,
                  -2
                ],
                [
                  9,
                  -7
                ],
                [
                  3,
                  -6
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  3,
                  -7
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  3
                ],
                [
                  -3,
                  2
                ],
                [
                  -3,
                  1
                ],
                [
                  -3,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  3,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  3,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  4
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  3
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  -3
                ],
                [
                  3,
                  -1
                ],
                [
                  2,
                  -3
                ],
                [
                  4,
                  -6
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  2,
                  -2
                ],
                [
                  6,
                  -2
                ],
                [
                  2,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -3
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -6
                ],
                [
                  1,
                  -2
                ],
                [
                  4,
                  -4
                ],
                [
                  5,
                  -3
                ],
                [
                  5,
                  -3
                ],
                [
                  3,
                  -1
                ],
                [
                  2,
                  -3
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -5
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -3
                ],
                [
                  0,
                  -3
                ],
                [
                  2,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  3,
                  -3
                ],
                [
                  1,
                  -3
                ],
                [
                  -2,
                  1
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -4
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -4
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -4
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -3
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -4
                ],
                [
                  -2,
                  -8
                ],
                [
                  1,
                  -4
                ],
                [
                  2,
                  -2
                ],
                [
                  4,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -4
                ],
                [
                  4,
                  -6
                ],
                [
                  2,
                  -4
                ],
                [
                  4,
                  -12
                ],
                [
                  2,
                  -3
                ],
                [
                  3,
                  -4
                ],
                [
                  2,
                  -4
                ],
                [
                  3,
                  -4
                ],
                [
                  11,
                  -25
                ],
                [
                  5,
                  -7
                ],
                [
                  5,
                  -12
                ],
                [
                  10,
                  -13
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -4
                ],
                [
                  9,
                  -13
                ],
                [
                  5,
                  -5
                ],
                [
                  1,
                  -1
                ],
                [
                  11,
                  -22
                ],
                [
                  2,
                  -6
                ],
                [
                  3,
                  -6
                ],
                [
                  2,
                  -7
                ],
                [
                  2,
                  -4
                ],
                [
                  6,
                  -7
                ],
                [
                  0,
                  -2
                ],
                [
                  2,
                  -4
                ],
                [
                  0,
                  -1
                ],
                [
                  4,
                  -6
                ],
                [
                  2,
                  -6
                ],
                [
                  6,
                  -10
                ],
                [
                  11,
                  -19
                ],
                [
                  1,
                  -4
                ],
                [
                  1,
                  -4
                ],
                [
                  2,
                  -3
                ],
                [
                  3,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -5
                ],
                [
                  1,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  3,
                  -3
                ],
                [
                  2,
                  -4
                ],
                [
                  3,
                  -11
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -3
                ],
                [
                  3,
                  -5
                ],
                [
                  2,
                  -1
                ],
                [
                  0,
                  -3
                ],
                [
                  -2,
                  -4
                ],
                [
                  0,
                  -4
                ],
                [
                  5,
                  -2
                ],
                [
                  7,
                  -12
                ],
                [
                  17,
                  -13
                ],
                [
                  3,
                  -3
                ],
                [
                  5,
                  -13
                ],
                [
                  3,
                  -4
                ],
                [
                  5,
                  -7
                ],
                [
                  2,
                  0
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  -2
                ],
                [
                  4,
                  -2
                ],
                [
                  5,
                  -5
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -4
                ],
                [
                  4,
                  -3
                ],
                [
                  4,
                  1
                ],
                [
                  3,
                  -1
                ],
                [
                  3,
                  -1
                ],
                [
                  3,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  3,
                  -7
                ],
                [
                  2,
                  -3
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  3
                ],
                [
                  -2,
                  3
                ],
                [
                  -2,
                  0
                ],
                [
                  -5,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -3,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -3,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -3
                ],
                [
                  -1,
                  -4
                ],
                [
                  1,
                  -7
                ],
                [
                  -1,
                  -6
                ],
                [
                  -1,
                  -4
                ],
                [
                  1,
                  -4
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -3
                ],
                [
                  0,
                  -6
                ],
                [
                  0,
                  -12
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -4
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  3,
                  -4
                ],
                [
                  2,
                  -4
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -7
                ],
                [
                  1,
                  -6
                ],
                [
                  1,
                  -6
                ],
                [
                  1,
                  -4
                ],
                [
                  6,
                  -10
                ],
                [
                  2,
                  -4
                ],
                [
                  2,
                  -5
                ],
                [
                  2,
                  -13
                ],
                [
                  1,
                  -2
                ],
                [
                  3,
                  -5
                ],
                [
                  5,
                  -7
                ],
                [
                  3,
                  -2
                ],
                [
                  -1,
                  3
                ],
                [
                  -4,
                  6
                ],
                [
                  3,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  0,
                  -3
                ],
                [
                  2,
                  -7
                ],
                [
                  0,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  2,
                  -3
                ],
                [
                  5,
                  -4
                ],
                [
                  5,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  7,
                  -1
                ],
                [
                  11,
                  -2
                ],
                [
                  10,
                  -3
                ],
                [
                  4,
                  -2
                ],
                [
                  6,
                  -6
                ],
                [
                  2,
                  -3
                ],
                [
                  1,
                  -7
                ],
                [
                  2,
                  -4
                ],
                [
                  4,
                  -3
                ],
                [
                  4,
                  -3
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  -1,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  -3
                ],
                [
                  -1,
                  -4
                ],
                [
                  2,
                  -6
                ],
                [
                  9,
                  -4
                ],
                [
                  5,
                  -2
                ],
                [
                  2,
                  -2
                ],
                [
                  8,
                  -7
                ],
                [
                  12,
                  -11
                ],
                [
                  3,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -4
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -2
                ],
                [
                  5,
                  -3
                ],
                [
                  3,
                  -1
                ],
                [
                  0,
                  -5
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -2
                ]
              ],
              [
                [
                  8516,
                  7025
                ],
                [
                  4,
                  -2
                ],
                [
                  3,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -11
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  2,
                  -4
                ],
                [
                  0,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  7,
                  -2
                ],
                [
                  2,
                  4
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  3,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -5
                ],
                [
                  -1,
                  -3
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -7,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -3,
                  1
                ],
                [
                  -5,
                  3
                ],
                [
                  -3,
                  0
                ],
                [
                  -6,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -3,
                  1
                ],
                [
                  -5,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -3,
                  10
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  6,
                  2
                ],
                [
                  -3,
                  4
                ],
                [
                  -3,
                  4
                ],
                [
                  -4,
                  2
                ],
                [
                  -4,
                  1
                ],
                [
                  -4,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  3
                ],
                [
                  0,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  4,
                  1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -4,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  4,
                  -1
                ],
                [
                  6,
                  -1
                ]
              ],
              [
                [
                  8527,
                  7040
                ],
                [
                  -2,
                  -1
                ],
                [
                  -4,
                  1
                ],
                [
                  -3,
                  2
                ],
                [
                  -6,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ]
              ],
              [
                [
                  8822,
                  6552
                ],
                [
                  -6,
                  7
                ],
                [
                  -11,
                  15
                ],
                [
                  -8,
                  15
                ],
                [
                  -7,
                  5
                ],
                [
                  -7,
                  5
                ],
                [
                  -7,
                  3
                ],
                [
                  -10,
                  7
                ],
                [
                  -7,
                  10
                ],
                [
                  -10,
                  23
                ],
                [
                  -4,
                  7
                ],
                [
                  -5,
                  6
                ],
                [
                  -5,
                  5
                ],
                [
                  -10,
                  9
                ],
                [
                  -14,
                  11
                ],
                [
                  -22,
                  15
                ],
                [
                  -18,
                  12
                ],
                [
                  -4,
                  4
                ],
                [
                  -9,
                  17
                ],
                [
                  -10,
                  19
                ],
                [
                  -14,
                  16
                ],
                [
                  -13,
                  16
                ],
                [
                  -8,
                  6
                ],
                [
                  -9,
                  3
                ],
                [
                  -12,
                  2
                ],
                [
                  -4,
                  1
                ],
                [
                  -13,
                  7
                ],
                [
                  -8,
                  4
                ],
                [
                  -9,
                  9
                ],
                [
                  -10,
                  9
                ],
                [
                  -5,
                  4
                ],
                [
                  -6,
                  2
                ],
                [
                  -11,
                  3
                ],
                [
                  -3,
                  0
                ],
                [
                  -6,
                  -2
                ],
                [
                  -2,
                  0
                ],
                [
                  -3,
                  1
                ],
                [
                  -3,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -4,
                  -3
                ],
                [
                  -2,
                  -1
                ],
                [
                  -3,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -7,
                  6
                ],
                [
                  -3,
                  2
                ],
                [
                  -4,
                  1
                ],
                [
                  -4,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -6,
                  -1
                ],
                [
                  -3,
                  0
                ],
                [
                  -7,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  3
                ],
                [
                  -2,
                  2
                ],
                [
                  -3,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  -3
                ],
                [
                  -2,
                  -3
                ],
                [
                  -6,
                  -3
                ],
                [
                  -10,
                  -3
                ],
                [
                  -3,
                  0
                ],
                [
                  -7,
                  1
                ],
                [
                  -3,
                  0
                ],
                [
                  -2,
                  -2
                ],
                [
                  -3,
                  -5
                ],
                [
                  -3,
                  0
                ],
                [
                  -3,
                  6
                ],
                [
                  -3,
                  11
                ],
                [
                  -2,
                  3
                ],
                [
                  -3,
                  3
                ],
                [
                  -2,
                  2
                ],
                [
                  -3,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -4,
                  1
                ],
                [
                  -5,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  -2,
                  -3
                ],
                [
                  -2,
                  -2
                ],
                [
                  -6,
                  -2
                ],
                [
                  -4,
                  -4
                ],
                [
                  -3,
                  -2
                ],
                [
                  -5,
                  -1
                ],
                [
                  -8,
                  -3
                ],
                [
                  -3,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -3,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -8,
                  -4
                ],
                [
                  -5,
                  -1
                ],
                [
                  -10,
                  -2
                ],
                [
                  -7,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  1
                ],
                [
                  -7,
                  4
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  5
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  4
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  0
                ],
                [
                  -4,
                  1
                ],
                [
                  -7,
                  -2
                ],
                [
                  -2,
                  1
                ],
                [
                  -14,
                  6
                ],
                [
                  -2,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  -3,
                  5
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  2
                ],
                [
                  -6,
                  -13
                ],
                [
                  -8,
                  -21
                ],
                [
                  -9,
                  -21
                ],
                [
                  -8,
                  -20
                ],
                [
                  -7,
                  -19
                ],
                [
                  -5,
                  -11
                ],
                [
                  -1,
                  -2
                ],
                [
                  -3,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  3
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  1
                ],
                [
                  -5,
                  4
                ],
                [
                  -2,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  -5,
                  8
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  3
                ],
                [
                  -2,
                  0
                ],
                [
                  -3,
                  -1
                ],
                [
                  -10,
                  0
                ],
                [
                  -4,
                  -1
                ],
                [
                  -4,
                  -3
                ],
                [
                  -2,
                  -3
                ],
                [
                  -1,
                  -3
                ],
                [
                  0,
                  -3
                ],
                [
                  0,
                  -3
                ],
                [
                  -1,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -3,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  -5,
                  0
                ],
                [
                  -8,
                  3
                ],
                [
                  -4,
                  0
                ],
                [
                  -9,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -6,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -4,
                  -2
                ],
                [
                  -2,
                  0
                ],
                [
                  -3,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -3
                ],
                [
                  -2,
                  0
                ]
              ],
              [
                [
                  8060,
                  6801
                ],
                [
                  -3,
                  25
                ],
                [
                  -2,
                  18
                ],
                [
                  -2,
                  17
                ],
                [
                  -2,
                  13
                ],
                [
                  0,
                  8
                ],
                [
                  -3,
                  23
                ],
                [
                  -2,
                  13
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  9,
                  10
                ],
                [
                  3,
                  3
                ],
                [
                  6,
                  21
                ],
                [
                  3,
                  4
                ],
                [
                  4,
                  3
                ],
                [
                  -2,
                  6
                ],
                [
                  1,
                  6
                ],
                [
                  7,
                  26
                ],
                [
                  1,
                  3
                ],
                [
                  7,
                  7
                ],
                [
                  3,
                  6
                ],
                [
                  6,
                  18
                ],
                [
                  6,
                  18
                ],
                [
                  5,
                  12
                ],
                [
                  2,
                  4
                ],
                [
                  5,
                  6
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  3
                ],
                [
                  -2,
                  6
                ],
                [
                  -1,
                  3
                ],
                [
                  0,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  -2,
                  3
                ],
                [
                  -2,
                  2
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  4
                ],
                [
                  0,
                  2
                ],
                [
                  2,
                  5
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  4
                ],
                [
                  0,
                  3
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  4,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  3,
                  9
                ],
                [
                  1,
                  8
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  5
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  3,
                  4
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  3
                ],
                [
                  -3,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  3,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  5,
                  -3
                ],
                [
                  1,
                  -1
                ],
                [
                  7,
                  2
                ],
                [
                  2,
                  -1
                ],
                [
                  4,
                  1
                ],
                [
                  6,
                  3
                ],
                [
                  4,
                  1
                ],
                [
                  12,
                  -4
                ],
                [
                  7,
                  9
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  3,
                  5
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  6
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  7
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  18,
                  6
                ],
                [
                  5,
                  0
                ],
                [
                  5,
                  3
                ],
                [
                  6,
                  11
                ],
                [
                  4,
                  2
                ],
                [
                  3,
                  -1
                ],
                [
                  4,
                  -3
                ],
                [
                  3,
                  -1
                ],
                [
                  3,
                  0
                ],
                [
                  3,
                  2
                ],
                [
                  4,
                  6
                ],
                [
                  9,
                  6
                ],
                [
                  3,
                  1
                ],
                [
                  3,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -3
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  5,
                  1
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  2,
                  -2
                ],
                [
                  3,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  3
                ],
                [
                  -1,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  2,
                  2
                ],
                [
                  7,
                  3
                ],
                [
                  2,
                  2
                ],
                [
                  4,
                  6
                ],
                [
                  8,
                  21
                ],
                [
                  3,
                  6
                ],
                [
                  19,
                  15
                ]
              ],
              [
                [
                  8330,
                  7319
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -4
                ],
                [
                  6,
                  -8
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  2,
                  -3
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  13,
                  -19
                ],
                [
                  9,
                  -22
                ],
                [
                  9,
                  -16
                ],
                [
                  3,
                  -12
                ],
                [
                  1,
                  -2
                ],
                [
                  -1,
                  -6
                ],
                [
                  2,
                  -4
                ],
                [
                  4,
                  -4
                ],
                [
                  2,
                  -4
                ],
                [
                  0,
                  -5
                ],
                [
                  1,
                  -5
                ],
                [
                  4,
                  -8
                ],
                [
                  1,
                  -3
                ],
                [
                  0,
                  -5
                ],
                [
                  1,
                  -3
                ],
                [
                  2,
                  -4
                ],
                [
                  1,
                  -6
                ],
                [
                  0,
                  -2
                ],
                [
                  5,
                  -10
                ],
                [
                  2,
                  -11
                ],
                [
                  -1,
                  1
                ],
                [
                  2,
                  -6
                ],
                [
                  1,
                  -3
                ],
                [
                  0,
                  -4
                ],
                [
                  -2,
                  -3
                ],
                [
                  2,
                  -6
                ],
                [
                  -1,
                  -4
                ],
                [
                  -1,
                  1
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -5
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -5
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  4,
                  -18
                ],
                [
                  0,
                  -6
                ],
                [
                  1,
                  -2
                ],
                [
                  3,
                  -7
                ],
                [
                  4,
                  -18
                ],
                [
                  3,
                  -5
                ],
                [
                  7,
                  -5
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  4,
                  -2
                ],
                [
                  2,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -4
                ],
                [
                  1,
                  -2
                ],
                [
                  3,
                  -4
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -3
                ],
                [
                  -3,
                  -1
                ],
                [
                  -3,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -2
                ],
                [
                  3,
                  -4
                ],
                [
                  0,
                  -4
                ],
                [
                  0,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  3,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  3,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  4,
                  -5
                ],
                [
                  6,
                  -22
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -3
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  -2,
                  -8
                ],
                [
                  0,
                  -12
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  -3
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  5
                ],
                [
                  0,
                  3
                ],
                [
                  -2,
                  4
                ],
                [
                  -2,
                  6
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  2
                ],
                [
                  1,
                  7
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  5
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  0
                ],
                [
                  -1,
                  -2
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  -4
                ],
                [
                  2,
                  -3
                ],
                [
                  13,
                  -10
                ],
                [
                  2,
                  -1
                ],
                [
                  3,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -3,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  -5
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  3,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  2,
                  -4
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  3,
                  -2
                ],
                [
                  10,
                  -4
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -3
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  3
                ],
                [
                  3,
                  1
                ],
                [
                  2,
                  3
                ],
                [
                  2,
                  3
                ],
                [
                  2,
                  2
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  3,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  3,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -6
                ],
                [
                  1,
                  -1
                ],
                [
                  4,
                  -2
                ],
                [
                  -1,
                  3
                ],
                [
                  1,
                  0
                ],
                [
                  4,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  7,
                  -6
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -4
                ],
                [
                  -2,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  2,
                  -2
                ],
                [
                  3,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  2
                ],
                [
                  3,
                  -1
                ],
                [
                  7,
                  0
                ],
                [
                  4,
                  -2
                ],
                [
                  4,
                  -3
                ],
                [
                  4,
                  -1
                ],
                [
                  9,
                  0
                ],
                [
                  15,
                  -4
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  -2
                ],
                [
                  2,
                  -5
                ],
                [
                  2,
                  -3
                ],
                [
                  5,
                  -4
                ],
                [
                  4,
                  -3
                ],
                [
                  3,
                  -4
                ],
                [
                  2,
                  -5
                ],
                [
                  1,
                  -5
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -4
                ],
                [
                  2,
                  -5
                ],
                [
                  3,
                  -3
                ],
                [
                  6,
                  -6
                ],
                [
                  3,
                  -4
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -5
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  4,
                  -3
                ],
                [
                  2,
                  -2
                ],
                [
                  2,
                  -3
                ],
                [
                  5,
                  -9
                ],
                [
                  1,
                  -6
                ],
                [
                  1,
                  -2
                ],
                [
                  9,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  5,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  -5
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  5,
                  -3
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -3
                ],
                [
                  5,
                  -4
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  -4
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -1
                ],
                [
                  3,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  0,
                  4
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  4,
                  -3
                ],
                [
                  5,
                  -7
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -4
                ],
                [
                  0,
                  -6
                ],
                [
                  1,
                  -4
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -3
                ],
                [
                  2,
                  -16
                ],
                [
                  2,
                  -4
                ],
                [
                  1,
                  -6
                ],
                [
                  0,
                  -1
                ],
                [
                  4,
                  -3
                ],
                [
                  3,
                  -1
                ],
                [
                  6,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  3
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  6,
                  -6
                ],
                [
                  5,
                  -8
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -7
                ],
                [
                  2,
                  -5
                ],
                [
                  1,
                  -3
                ],
                [
                  0,
                  -4
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  -4
                ],
                [
                  3,
                  -2
                ],
                [
                  3,
                  -1
                ],
                [
                  5,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  4,
                  -3
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -4
                ],
                [
                  0,
                  -2
                ],
                [
                  4,
                  -7
                ],
                [
                  -1,
                  -1
                ]
              ],
              [
                [
                  974,
                  8676
                ],
                [
                  -6,
                  -7
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -4
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -10,
                  2
                ],
                [
                  -3,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  5
                ],
                [
                  3,
                  1
                ],
                [
                  6,
                  0
                ],
                [
                  5,
                  -2
                ],
                [
                  2,
                  2
                ],
                [
                  5,
                  4
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  4,
                  3
                ],
                [
                  3,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -2
                ]
              ],
              [
                [
                  1295,
                  8724
                ],
                [
                  0,
                  -4
                ],
                [
                  1,
                  -5
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -3
                ],
                [
                  2,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  -3
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -4,
                  -5
                ],
                [
                  -2,
                  -2
                ],
                [
                  -9,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -3,
                  -4
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -5,
                  0
                ],
                [
                  -3,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -7,
                  6
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -4,
                  8
                ],
                [
                  -1,
                  2
                ],
                [
                  1,
                  3
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  5,
                  3
                ],
                [
                  3,
                  1
                ],
                [
                  3,
                  3
                ],
                [
                  2,
                  4
                ],
                [
                  -1,
                  3
                ],
                [
                  2,
                  1
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  1
                ],
                [
                  7,
                  -2
                ],
                [
                  9,
                  0
                ],
                [
                  9,
                  -2
                ],
                [
                  3,
                  1
                ],
                [
                  -1,
                  4
                ],
                [
                  4,
                  1
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ]
              ],
              [
                [
                  1062,
                  8708
                ],
                [
                  -3,
                  -1
                ],
                [
                  -4,
                  1
                ],
                [
                  -7,
                  4
                ],
                [
                  -4,
                  6
                ],
                [
                  0,
                  5
                ],
                [
                  1,
                  5
                ],
                [
                  3,
                  5
                ],
                [
                  7,
                  1
                ],
                [
                  6,
                  -1
                ],
                [
                  6,
                  -4
                ],
                [
                  7,
                  -5
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -3
                ],
                [
                  -2,
                  -3
                ],
                [
                  -3,
                  -1
                ],
                [
                  -3,
                  -4
                ],
                [
                  -3,
                  -1
                ],
                [
                  -3,
                  -1
                ]
              ],
              [
                [
                  1204,
                  8783
                ],
                [
                  -2,
                  -3
                ],
                [
                  -3,
                  -3
                ],
                [
                  -10,
                  -5
                ],
                [
                  -2,
                  -4
                ],
                [
                  -3,
                  -2
                ],
                [
                  -4,
                  -4
                ],
                [
                  -3,
                  -3
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -3
                ],
                [
                  0,
                  -3
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -3
                ],
                [
                  -5,
                  -8
                ],
                [
                  -1,
                  -6
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  -3
                ],
                [
                  -9,
                  -8
                ],
                [
                  -2,
                  -3
                ],
                [
                  -1,
                  -1
                ],
                [
                  -4,
                  0
                ],
                [
                  -8,
                  -2
                ],
                [
                  -3,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  -5,
                  5
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  -2,
                  2
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  6
                ],
                [
                  0,
                  2
                ],
                [
                  -2,
                  2
                ],
                [
                  -2,
                  3
                ],
                [
                  -4,
                  5
                ],
                [
                  -1,
                  2
                ],
                [
                  3,
                  2
                ],
                [
                  7,
                  3
                ],
                [
                  3,
                  -1
                ],
                [
                  3,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  5,
                  2
                ],
                [
                  3,
                  1
                ],
                [
                  2,
                  -1
                ],
                [
                  5,
                  1
                ],
                [
                  3,
                  0
                ],
                [
                  3,
                  2
                ],
                [
                  3,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  3,
                  0
                ],
                [
                  3,
                  2
                ],
                [
                  6,
                  5
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  0
                ],
                [
                  13,
                  -1
                ],
                [
                  8,
                  3
                ],
                [
                  3,
                  -2
                ]
              ],
              [
                [
                  1448,
                  8722
                ],
                [
                  -4,
                  -4
                ],
                [
                  -4,
                  -4
                ],
                [
                  -5,
                  -3
                ],
                [
                  -4,
                  0
                ],
                [
                  -5,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -9,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  4,
                  -1
                ],
                [
                  3,
                  0
                ],
                [
                  5,
                  2
                ],
                [
                  7,
                  3
                ],
                [
                  9,
                  6
                ],
                [
                  4,
                  3
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  7
                ],
                [
                  1,
                  3
                ],
                [
                  3,
                  4
                ],
                [
                  3,
                  10
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  4,
                  6
                ],
                [
                  3,
                  6
                ],
                [
                  5,
                  8
                ],
                [
                  1,
                  6
                ],
                [
                  2,
                  5
                ],
                [
                  1,
                  5
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  5,
                  2
                ],
                [
                  5,
                  1
                ],
                [
                  4,
                  -2
                ],
                [
                  4,
                  -4
                ],
                [
                  1,
                  -4
                ],
                [
                  1,
                  -7
                ],
                [
                  -1,
                  -11
                ],
                [
                  -1,
                  -3
                ],
                [
                  -2,
                  -6
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -5
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  -3
                ],
                [
                  -1,
                  -3
                ],
                [
                  -2,
                  -4
                ],
                [
                  -3,
                  -5
                ],
                [
                  -4,
                  -2
                ],
                [
                  -14,
                  -2
                ],
                [
                  -6,
                  -2
                ],
                [
                  -4,
                  -3
                ],
                [
                  -5,
                  -1
                ],
                [
                  -3,
                  -2
                ],
                [
                  -4,
                  -4
                ]
              ],
              [
                [
                  976,
                  8821
                ],
                [
                  3,
                  -1
                ],
                [
                  5,
                  2
                ],
                [
                  3,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -3
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -3
                ],
                [
                  3,
                  -1
                ],
                [
                  0,
                  -3
                ],
                [
                  -4,
                  -4
                ],
                [
                  -2,
                  -3
                ],
                [
                  1,
                  -3
                ],
                [
                  2,
                  -5
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -4
                ],
                [
                  -3,
                  -4
                ],
                [
                  -3,
                  -5
                ],
                [
                  -2,
                  -5
                ],
                [
                  -1,
                  -3
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  2
                ],
                [
                  -3,
                  1
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  7
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -3,
                  4
                ],
                [
                  -1,
                  3
                ],
                [
                  -5,
                  7
                ],
                [
                  0,
                  4
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  -2,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  1,
                  4
                ],
                [
                  3,
                  5
                ],
                [
                  5,
                  4
                ],
                [
                  3,
                  2
                ],
                [
                  3,
                  -2
                ],
                [
                  3,
                  0
                ]
              ],
              [
                [
                  1550,
                  8863
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -3
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  -3
                ],
                [
                  -4,
                  -3
                ],
                [
                  -4,
                  -3
                ],
                [
                  -6,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -3,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -5,
                  -1
                ],
                [
                  -3,
                  -3
                ],
                [
                  -3,
                  -3
                ],
                [
                  -2,
                  -4
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -3,
                  1
                ],
                [
                  -6,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  7
                ],
                [
                  0,
                  2
                ],
                [
                  5,
                  6
                ],
                [
                  2,
                  3
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  1
                ],
                [
                  3,
                  0
                ],
                [
                  4,
                  4
                ],
                [
                  3,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  7,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  3
                ],
                [
                  1,
                  5
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  -1
                ],
                [
                  3,
                  -3
                ],
                [
                  -1,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -3,
                  -2
                ]
              ],
              [
                [
                  1546,
                  8876
                ],
                [
                  -4,
                  -2
                ],
                [
                  -3,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  3
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  -2,
                  -4
                ]
              ],
              [
                [
                  8893,
                  6349
                ],
                [
                  -2,
                  -3
                ],
                [
                  -1,
                  -6
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  -6,
                  -3
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  -5,
                  -4
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  -4
                ],
                [
                  -1,
                  -5
                ],
                [
                  -1,
                  -3
                ],
                [
                  -1,
                  -3
                ],
                [
                  -3,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  0,
                  -3
                ],
                [
                  3,
                  -6
                ],
                [
                  3,
                  -6
                ],
                [
                  7,
                  -7
                ],
                [
                  2,
                  -3
                ],
                [
                  2,
                  -4
                ],
                [
                  1,
                  -13
                ],
                [
                  3,
                  -8
                ],
                [
                  3,
                  -9
                ],
                [
                  4,
                  -4
                ],
                [
                  12,
                  -9
                ],
                [
                  3,
                  -3
                ],
                [
                  3,
                  -4
                ],
                [
                  1,
                  -5
                ],
                [
                  2,
                  -4
                ],
                [
                  2,
                  -7
                ],
                [
                  4,
                  -4
                ],
                [
                  4,
                  -2
                ],
                [
                  6,
                  -1
                ],
                [
                  5,
                  -2
                ],
                [
                  3,
                  -4
                ],
                [
                  3,
                  -22
                ],
                [
                  2,
                  -6
                ],
                [
                  3,
                  -3
                ],
                [
                  4,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  3,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  3,
                  -6
                ],
                [
                  1,
                  -3
                ],
                [
                  0,
                  -4
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -2
                ],
                [
                  7,
                  -4
                ],
                [
                  10,
                  -7
                ],
                [
                  3,
                  0
                ],
                [
                  3,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  10,
                  -9
                ],
                [
                  11,
                  -11
                ],
                [
                  17,
                  -16
                ],
                [
                  9,
                  -9
                ],
                [
                  5,
                  -3
                ],
                [
                  11,
                  -4
                ],
                [
                  11,
                  -4
                ],
                [
                  12,
                  -4
                ],
                [
                  11,
                  -4
                ],
                [
                  12,
                  -4
                ],
                [
                  11,
                  -4
                ],
                [
                  11,
                  -4
                ],
                [
                  12,
                  -4
                ],
                [
                  11,
                  -4
                ],
                [
                  12,
                  -4
                ],
                [
                  11,
                  -4
                ],
                [
                  12,
                  -4
                ],
                [
                  11,
                  -4
                ],
                [
                  12,
                  -4
                ],
                [
                  11,
                  -4
                ],
                [
                  12,
                  -4
                ],
                [
                  11,
                  -4
                ],
                [
                  11,
                  -4
                ],
                [
                  11,
                  -4
                ],
                [
                  11,
                  -4
                ],
                [
                  11,
                  -4
                ],
                [
                  11,
                  -4
                ],
                [
                  11,
                  -3
                ],
                [
                  11,
                  -4
                ],
                [
                  11,
                  -4
                ],
                [
                  11,
                  -4
                ],
                [
                  11,
                  -4
                ],
                [
                  11,
                  -4
                ],
                [
                  10,
                  -4
                ],
                [
                  11,
                  -4
                ],
                [
                  11,
                  -4
                ],
                [
                  11,
                  -3
                ],
                [
                  11,
                  -4
                ],
                [
                  8,
                  -3
                ],
                [
                  8,
                  -4
                ],
                [
                  12,
                  0
                ],
                [
                  18,
                  0
                ],
                [
                  20,
                  0
                ],
                [
                  21,
                  0
                ],
                [
                  17,
                  0
                ],
                [
                  24,
                  0
                ],
                [
                  18,
                  0
                ]
              ],
              [
                [
                  9551,
                  5933
                ],
                [
                  -6,
                  -7
                ],
                [
                  -6,
                  -6
                ],
                [
                  -7,
                  -7
                ],
                [
                  -6,
                  -6
                ],
                [
                  -6,
                  -7
                ],
                [
                  -7,
                  -6
                ],
                [
                  -6,
                  -7
                ],
                [
                  -6,
                  -6
                ],
                [
                  -7,
                  -7
                ],
                [
                  -1,
                  -1
                ],
                [
                  -5,
                  -5
                ],
                [
                  -6,
                  -7
                ],
                [
                  -7,
                  -6
                ],
                [
                  -6,
                  -7
                ],
                [
                  -6,
                  -6
                ],
                [
                  -7,
                  -7
                ],
                [
                  -6,
                  -6
                ],
                [
                  -6,
                  -7
                ],
                [
                  -7,
                  -6
                ],
                [
                  -6,
                  -7
                ],
                [
                  -6,
                  -6
                ],
                [
                  -7,
                  -7
                ],
                [
                  -6,
                  -6
                ],
                [
                  -6,
                  -7
                ],
                [
                  -7,
                  -6
                ],
                [
                  -6,
                  -7
                ],
                [
                  -6,
                  -6
                ],
                [
                  -7,
                  -7
                ],
                [
                  -6,
                  -6
                ],
                [
                  -3,
                  -3
                ],
                [
                  -5,
                  -6
                ],
                [
                  -6,
                  -6
                ],
                [
                  -3,
                  -3
                ],
                [
                  -3,
                  -2
                ]
              ],
              [
                [
                  9354,
                  5731
                ],
                [
                  -5,
                  -6
                ],
                [
                  -8,
                  -9
                ],
                [
                  -8,
                  -8
                ],
                [
                  -8,
                  -9
                ],
                [
                  -8,
                  -9
                ],
                [
                  -8,
                  -8
                ],
                [
                  -8,
                  -9
                ],
                [
                  -8,
                  -9
                ],
                [
                  -8,
                  -8
                ],
                [
                  -14,
                  -17
                ],
                [
                  -14,
                  -16
                ],
                [
                  -14,
                  -16
                ],
                [
                  -12,
                  -15
                ],
                [
                  -2,
                  -1
                ],
                [
                  -14,
                  -17
                ],
                [
                  -14,
                  -16
                ],
                [
                  -14,
                  -16
                ],
                [
                  -14,
                  -16
                ],
                [
                  -7,
                  -9
                ],
                [
                  -10,
                  -12
                ],
                [
                  -4,
                  -1
                ],
                [
                  -7,
                  0
                ],
                [
                  -7,
                  0
                ],
                [
                  -7,
                  1
                ],
                [
                  -6,
                  0
                ],
                [
                  -7,
                  1
                ],
                [
                  -7,
                  0
                ],
                [
                  -7,
                  0
                ],
                [
                  -6,
                  1
                ],
                [
                  -7,
                  0
                ],
                [
                  -7,
                  1
                ],
                [
                  -7,
                  0
                ],
                [
                  -6,
                  1
                ],
                [
                  -7,
                  0
                ],
                [
                  -7,
                  0
                ],
                [
                  -7,
                  1
                ],
                [
                  -6,
                  0
                ],
                [
                  -7,
                  1
                ],
                [
                  -8,
                  0
                ],
                [
                  -5,
                  -1
                ],
                [
                  -11,
                  -4
                ],
                [
                  -4,
                  -1
                ],
                [
                  -13,
                  -3
                ],
                [
                  -10,
                  -3
                ],
                [
                  -14,
                  -3
                ],
                [
                  -9,
                  -5
                ],
                [
                  -15,
                  -7
                ],
                [
                  -15,
                  -8
                ],
                [
                  -15,
                  -7
                ],
                [
                  -11,
                  -10
                ],
                [
                  -9,
                  -8
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -5
                ],
                [
                  -2,
                  -10
                ],
                [
                  -2,
                  -4
                ],
                [
                  -4,
                  -5
                ],
                [
                  -5,
                  -3
                ],
                [
                  -6,
                  -3
                ],
                [
                  -9,
                  -1
                ],
                [
                  -19,
                  -4
                ],
                [
                  -20,
                  -3
                ],
                [
                  -16,
                  -3
                ],
                [
                  -10,
                  0
                ],
                [
                  -11,
                  0
                ],
                [
                  -4,
                  -2
                ],
                [
                  -5,
                  -2
                ],
                [
                  -7,
                  -6
                ],
                [
                  -9,
                  -6
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  -3
                ],
                [
                  0,
                  -4
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  -2
                ]
              ],
              [
                [
                  8758,
                  5376
                ],
                [
                  -7,
                  -4
                ],
                [
                  -6,
                  1
                ],
                [
                  -5,
                  3
                ],
                [
                  -7,
                  2
                ],
                [
                  -5,
                  -3
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -3,
                  2
                ],
                [
                  -2,
                  0
                ],
                [
                  -11,
                  -3
                ],
                [
                  -3,
                  0
                ],
                [
                  -7,
                  -2
                ],
                [
                  -14,
                  -1
                ],
                [
                  -14,
                  -1
                ],
                [
                  -6,
                  1
                ],
                [
                  -7,
                  3
                ],
                [
                  -6,
                  4
                ],
                [
                  -8,
                  13
                ],
                [
                  -3,
                  3
                ],
                [
                  -2,
                  2
                ],
                [
                  -7,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  4
                ],
                [
                  -4,
                  4
                ],
                [
                  -8,
                  5
                ],
                [
                  -2,
                  4
                ],
                [
                  -9,
                  -5
                ],
                [
                  -10,
                  -5
                ],
                [
                  -14,
                  -5
                ],
                [
                  -17,
                  -7
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -11,
                  -4
                ],
                [
                  -13,
                  -5
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -6,
                  -4
                ],
                [
                  -12,
                  -6
                ],
                [
                  -11,
                  -6
                ],
                [
                  -12,
                  -5
                ],
                [
                  -2,
                  -4
                ],
                [
                  -3,
                  -7
                ],
                [
                  -3,
                  -10
                ],
                [
                  -3,
                  -5
                ],
                [
                  -2,
                  -3
                ],
                [
                  -10,
                  -10
                ],
                [
                  -9,
                  -8
                ],
                [
                  -3,
                  -5
                ],
                [
                  -3,
                  -9
                ],
                [
                  -2,
                  -4
                ],
                [
                  -4,
                  0
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -4,
                  1
                ],
                [
                  -17,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -5,
                  -4
                ],
                [
                  -5,
                  0
                ],
                [
                  -5,
                  1
                ],
                [
                  -11,
                  6
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -8,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -5,
                  -1
                ],
                [
                  -4,
                  0
                ],
                [
                  -9,
                  2
                ],
                [
                  -13,
                  4
                ],
                [
                  -3,
                  1
                ],
                [
                  -2,
                  3
                ],
                [
                  -3,
                  5
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -8,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -6,
                  -3
                ],
                [
                  -8,
                  -1
                ],
                [
                  -13,
                  2
                ],
                [
                  -14,
                  1
                ],
                [
                  -4,
                  0
                ],
                [
                  -4,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -3,
                  3
                ],
                [
                  -4,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  3
                ],
                [
                  -3,
                  5
                ],
                [
                  -2,
                  3
                ],
                [
                  -4,
                  3
                ],
                [
                  -13,
                  9
                ],
                [
                  -13,
                  8
                ],
                [
                  -13,
                  9
                ],
                [
                  -12,
                  8
                ],
                [
                  -11,
                  8
                ],
                [
                  -15,
                  10
                ],
                [
                  -12,
                  9
                ],
                [
                  -13,
                  8
                ],
                [
                  -7,
                  5
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  3
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  3
                ],
                [
                  -2,
                  1
                ],
                [
                  -5,
                  2
                ],
                [
                  -9,
                  5
                ],
                [
                  -8,
                  2
                ],
                [
                  -25,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -21,
                  0
                ],
                [
                  -24,
                  -1
                ],
                [
                  -1,
                  1
                ],
                [
                  -3,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -5,
                  0
                ],
                [
                  -19,
                  -1
                ],
                [
                  -3,
                  1
                ],
                [
                  -3,
                  2
                ],
                [
                  -5,
                  5
                ],
                [
                  -3,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  -2,
                  3
                ],
                [
                  0,
                  3
                ]
              ],
              [
                [
                  7981,
                  5465
                ],
                [
                  -18,
                  20
                ],
                [
                  -3,
                  6
                ],
                [
                  -1,
                  6
                ],
                [
                  0,
                  29
                ],
                [
                  1,
                  2
                ],
                [
                  5,
                  7
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  4
                ],
                [
                  -3,
                  5
                ],
                [
                  0,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  3,
                  5
                ],
                [
                  0,
                  2
                ],
                [
                  -7,
                  2
                ],
                [
                  -9,
                  6
                ],
                [
                  -3,
                  1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -3,
                  0
                ],
                [
                  -3,
                  0
                ],
                [
                  -6,
                  5
                ],
                [
                  -3,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  0
                ],
                [
                  -3,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -3,
                  -2
                ],
                [
                  -5,
                  -7
                ],
                [
                  -3,
                  -2
                ],
                [
                  -3,
                  0
                ],
                [
                  -3,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  -4,
                  7
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -5,
                  5
                ],
                [
                  -10,
                  6
                ],
                [
                  -6,
                  5
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  8
                ],
                [
                  -2,
                  4
                ],
                [
                  -10,
                  16
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  3
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  8
                ],
                [
                  -1,
                  2
                ],
                [
                  -3,
                  3
                ],
                [
                  -2,
                  3
                ],
                [
                  -2,
                  2
                ],
                [
                  -3,
                  7
                ],
                [
                  -4,
                  8
                ],
                [
                  -1,
                  3
                ],
                [
                  0,
                  8
                ],
                [
                  -1,
                  4
                ],
                [
                  -5,
                  9
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  8
                ],
                [
                  -3,
                  8
                ],
                [
                  -1,
                  6
                ],
                [
                  -2,
                  5
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -9,
                  6
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  0
                ],
                [
                  -5,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  6
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  3
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  1
                ],
                [
                  -8,
                  7
                ],
                [
                  -19,
                  4
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -5,
                  4
                ],
                [
                  -2,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  4
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  4
                ],
                [
                  0,
                  3
                ],
                [
                  -2,
                  3
                ],
                [
                  -1,
                  1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -3,
                  2
                ],
                [
                  -3,
                  5
                ],
                [
                  -6,
                  5
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  13
                ],
                [
                  -1,
                  5
                ],
                [
                  -2,
                  3
                ],
                [
                  -17,
                  18
                ],
                [
                  -3,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -6,
                  5
                ],
                [
                  -5,
                  7
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  -5,
                  2
                ],
                [
                  -3,
                  2
                ],
                [
                  -2,
                  0
                ],
                [
                  -8,
                  0
                ],
                [
                  -3,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  3
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -4,
                  0
                ],
                [
                  -5,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -4,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  -8,
                  2
                ],
                [
                  -2,
                  2
                ],
                [
                  -2,
                  3
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  -4,
                  1
                ],
                [
                  -4,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -4,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  2
                ],
                [
                  -4,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  -3,
                  10
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  8,
                  8
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  4,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  4,
                  3
                ],
                [
                  2,
                  1
                ],
                [
                  15,
                  -4
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  9,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  3,
                  0
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  4,
                  -4
                ],
                [
                  3,
                  -4
                ],
                [
                  3,
                  -4
                ],
                [
                  6,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  5,
                  5
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  4,
                  0
                ],
                [
                  8,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  2
                ],
                [
                  13,
                  12
                ],
                [
                  2,
                  3
                ],
                [
                  2,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  4
                ],
                [
                  -2,
                  40
                ],
                [
                  -1,
                  40
                ],
                [
                  -2,
                  35
                ]
              ],
              [
                [
                  7740,
                  6135
                ],
                [
                  -1,
                  10
                ],
                [
                  5,
                  21
                ],
                [
                  16,
                  48
                ],
                [
                  7,
                  7
                ],
                [
                  3,
                  5
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  4
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  6
                ],
                [
                  0,
                  6
                ],
                [
                  -6,
                  31
                ],
                [
                  -1,
                  6
                ],
                [
                  1,
                  5
                ],
                [
                  11,
                  16
                ],
                [
                  5,
                  11
                ],
                [
                  2,
                  2
                ],
                [
                  3,
                  2
                ],
                [
                  15,
                  12
                ],
                [
                  3,
                  1
                ],
                [
                  1,
                  -1
                ],
                [
                  16,
                  -15
                ],
                [
                  4,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -4
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  4
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  3
                ],
                [
                  7,
                  5
                ],
                [
                  3,
                  4
                ],
                [
                  1,
                  4
                ],
                [
                  -1,
                  2
                ],
                [
                  -4,
                  3
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  8,
                  26
                ],
                [
                  1,
                  5
                ],
                [
                  -2,
                  2
                ],
                [
                  -2,
                  3
                ],
                [
                  -1,
                  4
                ],
                [
                  0,
                  3
                ],
                [
                  16,
                  38
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  -3,
                  6
                ],
                [
                  -1,
                  3
                ],
                [
                  0,
                  5
                ],
                [
                  -1,
                  6
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  4
                ],
                [
                  2,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  2,
                  3
                ],
                [
                  5,
                  3
                ],
                [
                  3,
                  1
                ],
                [
                  9,
                  4
                ],
                [
                  4,
                  5
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  5,
                  3
                ],
                [
                  2,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  2,
                  8
                ],
                [
                  2,
                  6
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  3,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  2,
                  4
                ],
                [
                  24,
                  43
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  4
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  4,
                  1
                ],
                [
                  39,
                  6
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  -1
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  3,
                  16
                ],
                [
                  0,
                  3
                ],
                [
                  -1,
                  2
                ],
                [
                  -3,
                  6
                ],
                [
                  0,
                  3
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  13,
                  46
                ],
                [
                  19,
                  29
                ],
                [
                  1,
                  4
                ],
                [
                  1,
                  8
                ],
                [
                  0,
                  3
                ],
                [
                  5,
                  13
                ],
                [
                  3,
                  7
                ],
                [
                  -1,
                  6
                ],
                [
                  -2,
                  7
                ],
                [
                  0,
                  4
                ],
                [
                  -1,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  12,
                  38
                ]
              ],
              [
                [
                  8562,
                  1732
                ],
                [
                  -1,
                  1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -3
                ],
                [
                  -2,
                  -3
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  2
                ]
              ],
              [
                [
                  4478,
                  4720
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  4,
                  -1
                ],
                [
                  1,
                  -5
                ],
                [
                  0,
                  -6
                ],
                [
                  0,
                  -4
                ],
                [
                  -2,
                  -2
                ]
              ],
              [
                [
                  4525,
                  4937
                ],
                [
                  -1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  0
                ]
              ],
              [
                [
                  4750,
                  4279
                ],
                [
                  -2,
                  2
                ],
                [
                  -4,
                  2
                ],
                [
                  -6,
                  7
                ],
                [
                  -2,
                  9
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  -1,
                  3
                ],
                [
                  -2,
                  3
                ],
                [
                  -5,
                  4
                ],
                [
                  -16,
                  14
                ],
                [
                  -21,
                  15
                ],
                [
                  -1,
                  7
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  3
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  3
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  2
                ],
                [
                  -4,
                  3
                ],
                [
                  -2,
                  1
                ],
                [
                  0,
                  3
                ],
                [
                  -5,
                  6
                ],
                [
                  -2,
                  2
                ],
                [
                  -2,
                  3
                ],
                [
                  -4,
                  4
                ],
                [
                  -14,
                  12
                ],
                [
                  -16,
                  14
                ],
                [
                  -7,
                  5
                ],
                [
                  -17,
                  13
                ],
                [
                  -8,
                  8
                ],
                [
                  -10,
                  8
                ],
                [
                  -23,
                  30
                ],
                [
                  -3,
                  5
                ],
                [
                  3,
                  -2
                ],
                [
                  4,
                  -4
                ],
                [
                  2,
                  -1
                ],
                [
                  3,
                  -1
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  3
                ],
                [
                  2,
                  2
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  1
                ],
                [
                  4,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -3
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  -5
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  -1,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  -1
                ],
                [
                  3,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  0,
                  2
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  3
                ],
                [
                  -3,
                  1
                ],
                [
                  -3,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -7
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  -3,
                  1
                ],
                [
                  -3,
                  1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -3,
                  7
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -3,
                  1
                ],
                [
                  -3,
                  -3
                ],
                [
                  -3,
                  -3
                ],
                [
                  -3,
                  -1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  1
                ],
                [
                  -5,
                  7
                ],
                [
                  -2,
                  2
                ],
                [
                  1,
                  -2
                ],
                [
                  3,
                  -4
                ],
                [
                  1,
                  -2
                ],
                [
                  -3,
                  2
                ],
                [
                  -3,
                  4
                ],
                [
                  -3,
                  4
                ],
                [
                  -2,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  3
                ],
                [
                  0,
                  13
                ],
                [
                  -1,
                  2
                ],
                [
                  -13,
                  13
                ],
                [
                  -4,
                  3
                ],
                [
                  -4,
                  5
                ],
                [
                  -2,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -3,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  6
                ],
                [
                  -5,
                  5
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -2
                ],
                [
                  3,
                  -1
                ],
                [
                  3,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  -3
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  7,
                  0
                ],
                [
                  4,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  -1,
                  -3
                ],
                [
                  -3,
                  -2
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  3,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -3
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  2
                ],
                [
                  -4,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -4,
                  8
                ],
                [
                  -2,
                  2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -3
                ],
                [
                  -3,
                  2
                ],
                [
                  -3,
                  7
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  -3,
                  3
                ],
                [
                  -3,
                  -2
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  3
                ],
                [
                  0,
                  4
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  6
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  5
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  6
                ],
                [
                  -3,
                  4
                ],
                [
                  -8,
                  8
                ],
                [
                  -16,
                  24
                ],
                [
                  -1,
                  3
                ],
                [
                  -2,
                  3
                ],
                [
                  -1,
                  3
                ],
                [
                  0,
                  3
                ],
                [
                  1,
                  -4
                ],
                [
                  2,
                  -4
                ],
                [
                  1,
                  -2
                ],
                [
                  3,
                  -3
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -5
                ],
                [
                  3,
                  -3
                ],
                [
                  1,
                  -3
                ],
                [
                  0,
                  -1
                ],
                [
                  5,
                  -6
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  6,
                  -5
                ],
                [
                  2,
                  -1
                ],
                [
                  3,
                  -1
                ],
                [
                  2,
                  -17
                ],
                [
                  0,
                  -2
                ],
                [
                  2,
                  0
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  3
                ],
                [
                  3,
                  2
                ],
                [
                  3,
                  1
                ],
                [
                  3,
                  0
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  5
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  4,
                  1
                ],
                [
                  11,
                  -2
                ],
                [
                  4,
                  1
                ],
                [
                  -6,
                  2
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  5
                ],
                [
                  -1,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  -3,
                  2
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -3,
                  -5
                ],
                [
                  -3,
                  -2
                ],
                [
                  -3,
                  -1
                ],
                [
                  -5,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  3
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  3
                ],
                [
                  2,
                  4
                ],
                [
                  0,
                  2
                ],
                [
                  -3,
                  5
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  0,
                  -3
                ],
                [
                  1,
                  -7
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -6,
                  -1
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -5,
                  4
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  3,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  -2,
                  4
                ],
                [
                  -2,
                  2
                ],
                [
                  1,
                  -5
                ],
                [
                  -1,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  9
                ],
                [
                  -2,
                  6
                ],
                [
                  -13,
                  17
                ],
                [
                  3,
                  -3
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -4,
                  -3
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  5
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  3
                ],
                [
                  -3,
                  8
                ],
                [
                  -3,
                  5
                ],
                [
                  -2,
                  8
                ],
                [
                  -4,
                  5
                ],
                [
                  -3,
                  10
                ],
                [
                  2,
                  3
                ],
                [
                  1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  4,
                  0
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  3,
                  0
                ],
                [
                  2,
                  -3
                ],
                [
                  1,
                  -5
                ],
                [
                  1,
                  -6
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  -1,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  -1
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -3
                ],
                [
                  5,
                  -4
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -3
                ],
                [
                  -1,
                  -5
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  9
                ],
                [
                  1,
                  2
                ],
                [
                  3,
                  4
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  -4
                ],
                [
                  0,
                  3
                ],
                [
                  -2,
                  3
                ],
                [
                  -1,
                  2
                ],
                [
                  1,
                  4
                ],
                [
                  8,
                  7
                ],
                [
                  2,
                  5
                ],
                [
                  12,
                  14
                ],
                [
                  3,
                  5
                ],
                [
                  2,
                  6
                ],
                [
                  0,
                  18
                ],
                [
                  1,
                  2
                ],
                [
                  3,
                  7
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  3
                ],
                [
                  -5,
                  27
                ],
                [
                  -1,
                  4
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  4
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  4,
                  4
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -4
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -6
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  4,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  4,
                  -3
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -5
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  2
                ],
                [
                  -1,
                  6
                ],
                [
                  0,
                  2
                ],
                [
                  2,
                  3
                ],
                [
                  6,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -4
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  1
                ],
                [
                  4,
                  4
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -3
                ],
                [
                  7,
                  1
                ],
                [
                  4,
                  -5
                ],
                [
                  4,
                  -6
                ],
                [
                  5,
                  -4
                ],
                [
                  -5,
                  9
                ],
                [
                  -2,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  4,
                  0
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  1
                ],
                [
                  3,
                  4
                ],
                [
                  1,
                  1
                ],
                [
                  5,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  4,
                  -2
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  5,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -6,
                  0
                ],
                [
                  -3,
                  0
                ],
                [
                  -2,
                  3
                ],
                [
                  -2,
                  -2
                ],
                [
                  -3,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -10,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -6,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -5,
                  -1
                ],
                [
                  -1,
                  1
                ],
                [
                  -6,
                  5
                ],
                [
                  -5,
                  3
                ],
                [
                  -2,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -3,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  5
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  -7,
                  15
                ],
                [
                  -1,
                  2
                ],
                [
                  -4,
                  5
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  8
                ],
                [
                  1,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  3,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  3,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -3
                ],
                [
                  0,
                  -3
                ],
                [
                  -2,
                  -1
                ],
                [
                  -6,
                  1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  3,
                  1
                ],
                [
                  4,
                  -1
                ],
                [
                  3,
                  -1
                ],
                [
                  1,
                  -4
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  -3
                ],
                [
                  0,
                  -4
                ],
                [
                  0,
                  -4
                ],
                [
                  -1,
                  -2
                ],
                [
                  1,
                  -4
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  6
                ],
                [
                  2,
                  3
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  1,
                  7
                ],
                [
                  -2,
                  16
                ],
                [
                  -4,
                  13
                ],
                [
                  -1,
                  4
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  8,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -3
                ],
                [
                  1,
                  -6
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  2
                ]
              ],
              [
                [
                  4580,
                  4963
                ],
                [
                  4,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  3,
                  -4
                ],
                [
                  2,
                  -2
                ],
                [
                  3,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  4
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  0
                ],
                [
                  4,
                  1
                ],
                [
                  14,
                  0
                ],
                [
                  36,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  39,
                  -1
                ],
                [
                  30,
                  0
                ],
                [
                  9,
                  0
                ],
                [
                  39,
                  0
                ],
                [
                  0,
                  36
                ],
                [
                  0,
                  37
                ],
                [
                  0,
                  29
                ],
                [
                  0,
                  7
                ],
                [
                  -1,
                  36
                ],
                [
                  0,
                  11
                ],
                [
                  -1,
                  6
                ]
              ],
              [
                [
                  3281,
                  6367
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -2
                ],
                [
                  3,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  3,
                  0
                ],
                [
                  4,
                  1
                ],
                [
                  3,
                  0
                ],
                [
                  4,
                  -1
                ],
                [
                  2,
                  -4
                ],
                [
                  0,
                  -4
                ],
                [
                  0,
                  -5
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -3,
                  -14
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -3
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -6
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -3
                ],
                [
                  0,
                  -3
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  4,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -2
                ],
                [
                  7,
                  -4
                ],
                [
                  2,
                  -3
                ],
                [
                  7,
                  -13
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  4,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  2,
                  -3
                ],
                [
                  1,
                  -2
                ],
                [
                  -1,
                  -3
                ],
                [
                  2,
                  0
                ],
                [
                  6,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  -3
                ],
                [
                  -3,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  1,
                  -5
                ],
                [
                  -1,
                  -10
                ],
                [
                  1,
                  -3
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -3
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -6
                ],
                [
                  0,
                  -1
                ],
                [
                  -3,
                  -11
                ],
                [
                  0,
                  -3
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -3,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  4
                ],
                [
                  -2,
                  -4
                ],
                [
                  0,
                  -4
                ],
                [
                  2,
                  -3
                ],
                [
                  4,
                  -1
                ],
                [
                  5,
                  2
                ],
                [
                  3,
                  -1
                ],
                [
                  1,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -3,
                  0
                ],
                [
                  -6,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -4
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  3,
                  1
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  0
                ],
                [
                  -6,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  3,
                  1
                ],
                [
                  6,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  5,
                  0
                ],
                [
                  3,
                  -1
                ],
                [
                  7,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  4,
                  -2
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -3
                ],
                [
                  -1,
                  -7
                ],
                [
                  -1,
                  -4
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -3
                ],
                [
                  1,
                  -5
                ],
                [
                  1,
                  -2
                ],
                [
                  -2,
                  -3
                ],
                [
                  -3,
                  -3
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -5
                ],
                [
                  -2,
                  -4
                ],
                [
                  -1,
                  -4
                ],
                [
                  2,
                  -5
                ],
                [
                  6,
                  -11
                ],
                [
                  2,
                  -7
                ],
                [
                  -3,
                  -4
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  3
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -5
                ],
                [
                  3,
                  -9
                ],
                [
                  6,
                  -8
                ],
                [
                  5,
                  -4
                ],
                [
                  2,
                  -2
                ],
                [
                  3,
                  -3
                ],
                [
                  4,
                  -3
                ],
                [
                  8,
                  -4
                ],
                [
                  2,
                  -5
                ],
                [
                  2,
                  -5
                ],
                [
                  5,
                  -5
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -4
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -6,
                  -3
                ],
                [
                  -2,
                  -1
                ],
                [
                  -5,
                  -4
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -3
                ],
                [
                  1,
                  -7
                ],
                [
                  1,
                  -5
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -6
                ],
                [
                  1,
                  -9
                ],
                [
                  0,
                  -9
                ],
                [
                  1,
                  -8
                ],
                [
                  0,
                  -7
                ],
                [
                  1,
                  -3
                ],
                [
                  -4,
                  1
                ],
                [
                  -2,
                  -3
                ],
                [
                  0,
                  -4
                ],
                [
                  0,
                  -4
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -8
                ],
                [
                  1,
                  -6
                ],
                [
                  2,
                  -6
                ],
                [
                  4,
                  -4
                ],
                [
                  3,
                  -1
                ],
                [
                  2,
                  1
                ],
                [
                  5,
                  2
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -9
                ],
                [
                  0,
                  -3
                ],
                [
                  -2,
                  -5
                ],
                [
                  -1,
                  -6
                ],
                [
                  -3,
                  -8
                ],
                [
                  -1,
                  -6
                ],
                [
                  1,
                  -6
                ],
                [
                  0,
                  -6
                ],
                [
                  -3,
                  -5
                ],
                [
                  -2,
                  -1
                ],
                [
                  -5,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  2,
                  -2
                ],
                [
                  3,
                  -3
                ],
                [
                  2,
                  -3
                ],
                [
                  0,
                  -3
                ],
                [
                  -3,
                  -4
                ],
                [
                  -1,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  -2
                ],
                [
                  4,
                  -7
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -3
                ],
                [
                  -2,
                  -7
                ],
                [
                  1,
                  -3
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  4,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -3
                ],
                [
                  1,
                  -3
                ],
                [
                  2,
                  -4
                ],
                [
                  2,
                  -3
                ],
                [
                  3,
                  -3
                ],
                [
                  6,
                  -3
                ],
                [
                  3,
                  -2
                ],
                [
                  5,
                  -6
                ],
                [
                  1,
                  -1
                ],
                [
                  3,
                  -1
                ],
                [
                  10,
                  0
                ],
                [
                  3,
                  -11
                ],
                [
                  2,
                  -3
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -3
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  11,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -5
                ]
              ],
              [
                [
                  3457,
                  5670
                ],
                [
                  -1,
                  0
                ],
                [
                  -6,
                  -4
                ],
                [
                  -4,
                  -3
                ],
                [
                  -7,
                  -8
                ],
                [
                  -1,
                  -2
                ],
                [
                  -3,
                  -7
                ],
                [
                  -1,
                  -3
                ],
                [
                  0,
                  -3
                ],
                [
                  -2,
                  -6
                ],
                [
                  -1,
                  -3
                ],
                [
                  -4,
                  -4
                ],
                [
                  -5,
                  -2
                ],
                [
                  -25,
                  -3
                ],
                [
                  -47,
                  4
                ],
                [
                  -5,
                  -1
                ],
                [
                  -3,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -3,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  -9,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  -3,
                  -3
                ],
                [
                  -5,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  -10,
                  -4
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -28,
                  -9
                ],
                [
                  -6,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -9,
                  -9
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  -4,
                  -3
                ],
                [
                  -9,
                  -3
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  2
                ],
                [
                  -7,
                  -5
                ],
                [
                  -2,
                  -1
                ],
                [
                  -7,
                  -7
                ],
                [
                  -3,
                  -3
                ],
                [
                  -2,
                  -2
                ],
                [
                  -10,
                  -1
                ],
                [
                  -3,
                  0
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  -3,
                  0
                ],
                [
                  -3,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -14,
                  -6
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -3,
                  -2
                ],
                [
                  -5,
                  -3
                ],
                [
                  -3,
                  0
                ],
                [
                  -8,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -3,
                  -2
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -3,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -3,
                  -1
                ],
                [
                  -4,
                  -3
                ],
                [
                  -9,
                  -1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -3,
                  -2
                ],
                [
                  -1,
                  1
                ],
                [
                  -3,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -8,
                  -4
                ],
                [
                  -2,
                  -2
                ],
                [
                  -4,
                  -4
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -9,
                  -3
                ],
                [
                  -10,
                  -4
                ],
                [
                  -2,
                  -2
                ],
                [
                  -3,
                  -5
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -9,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -3,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  2
                ],
                [
                  -6,
                  5
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -13,
                  5
                ],
                [
                  -22,
                  5
                ],
                [
                  -22,
                  8
                ],
                [
                  -17,
                  1
                ],
                [
                  -18,
                  4
                ],
                [
                  -18,
                  6
                ],
                [
                  -2,
                  0
                ]
              ],
              [
                [
                  2897,
                  5532
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  9,
                  0
                ],
                [
                  3,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  -1,
                  3
                ],
                [
                  4,
                  2
                ],
                [
                  5,
                  1
                ],
                [
                  2,
                  1
                ]
              ],
              [
                [
                  1820,
                  6543
                ],
                [
                  0,
                  -2
                ],
                [
                  -3,
                  -1
                ],
                [
                  -3,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -3
                ],
                [
                  1,
                  -5
                ],
                [
                  0,
                  -4
                ],
                [
                  -2,
                  -5
                ],
                [
                  -4,
                  -4
                ],
                [
                  -2,
                  -4
                ],
                [
                  2,
                  -6
                ],
                [
                  3,
                  -2
                ],
                [
                  8,
                  -4
                ],
                [
                  2,
                  -2
                ],
                [
                  5,
                  -7
                ],
                [
                  3,
                  -2
                ],
                [
                  2,
                  -2
                ],
                [
                  3,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  3,
                  0
                ],
                [
                  4,
                  2
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  3
                ],
                [
                  0,
                  4
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  4,
                  3
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  6
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  0
                ],
                [
                  6,
                  2
                ],
                [
                  2,
                  0
                ],
                [
                  4,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  5,
                  -8
                ],
                [
                  3,
                  -3
                ],
                [
                  3,
                  -1
                ],
                [
                  3,
                  -2
                ],
                [
                  0,
                  -4
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -3
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  4,
                  -4
                ],
                [
                  5,
                  -11
                ],
                [
                  4,
                  -4
                ],
                [
                  5,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  3,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  -1,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  3,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  6,
                  -1
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  4,
                  4
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  1
                ],
                [
                  5,
                  3
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  4,
                  -1
                ],
                [
                  5,
                  -2
                ],
                [
                  3,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  3,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  3,
                  -1
                ],
                [
                  4,
                  -2
                ],
                [
                  3,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  5,
                  -3
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  3,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  8,
                  0
                ],
                [
                  3,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  4,
                  3
                ],
                [
                  15,
                  5
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  6,
                  3
                ],
                [
                  2,
                  0
                ],
                [
                  8,
                  -1
                ],
                [
                  3,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -3,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -3,
                  2
                ],
                [
                  -2,
                  3
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  2,
                  3
                ],
                [
                  6,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  10,
                  -2
                ],
                [
                  5,
                  -2
                ],
                [
                  16,
                  -9
                ],
                [
                  4,
                  -2
                ],
                [
                  3,
                  -3
                ],
                [
                  1,
                  -3
                ],
                [
                  0,
                  -3
                ],
                [
                  -1,
                  -3
                ],
                [
                  -1,
                  -3
                ],
                [
                  -2,
                  -2
                ],
                [
                  0,
                  -4
                ],
                [
                  0,
                  -2
                ],
                [
                  2,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -3
                ],
                [
                  0,
                  -3
                ],
                [
                  -2,
                  -6
                ],
                [
                  -1,
                  -3
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -2
                ],
                [
                  3,
                  -1
                ],
                [
                  3,
                  1
                ],
                [
                  3,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -3
                ],
                [
                  0,
                  -3
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  -6,
                  -35
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  3,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  -2
                ],
                [
                  3,
                  -10
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -3
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  7,
                  -4
                ],
                [
                  4,
                  0
                ],
                [
                  3,
                  3
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -3
                ],
                [
                  0,
                  -3
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  8,
                  -3
                ],
                [
                  4,
                  -2
                ],
                [
                  3,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  3,
                  -1
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  -1
                ],
                [
                  -1,
                  -3
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -3,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -5,
                  1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -3
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  0,
                  -5
                ],
                [
                  -1,
                  -3
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  -6,
                  -7
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  2,
                  -2
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  3,
                  7
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  -1
                ],
                [
                  2,
                  -3
                ],
                [
                  2,
                  -3
                ],
                [
                  1,
                  -3
                ],
                [
                  0,
                  -15
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -8
                ],
                [
                  -1,
                  -3
                ],
                [
                  4,
                  -1
                ],
                [
                  0,
                  -3
                ],
                [
                  2,
                  -27
                ],
                [
                  2,
                  -4
                ],
                [
                  4,
                  -6
                ],
                [
                  3,
                  -6
                ],
                [
                  2,
                  -1
                ],
                [
                  3,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -4
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -2
                ],
                [
                  4,
                  0
                ],
                [
                  7,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -3
                ],
                [
                  2,
                  -4
                ],
                [
                  1,
                  -3
                ],
                [
                  0,
                  -3
                ],
                [
                  -1,
                  -4
                ],
                [
                  -3,
                  -6
                ]
              ],
              [
                [
                  2198,
                  5872
                ],
                [
                  -4,
                  3
                ],
                [
                  -4,
                  3
                ],
                [
                  -3,
                  3
                ],
                [
                  -1,
                  4
                ],
                [
                  1,
                  5
                ],
                [
                  -16,
                  1
                ],
                [
                  -1,
                  -3
                ],
                [
                  -3,
                  -4
                ],
                [
                  -1,
                  -3
                ],
                [
                  0,
                  -5
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -3
                ],
                [
                  0,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  -3,
                  -3
                ],
                [
                  -3,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -3
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -3
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -3
                ],
                [
                  -1,
                  -3
                ],
                [
                  -1,
                  0
                ],
                [
                  -6,
                  -3
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  4
                ],
                [
                  -2,
                  1
                ],
                [
                  0,
                  -3
                ],
                [
                  -2,
                  1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -3,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -3,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  2,
                  5
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -3,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -3,
                  3
                ],
                [
                  -2,
                  9
                ],
                [
                  -2,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -4,
                  -2
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -3
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  5
                ],
                [
                  -2,
                  -2
                ],
                [
                  -4,
                  -4
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  3,
                  2
                ],
                [
                  3,
                  5
                ],
                [
                  1,
                  3
                ],
                [
                  -1,
                  2
                ],
                [
                  3,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  4
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  -3,
                  3
                ],
                [
                  0,
                  5
                ],
                [
                  1,
                  5
                ],
                [
                  1,
                  3
                ],
                [
                  -3,
                  5
                ],
                [
                  -1,
                  2
                ],
                [
                  -3,
                  5
                ],
                [
                  -3,
                  6
                ],
                [
                  -2,
                  5
                ],
                [
                  1,
                  6
                ],
                [
                  1,
                  6
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  -3,
                  10
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -3,
                  0
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  4
                ],
                [
                  1,
                  3
                ],
                [
                  2,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  -7,
                  3
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  -3,
                  0
                ],
                [
                  -2,
                  -2
                ],
                [
                  0,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  3
                ],
                [
                  -2,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  7
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -4,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -3,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -6,
                  -5
                ],
                [
                  -5,
                  -3
                ],
                [
                  -3,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  2
                ],
                [
                  1,
                  7
                ],
                [
                  0,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -8,
                  2
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -5,
                  -4
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  3
                ],
                [
                  -3,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ]
              ],
              [
                [
                  1964,
                  6000
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -4,
                  1
                ],
                [
                  -4,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  -3,
                  -6
                ],
                [
                  -1,
                  -3
                ],
                [
                  -8,
                  -7
                ],
                [
                  -5,
                  -4
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -4,
                  0
                ],
                [
                  -4,
                  -1
                ],
                [
                  -3,
                  -3
                ],
                [
                  -1,
                  -5
                ],
                [
                  -2,
                  3
                ],
                [
                  1,
                  4
                ],
                [
                  3,
                  5
                ],
                [
                  2,
                  3
                ],
                [
                  2,
                  3
                ],
                [
                  2,
                  12
                ],
                [
                  2,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  4
                ],
                [
                  2,
                  3
                ],
                [
                  3,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  0
                ],
                [
                  3,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  3
                ],
                [
                  -6,
                  8
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -5,
                  8
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  4
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  10
                ],
                [
                  0,
                  5
                ],
                [
                  2,
                  8
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -4,
                  0
                ],
                [
                  -5,
                  1
                ],
                [
                  -5,
                  0
                ],
                [
                  -5,
                  1
                ],
                [
                  -1,
                  5
                ],
                [
                  2,
                  6
                ],
                [
                  2,
                  5
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  -6,
                  5
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -3,
                  1
                ],
                [
                  -1,
                  3
                ],
                [
                  -2,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  4
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  4
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -4,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  2
                ],
                [
                  -2,
                  4
                ],
                [
                  -3,
                  7
                ],
                [
                  -5,
                  6
                ],
                [
                  -5,
                  5
                ],
                [
                  -10,
                  7
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  9
                ],
                [
                  -1,
                  3
                ],
                [
                  -2,
                  2
                ],
                [
                  -2,
                  0
                ],
                [
                  -4,
                  1
                ],
                [
                  -3,
                  1
                ],
                [
                  -28,
                  0
                ],
                [
                  -55,
                  -1
                ],
                [
                  -1,
                  -8
                ],
                [
                  -1,
                  -2
                ],
                [
                  -24,
                  -5
                ],
                [
                  -4,
                  -1
                ],
                [
                  -3,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  2
                ],
                [
                  -3,
                  3
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  0
                ],
                [
                  -20,
                  -4
                ],
                [
                  -6,
                  -2
                ],
                [
                  -4,
                  -3
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  -2,
                  -10
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -4,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  -4
                ],
                [
                  -1,
                  -6
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -4
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -4,
                  -15
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -3,
                  -5
                ],
                [
                  -2,
                  -2
                ],
                [
                  -3,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -3,
                  0
                ],
                [
                  -3,
                  -1
                ],
                [
                  -2,
                  2
                ],
                [
                  -3,
                  -2
                ],
                [
                  -2,
                  -4
                ],
                [
                  0,
                  -4
                ],
                [
                  0,
                  -1
                ],
                [
                  2,
                  -3
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  -5
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  -5,
                  -2
                ],
                [
                  -4,
                  -3
                ],
                [
                  -2,
                  -1
                ],
                [
                  -3,
                  2
                ],
                [
                  -5,
                  3
                ],
                [
                  -2,
                  0
                ],
                [
                  -4,
                  0
                ],
                [
                  -5,
                  -2
                ],
                [
                  -3,
                  -3
                ]
              ],
              [
                [
                  1571,
                  6077
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  3,
                  4
                ],
                [
                  3,
                  4
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  3,
                  0
                ],
                [
                  4,
                  -1
                ],
                [
                  2,
                  1
                ],
                [
                  -8,
                  0
                ],
                [
                  -3,
                  0
                ],
                [
                  -2,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  3
                ],
                [
                  -2,
                  -3
                ],
                [
                  -2,
                  -4
                ],
                [
                  0,
                  -3
                ],
                [
                  -2,
                  -4
                ],
                [
                  -3,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  4
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  3
                ],
                [
                  0,
                  4
                ],
                [
                  1,
                  2
                ],
                [
                  3,
                  -2
                ],
                [
                  -1,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -6
                ],
                [
                  -1,
                  -2
                ],
                [
                  -3,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  3,
                  4
                ],
                [
                  1,
                  3
                ],
                [
                  -1,
                  0
                ],
                [
                  -3,
                  -3
                ],
                [
                  -5,
                  0
                ],
                [
                  -4,
                  1
                ],
                [
                  -2,
                  3
                ],
                [
                  -1,
                  4
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  -7
                ],
                [
                  -2,
                  -2
                ],
                [
                  -3,
                  -1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  3
                ],
                [
                  -2,
                  3
                ],
                [
                  0,
                  3
                ],
                [
                  -4,
                  -2
                ],
                [
                  -3,
                  -2
                ],
                [
                  -5,
                  -3
                ],
                [
                  -3,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  4,
                  6
                ],
                [
                  3,
                  3
                ],
                [
                  1,
                  4
                ],
                [
                  2,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  -1,
                  7
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  -3,
                  -2
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -6,
                  7
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  2,
                  -5
                ],
                [
                  0,
                  -4
                ],
                [
                  -1,
                  -3
                ],
                [
                  -4,
                  -2
                ],
                [
                  -5,
                  1
                ],
                [
                  -3,
                  3
                ],
                [
                  0,
                  5
                ],
                [
                  1,
                  4
                ],
                [
                  6,
                  7
                ],
                [
                  2,
                  4
                ],
                [
                  -1,
                  5
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -3
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -3,
                  -4
                ],
                [
                  -2,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -4,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  -3,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  3
                ],
                [
                  -3,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  4
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  2,
                  4
                ],
                [
                  4,
                  2
                ],
                [
                  3,
                  -2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  3
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  3,
                  2
                ],
                [
                  2,
                  3
                ],
                [
                  4,
                  6
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -3
                ],
                [
                  -2,
                  -1
                ],
                [
                  -3,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -7
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -3,
                  1
                ],
                [
                  -3,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  0,
                  3
                ],
                [
                  2,
                  2
                ],
                [
                  4,
                  2
                ],
                [
                  1,
                  3
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -3,
                  0
                ],
                [
                  1,
                  -3
                ],
                [
                  -3,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  -3
                ],
                [
                  -3,
                  2
                ],
                [
                  -7,
                  8
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  -3
                ],
                [
                  -2,
                  1
                ],
                [
                  0,
                  4
                ],
                [
                  0,
                  3
                ],
                [
                  1,
                  4
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -8,
                  9
                ],
                [
                  -2,
                  3
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  4
                ],
                [
                  0,
                  3
                ],
                [
                  2,
                  2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  4
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  -3,
                  0
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  8
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  6
                ],
                [
                  3,
                  6
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  -5,
                  -3
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -4
                ],
                [
                  -2,
                  -3
                ],
                [
                  -2,
                  -5
                ],
                [
                  -2,
                  -3
                ],
                [
                  -3,
                  -5
                ],
                [
                  -4,
                  -3
                ],
                [
                  -2,
                  -1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  2
                ],
                [
                  1,
                  6
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  -2
                ],
                [
                  -6,
                  -5
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  -5
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  0,
                  4
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -4,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  3
                ],
                [
                  2,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  3
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -3
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  1,
                  3
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -3,
                  -5
                ],
                [
                  -4,
                  1
                ],
                [
                  -3,
                  8
                ],
                [
                  -3,
                  0
                ],
                [
                  2,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  -3,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  4,
                  -3
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  -1,
                  -3
                ],
                [
                  -3,
                  -3
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -5
                ],
                [
                  0,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -3,
                  1
                ],
                [
                  -5,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  3
                ],
                [
                  -2,
                  3
                ],
                [
                  -1,
                  3
                ],
                [
                  0,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ]
              ],
              [
                [
                  1347,
                  6344
                ],
                [
                  3,
                  4
                ],
                [
                  5,
                  6
                ],
                [
                  12,
                  25
                ],
                [
                  3,
                  11
                ],
                [
                  2,
                  5
                ],
                [
                  13,
                  20
                ],
                [
                  2,
                  3
                ],
                [
                  3,
                  2
                ],
                [
                  5,
                  0
                ],
                [
                  11,
                  -1
                ],
                [
                  6,
                  1
                ],
                [
                  11,
                  6
                ],
                [
                  12,
                  7
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  11,
                  -1
                ],
                [
                  3,
                  1
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  4,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  6,
                  -1
                ],
                [
                  2,
                  1
                ],
                [
                  6,
                  4
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  3,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  4
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  0,
                  -3
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  4,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  6
                ],
                [
                  0,
                  2
                ],
                [
                  -2,
                  17
                ],
                [
                  0,
                  5
                ],
                [
                  2,
                  6
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -5,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -3,
                  4
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -4,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  3
                ],
                [
                  -3,
                  1
                ],
                [
                  -3,
                  1
                ],
                [
                  -3,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  3,
                  4
                ],
                [
                  8,
                  3
                ],
                [
                  3,
                  3
                ],
                [
                  2,
                  2
                ],
                [
                  4,
                  1
                ],
                [
                  2,
                  -1
                ],
                [
                  -2,
                  -3
                ],
                [
                  9,
                  0
                ],
                [
                  4,
                  1
                ],
                [
                  2,
                  4
                ],
                [
                  1,
                  4
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  4
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  6
                ],
                [
                  1,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  -7,
                  9
                ],
                [
                  -1,
                  3
                ],
                [
                  0,
                  4
                ],
                [
                  1,
                  9
                ]
              ],
              [
                [
                  1515,
                  6581
                ],
                [
                  42,
                  -2
                ],
                [
                  6,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  4,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  -2
                ],
                [
                  3,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -3
                ],
                [
                  0,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  -5
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  0,
                  3
                ],
                [
                  2,
                  6
                ],
                [
                  5,
                  0
                ],
                [
                  5,
                  -3
                ],
                [
                  3,
                  -3
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  4,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  3,
                  -1
                ],
                [
                  8,
                  1
                ],
                [
                  3,
                  -1
                ],
                [
                  3,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  3,
                  -5
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  3,
                  2
                ],
                [
                  3,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  6,
                  -3
                ],
                [
                  2,
                  -1
                ],
                [
                  4,
                  -6
                ],
                [
                  2,
                  -1
                ],
                [
                  22,
                  6
                ],
                [
                  5,
                  2
                ],
                [
                  4,
                  5
                ],
                [
                  2,
                  1
                ],
                [
                  4,
                  0
                ],
                [
                  8,
                  -3
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  5,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  8,
                  -3
                ],
                [
                  3,
                  -1
                ],
                [
                  11,
                  -1
                ],
                [
                  4,
                  1
                ],
                [
                  10,
                  4
                ],
                [
                  6,
                  1
                ],
                [
                  11,
                  1
                ],
                [
                  4,
                  0
                ],
                [
                  9,
                  -4
                ],
                [
                  4,
                  0
                ]
              ],
              [
                [
                  1121,
                  6635
                ],
                [
                  -2,
                  2
                ],
                [
                  -2,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  -3,
                  6
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  7
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  5
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  7,
                  10
                ],
                [
                  4,
                  3
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -3
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  -2
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -4
                ],
                [
                  1,
                  -4
                ],
                [
                  0,
                  -2
                ],
                [
                  5,
                  -6
                ],
                [
                  1,
                  -1
                ],
                [
                  7,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  3,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  3,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  3
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  4,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  -3
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  5,
                  3
                ],
                [
                  2,
                  1
                ],
                [
                  4,
                  -1
                ],
                [
                  1,
                  -3
                ],
                [
                  -1,
                  -3
                ],
                [
                  0,
                  -3
                ],
                [
                  3,
                  0
                ],
                [
                  3,
                  1
                ],
                [
                  4,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  5,
                  4
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  19,
                  -1
                ],
                [
                  7,
                  2
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  8,
                  -1
                ],
                [
                  3,
                  0
                ],
                [
                  7,
                  3
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  4
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  3,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  4,
                  -2
                ],
                [
                  6,
                  0
                ],
                [
                  5,
                  2
                ],
                [
                  1,
                  6
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  -3,
                  0
                ],
                [
                  -4,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  2
                ],
                [
                  -3,
                  3
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -3,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -4,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -5,
                  -3
                ],
                [
                  -5,
                  -2
                ],
                [
                  -42,
                  -3
                ],
                [
                  -4,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -4,
                  -3
                ],
                [
                  -5,
                  -6
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  -2,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  -3,
                  -2
                ],
                [
                  -4,
                  0
                ],
                [
                  -5,
                  0
                ],
                [
                  -3,
                  0
                ],
                [
                  -10,
                  2
                ],
                [
                  -4,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  3
                ],
                [
                  1,
                  6
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  1
                ]
              ],
              [
                [
                  1146,
                  6707
                ],
                [
                  8,
                  0
                ],
                [
                  8,
                  0
                ],
                [
                  8,
                  0
                ],
                [
                  8,
                  0
                ],
                [
                  8,
                  0
                ],
                [
                  9,
                  0
                ],
                [
                  8,
                  0
                ],
                [
                  5,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  8,
                  0
                ],
                [
                  8,
                  0
                ],
                [
                  8,
                  0
                ],
                [
                  8,
                  0
                ],
                [
                  8,
                  0
                ],
                [
                  8,
                  0
                ],
                [
                  8,
                  0
                ],
                [
                  8,
                  0
                ],
                [
                  7,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  0,
                  6
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  4,
                  5
                ],
                [
                  6,
                  4
                ],
                [
                  6,
                  2
                ],
                [
                  6,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -3
                ],
                [
                  1,
                  -1
                ],
                [
                  3,
                  0
                ],
                [
                  10,
                  7
                ],
                [
                  10,
                  4
                ],
                [
                  2,
                  -1
                ],
                [
                  8,
                  -3
                ],
                [
                  13,
                  0
                ],
                [
                  5,
                  -2
                ],
                [
                  2,
                  -2
                ],
                [
                  3,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -3
                ],
                [
                  3,
                  -9
                ],
                [
                  1,
                  -1
                ],
                [
                  5,
                  -3
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  1
                ],
                [
                  8,
                  4
                ],
                [
                  5,
                  2
                ],
                [
                  5,
                  -1
                ],
                [
                  6,
                  -2
                ],
                [
                  2,
                  -2
                ],
                [
                  2,
                  -3
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -6
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  10,
                  -7
                ],
                [
                  3,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  7,
                  3
                ],
                [
                  7,
                  5
                ],
                [
                  3,
                  1
                ],
                [
                  7,
                  2
                ],
                [
                  6,
                  3
                ],
                [
                  3,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  3,
                  -2
                ],
                [
                  3,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  3,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  3,
                  -7
                ],
                [
                  0,
                  -7
                ],
                [
                  -4,
                  -6
                ],
                [
                  -7,
                  -3
                ],
                [
                  -9,
                  0
                ],
                [
                  -6,
                  -2
                ],
                [
                  -5,
                  0
                ],
                [
                  -5,
                  -2
                ],
                [
                  -3,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -6,
                  -5
                ],
                [
                  -3,
                  -1
                ],
                [
                  -4,
                  0
                ],
                [
                  -7,
                  1
                ],
                [
                  -7,
                  -1
                ],
                [
                  -4,
                  1
                ],
                [
                  -3,
                  1
                ],
                [
                  -5,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -5,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -4,
                  3
                ],
                [
                  -2,
                  1
                ],
                [
                  -4,
                  -1
                ],
                [
                  -5,
                  -1
                ],
                [
                  -4,
                  1
                ],
                [
                  -5,
                  2
                ],
                [
                  -3,
                  3
                ],
                [
                  -3,
                  4
                ],
                [
                  -1,
                  1
                ],
                [
                  -3,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -5,
                  3
                ],
                [
                  -2,
                  0
                ],
                [
                  -5,
                  1
                ],
                [
                  -4,
                  1
                ],
                [
                  -9,
                  5
                ],
                [
                  -6,
                  5
                ],
                [
                  -6,
                  5
                ],
                [
                  -4,
                  3
                ],
                [
                  -3,
                  -2
                ],
                [
                  -2,
                  -3
                ],
                [
                  -3,
                  -3
                ],
                [
                  -2,
                  -3
                ],
                [
                  -1,
                  -8
                ],
                [
                  0,
                  -4
                ],
                [
                  -3,
                  -4
                ],
                [
                  -4,
                  -2
                ],
                [
                  -4,
                  -2
                ],
                [
                  -4,
                  -1
                ],
                [
                  -5,
                  0
                ],
                [
                  -14,
                  3
                ],
                [
                  -4,
                  0
                ],
                [
                  -3,
                  -1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -4,
                  -2
                ],
                [
                  -2,
                  0
                ],
                [
                  -9,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -6,
                  -2
                ],
                [
                  -9,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -10
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -10
                ],
                [
                  -1,
                  0
                ],
                [
                  -5,
                  0
                ],
                [
                  -4,
                  0
                ],
                [
                  -8,
                  0
                ],
                [
                  -17,
                  0
                ],
                [
                  -29,
                  0
                ],
                [
                  -20,
                  0
                ],
                [
                  -21,
                  1
                ],
                [
                  -6,
                  0
                ],
                [
                  -4,
                  -1
                ],
                [
                  -2,
                  -4
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -3
                ]
              ],
              [
                [
                  4036,
                  4623
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  -4
                ],
                [
                  0,
                  -3
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ]
              ],
              [
                [
                  1232,
                  6368
                ],
                [
                  1,
                  -6
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -3,
                  1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  4,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  0,
                  -3
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  3,
                  -2
                ],
                [
                  2,
                  -3
                ],
                [
                  1,
                  -4
                ]
              ],
              [
                [
                  1222,
                  6371
                ],
                [
                  1,
                  -4
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -3,
                  -4
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  -3,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  3
                ],
                [
                  2,
                  1
                ],
                [
                  6,
                  2
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -3
                ]
              ],
              [
                [
                  1210,
                  6373
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -3
                ],
                [
                  -2,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  -3,
                  -2
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -3,
                  -1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  -3
                ],
                [
                  1,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -3,
                  2
                ],
                [
                  -3,
                  4
                ],
                [
                  -1,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  3,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  5
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  0,
                  3
                ],
                [
                  2,
                  2
                ],
                [
                  3,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ]
              ],
              [
                [
                  1239,
                  6377
                ],
                [
                  -3,
                  0
                ],
                [
                  -3,
                  2
                ],
                [
                  0,
                  4
                ],
                [
                  2,
                  5
                ],
                [
                  3,
                  3
                ],
                [
                  3,
                  0
                ],
                [
                  1,
                  -2
                ],
                [
                  -2,
                  -5
                ],
                [
                  0,
                  -6
                ],
                [
                  -1,
                  -1
                ]
              ],
              [
                [
                  1263,
                  6388
                ],
                [
                  1,
                  -4
                ],
                [
                  0,
                  -3
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  3,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  3
                ],
                [
                  3,
                  1
                ],
                [
                  4,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  -1,
                  -3
                ]
              ],
              [
                [
                  1192,
                  6392
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  -9,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -3,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  2
                ],
                [
                  2,
                  3
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  1
                ]
              ],
              [
                [
                  1263,
                  6417
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -3,
                  -2
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -2
                ],
                [
                  -3,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ]
              ],
              [
                [
                  1192,
                  6411
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -4,
                  1
                ],
                [
                  -3,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  4,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -4,
                  -5
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ]
              ],
              [
                [
                  1187,
                  6429
                ],
                [
                  1,
                  -1
                ],
                [
                  -1,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  -3
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  -7,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  4,
                  3
                ],
                [
                  6,
                  0
                ],
                [
                  5,
                  0
                ],
                [
                  3,
                  5
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  -1
                ]
              ],
              [
                [
                  1228,
                  6429
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -4
                ],
                [
                  1,
                  -1
                ],
                [
                  -1,
                  -3
                ],
                [
                  -1,
                  -3
                ],
                [
                  1,
                  -4
                ],
                [
                  1,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -4,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  3
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  2
                ],
                [
                  -4,
                  3
                ],
                [
                  -1,
                  2
                ],
                [
                  5,
                  2
                ],
                [
                  3,
                  4
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  3
                ],
                [
                  2,
                  0
                ],
                [
                  0,
                  -3
                ],
                [
                  1,
                  -1
                ]
              ],
              [
                [
                  1288,
                  6436
                ],
                [
                  0,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -3,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  -3,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  3,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  3,
                  0
                ],
                [
                  0,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  3,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  0
                ]
              ],
              [
                [
                  1221,
                  6472
                ],
                [
                  -1,
                  -4
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -5
                ],
                [
                  -1,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  1
                ],
                [
                  -4,
                  6
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  4
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  5,
                  -1
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  3
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -1
                ]
              ],
              [
                [
                  1347,
                  6344
                ],
                [
                  -6,
                  -3
                ],
                [
                  -3,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  2
                ],
                [
                  2,
                  10
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  5,
                  0
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  -3
                ],
                [
                  -2,
                  -3
                ],
                [
                  -2,
                  -2
                ],
                [
                  -4,
                  0
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  -3
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  -4
                ],
                [
                  -4,
                  -5
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  -2,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  4,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  6
                ],
                [
                  -1,
                  12
                ],
                [
                  1,
                  3
                ],
                [
                  -3,
                  0
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -3
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -4
                ],
                [
                  -1,
                  -2
                ],
                [
                  -4,
                  1
                ],
                [
                  -4,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -3,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  3
                ],
                [
                  1,
                  7
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  4,
                  5
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  -7,
                  -6
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  1,
                  4
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  0,
                  -3
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  5
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  3,
                  6
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  2,
                  0
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  0,
                  -3
                ],
                [
                  3,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  2
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  3,
                  -1
                ],
                [
                  2,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  3,
                  -3
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  2,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  -6,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  -1,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  4
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  4,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -4,
                  -1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  -2,
                  3
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  -5
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  0,
                  3
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  -2,
                  -3
                ],
                [
                  -2,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  3,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  1,
                  4
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  -3,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  6
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  1,
                  -2
                ],
                [
                  -2,
                  0
                ],
                [
                  0,
                  -4
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  -3,
                  4
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  3
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  -3
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  -4,
                  -4
                ],
                [
                  -3,
                  -2
                ],
                [
                  -2,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  3,
                  4
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  5,
                  5
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  6,
                  -1
                ],
                [
                  3,
                  -1
                ],
                [
                  16,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  4,
                  0
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  3
                ],
                [
                  3,
                  1
                ],
                [
                  3,
                  0
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -3
                ],
                [
                  0,
                  -3
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -3
                ],
                [
                  3,
                  -1
                ],
                [
                  3,
                  -1
                ],
                [
                  3,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -2
                ],
                [
                  3,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  1,
                  2
                ],
                [
                  -3,
                  -1
                ],
                [
                  -3,
                  2
                ],
                [
                  -2,
                  3
                ],
                [
                  -1,
                  2
                ],
                [
                  -4,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  7
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -3,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -4,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -4,
                  -4
                ],
                [
                  -2,
                  -2
                ],
                [
                  -3,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -5,
                  2
                ],
                [
                  -5,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  1
                ],
                [
                  -3,
                  0
                ],
                [
                  -3,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  -3,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -4,
                  -5
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -4,
                  -6
                ],
                [
                  -1,
                  -1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -5,
                  -4
                ],
                [
                  -3,
                  -1
                ],
                [
                  -9,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -6,
                  -4
                ],
                [
                  -3,
                  -1
                ],
                [
                  3,
                  12
                ],
                [
                  2,
                  4
                ],
                [
                  3,
                  1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  -3,
                  0
                ],
                [
                  -3,
                  2
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  -4,
                  -9
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  1,
                  5
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -3
                ],
                [
                  -1,
                  -3
                ],
                [
                  -3,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  2,
                  5
                ],
                [
                  2,
                  8
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  3
                ],
                [
                  4,
                  5
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -3,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -5,
                  -1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -2
                ],
                [
                  -3,
                  -1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -9,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -3,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  -3,
                  0
                ],
                [
                  -4,
                  0
                ],
                [
                  -4,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -3,
                  6
                ],
                [
                  -1,
                  0
                ],
                [
                  -4,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  4
                ],
                [
                  -1,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  3,
                  8
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  10,
                  6
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  -4,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  -7,
                  -2
                ],
                [
                  -3,
                  0
                ],
                [
                  -4,
                  -4
                ],
                [
                  -1,
                  -1
                ],
                [
                  -5,
                  -5
                ],
                [
                  -2,
                  1
                ],
                [
                  0,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  3
                ],
                [
                  -1,
                  -3
                ],
                [
                  -2,
                  -2
                ],
                [
                  0,
                  -5
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -3,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  -3,
                  4
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -3,
                  3
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -5,
                  4
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  1
                ]
              ],
              [
                [
                  1124,
                  6533
                ],
                [
                  3,
                  3
                ],
                [
                  5,
                  1
                ],
                [
                  18,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  7,
                  1
                ],
                [
                  6,
                  0
                ],
                [
                  4,
                  2
                ],
                [
                  11,
                  6
                ],
                [
                  9,
                  5
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  10,
                  2
                ],
                [
                  5,
                  -1
                ],
                [
                  8,
                  -3
                ],
                [
                  3,
                  0
                ],
                [
                  10,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  23,
                  -2
                ],
                [
                  4,
                  1
                ],
                [
                  33,
                  16
                ],
                [
                  0,
                  1
                ],
                [
                  7,
                  5
                ],
                [
                  8,
                  4
                ],
                [
                  8,
                  5
                ],
                [
                  3,
                  2
                ],
                [
                  4,
                  0
                ],
                [
                  6,
                  0
                ],
                [
                  36,
                  0
                ],
                [
                  10,
                  0
                ],
                [
                  47,
                  0
                ],
                [
                  12,
                  0
                ],
                [
                  34,
                  0
                ],
                [
                  46,
                  0
                ]
              ],
              [
                [
                  4465,
                  5344
                ],
                [
                  3,
                  -4
                ],
                [
                  2,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -3
                ],
                [
                  -1,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  -4,
                  -4
                ],
                [
                  -2,
                  -4
                ],
                [
                  -4,
                  -5
                ],
                [
                  0,
                  -1
                ],
                [
                  -3,
                  -7
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  -3
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -4,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -7
                ],
                [
                  0,
                  -2
                ],
                [
                  -6,
                  -7
                ],
                [
                  -5,
                  -8
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  1
                ],
                [
                  -3,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  -3,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  -3,
                  0
                ],
                [
                  -3,
                  1
                ],
                [
                  -3,
                  2
                ],
                [
                  -1,
                  4
                ],
                [
                  0,
                  2
                ],
                [
                  -2,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  6
                ],
                [
                  1,
                  3
                ],
                [
                  2,
                  3
                ],
                [
                  2,
                  3
                ],
                [
                  3,
                  -1
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  5,
                  -1
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  13
                ],
                [
                  2,
                  5
                ],
                [
                  4,
                  6
                ],
                [
                  4,
                  5
                ],
                [
                  5,
                  1
                ],
                [
                  0,
                  -2
                ],
                [
                  4,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  -1
                ],
                [
                  4,
                  0
                ],
                [
                  4,
                  0
                ],
                [
                  4,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ]
              ],
              [
                [
                  4580,
                  4963
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  4
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -3,
                  2
                ],
                [
                  -2,
                  0
                ],
                [
                  -5,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -3,
                  -3
                ],
                [
                  -3,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -5,
                  -1
                ],
                [
                  -3,
                  -2
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  6
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -5,
                  -1
                ],
                [
                  -3,
                  -2
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -4,
                  3
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  7
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  4
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  5
                ],
                [
                  0,
                  3
                ],
                [
                  4,
                  1
                ],
                [
                  5,
                  5
                ],
                [
                  2,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  4
                ],
                [
                  2,
                  5
                ],
                [
                  3,
                  2
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  3,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  3,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  3,
                  1
                ],
                [
                  -3,
                  0
                ],
                [
                  -5,
                  -4
                ],
                [
                  -2,
                  1
                ],
                [
                  -6,
                  6
                ],
                [
                  -2,
                  4
                ],
                [
                  1,
                  3
                ],
                [
                  8,
                  8
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  4
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  5,
                  5
                ],
                [
                  1,
                  5
                ],
                [
                  0,
                  6
                ],
                [
                  -4,
                  11
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  17
                ],
                [
                  0,
                  3
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  3,
                  2
                ]
              ],
              [
                [
                  8870,
                  2459
                ],
                [
                  -3,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  -1,
                  -2
                ]
              ],
              [
                [
                  8664,
                  4535
                ],
                [
                  -1,
                  -3
                ],
                [
                  -3,
                  0
                ],
                [
                  -2,
                  3
                ],
                [
                  1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -5,
                  -3
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  -3,
                  -1
                ],
                [
                  0,
                  4
                ],
                [
                  1,
                  4
                ],
                [
                  2,
                  3
                ],
                [
                  3,
                  2
                ],
                [
                  3,
                  0
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  3
                ],
                [
                  2,
                  2
                ],
                [
                  3,
                  -1
                ],
                [
                  4,
                  -1
                ],
                [
                  3,
                  -2
                ],
                [
                  3,
                  -4
                ]
              ],
              [
                [
                  8758,
                  5376
                ],
                [
                  -11,
                  -17
                ],
                [
                  -11,
                  -17
                ],
                [
                  -11,
                  -16
                ],
                [
                  -11,
                  -17
                ],
                [
                  -7,
                  -10
                ],
                [
                  -7,
                  -10
                ],
                [
                  -6,
                  -11
                ],
                [
                  -7,
                  -10
                ],
                [
                  -11,
                  -11
                ],
                [
                  -10,
                  -11
                ],
                [
                  -11,
                  -12
                ],
                [
                  -11,
                  -11
                ],
                [
                  -4,
                  -5
                ],
                [
                  -2,
                  -3
                ],
                [
                  0,
                  -8
                ],
                [
                  0,
                  -18
                ],
                [
                  0,
                  -18
                ],
                [
                  0,
                  -11
                ],
                [
                  0,
                  -14
                ],
                [
                  0,
                  -15
                ],
                [
                  0,
                  -15
                ],
                [
                  0,
                  -15
                ],
                [
                  0,
                  -17
                ],
                [
                  0,
                  -17
                ],
                [
                  0,
                  -18
                ],
                [
                  0,
                  -17
                ],
                [
                  0,
                  -17
                ],
                [
                  0,
                  -17
                ],
                [
                  0,
                  -3
                ],
                [
                  0,
                  -15
                ],
                [
                  0,
                  -17
                ],
                [
                  0,
                  -17
                ],
                [
                  0,
                  -18
                ],
                [
                  0,
                  -17
                ],
                [
                  0,
                  -17
                ],
                [
                  0,
                  -18
                ],
                [
                  0,
                  -17
                ],
                [
                  0,
                  -17
                ],
                [
                  0,
                  -18
                ],
                [
                  0,
                  -11
                ],
                [
                  1,
                  -9
                ],
                [
                  0,
                  -10
                ],
                [
                  0,
                  -15
                ],
                [
                  0,
                  -15
                ],
                [
                  0,
                  -15
                ],
                [
                  0,
                  -15
                ],
                [
                  0,
                  -10
                ],
                [
                  1,
                  -9
                ],
                [
                  0,
                  -11
                ],
                [
                  3,
                  -5
                ],
                [
                  3,
                  -4
                ],
                [
                  4,
                  -5
                ],
                [
                  3,
                  -4
                ],
                [
                  6,
                  -9
                ],
                [
                  7,
                  -9
                ],
                [
                  7,
                  -10
                ],
                [
                  6,
                  -8
                ],
                [
                  7,
                  -9
                ],
                [
                  6,
                  -9
                ],
                [
                  7,
                  -9
                ],
                [
                  6,
                  -9
                ],
                [
                  5,
                  -7
                ],
                [
                  2,
                  -3
                ],
                [
                  0,
                  -3
                ],
                [
                  0,
                  -9
                ],
                [
                  0,
                  -2
                ]
              ],
              [
                [
                  8712,
                  4590
                ],
                [
                  -10,
                  -11
                ],
                [
                  -5,
                  -8
                ],
                [
                  0,
                  -2
                ],
                [
                  -3,
                  -2
                ],
                [
                  -7,
                  -7
                ],
                [
                  -5,
                  -6
                ],
                [
                  -3,
                  -2
                ],
                [
                  -2,
                  3
                ],
                [
                  -2,
                  -1
                ],
                [
                  -3,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  3
                ],
                [
                  -3,
                  -3
                ],
                [
                  0,
                  -3
                ],
                [
                  -1,
                  -3
                ],
                [
                  -4,
                  0
                ],
                [
                  -5,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -3,
                  -3
                ],
                [
                  -3,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  4
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  2,
                  3
                ],
                [
                  -4,
                  -4
                ],
                [
                  -1,
                  -16
                ],
                [
                  -3,
                  -4
                ],
                [
                  -2,
                  2
                ],
                [
                  -3,
                  9
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -10
                ],
                [
                  1,
                  -5
                ],
                [
                  2,
                  -4
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  -4
                ],
                [
                  -3,
                  -4
                ],
                [
                  -3,
                  -1
                ],
                [
                  0,
                  2
                ],
                [
                  4,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  4
                ],
                [
                  -1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -4,
                  -2
                ],
                [
                  -3,
                  -4
                ],
                [
                  -2,
                  -3
                ],
                [
                  -3,
                  2
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  4,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  -1,
                  -4
                ],
                [
                  -4,
                  -3
                ],
                [
                  -4,
                  -3
                ],
                [
                  -6,
                  -3
                ],
                [
                  -8,
                  -10
                ],
                [
                  -5,
                  -2
                ],
                [
                  -4,
                  1
                ],
                [
                  -4,
                  2
                ],
                [
                  -4,
                  1
                ],
                [
                  -4,
                  -1
                ],
                [
                  -13,
                  -4
                ],
                [
                  -6,
                  -4
                ],
                [
                  -3,
                  -1
                ],
                [
                  -4,
                  -3
                ],
                [
                  -6,
                  -5
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  -6
                ],
                [
                  -4,
                  -5
                ],
                [
                  -1,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -3
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  -9
                ],
                [
                  -1,
                  -5
                ],
                [
                  3,
                  -2
                ],
                [
                  -1,
                  -4
                ],
                [
                  2,
                  -1
                ],
                [
                  3,
                  0
                ],
                [
                  2,
                  2
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -4,
                  -5
                ],
                [
                  -3,
                  -4
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -7
                ],
                [
                  -1,
                  -3
                ],
                [
                  -4,
                  -6
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -5
                ],
                [
                  0,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -7,
                  -3
                ],
                [
                  -1,
                  -1
                ],
                [
                  -4,
                  -4
                ],
                [
                  -1,
                  -2
                ],
                [
                  -3,
                  0
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  6
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -3
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  -3,
                  -4
                ],
                [
                  -2,
                  -8
                ],
                [
                  -4,
                  -6
                ],
                [
                  -1,
                  -8
                ],
                [
                  -2,
                  -3
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -3,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  2
                ],
                [
                  -4,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  4,
                  2
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -4
                ],
                [
                  -11,
                  -31
                ],
                [
                  -3,
                  -3
                ],
                [
                  -4,
                  -1
                ],
                [
                  -2,
                  2
                ],
                [
                  0,
                  5
                ],
                [
                  -3,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  3,
                  1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -3
                ],
                [
                  -3,
                  -3
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  4
                ],
                [
                  0,
                  2
                ],
                [
                  -2,
                  -3
                ],
                [
                  -4,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  4,
                  0
                ],
                [
                  -1,
                  -3
                ],
                [
                  -2,
                  -1
                ],
                [
                  -4,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -3
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  3
                ],
                [
                  4,
                  0
                ],
                [
                  5,
                  -1
                ],
                [
                  2,
                  -3
                ],
                [
                  0,
                  -3
                ],
                [
                  -7,
                  -12
                ],
                [
                  -4,
                  -11
                ],
                [
                  -4,
                  -17
                ],
                [
                  -2,
                  -4
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -4,
                  -14
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  4
                ],
                [
                  0,
                  2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  2,
                  -3
                ],
                [
                  -2,
                  -2
                ],
                [
                  -4,
                  0
                ],
                [
                  -5,
                  1
                ],
                [
                  -3,
                  4
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -4,
                  1
                ],
                [
                  -3,
                  -2
                ],
                [
                  -2,
                  -4
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ]
              ],
              [
                [
                  8407,
                  4177
                ],
                [
                  -11,
                  8
                ],
                [
                  -11,
                  9
                ],
                [
                  -12,
                  8
                ],
                [
                  -11,
                  9
                ],
                [
                  -11,
                  8
                ],
                [
                  -11,
                  9
                ],
                [
                  -11,
                  8
                ],
                [
                  -11,
                  9
                ],
                [
                  -11,
                  8
                ],
                [
                  -1,
                  1
                ],
                [
                  -10,
                  8
                ],
                [
                  -12,
                  8
                ],
                [
                  -11,
                  9
                ],
                [
                  -11,
                  8
                ],
                [
                  -11,
                  9
                ],
                [
                  -11,
                  8
                ],
                [
                  -11,
                  9
                ],
                [
                  -7,
                  5
                ],
                [
                  -2,
                  3
                ],
                [
                  -1,
                  3
                ],
                [
                  -3,
                  8
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -3,
                  1
                ],
                [
                  -3,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -7,
                  0
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  3,
                  3
                ],
                [
                  3,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  3,
                  0
                ],
                [
                  -3,
                  17
                ],
                [
                  0,
                  2
                ],
                [
                  -3,
                  15
                ],
                [
                  -2,
                  4
                ],
                [
                  -10,
                  6
                ],
                [
                  -18,
                  11
                ],
                [
                  -10,
                  6
                ],
                [
                  -28,
                  16
                ],
                [
                  -28,
                  17
                ],
                [
                  -28,
                  16
                ],
                [
                  -28,
                  17
                ],
                [
                  -28,
                  17
                ],
                [
                  -28,
                  16
                ],
                [
                  -28,
                  17
                ],
                [
                  -28,
                  17
                ],
                [
                  -28,
                  16
                ],
                [
                  -22,
                  13
                ],
                [
                  -6,
                  4
                ],
                [
                  -28,
                  16
                ],
                [
                  -28,
                  17
                ],
                [
                  -7,
                  4
                ],
                [
                  -21,
                  13
                ],
                [
                  -28,
                  16
                ],
                [
                  -28,
                  17
                ],
                [
                  -9,
                  6
                ],
                [
                  -5,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  0,
                  4
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -10,
                  0
                ]
              ],
              [
                [
                  7718,
                  4686
                ],
                [
                  0,
                  28
                ],
                [
                  -1,
                  19
                ],
                [
                  2,
                  20
                ],
                [
                  3,
                  28
                ],
                [
                  3,
                  22
                ],
                [
                  0,
                  6
                ],
                [
                  -4,
                  14
                ],
                [
                  -5,
                  14
                ],
                [
                  1,
                  3
                ],
                [
                  7,
                  11
                ],
                [
                  2,
                  1
                ],
                [
                  10,
                  15
                ],
                [
                  5,
                  4
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  -1,
                  5
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  3,
                  14
                ],
                [
                  2,
                  4
                ],
                [
                  4,
                  3
                ],
                [
                  5,
                  2
                ],
                [
                  5,
                  2
                ],
                [
                  3,
                  4
                ],
                [
                  2,
                  6
                ],
                [
                  0,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  8,
                  5
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  5
                ],
                [
                  4,
                  6
                ],
                [
                  3,
                  8
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  6
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  3,
                  2
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  3,
                  0
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  7,
                  2
                ],
                [
                  4,
                  4
                ],
                [
                  3,
                  2
                ],
                [
                  10,
                  1
                ],
                [
                  5,
                  2
                ],
                [
                  1,
                  6
                ],
                [
                  -1,
                  6
                ],
                [
                  -2,
                  5
                ],
                [
                  -1,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  8,
                  7
                ],
                [
                  3,
                  11
                ],
                [
                  3,
                  5
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  4,
                  9
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  27
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -3,
                  3
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  6
                ],
                [
                  0,
                  3
                ],
                [
                  -6,
                  15
                ],
                [
                  -3,
                  6
                ],
                [
                  -5,
                  13
                ],
                [
                  0,
                  5
                ],
                [
                  1,
                  4
                ],
                [
                  2,
                  2
                ],
                [
                  3,
                  1
                ],
                [
                  2,
                  3
                ],
                [
                  0,
                  3
                ],
                [
                  -1,
                  2
                ],
                [
                  -4,
                  4
                ],
                [
                  -1,
                  3
                ],
                [
                  0,
                  7
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  2
                ],
                [
                  -5,
                  12
                ],
                [
                  -2,
                  12
                ],
                [
                  -3,
                  9
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -4,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  4
                ],
                [
                  -4,
                  4
                ],
                [
                  -1,
                  3
                ],
                [
                  -4,
                  21
                ],
                [
                  -2,
                  3
                ],
                [
                  -2,
                  2
                ],
                [
                  -7,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  4
                ],
                [
                  -1,
                  17
                ],
                [
                  -2,
                  5
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  4
                ],
                [
                  2,
                  6
                ],
                [
                  0,
                  11
                ],
                [
                  -1,
                  3
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  1
                ],
                [
                  -4,
                  5
                ],
                [
                  -2,
                  1
                ],
                [
                  -4,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  5
                ],
                [
                  -3,
                  4
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -3,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -3,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  3,
                  2
                ],
                [
                  -2,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  6,
                  4
                ],
                [
                  2,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  0
                ],
                [
                  -5,
                  -2
                ],
                [
                  -2,
                  0
                ],
                [
                  -3,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  2,
                  4
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  -2,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  5
                ],
                [
                  -2,
                  3
                ],
                [
                  -2,
                  2
                ],
                [
                  -4,
                  2
                ]
              ],
              [
                [
                  7728,
                  5409
                ],
                [
                  13,
                  14
                ],
                [
                  13,
                  14
                ],
                [
                  13,
                  14
                ],
                [
                  13,
                  14
                ],
                [
                  11,
                  5
                ],
                [
                  9,
                  5
                ],
                [
                  9,
                  5
                ],
                [
                  8,
                  5
                ],
                [
                  13,
                  5
                ],
                [
                  11,
                  4
                ],
                [
                  10,
                  4
                ],
                [
                  10,
                  4
                ],
                [
                  12,
                  5
                ],
                [
                  11,
                  4
                ],
                [
                  9,
                  4
                ],
                [
                  2,
                  -5
                ],
                [
                  9,
                  6
                ],
                [
                  11,
                  6
                ],
                [
                  2,
                  -4
                ],
                [
                  -4,
                  -11
                ],
                [
                  13,
                  0
                ],
                [
                  9,
                  -3
                ],
                [
                  -6,
                  -17
                ],
                [
                  5,
                  -10
                ],
                [
                  6,
                  -12
                ],
                [
                  1,
                  0
                ],
                [
                  11,
                  -4
                ],
                [
                  1,
                  4
                ],
                [
                  1,
                  6
                ],
                [
                  3,
                  2
                ],
                [
                  5,
                  0
                ],
                [
                  1,
                  -8
                ],
                [
                  10,
                  0
                ],
                [
                  8,
                  0
                ]
              ],
              [
                [
                  2321,
                  5428
                ],
                [
                  -7,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -3,
                  2
                ],
                [
                  -2,
                  0
                ],
                [
                  -9,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -6,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -4,
                  1
                ],
                [
                  -3,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -6,
                  1
                ],
                [
                  -4,
                  1
                ],
                [
                  -8,
                  4
                ],
                [
                  -16,
                  2
                ],
                [
                  -5,
                  1
                ],
                [
                  -5,
                  7
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  0
                ],
                [
                  -13,
                  6
                ],
                [
                  -15,
                  11
                ],
                [
                  -7,
                  4
                ],
                [
                  -18,
                  7
                ],
                [
                  -4,
                  2
                ],
                [
                  -10,
                  8
                ],
                [
                  -3,
                  3
                ],
                [
                  -4,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  -3,
                  1
                ],
                [
                  -4,
                  1
                ],
                [
                  -3,
                  1
                ],
                [
                  -3,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -5,
                  2
                ],
                [
                  -5,
                  3
                ],
                [
                  -7,
                  7
                ],
                [
                  -3,
                  1
                ],
                [
                  -4,
                  2
                ],
                [
                  -4,
                  4
                ],
                [
                  -2,
                  0
                ],
                [
                  -3,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  -1,
                  3
                ],
                [
                  -3,
                  1
                ],
                [
                  -3,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  -16,
                  15
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  5
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -3,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  -2,
                  0
                ],
                [
                  -4,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  -2,
                  3
                ],
                [
                  -13,
                  8
                ],
                [
                  -19,
                  19
                ],
                [
                  -18,
                  16
                ],
                [
                  -5,
                  6
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -9,
                  8
                ],
                [
                  -5,
                  6
                ],
                [
                  -7,
                  5
                ],
                [
                  -2,
                  1
                ],
                [
                  -5,
                  1
                ],
                [
                  -3,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  -3,
                  0
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  2
                ],
                [
                  -2,
                  2
                ],
                [
                  -4,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  7,
                  -3
                ],
                [
                  3,
                  -3
                ],
                [
                  1,
                  -3
                ],
                [
                  -2,
                  3
                ],
                [
                  -4,
                  2
                ],
                [
                  -4,
                  2
                ],
                [
                  -26,
                  7
                ],
                [
                  -17,
                  9
                ],
                [
                  -3,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  -2,
                  3
                ],
                [
                  -1,
                  4
                ],
                [
                  2,
                  3
                ],
                [
                  3,
                  3
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -3,
                  7
                ],
                [
                  -4,
                  5
                ],
                [
                  -5,
                  3
                ],
                [
                  -21,
                  12
                ],
                [
                  -23,
                  9
                ],
                [
                  -16,
                  7
                ],
                [
                  -3,
                  4
                ],
                [
                  0,
                  5
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  4
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -3,
                  2
                ],
                [
                  -2,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  5
                ]
              ],
              [
                [
                  1808,
                  5783
                ],
                [
                  4,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  4
                ],
                [
                  1,
                  2
                ],
                [
                  3,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  3,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  -2,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  2,
                  3
                ],
                [
                  5,
                  7
                ],
                [
                  2,
                  1
                ],
                [
                  11,
                  5
                ],
                [
                  1,
                  1
                ],
                [
                  8,
                  11
                ],
                [
                  3,
                  4
                ],
                [
                  19,
                  16
                ],
                [
                  5,
                  3
                ],
                [
                  5,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  17,
                  22
                ],
                [
                  5,
                  5
                ],
                [
                  6,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  3,
                  0
                ],
                [
                  0,
                  34
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  3,
                  6
                ],
                [
                  2,
                  2
                ],
                [
                  3,
                  2
                ],
                [
                  2,
                  0
                ],
                [
                  11,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  4,
                  3
                ],
                [
                  0,
                  3
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  4
                ],
                [
                  0,
                  3
                ],
                [
                  3,
                  5
                ],
                [
                  4,
                  17
                ],
                [
                  0,
                  7
                ]
              ],
              [
                [
                  6556,
                  7872
                ],
                [
                  0,
                  -17
                ],
                [
                  0,
                  -17
                ],
                [
                  0,
                  -18
                ],
                [
                  0,
                  -17
                ],
                [
                  0,
                  -17
                ],
                [
                  0,
                  -17
                ],
                [
                  0,
                  -18
                ],
                [
                  0,
                  -17
                ],
                [
                  0,
                  -17
                ],
                [
                  0,
                  -17
                ],
                [
                  0,
                  -18
                ],
                [
                  0,
                  -17
                ],
                [
                  0,
                  -13
                ],
                [
                  0,
                  -13
                ],
                [
                  0,
                  -13
                ],
                [
                  0,
                  -14
                ],
                [
                  0,
                  -15
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -13,
                  0
                ],
                [
                  -19,
                  0
                ],
                [
                  -16,
                  0
                ],
                [
                  -16,
                  0
                ],
                [
                  -17,
                  0
                ],
                [
                  -15,
                  0
                ],
                [
                  -11,
                  0
                ],
                [
                  -21,
                  0
                ],
                [
                  0,
                  -17
                ],
                [
                  0,
                  -17
                ],
                [
                  0,
                  -18
                ],
                [
                  0,
                  -17
                ]
              ],
              [
                [
                  6426,
                  7526
                ],
                [
                  -16,
                  8
                ],
                [
                  -16,
                  9
                ],
                [
                  -16,
                  8
                ],
                [
                  -16,
                  9
                ],
                [
                  -16,
                  8
                ],
                [
                  -17,
                  9
                ],
                [
                  -16,
                  8
                ],
                [
                  -16,
                  9
                ],
                [
                  -16,
                  8
                ],
                [
                  -16,
                  8
                ],
                [
                  -16,
                  9
                ],
                [
                  -16,
                  8
                ],
                [
                  -16,
                  9
                ],
                [
                  -16,
                  8
                ],
                [
                  -16,
                  9
                ],
                [
                  -16,
                  8
                ],
                [
                  -17,
                  9
                ],
                [
                  -16,
                  8
                ],
                [
                  -16,
                  9
                ],
                [
                  -16,
                  8
                ],
                [
                  -16,
                  8
                ],
                [
                  -16,
                  9
                ],
                [
                  -16,
                  8
                ],
                [
                  -16,
                  9
                ],
                [
                  -16,
                  8
                ],
                [
                  -16,
                  9
                ],
                [
                  -16,
                  8
                ],
                [
                  -16,
                  9
                ],
                [
                  -17,
                  8
                ],
                [
                  -16,
                  8
                ],
                [
                  -16,
                  9
                ],
                [
                  -16,
                  8
                ],
                [
                  -16,
                  9
                ],
                [
                  -16,
                  8
                ],
                [
                  -16,
                  9
                ],
                [
                  -16,
                  8
                ],
                [
                  -16,
                  9
                ],
                [
                  -16,
                  8
                ],
                [
                  -14,
                  7
                ],
                [
                  -2,
                  2
                ],
                [
                  -16,
                  8
                ],
                [
                  -17,
                  8
                ],
                [
                  -16,
                  9
                ],
                [
                  -16,
                  8
                ],
                [
                  -16,
                  9
                ],
                [
                  -16,
                  8
                ],
                [
                  -16,
                  9
                ],
                [
                  -16,
                  8
                ],
                [
                  -16,
                  9
                ],
                [
                  -16,
                  8
                ],
                [
                  -16,
                  8
                ],
                [
                  -16,
                  9
                ],
                [
                  -17,
                  8
                ],
                [
                  -16,
                  9
                ],
                [
                  -16,
                  8
                ],
                [
                  -16,
                  9
                ],
                [
                  -16,
                  8
                ],
                [
                  -16,
                  9
                ],
                [
                  -16,
                  8
                ],
                [
                  -16,
                  9
                ],
                [
                  -16,
                  8
                ],
                [
                  -16,
                  8
                ],
                [
                  -16,
                  9
                ],
                [
                  -16,
                  8
                ],
                [
                  -17,
                  9
                ],
                [
                  -11,
                  6
                ],
                [
                  -3,
                  0
                ],
                [
                  -6,
                  -3
                ],
                [
                  -7,
                  -4
                ],
                [
                  -8,
                  -3
                ],
                [
                  -7,
                  -4
                ],
                [
                  -8,
                  -4
                ],
                [
                  -7,
                  -3
                ],
                [
                  -8,
                  -4
                ],
                [
                  -7,
                  -3
                ],
                [
                  -8,
                  -4
                ],
                [
                  -7,
                  -4
                ],
                [
                  -8,
                  -3
                ],
                [
                  -7,
                  -4
                ],
                [
                  -8,
                  -4
                ],
                [
                  -8,
                  -3
                ],
                [
                  -7,
                  -4
                ],
                [
                  -8,
                  -3
                ],
                [
                  -7,
                  -4
                ],
                [
                  -2,
                  -1
                ]
              ],
              [
                [
                  5254,
                  8011
                ],
                [
                  -23,
                  -12
                ],
                [
                  -22,
                  -12
                ],
                [
                  -22,
                  -12
                ],
                [
                  -23,
                  -12
                ],
                [
                  -8,
                  -5
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -6,
                  5
                ],
                [
                  -16,
                  15
                ],
                [
                  -16,
                  14
                ],
                [
                  -16,
                  14
                ],
                [
                  -17,
                  14
                ],
                [
                  -7,
                  7
                ],
                [
                  -15,
                  8
                ],
                [
                  -14,
                  3
                ],
                [
                  -11,
                  3
                ],
                [
                  -12,
                  3
                ],
                [
                  -11,
                  3
                ],
                [
                  -12,
                  2
                ],
                [
                  -11,
                  3
                ],
                [
                  -12,
                  3
                ],
                [
                  -11,
                  3
                ],
                [
                  -12,
                  2
                ],
                [
                  -11,
                  3
                ],
                [
                  -12,
                  3
                ],
                [
                  -11,
                  2
                ],
                [
                  -12,
                  3
                ],
                [
                  -11,
                  3
                ],
                [
                  -11,
                  3
                ],
                [
                  -12,
                  2
                ],
                [
                  -11,
                  3
                ]
              ],
              [
                [
                  4543,
                  9013
                ],
                [
                  29,
                  14
                ],
                [
                  4,
                  1
                ],
                [
                  9,
                  1
                ],
                [
                  3,
                  2
                ],
                [
                  17,
                  19
                ],
                [
                  13,
                  20
                ],
                [
                  12,
                  13
                ],
                [
                  8,
                  15
                ],
                [
                  2,
                  6
                ],
                [
                  0,
                  4
                ],
                [
                  -3,
                  10
                ],
                [
                  -1,
                  5
                ],
                [
                  1,
                  5
                ],
                [
                  0,
                  3
                ],
                [
                  -4,
                  8
                ],
                [
                  -4,
                  14
                ],
                [
                  -10,
                  24
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  9
                ],
                [
                  2,
                  4
                ],
                [
                  9,
                  8
                ],
                [
                  8,
                  14
                ],
                [
                  7,
                  5
                ],
                [
                  15,
                  0
                ],
                [
                  7,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  5
                ],
                [
                  5,
                  4
                ],
                [
                  2,
                  5
                ],
                [
                  1,
                  11
                ],
                [
                  3,
                  3
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  3,
                  1
                ],
                [
                  4,
                  3
                ],
                [
                  5,
                  3
                ],
                [
                  4,
                  4
                ],
                [
                  5,
                  11
                ],
                [
                  4,
                  3
                ],
                [
                  40,
                  18
                ],
                [
                  34,
                  14
                ],
                [
                  9,
                  6
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  3
                ],
                [
                  3,
                  4
                ],
                [
                  -1,
                  6
                ],
                [
                  -3,
                  5
                ],
                [
                  -8,
                  7
                ],
                [
                  -3,
                  6
                ],
                [
                  0,
                  7
                ],
                [
                  2,
                  15
                ],
                [
                  -1,
                  14
                ],
                [
                  2,
                  10
                ],
                [
                  0,
                  8
                ],
                [
                  1,
                  2
                ],
                [
                  3,
                  13
                ],
                [
                  0,
                  6
                ]
              ],
              [
                [
                  4801,
                  9422
                ],
                [
                  3,
                  -1
                ],
                [
                  4,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -4
                ],
                [
                  2,
                  -1
                ],
                [
                  4,
                  -2
                ],
                [
                  16,
                  -2
                ],
                [
                  5,
                  -2
                ],
                [
                  -3,
                  3
                ],
                [
                  -8,
                  2
                ],
                [
                  -3,
                  3
                ],
                [
                  7,
                  -3
                ],
                [
                  14,
                  -5
                ],
                [
                  30,
                  -17
                ],
                [
                  6,
                  -5
                ],
                [
                  5,
                  -1
                ],
                [
                  8,
                  -5
                ],
                [
                  10,
                  -5
                ],
                [
                  6,
                  -1
                ],
                [
                  50,
                  -5
                ],
                [
                  12,
                  1
                ],
                [
                  33,
                  8
                ],
                [
                  5,
                  3
                ],
                [
                  4,
                  3
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  0
                ],
                [
                  9,
                  1
                ],
                [
                  13,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  26,
                  -12
                ],
                [
                  6,
                  -2
                ],
                [
                  22,
                  1
                ],
                [
                  6,
                  -1
                ],
                [
                  11,
                  -3
                ],
                [
                  10,
                  -3
                ],
                [
                  24,
                  -4
                ],
                [
                  1,
                  -1
                ],
                [
                  3,
                  -2
                ],
                [
                  3,
                  -1
                ],
                [
                  4,
                  -4
                ],
                [
                  7,
                  -4
                ],
                [
                  12,
                  -9
                ],
                [
                  6,
                  -6
                ],
                [
                  2,
                  -1
                ],
                [
                  21,
                  -3
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  6,
                  -2
                ],
                [
                  3,
                  -1
                ],
                [
                  24,
                  -1
                ],
                [
                  26,
                  -4
                ],
                [
                  6,
                  -2
                ],
                [
                  3,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  5,
                  -6
                ],
                [
                  4,
                  -2
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -5
                ],
                [
                  1,
                  -2
                ],
                [
                  3,
                  -6
                ],
                [
                  6,
                  -6
                ],
                [
                  1,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -5
                ],
                [
                  0,
                  -6
                ],
                [
                  0,
                  -3
                ],
                [
                  0,
                  -10
                ],
                [
                  2,
                  -5
                ],
                [
                  15,
                  -37
                ],
                [
                  3,
                  -5
                ],
                [
                  14,
                  -18
                ],
                [
                  9,
                  -8
                ],
                [
                  9,
                  -7
                ],
                [
                  37,
                  -16
                ],
                [
                  41,
                  -7
                ],
                [
                  48,
                  0
                ],
                [
                  28,
                  -6
                ],
                [
                  29,
                  -9
                ],
                [
                  22,
                  -4
                ],
                [
                  4,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  5,
                  -3
                ],
                [
                  4,
                  -3
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  19,
                  -5
                ],
                [
                  10,
                  -5
                ],
                [
                  11,
                  -3
                ],
                [
                  9,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  4,
                  -5
                ],
                [
                  2,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  12,
                  -3
                ],
                [
                  21,
                  -7
                ],
                [
                  4,
                  -2
                ],
                [
                  4,
                  -3
                ],
                [
                  11,
                  -13
                ],
                [
                  32,
                  -21
                ],
                [
                  7,
                  -8
                ],
                [
                  4,
                  -3
                ],
                [
                  9,
                  -4
                ],
                [
                  5,
                  -1
                ],
                [
                  3,
                  -2
                ],
                [
                  19,
                  -11
                ],
                [
                  5,
                  -2
                ],
                [
                  12,
                  -2
                ],
                [
                  11,
                  0
                ],
                [
                  12,
                  1
                ],
                [
                  7,
                  2
                ],
                [
                  6,
                  2
                ],
                [
                  11,
                  4
                ],
                [
                  14,
                  9
                ],
                [
                  3,
                  1
                ],
                [
                  6,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  18,
                  12
                ],
                [
                  21,
                  24
                ],
                [
                  6,
                  9
                ],
                [
                  3,
                  4
                ],
                [
                  5,
                  4
                ],
                [
                  2,
                  2
                ],
                [
                  8,
                  16
                ],
                [
                  7,
                  15
                ],
                [
                  0,
                  6
                ],
                [
                  0,
                  18
                ],
                [
                  -3,
                  4
                ],
                [
                  -3,
                  9
                ],
                [
                  -3,
                  3
                ],
                [
                  -6,
                  6
                ],
                [
                  -2,
                  3
                ],
                [
                  -8,
                  22
                ],
                [
                  -1,
                  6
                ],
                [
                  0,
                  6
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  6
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  6
                ],
                [
                  0,
                  6
                ],
                [
                  2,
                  12
                ],
                [
                  2,
                  5
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  12,
                  23
                ],
                [
                  3,
                  4
                ],
                [
                  25,
                  22
                ],
                [
                  2,
                  3
                ],
                [
                  6,
                  7
                ],
                [
                  2,
                  2
                ],
                [
                  6,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  19,
                  14
                ],
                [
                  30,
                  11
                ],
                [
                  18,
                  12
                ],
                [
                  15,
                  6
                ],
                [
                  6,
                  2
                ],
                [
                  25,
                  -2
                ],
                [
                  6,
                  1
                ],
                [
                  11,
                  2
                ],
                [
                  5,
                  3
                ],
                [
                  20,
                  16
                ],
                [
                  2,
                  1
                ],
                [
                  6,
                  1
                ],
                [
                  6,
                  1
                ],
                [
                  4,
                  -3
                ],
                [
                  5,
                  -2
                ],
                [
                  7,
                  -1
                ],
                [
                  5,
                  0
                ],
                [
                  28,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  4,
                  -4
                ],
                [
                  5,
                  -1
                ],
                [
                  12,
                  1
                ],
                [
                  5,
                  -2
                ],
                [
                  13,
                  -9
                ],
                [
                  3,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  6,
                  -1
                ],
                [
                  31,
                  -8
                ],
                [
                  7,
                  -4
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  4,
                  -2
                ],
                [
                  2,
                  0
                ],
                [
                  4,
                  0
                ],
                [
                  3,
                  -1
                ],
                [
                  6,
                  -2
                ],
                [
                  5,
                  -1
                ],
                [
                  3,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  2,
                  -8
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -2
                ],
                [
                  3,
                  -1
                ],
                [
                  -1,
                  -3
                ],
                [
                  -2,
                  -9
                ],
                [
                  -3,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  -11
                ],
                [
                  1,
                  -3
                ],
                [
                  2,
                  -2
                ],
                [
                  8,
                  -3
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  -1
                ],
                [
                  2,
                  -3
                ],
                [
                  2,
                  -3
                ],
                [
                  2,
                  -4
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -3
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  2
                ],
                [
                  -2,
                  6
                ],
                [
                  3,
                  0
                ],
                [
                  5,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  4,
                  -3
                ],
                [
                  1,
                  0
                ],
                [
                  16,
                  -1
                ],
                [
                  18,
                  0
                ],
                [
                  23,
                  -5
                ],
                [
                  20,
                  -8
                ],
                [
                  -3,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  3,
                  -1
                ],
                [
                  8,
                  -6
                ],
                [
                  3,
                  -1
                ],
                [
                  25,
                  0
                ],
                [
                  34,
                  -2
                ],
                [
                  12,
                  3
                ],
                [
                  3,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  5,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  -2
                ],
                [
                  5,
                  0
                ],
                [
                  5,
                  -2
                ],
                [
                  15,
                  -3
                ],
                [
                  5,
                  -3
                ],
                [
                  2,
                  -4
                ],
                [
                  -1,
                  -6
                ],
                [
                  0,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  5,
                  -5
                ],
                [
                  7,
                  -9
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -4
                ],
                [
                  3,
                  -4
                ],
                [
                  -1,
                  -1
                ]
              ],
              [
                [
                  7077,
                  819
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  3,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -3
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  5,
                  -2
                ],
                [
                  11,
                  -11
                ],
                [
                  4,
                  -1
                ],
                [
                  5,
                  0
                ],
                [
                  4,
                  -2
                ],
                [
                  1,
                  -8
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -5
                ],
                [
                  3,
                  -5
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  0
                ],
                [
                  -1,
                  -3
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  -3,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -4,
                  -2
                ],
                [
                  -4,
                  -1
                ],
                [
                  -3,
                  -3
                ],
                [
                  -1,
                  -3
                ],
                [
                  0,
                  -3
                ],
                [
                  1,
                  -3
                ],
                [
                  2,
                  -3
                ],
                [
                  -2,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  -10,
                  -3
                ],
                [
                  -3,
                  -3
                ],
                [
                  -3,
                  -3
                ],
                [
                  -1,
                  -4
                ],
                [
                  -3,
                  -4
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -3
                ],
                [
                  -1,
                  -3
                ],
                [
                  0,
                  -4
                ],
                [
                  2,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  2,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -4,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -10,
                  -6
                ],
                [
                  -6,
                  -3
                ],
                [
                  -15,
                  -9
                ],
                [
                  -8,
                  -3
                ],
                [
                  -9,
                  -2
                ],
                [
                  -11,
                  -4
                ],
                [
                  -5,
                  0
                ],
                [
                  -6,
                  2
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -6,
                  -3
                ],
                [
                  -3,
                  -1
                ],
                [
                  -7,
                  1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -3,
                  -4
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -3
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -3,
                  -1
                ],
                [
                  -3,
                  0
                ],
                [
                  -3,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  0,
                  -3
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -3
                ],
                [
                  -1,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  -11,
                  -8
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -3,
                  -7
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -3
                ],
                [
                  -4,
                  1
                ],
                [
                  -15,
                  1
                ],
                [
                  -3,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -3,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -6,
                  1
                ],
                [
                  -4,
                  1
                ],
                [
                  -4,
                  2
                ],
                [
                  -7,
                  8
                ],
                [
                  -8,
                  5
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -4,
                  4
                ],
                [
                  -3,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -5,
                  2
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -3,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -3,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  2
                ],
                [
                  -3,
                  8
                ],
                [
                  0,
                  4
                ],
                [
                  3,
                  6
                ],
                [
                  2,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  7
                ],
                [
                  -2,
                  2
                ],
                [
                  -7,
                  5
                ],
                [
                  -2,
                  3
                ],
                [
                  -4,
                  8
                ],
                [
                  -10,
                  24
                ],
                [
                  -1,
                  2
                ],
                [
                  -4,
                  5
                ],
                [
                  -2,
                  2
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  2,
                  4
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  4,
                  4
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  2
                ],
                [
                  4,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  4,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  5,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  3,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  3
                ],
                [
                  2,
                  2
                ],
                [
                  5,
                  5
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  6,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  8,
                  8
                ],
                [
                  3,
                  5
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  3
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  15,
                  -1
                ],
                [
                  4,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  4,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  5,
                  7
                ],
                [
                  5,
                  5
                ],
                [
                  1,
                  1
                ],
                [
                  3,
                  5
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  -1
                ],
                [
                  7,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  -1
                ],
                [
                  3,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  3,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  4,
                  6
                ],
                [
                  2,
                  2
                ],
                [
                  3,
                  1
                ],
                [
                  18,
                  2
                ],
                [
                  3,
                  0
                ],
                [
                  7,
                  5
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  -2
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -5
                ],
                [
                  1,
                  -2
                ],
                [
                  6,
                  0
                ],
                [
                  2,
                  -2
                ],
                [
                  4,
                  -7
                ],
                [
                  1,
                  0
                ],
                [
                  4,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  5,
                  -9
                ],
                [
                  7,
                  -7
                ]
              ],
              [
                [
                  2600,
                  9802
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -3
                ],
                [
                  2,
                  -2
                ],
                [
                  3,
                  -3
                ]
              ],
              [
                [
                  2607,
                  9791
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -3
                ],
                [
                  2,
                  -7
                ],
                [
                  1,
                  -6
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -7
                ],
                [
                  1,
                  -3
                ],
                [
                  3,
                  -2
                ],
                [
                  5,
                  -4
                ],
                [
                  5,
                  -3
                ],
                [
                  11,
                  -14
                ],
                [
                  2,
                  -1
                ],
                [
                  3,
                  -1
                ],
                [
                  3,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  5,
                  -4
                ],
                [
                  3,
                  -4
                ],
                [
                  2,
                  -2
                ],
                [
                  6,
                  -2
                ],
                [
                  7,
                  -6
                ],
                [
                  5,
                  -3
                ],
                [
                  19,
                  -4
                ],
                [
                  17,
                  -4
                ],
                [
                  16,
                  -4
                ],
                [
                  4,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  8,
                  4
                ],
                [
                  18,
                  2
                ],
                [
                  11,
                  5
                ],
                [
                  11,
                  2
                ],
                [
                  5,
                  2
                ],
                [
                  2,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  3,
                  0
                ],
                [
                  4,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  5,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  3
                ],
                [
                  1,
                  4
                ],
                [
                  2,
                  2
                ],
                [
                  4,
                  1
                ],
                [
                  3,
                  0
                ],
                [
                  3,
                  -2
                ],
                [
                  5,
                  -4
                ],
                [
                  3,
                  -2
                ],
                [
                  10,
                  -1
                ],
                [
                  3,
                  -2
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  7,
                  0
                ],
                [
                  6,
                  1
                ],
                [
                  16,
                  5
                ],
                [
                  2,
                  2
                ],
                [
                  6,
                  5
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  4,
                  4
                ],
                [
                  5,
                  11
                ],
                [
                  4,
                  4
                ],
                [
                  -1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -4
                ],
                [
                  2,
                  -6
                ]
              ],
              [
                [
                  2919,
                  9720
                ],
                [
                  -3,
                  -2
                ],
                [
                  1,
                  -4
                ],
                [
                  2,
                  -3
                ],
                [
                  4,
                  1
                ]
              ],
              [
                [
                  2923,
                  9712
                ],
                [
                  2,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -3
                ],
                [
                  1,
                  -4
                ],
                [
                  0,
                  -2
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  4,
                  -2
                ],
                [
                  4,
                  -1
                ],
                [
                  10,
                  -1
                ],
                [
                  -6,
                  4
                ],
                [
                  -10,
                  10
                ],
                [
                  -2,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  -1
                ],
                [
                  6,
                  -6
                ],
                [
                  1,
                  -1
                ],
                [
                  6,
                  -6
                ],
                [
                  6,
                  -3
                ],
                [
                  6,
                  -2
                ],
                [
                  14,
                  -2
                ],
                [
                  6,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  3,
                  1
                ],
                [
                  12,
                  -4
                ],
                [
                  3,
                  -1
                ],
                [
                  3,
                  -1
                ],
                [
                  4,
                  -1
                ],
                [
                  3,
                  -2
                ]
              ],
              [
                [
                  2172,
                  8657
                ],
                [
                  -9,
                  0
                ],
                [
                  -8,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  1,
                  -6
                ],
                [
                  4,
                  -12
                ],
                [
                  1,
                  -10
                ],
                [
                  -2,
                  -6
                ],
                [
                  -1,
                  -7
                ],
                [
                  0,
                  -8
                ],
                [
                  3,
                  -8
                ],
                [
                  3,
                  -8
                ],
                [
                  0,
                  -6
                ],
                [
                  -5,
                  -4
                ],
                [
                  -13,
                  -2
                ],
                [
                  -14,
                  -2
                ],
                [
                  -11,
                  0
                ],
                [
                  -16,
                  1
                ],
                [
                  -10,
                  0
                ],
                [
                  -9,
                  0
                ],
                [
                  -8,
                  -1
                ],
                [
                  -10,
                  -5
                ],
                [
                  -10,
                  -9
                ],
                [
                  -14,
                  -11
                ],
                [
                  -8,
                  -7
                ],
                [
                  -11,
                  -1
                ],
                [
                  -10,
                  0
                ],
                [
                  -11,
                  5
                ],
                [
                  -7,
                  3
                ],
                [
                  -4,
                  0
                ],
                [
                  -7,
                  -4
                ],
                [
                  -9,
                  -3
                ],
                [
                  -8,
                  0
                ],
                [
                  -14,
                  6
                ],
                [
                  -16,
                  8
                ],
                [
                  -9,
                  4
                ],
                [
                  -14,
                  2
                ],
                [
                  -13,
                  2
                ],
                [
                  -10,
                  -1
                ],
                [
                  -12,
                  0
                ],
                [
                  -16,
                  -6
                ],
                [
                  -13,
                  -4
                ],
                [
                  -15,
                  -4
                ],
                [
                  -17,
                  -4
                ],
                [
                  4,
                  -12
                ],
                [
                  6,
                  -7
                ],
                [
                  0,
                  -8
                ],
                [
                  -3,
                  -7
                ],
                [
                  -8,
                  -7
                ],
                [
                  -9,
                  -9
                ],
                [
                  -5,
                  -7
                ],
                [
                  -6,
                  -9
                ],
                [
                  -4,
                  -6
                ],
                [
                  -7,
                  -9
                ],
                [
                  -6,
                  -11
                ],
                [
                  -2,
                  -7
                ],
                [
                  -2,
                  -9
                ],
                [
                  -5,
                  -2
                ],
                [
                  -16,
                  -2
                ],
                [
                  -11,
                  -3
                ],
                [
                  -9,
                  -3
                ],
                [
                  -3,
                  -4
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -10
                ],
                [
                  0,
                  -7
                ],
                [
                  -3,
                  -5
                ],
                [
                  -4,
                  -14
                ],
                [
                  -5,
                  -13
                ],
                [
                  -4,
                  -16
                ],
                [
                  -4,
                  -14
                ],
                [
                  -5,
                  -22
                ],
                [
                  -5,
                  -21
                ],
                [
                  -7,
                  -20
                ],
                [
                  -5,
                  -12
                ],
                [
                  -4,
                  -7
                ],
                [
                  -9,
                  -8
                ],
                [
                  -8,
                  -6
                ],
                [
                  -9,
                  -7
                ],
                [
                  -10,
                  -7
                ],
                [
                  -15,
                  -8
                ],
                [
                  -12,
                  -7
                ],
                [
                  -4,
                  -3
                ],
                [
                  -6,
                  -4
                ],
                [
                  -9,
                  -10
                ],
                [
                  -8,
                  -13
                ],
                [
                  -5,
                  -12
                ],
                [
                  -9,
                  -18
                ],
                [
                  -7,
                  -9
                ],
                [
                  -4,
                  -6
                ],
                [
                  -10,
                  -5
                ],
                [
                  -12,
                  -4
                ],
                [
                  -13,
                  -6
                ],
                [
                  -10,
                  -6
                ],
                [
                  -15,
                  -5
                ],
                [
                  -9,
                  -6
                ],
                [
                  -6,
                  -8
                ],
                [
                  -5,
                  -10
                ],
                [
                  -7,
                  -14
                ],
                [
                  -5,
                  -15
                ],
                [
                  -3,
                  -9
                ],
                [
                  -8,
                  -34
                ],
                [
                  -2,
                  -19
                ],
                [
                  -3,
                  -13
                ],
                [
                  -4,
                  -15
                ],
                [
                  -2,
                  -23
                ],
                [
                  0,
                  -20
                ],
                [
                  -3,
                  -11
                ],
                [
                  -1,
                  -8
                ],
                [
                  -7,
                  -10
                ],
                [
                  -5,
                  -7
                ],
                [
                  -9,
                  -9
                ],
                [
                  -8,
                  -6
                ],
                [
                  -2,
                  -6
                ],
                [
                  -8,
                  -6
                ],
                [
                  -8,
                  -12
                ],
                [
                  -7,
                  -6
                ],
                [
                  2,
                  -6
                ],
                [
                  1,
                  -10
                ],
                [
                  -4,
                  -9
                ],
                [
                  -4,
                  -12
                ],
                [
                  -10,
                  -13
                ],
                [
                  -12,
                  -7
                ],
                [
                  -17,
                  -2
                ],
                [
                  -23,
                  0
                ],
                [
                  -18,
                  2
                ],
                [
                  -23,
                  0
                ],
                [
                  -19,
                  2
                ],
                [
                  -18,
                  3
                ],
                [
                  -23,
                  2
                ],
                [
                  -15,
                  0
                ],
                [
                  -20,
                  -3
                ],
                [
                  -51,
                  0
                ],
                [
                  -19,
                  -2
                ],
                [
                  -29,
                  -5
                ],
                [
                  -8,
                  -1
                ]
              ],
              [
                [
                  1087,
                  7793
                ],
                [
                  0,
                  3
                ],
                [
                  6,
                  20
                ],
                [
                  0,
                  7
                ],
                [
                  0,
                  5
                ],
                [
                  0,
                  3
                ],
                [
                  2,
                  4
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  4
                ],
                [
                  3,
                  5
                ],
                [
                  1,
                  6
                ],
                [
                  1,
                  3
                ],
                [
                  14,
                  28
                ],
                [
                  4,
                  5
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  3,
                  5
                ],
                [
                  1,
                  2
                ],
                [
                  3,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  14,
                  5
                ],
                [
                  3,
                  3
                ],
                [
                  2,
                  3
                ],
                [
                  2,
                  3
                ],
                [
                  5,
                  16
                ],
                [
                  0,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  7,
                  7
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  9
                ],
                [
                  1,
                  11
                ],
                [
                  0,
                  3
                ],
                [
                  2,
                  5
                ],
                [
                  1,
                  3
                ],
                [
                  2,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  3,
                  1
                ],
                [
                  4,
                  4
                ],
                [
                  5,
                  5
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  4
                ],
                [
                  -1,
                  3
                ],
                [
                  -2,
                  0
                ],
                [
                  -6,
                  -1
                ],
                [
                  1,
                  3
                ],
                [
                  3,
                  4
                ],
                [
                  1,
                  2
                ],
                [
                  6,
                  5
                ],
                [
                  0,
                  1
                ],
                [
                  10,
                  22
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  5,
                  10
                ],
                [
                  2,
                  9
                ],
                [
                  2,
                  3
                ],
                [
                  2,
                  3
                ],
                [
                  4,
                  8
                ],
                [
                  7,
                  7
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  3
                ],
                [
                  2,
                  3
                ],
                [
                  2,
                  3
                ],
                [
                  0,
                  3
                ],
                [
                  1,
                  6
                ],
                [
                  -1,
                  3
                ],
                [
                  -2,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -4,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  -5
                ],
                [
                  -2,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -3
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -6,
                  -5
                ],
                [
                  -2,
                  1
                ],
                [
                  1,
                  3
                ],
                [
                  2,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  5,
                  9
                ],
                [
                  8,
                  11
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  9,
                  8
                ],
                [
                  4,
                  2
                ],
                [
                  6,
                  3
                ],
                [
                  2,
                  2
                ],
                [
                  4,
                  0
                ],
                [
                  4,
                  3
                ],
                [
                  2,
                  3
                ],
                [
                  2,
                  3
                ],
                [
                  6,
                  6
                ],
                [
                  3,
                  5
                ],
                [
                  5,
                  4
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  12,
                  9
                ],
                [
                  7,
                  8
                ],
                [
                  9,
                  13
                ],
                [
                  4,
                  4
                ],
                [
                  4,
                  3
                ],
                [
                  2,
                  2
                ],
                [
                  3,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  5,
                  1
                ],
                [
                  3,
                  2
                ],
                [
                  4,
                  3
                ],
                [
                  0,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  3
                ],
                [
                  3,
                  4
                ],
                [
                  4,
                  2
                ],
                [
                  3,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  3
                ],
                [
                  1,
                  9
                ],
                [
                  3,
                  8
                ],
                [
                  1,
                  6
                ],
                [
                  2,
                  4
                ],
                [
                  1,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  13
                ],
                [
                  -1,
                  3
                ],
                [
                  4,
                  16
                ],
                [
                  1,
                  2
                ],
                [
                  4,
                  14
                ],
                [
                  6,
                  9
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  4,
                  9
                ],
                [
                  1,
                  7
                ],
                [
                  2,
                  3
                ],
                [
                  0,
                  4
                ],
                [
                  6,
                  13
                ],
                [
                  9,
                  13
                ],
                [
                  4,
                  7
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  3
                ],
                [
                  2,
                  6
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  8
                ],
                [
                  0,
                  2
                ],
                [
                  -2,
                  4
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  4
                ],
                [
                  1,
                  2
                ],
                [
                  7,
                  9
                ],
                [
                  1,
                  1
                ],
                [
                  7,
                  1
                ],
                [
                  7,
                  4
                ],
                [
                  10,
                  10
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  3
                ],
                [
                  2,
                  2
                ],
                [
                  3,
                  1
                ],
                [
                  14,
                  2
                ],
                [
                  3,
                  1
                ],
                [
                  13,
                  6
                ],
                [
                  24,
                  17
                ],
                [
                  16,
                  10
                ],
                [
                  8,
                  8
                ],
                [
                  8,
                  15
                ],
                [
                  2,
                  7
                ],
                [
                  3,
                  12
                ],
                [
                  3,
                  8
                ],
                [
                  4,
                  17
                ],
                [
                  3,
                  5
                ],
                [
                  11,
                  16
                ],
                [
                  -1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  7,
                  16
                ],
                [
                  5,
                  14
                ],
                [
                  0,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  2,
                  5
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  3
                ],
                [
                  2,
                  1
                ],
                [
                  4,
                  2
                ],
                [
                  4,
                  3
                ],
                [
                  5,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  5,
                  8
                ],
                [
                  3,
                  10
                ],
                [
                  2,
                  3
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  13,
                  4
                ],
                [
                  23,
                  4
                ],
                [
                  19,
                  0
                ],
                [
                  23,
                  7
                ],
                [
                  36,
                  6
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  29,
                  12
                ],
                [
                  39,
                  16
                ],
                [
                  4,
                  3
                ],
                [
                  3,
                  4
                ],
                [
                  6,
                  8
                ],
                [
                  1,
                  3
                ],
                [
                  3,
                  1
                ],
                [
                  2,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  3
                ],
                [
                  8,
                  5
                ],
                [
                  6,
                  7
                ],
                [
                  1,
                  2
                ],
                [
                  5,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  4,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  4
                ],
                [
                  4,
                  3
                ],
                [
                  2,
                  2
                ],
                [
                  37,
                  18
                ],
                [
                  9,
                  5
                ],
                [
                  11,
                  5
                ],
                [
                  5,
                  3
                ],
                [
                  16,
                  15
                ],
                [
                  13,
                  19
                ],
                [
                  4,
                  3
                ],
                [
                  2,
                  2
                ],
                [
                  5,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  3,
                  5
                ],
                [
                  4,
                  4
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  5,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  3
                ],
                [
                  5,
                  7
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  2,
                  2
                ],
                [
                  6,
                  5
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  5,
                  7
                ],
                [
                  17,
                  17
                ],
                [
                  13,
                  22
                ],
                [
                  8,
                  18
                ],
                [
                  2,
                  5
                ],
                [
                  2,
                  18
                ],
                [
                  2,
                  9
                ],
                [
                  1,
                  3
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  3
                ],
                [
                  -1,
                  2
                ],
                [
                  -3,
                  7
                ],
                [
                  -1,
                  4
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  4
                ],
                [
                  -9,
                  5
                ],
                [
                  -3,
                  1
                ],
                [
                  -3,
                  0
                ],
                [
                  -2,
                  2
                ],
                [
                  0,
                  5
                ],
                [
                  3,
                  6
                ],
                [
                  3,
                  5
                ],
                [
                  3,
                  4
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  27
                ],
                [
                  -1,
                  3
                ],
                [
                  -2,
                  5
                ],
                [
                  2,
                  3
                ],
                [
                  3,
                  20
                ],
                [
                  1,
                  7
                ],
                [
                  -1,
                  4
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  -2,
                  2
                ],
                [
                  4,
                  4
                ],
                [
                  3,
                  5
                ],
                [
                  3,
                  8
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  3
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  11
                ],
                [
                  1,
                  2
                ],
                [
                  12,
                  12
                ],
                [
                  5,
                  7
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  15,
                  14
                ],
                [
                  2,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  5
                ],
                [
                  0,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  5,
                  6
                ],
                [
                  2,
                  4
                ],
                [
                  1,
                  4
                ],
                [
                  0,
                  14
                ],
                [
                  0,
                  1
                ],
                [
                  -3,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  3,
                  6
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  3,
                  4
                ],
                [
                  19,
                  15
                ],
                [
                  15,
                  16
                ],
                [
                  12,
                  8
                ],
                [
                  5,
                  4
                ],
                [
                  15,
                  17
                ],
                [
                  16,
                  17
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  11,
                  11
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  5,
                  2
                ],
                [
                  5,
                  3
                ],
                [
                  7,
                  9
                ],
                [
                  5,
                  3
                ],
                [
                  5,
                  2
                ],
                [
                  18,
                  4
                ],
                [
                  12,
                  5
                ],
                [
                  7,
                  2
                ],
                [
                  6,
                  1
                ],
                [
                  3,
                  2
                ],
                [
                  3,
                  3
                ],
                [
                  3,
                  1
                ],
                [
                  9,
                  3
                ],
                [
                  5,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  3,
                  -1
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  4,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  5,
                  5
                ],
                [
                  4,
                  2
                ],
                [
                  3,
                  4
                ],
                [
                  3,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  9,
                  6
                ],
                [
                  5,
                  4
                ],
                [
                  5,
                  2
                ],
                [
                  5,
                  2
                ],
                [
                  5,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  4,
                  4
                ],
                [
                  5,
                  1
                ],
                [
                  14,
                  10
                ],
                [
                  13,
                  13
                ],
                [
                  12,
                  17
                ],
                [
                  8,
                  16
                ],
                [
                  15,
                  19
                ],
                [
                  1,
                  3
                ],
                [
                  2,
                  5
                ],
                [
                  3,
                  4
                ],
                [
                  28,
                  53
                ],
                [
                  12,
                  33
                ],
                [
                  23,
                  53
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  4
                ],
                [
                  1,
                  1
                ],
                [
                  3,
                  6
                ],
                [
                  2,
                  7
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  7
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  3
                ],
                [
                  5,
                  0
                ],
                [
                  12,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  4,
                  3
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  0
                ],
                [
                  3,
                  -1
                ],
                [
                  3,
                  -1
                ],
                [
                  7,
                  4
                ],
                [
                  2,
                  2
                ],
                [
                  5,
                  4
                ],
                [
                  3,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ]
              ],
              [
                [
                  9794,
                  2459
                ],
                [
                  -2,
                  -3
                ],
                [
                  -1,
                  4
                ],
                [
                  0,
                  4
                ],
                [
                  3,
                  6
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  4
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  3,
                  4
                ],
                [
                  9,
                  14
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  5,
                  3
                ],
                [
                  -1,
                  -3
                ],
                [
                  -5,
                  -10
                ],
                [
                  -3,
                  -11
                ],
                [
                  -6,
                  -14
                ],
                [
                  -5,
                  -7
                ],
                [
                  -4,
                  -8
                ]
              ],
              [
                [
                  9596,
                  2989
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -3
                ],
                [
                  -1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -5,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  6
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  1
                ],
                [
                  0,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -3
                ],
                [
                  1,
                  0
                ]
              ],
              [
                [
                  9730,
                  3150
                ],
                [
                  0,
                  -4
                ],
                [
                  0,
                  -4
                ],
                [
                  3,
                  -5
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  -5,
                  5
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  -4
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  -2,
                  4
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  -1
                ],
                [
                  4,
                  -6
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -3
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  3,
                  -3
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  3
                ],
                [
                  4,
                  -9
                ],
                [
                  0,
                  -3
                ],
                [
                  1,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  4
                ],
                [
                  -1,
                  -4
                ],
                [
                  2,
                  -7
                ],
                [
                  -1,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  3,
                  -2
                ],
                [
                  2,
                  -3
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  -2,
                  -3
                ],
                [
                  -1,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  3,
                  -4
                ],
                [
                  1,
                  0
                ],
                [
                  -1,
                  -4
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -4
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -3
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  3,
                  -4
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -8
                ],
                [
                  -1,
                  -11
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  4,
                  -5
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -6
                ],
                [
                  0,
                  -2
                ],
                [
                  2,
                  -2
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -3
                ],
                [
                  -1,
                  -5
                ],
                [
                  0,
                  -3
                ],
                [
                  2,
                  -8
                ],
                [
                  1,
                  -4
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -5
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  3,
                  -6
                ],
                [
                  1,
                  -5
                ],
                [
                  1,
                  -28
                ],
                [
                  3,
                  -10
                ],
                [
                  0,
                  -4
                ],
                [
                  0,
                  -5
                ],
                [
                  -1,
                  -4
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -5
                ],
                [
                  0,
                  -3
                ],
                [
                  1,
                  -2
                ],
                [
                  3,
                  -3
                ],
                [
                  2,
                  -4
                ],
                [
                  0,
                  -4
                ],
                [
                  -1,
                  -10
                ],
                [
                  -2,
                  -5
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  2,
                  -7
                ],
                [
                  1,
                  -15
                ],
                [
                  3,
                  -8
                ],
                [
                  1,
                  -5
                ],
                [
                  -1,
                  -4
                ],
                [
                  -3,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  3,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -9
                ],
                [
                  10,
                  -21
                ],
                [
                  2,
                  -4
                ],
                [
                  6,
                  -8
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -5
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -5
                ],
                [
                  1,
                  -8
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -3
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -5
                ],
                [
                  -2,
                  -6
                ],
                [
                  -1,
                  -3
                ],
                [
                  -1,
                  -4
                ],
                [
                  -11,
                  -22
                ],
                [
                  -1,
                  -4
                ],
                [
                  1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -9,
                  -13
                ],
                [
                  -3,
                  -7
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  7
                ],
                [
                  -3,
                  2
                ],
                [
                  -3,
                  0
                ],
                [
                  -6,
                  5
                ],
                [
                  -2,
                  3
                ],
                [
                  -1,
                  4
                ],
                [
                  -1,
                  8
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  -4,
                  5
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  5
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  7
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -4,
                  -1
                ],
                [
                  -5,
                  -1
                ],
                [
                  -8,
                  0
                ],
                [
                  -4,
                  -1
                ],
                [
                  -3,
                  -3
                ],
                [
                  -8,
                  -11
                ],
                [
                  0,
                  -4
                ],
                [
                  3,
                  -8
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -4
                ],
                [
                  0,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -5
                ],
                [
                  2,
                  -4
                ],
                [
                  1,
                  -7
                ],
                [
                  2,
                  -5
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -3
                ],
                [
                  -4,
                  -7
                ],
                [
                  -1,
                  -4
                ],
                [
                  0,
                  -5
                ],
                [
                  1,
                  -4
                ],
                [
                  2,
                  -4
                ],
                [
                  3,
                  -3
                ],
                [
                  9,
                  -4
                ],
                [
                  3,
                  -2
                ],
                [
                  3,
                  -5
                ],
                [
                  1,
                  -4
                ],
                [
                  -3,
                  -12
                ],
                [
                  0,
                  -6
                ],
                [
                  1,
                  -5
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  -1,
                  -5
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -5
                ],
                [
                  0,
                  -2
                ],
                [
                  -7,
                  -12
                ],
                [
                  -4,
                  -4
                ],
                [
                  -6,
                  -5
                ],
                [
                  1,
                  -7
                ],
                [
                  1,
                  -3
                ],
                [
                  2,
                  -3
                ],
                [
                  2,
                  -2
                ],
                [
                  3,
                  -2
                ],
                [
                  3,
                  0
                ],
                [
                  4,
                  0
                ],
                [
                  -4,
                  -2
                ],
                [
                  -4,
                  -2
                ],
                [
                  -8,
                  -1
                ],
                [
                  -3,
                  -2
                ],
                [
                  -7,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -1,
                  -3
                ],
                [
                  -9,
                  -17
                ],
                [
                  -6,
                  -18
                ],
                [
                  -7,
                  -16
                ],
                [
                  -1,
                  -10
                ],
                [
                  1,
                  -2
                ],
                [
                  4,
                  -7
                ],
                [
                  6,
                  -34
                ],
                [
                  1,
                  -9
                ],
                [
                  -2,
                  -9
                ],
                [
                  -5,
                  -17
                ],
                [
                  -6,
                  -21
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -4,
                  -8
                ],
                [
                  -3,
                  -27
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  -3,
                  -9
                ],
                [
                  -8,
                  -16
                ],
                [
                  -7,
                  -26
                ],
                [
                  -10,
                  -24
                ],
                [
                  -5,
                  -7
                ],
                [
                  -12,
                  -43
                ],
                [
                  -16,
                  -43
                ],
                [
                  -5,
                  -22
                ],
                [
                  0,
                  -3
                ],
                [
                  0,
                  -5
                ],
                [
                  -4,
                  -12
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  3
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  3,
                  -5
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  -11,
                  -22
                ],
                [
                  -7,
                  -20
                ],
                [
                  -4,
                  -11
                ],
                [
                  -7,
                  -21
                ],
                [
                  -13,
                  -50
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  -4
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -5
                ],
                [
                  -1,
                  -5
                ],
                [
                  -5,
                  -11
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -4
                ],
                [
                  -3,
                  -12
                ],
                [
                  -1,
                  -5
                ],
                [
                  -2,
                  -3
                ],
                [
                  -17,
                  -53
                ],
                [
                  -16,
                  -38
                ],
                [
                  -17,
                  -39
                ],
                [
                  -2,
                  -9
                ],
                [
                  -4,
                  -9
                ],
                [
                  -5,
                  -37
                ],
                [
                  -3,
                  -8
                ],
                [
                  -1,
                  -13
                ],
                [
                  -4,
                  -16
                ],
                [
                  -5,
                  -13
                ],
                [
                  -3,
                  -20
                ],
                [
                  -16,
                  -47
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -3
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -4
                ],
                [
                  -7,
                  -29
                ],
                [
                  -7,
                  -19
                ],
                [
                  -3,
                  -4
                ],
                [
                  0,
                  -1
                ],
                [
                  -3,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -3
                ],
                [
                  -2,
                  -5
                ],
                [
                  0,
                  -1
                ],
                [
                  -8,
                  -20
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  -1
                ],
                [
                  2,
                  -8
                ],
                [
                  -4,
                  -22
                ],
                [
                  -11,
                  -27
                ],
                [
                  -3,
                  -5
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -4
                ],
                [
                  -1,
                  -2
                ],
                [
                  -7,
                  -5
                ],
                [
                  -1,
                  -5
                ],
                [
                  1,
                  -9
                ],
                [
                  -2,
                  -3
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  -2,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -3
                ],
                [
                  -1,
                  -1
                ],
                [
                  -4,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  -4,
                  -3
                ],
                [
                  -6,
                  -7
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  -8,
                  -5
                ],
                [
                  -2,
                  -3
                ],
                [
                  -2,
                  0
                ],
                [
                  -4,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -9,
                  -3
                ],
                [
                  -2,
                  0
                ],
                [
                  -5,
                  2
                ],
                [
                  -13,
                  1
                ],
                [
                  -15,
                  0
                ],
                [
                  -20,
                  -5
                ],
                [
                  -25,
                  -11
                ],
                [
                  -17,
                  -8
                ],
                [
                  -18,
                  -10
                ],
                [
                  -13,
                  -12
                ],
                [
                  -2,
                  -1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -7,
                  -6
                ],
                [
                  -9,
                  -2
                ],
                [
                  -37,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  5
                ],
                [
                  -1,
                  2
                ],
                [
                  -4,
                  3
                ],
                [
                  -14,
                  5
                ],
                [
                  -4,
                  3
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  4
                ],
                [
                  -3,
                  2
                ],
                [
                  -9,
                  7
                ],
                [
                  -9,
                  4
                ],
                [
                  -5,
                  2
                ],
                [
                  -14,
                  2
                ],
                [
                  -14,
                  0
                ],
                [
                  -19,
                  4
                ],
                [
                  -2,
                  2
                ],
                [
                  -2,
                  5
                ],
                [
                  -4,
                  5
                ],
                [
                  -1,
                  3
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  4,
                  -5
                ],
                [
                  3,
                  -2
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  4
                ],
                [
                  -3,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -5,
                  2
                ],
                [
                  -8,
                  9
                ],
                [
                  -4,
                  2
                ],
                [
                  -4,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -10,
                  7
                ],
                [
                  -2,
                  3
                ],
                [
                  -1,
                  11
                ],
                [
                  -1,
                  5
                ],
                [
                  -9,
                  12
                ],
                [
                  -2,
                  5
                ],
                [
                  2,
                  12
                ],
                [
                  -2,
                  5
                ],
                [
                  -1,
                  2
                ],
                [
                  -5,
                  6
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  3
                ],
                [
                  -1,
                  1
                ],
                [
                  -4,
                  4
                ],
                [
                  -9,
                  6
                ],
                [
                  -4,
                  4
                ],
                [
                  -5,
                  10
                ],
                [
                  -2,
                  21
                ],
                [
                  2,
                  24
                ],
                [
                  -2,
                  13
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  4
                ],
                [
                  -1,
                  5
                ],
                [
                  -1,
                  3
                ],
                [
                  -2,
                  2
                ],
                [
                  2,
                  3
                ],
                [
                  0,
                  10
                ],
                [
                  0,
                  4
                ],
                [
                  3,
                  3
                ],
                [
                  9,
                  4
                ],
                [
                  2,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  -2,
                  4
                ],
                [
                  0,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  -3,
                  3
                ],
                [
                  -3,
                  3
                ],
                [
                  -5,
                  5
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  5
                ],
                [
                  -1,
                  12
                ],
                [
                  -1,
                  11
                ],
                [
                  -2,
                  5
                ],
                [
                  -4,
                  4
                ],
                [
                  -9,
                  7
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  4
                ],
                [
                  -2,
                  2
                ],
                [
                  -2,
                  2
                ],
                [
                  -5,
                  5
                ],
                [
                  -3,
                  4
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  5
                ],
                [
                  -2,
                  4
                ],
                [
                  -1,
                  7
                ],
                [
                  -1,
                  4
                ],
                [
                  -1,
                  5
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  3
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  7
                ],
                [
                  -1,
                  13
                ],
                [
                  -2,
                  6
                ],
                [
                  -3,
                  6
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  3
                ],
                [
                  0,
                  3
                ],
                [
                  3,
                  2
                ],
                [
                  4,
                  1
                ],
                [
                  2,
                  -3
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  -4,
                  0
                ],
                [
                  -2,
                  5
                ],
                [
                  0,
                  13
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  4
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  -1,
                  4
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -5
                ],
                [
                  3,
                  4
                ],
                [
                  0,
                  6
                ],
                [
                  0,
                  7
                ],
                [
                  1,
                  6
                ],
                [
                  1,
                  2
                ],
                [
                  9,
                  11
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  2,
                  -2
                ],
                [
                  0,
                  37
                ],
                [
                  1,
                  3
                ],
                [
                  3,
                  7
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  2
                ],
                [
                  4,
                  2
                ],
                [
                  2,
                  3
                ],
                [
                  8,
                  0
                ],
                [
                  4,
                  1
                ],
                [
                  3,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  4,
                  1
                ],
                [
                  4,
                  3
                ],
                [
                  3,
                  4
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  5
                ],
                [
                  4,
                  13
                ],
                [
                  5,
                  26
                ],
                [
                  8,
                  16
                ],
                [
                  3,
                  3
                ],
                [
                  4,
                  1
                ],
                [
                  3,
                  2
                ],
                [
                  7,
                  13
                ],
                [
                  1,
                  6
                ],
                [
                  2,
                  6
                ],
                [
                  1,
                  7
                ],
                [
                  4,
                  4
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  3,
                  8
                ],
                [
                  2,
                  2
                ],
                [
                  5,
                  5
                ],
                [
                  2,
                  2
                ],
                [
                  0,
                  4
                ],
                [
                  1,
                  5
                ],
                [
                  10,
                  19
                ],
                [
                  2,
                  4
                ],
                [
                  8,
                  8
                ],
                [
                  3,
                  4
                ],
                [
                  3,
                  4
                ],
                [
                  2,
                  6
                ],
                [
                  0,
                  4
                ],
                [
                  0,
                  6
                ],
                [
                  0,
                  4
                ],
                [
                  -3,
                  1
                ],
                [
                  -1,
                  4
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  2
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  5
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  5
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  3,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  3,
                  0
                ],
                [
                  2,
                  3
                ],
                [
                  0,
                  5
                ],
                [
                  -3,
                  9
                ],
                [
                  -2,
                  5
                ],
                [
                  -3,
                  4
                ],
                [
                  -6,
                  6
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  5
                ],
                [
                  -2,
                  5
                ],
                [
                  -12,
                  15
                ],
                [
                  -2,
                  5
                ],
                [
                  -1,
                  5
                ],
                [
                  1,
                  8
                ],
                [
                  1,
                  4
                ],
                [
                  0,
                  9
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  4
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  4
                ],
                [
                  -4,
                  10
                ],
                [
                  -6,
                  17
                ],
                [
                  -9,
                  13
                ],
                [
                  -8,
                  13
                ],
                [
                  -2,
                  4
                ],
                [
                  1,
                  27
                ],
                [
                  -6,
                  27
                ],
                [
                  0,
                  9
                ],
                [
                  4,
                  18
                ],
                [
                  1,
                  6
                ],
                [
                  -1,
                  2
                ],
                [
                  -3,
                  3
                ],
                [
                  -2,
                  6
                ],
                [
                  -8,
                  12
                ],
                [
                  -1,
                  3
                ],
                [
                  0,
                  5
                ],
                [
                  1,
                  8
                ],
                [
                  2,
                  4
                ],
                [
                  6,
                  11
                ],
                [
                  3,
                  6
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  4
                ],
                [
                  10,
                  15
                ],
                [
                  2,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  6
                ],
                [
                  3,
                  0
                ],
                [
                  4,
                  5
                ],
                [
                  4,
                  12
                ],
                [
                  1,
                  2
                ],
                [
                  4,
                  4
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  3
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  6
                ],
                [
                  4,
                  5
                ],
                [
                  4,
                  5
                ],
                [
                  4,
                  6
                ],
                [
                  1,
                  6
                ],
                [
                  0,
                  3
                ],
                [
                  -3,
                  6
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  4
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -4
                ],
                [
                  2,
                  4
                ],
                [
                  1,
                  4
                ],
                [
                  0,
                  4
                ],
                [
                  -1,
                  3
                ],
                [
                  -5,
                  8
                ],
                [
                  -2,
                  4
                ],
                [
                  0,
                  5
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  8
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  5,
                  0
                ],
                [
                  4,
                  0
                ],
                [
                  28,
                  -2
                ],
                [
                  4,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  -2
                ],
                [
                  2,
                  -2
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  4,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  8,
                  4
                ],
                [
                  4,
                  2
                ],
                [
                  2,
                  4
                ],
                [
                  5,
                  7
                ],
                [
                  2,
                  4
                ],
                [
                  3,
                  3
                ],
                [
                  4,
                  2
                ],
                [
                  8,
                  4
                ],
                [
                  5,
                  3
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -5
                ],
                [
                  3,
                  -8
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -3
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  4,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  -3,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  21,
                  3
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  0,
                  -4
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -4
                ],
                [
                  0,
                  -2
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  2
                ],
                [
                  -1,
                  7
                ],
                [
                  0,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  4
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  4,
                  5
                ],
                [
                  5,
                  3
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  5,
                  -3
                ],
                [
                  3,
                  1
                ],
                [
                  8,
                  4
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -5
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  -2
                ],
                [
                  3,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  3
                ],
                [
                  -3,
                  -2
                ],
                [
                  -3,
                  -3
                ],
                [
                  -2,
                  0
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  3,
                  3
                ],
                [
                  3,
                  2
                ],
                [
                  3,
                  2
                ],
                [
                  3,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  7,
                  0
                ],
                [
                  3,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  2,
                  -3
                ],
                [
                  2,
                  -2
                ],
                [
                  2,
                  -2
                ],
                [
                  5,
                  -10
                ],
                [
                  2,
                  -3
                ],
                [
                  3,
                  -2
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  3,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  -1,
                  2
                ],
                [
                  3,
                  1
                ],
                [
                  3,
                  -3
                ],
                [
                  2,
                  -3
                ],
                [
                  3,
                  -2
                ],
                [
                  1,
                  1
                ],
                [
                  -1,
                  4
                ],
                [
                  -4,
                  5
                ],
                [
                  -2,
                  2
                ],
                [
                  -6,
                  5
                ],
                [
                  -3,
                  1
                ],
                [
                  -4,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -3,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  3,
                  5
                ],
                [
                  1,
                  3
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  2,
                  4
                ],
                [
                  2,
                  5
                ],
                [
                  2,
                  3
                ],
                [
                  6,
                  5
                ],
                [
                  8,
                  9
                ],
                [
                  3,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  4
                ],
                [
                  6,
                  4
                ],
                [
                  1,
                  1
                ],
                [
                  3,
                  3
                ],
                [
                  4,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  3,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -4,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  8,
                  2
                ],
                [
                  13,
                  10
                ],
                [
                  10,
                  9
                ],
                [
                  6,
                  2
                ],
                [
                  3,
                  2
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -4
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  4,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  -4
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  -6,
                  -12
                ],
                [
                  -1,
                  -4
                ],
                [
                  0,
                  -4
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  4
                ],
                [
                  1,
                  2
                ],
                [
                  3,
                  1
                ],
                [
                  4,
                  0
                ],
                [
                  5,
                  2
                ],
                [
                  4,
                  2
                ],
                [
                  4,
                  2
                ],
                [
                  4,
                  -2
                ],
                [
                  5,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  4
                ],
                [
                  -2,
                  9
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -4,
                  -2
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  4
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  3
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  4
                ],
                [
                  1,
                  3
                ],
                [
                  4,
                  5
                ],
                [
                  4,
                  4
                ],
                [
                  6,
                  3
                ],
                [
                  5,
                  5
                ],
                [
                  2,
                  8
                ],
                [
                  2,
                  3
                ],
                [
                  7,
                  6
                ],
                [
                  2,
                  2
                ],
                [
                  3,
                  1
                ],
                [
                  3,
                  0
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  3
                ],
                [
                  -1,
                  3
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  4
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  6
                ],
                [
                  17,
                  18
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -4
                ],
                [
                  1,
                  -1
                ],
                [
                  -1,
                  -9
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -2
                ],
                [
                  -2,
                  -3
                ],
                [
                  -7,
                  -9
                ],
                [
                  -2,
                  -4
                ],
                [
                  -1,
                  -4
                ],
                [
                  -2,
                  -17
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  1
                ],
                [
                  4,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  4
                ],
                [
                  1,
                  4
                ],
                [
                  2,
                  4
                ],
                [
                  4,
                  3
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  9,
                  18
                ],
                [
                  1,
                  4
                ],
                [
                  1,
                  2
                ],
                [
                  4,
                  4
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  4
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  5,
                  -8
                ],
                [
                  3,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  4,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  -1,
                  -4
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  -1,
                  3
                ],
                [
                  -2,
                  1
                ],
                [
                  3,
                  3
                ],
                [
                  4,
                  0
                ],
                [
                  2,
                  -3
                ],
                [
                  2,
                  -5
                ],
                [
                  -1,
                  -9
                ],
                [
                  1,
                  -3
                ],
                [
                  2,
                  4
                ],
                [
                  1,
                  4
                ],
                [
                  0,
                  6
                ],
                [
                  -1,
                  5
                ],
                [
                  -3,
                  2
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  2
                ],
                [
                  -3,
                  3
                ],
                [
                  -3,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -4,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  -3,
                  -5
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -3,
                  5
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  5
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  0,
                  6
                ],
                [
                  1,
                  5
                ],
                [
                  2,
                  4
                ],
                [
                  2,
                  4
                ],
                [
                  4,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  4
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  6,
                  -5
                ],
                [
                  4,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  -2,
                  4
                ],
                [
                  -2,
                  4
                ],
                [
                  -2,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  -1
                ],
                [
                  6,
                  -4
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -3
                ],
                [
                  -2,
                  -7
                ],
                [
                  0,
                  -4
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  1,
                  3
                ],
                [
                  4,
                  5
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  3
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  3
                ],
                [
                  -5,
                  2
                ],
                [
                  -3,
                  2
                ],
                [
                  -5,
                  4
                ],
                [
                  10,
                  6
                ],
                [
                  0,
                  1
                ],
                [
                  -6,
                  5
                ],
                [
                  -5,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  7
                ],
                [
                  -2,
                  9
                ],
                [
                  1,
                  8
                ],
                [
                  6,
                  2
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  0,
                  4
                ],
                [
                  0,
                  3
                ],
                [
                  2,
                  4
                ],
                [
                  1,
                  3
                ],
                [
                  3,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  6
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  -3,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  5,
                  0
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -3
                ],
                [
                  0,
                  -4
                ],
                [
                  1,
                  -3
                ],
                [
                  4,
                  2
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -3
                ],
                [
                  0,
                  -3
                ],
                [
                  2,
                  -6
                ],
                [
                  1,
                  -3
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  1,
                  -3
                ],
                [
                  3,
                  -2
                ],
                [
                  4,
                  -2
                ],
                [
                  3,
                  -1
                ],
                [
                  4,
                  1
                ],
                [
                  4,
                  2
                ],
                [
                  1,
                  4
                ],
                [
                  -2,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  7
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  5
                ],
                [
                  1,
                  1
                ],
                [
                  -3,
                  5
                ],
                [
                  -1,
                  3
                ],
                [
                  3,
                  1
                ],
                [
                  1,
                  -1
                ],
                [
                  4,
                  -6
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  3,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  3,
                  -3
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  4
                ],
                [
                  -1,
                  4
                ],
                [
                  -2,
                  3
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  4
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  3,
                  -2
                ],
                [
                  7,
                  -3
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  5,
                  2
                ],
                [
                  4,
                  2
                ],
                [
                  5,
                  4
                ],
                [
                  3,
                  5
                ],
                [
                  -2,
                  2
                ],
                [
                  1,
                  4
                ],
                [
                  5,
                  6
                ],
                [
                  0,
                  2
                ],
                [
                  -2,
                  3
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  4
                ],
                [
                  0,
                  2
                ],
                [
                  3,
                  11
                ],
                [
                  2,
                  4
                ],
                [
                  3,
                  5
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  0
                ],
                [
                  -1,
                  4
                ],
                [
                  2,
                  9
                ],
                [
                  0,
                  4
                ],
                [
                  0,
                  1
                ],
                [
                  -3,
                  4
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  6
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  0,
                  4
                ],
                [
                  -1,
                  2
                ],
                [
                  -4,
                  4
                ],
                [
                  -2,
                  6
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  -3
                ],
                [
                  -5,
                  3
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  4
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  4,
                  0
                ],
                [
                  4,
                  -1
                ],
                [
                  3,
                  -3
                ],
                [
                  4,
                  -8
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  8
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  -3
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  3
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -5,
                  -1
                ],
                [
                  2,
                  3
                ],
                [
                  5,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  -1
                ],
                [
                  4,
                  -7
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  3
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  2
                ],
                [
                  -3,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  4,
                  4
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  3,
                  -4
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -4
                ],
                [
                  1,
                  -2
                ],
                [
                  3,
                  -3
                ],
                [
                  0,
                  -3
                ]
              ],
              [
                [
                  3853,
                  7477
                ],
                [
                  1,
                  -17
                ],
                [
                  0,
                  -17
                ],
                [
                  0,
                  -17
                ],
                [
                  0,
                  -18
                ],
                [
                  0,
                  -17
                ],
                [
                  0,
                  -17
                ],
                [
                  0,
                  -17
                ],
                [
                  0,
                  -17
                ],
                [
                  0,
                  -17
                ],
                [
                  0,
                  -8
                ],
                [
                  0,
                  -9
                ],
                [
                  0,
                  -18
                ],
                [
                  0,
                  -17
                ],
                [
                  0,
                  -17
                ],
                [
                  0,
                  -17
                ],
                [
                  0,
                  -17
                ],
                [
                  0,
                  -17
                ],
                [
                  0,
                  -9
                ],
                [
                  0,
                  -14
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -14
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -3
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -9
                ],
                [
                  1,
                  -19
                ],
                [
                  0,
                  -11
                ],
                [
                  0,
                  -16
                ],
                [
                  -1,
                  -3
                ],
                [
                  -2,
                  -2
                ],
                [
                  -6,
                  -3
                ],
                [
                  -3,
                  -2
                ],
                [
                  -2,
                  -3
                ],
                [
                  -2,
                  -3
                ],
                [
                  -12,
                  -30
                ],
                [
                  -1,
                  -3
                ],
                [
                  1,
                  -4
                ],
                [
                  2,
                  -4
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -8,
                  -7
                ],
                [
                  -2,
                  -4
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -14
                ],
                [
                  -1,
                  -5
                ],
                [
                  -2,
                  -4
                ],
                [
                  0,
                  -1
                ],
                [
                  -3,
                  -4
                ],
                [
                  -5,
                  -3
                ],
                [
                  -11,
                  -2
                ],
                [
                  -4,
                  -3
                ],
                [
                  -11,
                  -11
                ],
                [
                  -11,
                  -7
                ],
                [
                  -1,
                  -4
                ],
                [
                  -1,
                  -16
                ],
                [
                  -3,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -13,
                  2
                ],
                [
                  -24,
                  4
                ],
                [
                  -16,
                  3
                ],
                [
                  -5,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -5
                ],
                [
                  -1,
                  -2
                ],
                [
                  -6,
                  0
                ],
                [
                  -13,
                  -1
                ],
                [
                  -12,
                  0
                ],
                [
                  -13,
                  -1
                ],
                [
                  -12,
                  0
                ],
                [
                  -13,
                  0
                ],
                [
                  -12,
                  -1
                ],
                [
                  -13,
                  0
                ],
                [
                  -13,
                  -1
                ],
                [
                  -12,
                  0
                ],
                [
                  -13,
                  -1
                ],
                [
                  -12,
                  0
                ],
                [
                  -13,
                  -1
                ],
                [
                  -12,
                  0
                ],
                [
                  -13,
                  0
                ],
                [
                  -13,
                  -1
                ],
                [
                  -12,
                  0
                ],
                [
                  -10,
                  -1
                ],
                [
                  -4,
                  -1
                ],
                [
                  -4,
                  -2
                ],
                [
                  -9,
                  -8
                ],
                [
                  -10,
                  -11
                ],
                [
                  -8,
                  -8
                ],
                [
                  -11,
                  -10
                ],
                [
                  -4,
                  -2
                ],
                [
                  -3,
                  -1
                ],
                [
                  -20,
                  0
                ],
                [
                  -4,
                  -2
                ],
                [
                  -4,
                  -1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -20,
                  7
                ],
                [
                  -4,
                  0
                ],
                [
                  -9,
                  -3
                ],
                [
                  -4,
                  -1
                ],
                [
                  -4,
                  0
                ],
                [
                  -17,
                  4
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -3
                ],
                [
                  1,
                  -7
                ]
              ],
              [
                [
                  1820,
                  6543
                ],
                [
                  0,
                  4
                ],
                [
                  1,
                  4
                ],
                [
                  0,
                  3
                ],
                [
                  -2,
                  2
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  4
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  4
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  3
                ],
                [
                  0,
                  4
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  3
                ],
                [
                  -4,
                  4
                ],
                [
                  -1,
                  3
                ],
                [
                  0,
                  3
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  -4,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  0,
                  -3
                ],
                [
                  -1,
                  -3
                ],
                [
                  -5,
                  -4
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -4,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  2
                ],
                [
                  2,
                  7
                ],
                [
                  0,
                  3
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -8,
                  5
                ],
                [
                  -2,
                  3
                ],
                [
                  -3,
                  5
                ],
                [
                  -2,
                  5
                ],
                [
                  -2,
                  5
                ],
                [
                  -2,
                  3
                ],
                [
                  -2,
                  1
                ],
                [
                  11,
                  7
                ],
                [
                  5,
                  5
                ],
                [
                  2,
                  6
                ],
                [
                  1,
                  5
                ],
                [
                  0,
                  3
                ],
                [
                  -1,
                  3
                ],
                [
                  -2,
                  3
                ],
                [
                  -3,
                  2
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  0,
                  6
                ],
                [
                  3,
                  11
                ],
                [
                  1,
                  5
                ],
                [
                  -1,
                  3
                ],
                [
                  -5,
                  12
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -5,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -12,
                  4
                ],
                [
                  -2,
                  1
                ],
                [
                  0,
                  6
                ],
                [
                  0,
                  2
                ],
                [
                  -2,
                  7
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  3
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  3,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  3
                ],
                [
                  -1,
                  4
                ]
              ],
              [
                [
                  1706,
                  6872
                ],
                [
                  2,
                  -1
                ],
                [
                  3,
                  -1
                ],
                [
                  3,
                  1
                ],
                [
                  5,
                  2
                ],
                [
                  3,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  5,
                  -5
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  -1
                ],
                [
                  3,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  5
                ],
                [
                  2,
                  2
                ],
                [
                  6,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  5
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  3
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  1,
                  5
                ],
                [
                  1,
                  5
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  3
                ],
                [
                  3,
                  7
                ],
                [
                  0,
                  7
                ],
                [
                  1,
                  2
                ],
                [
                  4,
                  10
                ],
                [
                  2,
                  10
                ],
                [
                  2,
                  4
                ],
                [
                  3,
                  4
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  5
                ],
                [
                  3,
                  -1
                ],
                [
                  4,
                  -1
                ],
                [
                  3,
                  0
                ],
                [
                  4,
                  2
                ],
                [
                  5,
                  5
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  8,
                  -1
                ],
                [
                  3,
                  -2
                ],
                [
                  3,
                  -3
                ],
                [
                  12,
                  -18
                ],
                [
                  2,
                  -3
                ],
                [
                  33,
                  -25
                ],
                [
                  5,
                  -4
                ],
                [
                  3,
                  -7
                ],
                [
                  5,
                  -5
                ],
                [
                  4,
                  -7
                ],
                [
                  1,
                  3
                ],
                [
                  2,
                  7
                ],
                [
                  2,
                  3
                ],
                [
                  3,
                  3
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  6
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  6
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  8,
                  -1
                ],
                [
                  5,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  5,
                  2
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  14,
                  0
                ],
                [
                  3,
                  -1
                ],
                [
                  6,
                  1
                ],
                [
                  2,
                  -1
                ],
                [
                  11,
                  -4
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  -1
                ],
                [
                  4,
                  -3
                ],
                [
                  3,
                  -1
                ],
                [
                  6,
                  0
                ],
                [
                  15,
                  2
                ],
                [
                  15,
                  -2
                ],
                [
                  5,
                  2
                ],
                [
                  7,
                  4
                ],
                [
                  3,
                  1
                ],
                [
                  6,
                  2
                ],
                [
                  32,
                  1
                ],
                [
                  -1,
                  8
                ],
                [
                  -2,
                  8
                ],
                [
                  0,
                  5
                ],
                [
                  2,
                  3
                ],
                [
                  8,
                  10
                ],
                [
                  2,
                  2
                ],
                [
                  3,
                  -2
                ],
                [
                  1,
                  -4
                ],
                [
                  -2,
                  -10
                ],
                [
                  -1,
                  -12
                ],
                [
                  23,
                  0
                ],
                [
                  4,
                  0
                ],
                [
                  16,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  12,
                  0
                ],
                [
                  9,
                  0
                ],
                [
                  10,
                  0
                ],
                [
                  10,
                  0
                ],
                [
                  11,
                  0
                ],
                [
                  18,
                  0
                ],
                [
                  18,
                  0
                ],
                [
                  20,
                  0
                ],
                [
                  21,
                  0
                ],
                [
                  21,
                  0
                ],
                [
                  22,
                  0
                ],
                [
                  22,
                  0
                ],
                [
                  22,
                  0
                ],
                [
                  22,
                  0
                ],
                [
                  23,
                  0
                ],
                [
                  21,
                  0
                ],
                [
                  22,
                  0
                ],
                [
                  20,
                  0
                ],
                [
                  20,
                  0
                ],
                [
                  6,
                  0
                ],
                [
                  13,
                  0
                ],
                [
                  17,
                  0
                ],
                [
                  10,
                  -1
                ],
                [
                  9,
                  0
                ],
                [
                  9,
                  0
                ],
                [
                  8,
                  0
                ],
                [
                  18,
                  0
                ],
                [
                  20,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  14
                ],
                [
                  2,
                  13
                ],
                [
                  3,
                  14
                ],
                [
                  2,
                  13
                ],
                [
                  3,
                  13
                ],
                [
                  2,
                  13
                ],
                [
                  2,
                  14
                ],
                [
                  3,
                  13
                ],
                [
                  1,
                  4
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -5,
                  4
                ],
                [
                  -5,
                  3
                ],
                [
                  -6,
                  4
                ],
                [
                  -5,
                  4
                ],
                [
                  -5,
                  4
                ],
                [
                  -5,
                  3
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  3
                ],
                [
                  0,
                  5
                ],
                [
                  -1,
                  13
                ],
                [
                  -2,
                  12
                ],
                [
                  -1,
                  13
                ],
                [
                  -1,
                  12
                ],
                [
                  -2,
                  13
                ],
                [
                  -1,
                  12
                ],
                [
                  -1,
                  13
                ],
                [
                  -1,
                  12
                ],
                [
                  -2,
                  13
                ],
                [
                  -1,
                  12
                ],
                [
                  -1,
                  13
                ],
                [
                  -2,
                  12
                ],
                [
                  -1,
                  13
                ],
                [
                  -1,
                  12
                ],
                [
                  -1,
                  13
                ],
                [
                  -2,
                  12
                ],
                [
                  -1,
                  13
                ],
                [
                  -1,
                  13
                ],
                [
                  -2,
                  13
                ],
                [
                  -1,
                  13
                ],
                [
                  -1,
                  13
                ],
                [
                  -2,
                  12
                ],
                [
                  -1,
                  13
                ],
                [
                  -1,
                  13
                ],
                [
                  -2,
                  13
                ],
                [
                  -1,
                  13
                ],
                [
                  -1,
                  13
                ],
                [
                  -2,
                  12
                ],
                [
                  -1,
                  9
                ],
                [
                  0,
                  8
                ],
                [
                  -1,
                  8
                ],
                [
                  -1,
                  8
                ],
                [
                  -2,
                  19
                ],
                [
                  -2,
                  17
                ],
                [
                  -2,
                  18
                ],
                [
                  -2,
                  17
                ],
                [
                  -1,
                  17
                ],
                [
                  -2,
                  17
                ],
                [
                  -2,
                  18
                ],
                [
                  -2,
                  17
                ],
                [
                  -2,
                  17
                ],
                [
                  -2,
                  15
                ],
                [
                  -1,
                  8
                ],
                [
                  -1,
                  18
                ],
                [
                  -2,
                  18
                ],
                [
                  -1,
                  8
                ],
                [
                  -2,
                  17
                ],
                [
                  -2,
                  17
                ],
                [
                  -2,
                  16
                ],
                [
                  -2,
                  17
                ],
                [
                  -2,
                  17
                ],
                [
                  -1,
                  17
                ],
                [
                  -2,
                  16
                ],
                [
                  -2,
                  17
                ],
                [
                  -2,
                  17
                ],
                [
                  -2,
                  16
                ],
                [
                  -2,
                  17
                ],
                [
                  -1,
                  17
                ],
                [
                  -2,
                  17
                ],
                [
                  -2,
                  16
                ],
                [
                  -2,
                  17
                ],
                [
                  -2,
                  17
                ],
                [
                  -2,
                  17
                ],
                [
                  -1,
                  13
                ],
                [
                  0,
                  3
                ],
                [
                  -2,
                  17
                ],
                [
                  -2,
                  17
                ],
                [
                  -2,
                  16
                ],
                [
                  -2,
                  17
                ],
                [
                  -2,
                  17
                ],
                [
                  -1,
                  17
                ],
                [
                  -1,
                  8
                ],
                [
                  -2,
                  19
                ],
                [
                  -3,
                  19
                ],
                [
                  0,
                  8
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  11
                ],
                [
                  -1,
                  11
                ],
                [
                  -1,
                  12
                ],
                [
                  -2,
                  11
                ],
                [
                  -1,
                  11
                ],
                [
                  -1,
                  11
                ],
                [
                  -1,
                  11
                ],
                [
                  -2,
                  11
                ],
                [
                  -1,
                  11
                ],
                [
                  29,
                  0
                ],
                [
                  29,
                  0
                ],
                [
                  29,
                  0
                ],
                [
                  28,
                  0
                ],
                [
                  29,
                  0
                ],
                [
                  29,
                  0
                ],
                [
                  29,
                  0
                ],
                [
                  29,
                  0
                ]
              ],
              [
                [
                  7597,
                  1221
                ],
                [
                  -1,
                  -4
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  -4
                ],
                [
                  -1,
                  4
                ],
                [
                  3,
                  4
                ],
                [
                  5,
                  3
                ],
                [
                  3,
                  2
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -4
                ]
              ],
              [
                [
                  7920,
                  1807
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  11
                ],
                [
                  4,
                  17
                ],
                [
                  2,
                  3
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -3
                ],
                [
                  1,
                  -3
                ],
                [
                  -1,
                  -10
                ],
                [
                  -5,
                  -19
                ]
              ],
              [
                [
                  8500,
                  2551
                ],
                [
                  -4,
                  -1
                ],
                [
                  -3,
                  1
                ],
                [
                  -3,
                  3
                ],
                [
                  -2,
                  4
                ],
                [
                  1,
                  6
                ],
                [
                  1,
                  2
                ],
                [
                  4,
                  2
                ],
                [
                  6,
                  2
                ],
                [
                  5,
                  -1
                ],
                [
                  0,
                  -3
                ],
                [
                  0,
                  -3
                ],
                [
                  -4,
                  -4
                ],
                [
                  -1,
                  -4
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -2
                ]
              ],
              [
                [
                  7587,
                  1105
                ],
                [
                  -21,
                  0
                ],
                [
                  -18,
                  -1
                ],
                [
                  -17,
                  0
                ],
                [
                  -15,
                  -1
                ],
                [
                  -7,
                  1
                ],
                [
                  -10,
                  2
                ],
                [
                  -3,
                  0
                ],
                [
                  -7,
                  -1
                ],
                [
                  -4,
                  1
                ]
              ],
              [
                [
                  7485,
                  1106
                ],
                [
                  1,
                  36
                ],
                [
                  -2,
                  11
                ],
                [
                  -6,
                  12
                ],
                [
                  -1,
                  4
                ],
                [
                  -2,
                  14
                ],
                [
                  1,
                  4
                ],
                [
                  4,
                  11
                ],
                [
                  1,
                  4
                ],
                [
                  -1,
                  4
                ],
                [
                  -2,
                  6
                ],
                [
                  0,
                  5
                ],
                [
                  1,
                  4
                ],
                [
                  -8,
                  2
                ],
                [
                  -4,
                  2
                ],
                [
                  -3,
                  3
                ]
              ],
              [
                [
                  7464,
                  1228
                ],
                [
                  -5,
                  16
                ],
                [
                  -1,
                  4
                ],
                [
                  1,
                  4
                ],
                [
                  5,
                  14
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  -2,
                  8
                ],
                [
                  0,
                  3
                ],
                [
                  -2,
                  3
                ],
                [
                  0,
                  4
                ],
                [
                  0,
                  5
                ],
                [
                  1,
                  3
                ],
                [
                  2,
                  7
                ],
                [
                  0,
                  30
                ],
                [
                  -1,
                  22
                ],
                [
                  0,
                  17
                ],
                [
                  0,
                  23
                ],
                [
                  0,
                  20
                ],
                [
                  1,
                  9
                ],
                [
                  -1,
                  11
                ],
                [
                  -3,
                  10
                ],
                [
                  -4,
                  10
                ],
                [
                  -8,
                  16
                ],
                [
                  -1,
                  6
                ],
                [
                  0,
                  22
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  -2,
                  2
                ],
                [
                  -8,
                  6
                ],
                [
                  -3,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  -6,
                  12
                ],
                [
                  -5,
                  18
                ],
                [
                  -2,
                  5
                ],
                [
                  -13,
                  13
                ],
                [
                  -2,
                  5
                ],
                [
                  -1,
                  5
                ],
                [
                  3,
                  32
                ],
                [
                  -1,
                  4
                ],
                [
                  -9,
                  28
                ],
                [
                  -5,
                  16
                ],
                [
                  -7,
                  21
                ],
                [
                  -7,
                  20
                ],
                [
                  -6,
                  18
                ],
                [
                  2,
                  2
                ]
              ],
              [
                [
                  7378,
                  1721
                ],
                [
                  10,
                  8
                ],
                [
                  9,
                  6
                ],
                [
                  6,
                  7
                ],
                [
                  7,
                  8
                ],
                [
                  7,
                  7
                ],
                [
                  7,
                  8
                ],
                [
                  7,
                  7
                ],
                [
                  6,
                  8
                ],
                [
                  7,
                  7
                ],
                [
                  7,
                  8
                ],
                [
                  7,
                  7
                ],
                [
                  7,
                  8
                ],
                [
                  7,
                  7
                ],
                [
                  6,
                  8
                ],
                [
                  7,
                  8
                ],
                [
                  7,
                  7
                ],
                [
                  7,
                  8
                ],
                [
                  7,
                  7
                ],
                [
                  7,
                  8
                ],
                [
                  6,
                  7
                ],
                [
                  4,
                  5
                ],
                [
                  5,
                  -3
                ],
                [
                  0,
                  1
                ],
                [
                  -9,
                  16
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  10,
                  12
                ],
                [
                  6,
                  9
                ],
                [
                  3,
                  6
                ],
                [
                  1,
                  5
                ],
                [
                  -2,
                  15
                ],
                [
                  -2,
                  14
                ],
                [
                  1,
                  6
                ],
                [
                  1,
                  6
                ],
                [
                  4,
                  5
                ],
                [
                  6,
                  1
                ],
                [
                  6,
                  -1
                ],
                [
                  5,
                  1
                ],
                [
                  4,
                  4
                ],
                [
                  4,
                  8
                ],
                [
                  4,
                  8
                ],
                [
                  9,
                  11
                ],
                [
                  5,
                  7
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  4
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  6
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  4
                ],
                [
                  1,
                  1
                ],
                [
                  7,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  4
                ],
                [
                  1,
                  10
                ],
                [
                  2,
                  8
                ],
                [
                  0,
                  6
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  2
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  1,
                  5
                ],
                [
                  -1,
                  3
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -4,
                  -4
                ],
                [
                  -3,
                  0
                ],
                [
                  -3,
                  0
                ],
                [
                  -3,
                  0
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  10
                ],
                [
                  0,
                  3
                ],
                [
                  -1,
                  3
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -3,
                  0
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  5
                ],
                [
                  0,
                  4
                ],
                [
                  0,
                  2
                ],
                [
                  5,
                  5
                ],
                [
                  2,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  4
                ],
                [
                  4,
                  17
                ],
                [
                  -1,
                  5
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -8,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  8
                ],
                [
                  0,
                  1
                ],
                [
                  13,
                  6
                ],
                [
                  4,
                  1
                ],
                [
                  5,
                  -1
                ],
                [
                  4,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  4
                ],
                [
                  0,
                  5
                ],
                [
                  -1,
                  3
                ],
                [
                  -4,
                  8
                ],
                [
                  -1,
                  5
                ],
                [
                  -1,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  2
                ],
                [
                  3,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  3
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  -1
                ],
                [
                  3,
                  5
                ],
                [
                  3,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  -2,
                  2
                ],
                [
                  -6,
                  5
                ],
                [
                  -2,
                  3
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  5
                ],
                [
                  -5,
                  14
                ],
                [
                  0,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  -2,
                  4
                ],
                [
                  0,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  3
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  2
                ],
                [
                  1,
                  5
                ],
                [
                  0,
                  6
                ],
                [
                  0,
                  6
                ],
                [
                  2,
                  5
                ],
                [
                  1,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  -2,
                  3
                ],
                [
                  -5,
                  2
                ],
                [
                  -2,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  5
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  5,
                  10
                ],
                [
                  2,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -3,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  3
                ],
                [
                  0,
                  3
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  6
                ],
                [
                  -1,
                  8
                ],
                [
                  -4,
                  8
                ],
                [
                  -5,
                  10
                ],
                [
                  -8,
                  13
                ],
                [
                  0,
                  1
                ],
                [
                  10,
                  10
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  5
                ],
                [
                  3,
                  14
                ],
                [
                  1,
                  4
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -4,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -4,
                  0
                ],
                [
                  -8,
                  2
                ],
                [
                  -5,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -4,
                  3
                ],
                [
                  -1,
                  5
                ],
                [
                  0,
                  3
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -16,
                  6
                ],
                [
                  -20,
                  9
                ],
                [
                  -14,
                  5
                ],
                [
                  -10,
                  2
                ],
                [
                  -26,
                  -1
                ],
                [
                  -13,
                  2
                ],
                [
                  -3,
                  1
                ],
                [
                  -1,
                  3
                ],
                [
                  0,
                  5
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  2
                ],
                [
                  -5,
                  3
                ],
                [
                  -3,
                  2
                ],
                [
                  -8,
                  9
                ],
                [
                  -3,
                  3
                ],
                [
                  -4,
                  1
                ],
                [
                  -21,
                  2
                ],
                [
                  -5,
                  2
                ],
                [
                  -2,
                  2
                ],
                [
                  -3,
                  0
                ],
                [
                  -3,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -3,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -3,
                  5
                ],
                [
                  -2,
                  2
                ],
                [
                  -2,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -13,
                  3
                ],
                [
                  -6,
                  0
                ],
                [
                  -3,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -3,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -3,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  2
                ],
                [
                  -3,
                  2
                ],
                [
                  -5,
                  4
                ],
                [
                  -6,
                  1
                ],
                [
                  -14,
                  0
                ],
                [
                  -21,
                  0
                ],
                [
                  -9,
                  0
                ],
                [
                  -15,
                  0
                ],
                [
                  0,
                  9
                ],
                [
                  0,
                  17
                ],
                [
                  0,
                  13
                ],
                [
                  -1,
                  11
                ]
              ],
              [
                [
                  7261,
                  2658
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  -2,
                  4
                ],
                [
                  -1,
                  2
                ],
                [
                  -3,
                  4
                ],
                [
                  -1,
                  2
                ],
                [
                  1,
                  3
                ],
                [
                  3,
                  4
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  3
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  9
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -5,
                  3
                ],
                [
                  -3,
                  6
                ],
                [
                  -5,
                  18
                ],
                [
                  0,
                  6
                ],
                [
                  0,
                  6
                ],
                [
                  -1,
                  4
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  11,
                  1
                ],
                [
                  10,
                  5
                ],
                [
                  12,
                  6
                ],
                [
                  14,
                  5
                ],
                [
                  11,
                  5
                ],
                [
                  18,
                  7
                ],
                [
                  13,
                  3
                ],
                [
                  18,
                  4
                ],
                [
                  3,
                  0
                ],
                [
                  13,
                  4
                ],
                [
                  17,
                  4
                ],
                [
                  14,
                  3
                ],
                [
                  11,
                  4
                ],
                [
                  12,
                  7
                ],
                [
                  9,
                  5
                ],
                [
                  18,
                  6
                ],
                [
                  18,
                  6
                ],
                [
                  13,
                  5
                ],
                [
                  9,
                  4
                ],
                [
                  5,
                  2
                ],
                [
                  11,
                  2
                ],
                [
                  12,
                  4
                ],
                [
                  14,
                  5
                ],
                [
                  19,
                  7
                ],
                [
                  22,
                  8
                ],
                [
                  23,
                  8
                ],
                [
                  16,
                  6
                ],
                [
                  11,
                  4
                ],
                [
                  10,
                  3
                ]
              ],
              [
                [
                  7627,
                  2883
                ],
                [
                  7,
                  -4
                ],
                [
                  3,
                  -2
                ],
                [
                  1,
                  -4
                ],
                [
                  0,
                  -7
                ],
                [
                  0,
                  -3
                ],
                [
                  4,
                  -5
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  2,
                  -4
                ],
                [
                  2,
                  -3
                ],
                [
                  7,
                  -14
                ],
                [
                  2,
                  -3
                ],
                [
                  2,
                  -1
                ],
                [
                  5,
                  -3
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  4,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -5
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  3,
                  -1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  5
                ],
                [
                  2,
                  4
                ],
                [
                  2,
                  3
                ],
                [
                  2,
                  1
                ],
                [
                  7,
                  -5
                ],
                [
                  4,
                  -1
                ],
                [
                  4,
                  2
                ],
                [
                  7,
                  4
                ],
                [
                  4,
                  1
                ],
                [
                  4,
                  0
                ],
                [
                  13,
                  -2
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  4
                ],
                [
                  1,
                  1
                ],
                [
                  4,
                  2
                ],
                [
                  9,
                  0
                ],
                [
                  13,
                  5
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -3
                ],
                [
                  4,
                  -9
                ],
                [
                  3,
                  -4
                ],
                [
                  7,
                  -7
                ],
                [
                  2,
                  -4
                ],
                [
                  0,
                  -5
                ],
                [
                  -1,
                  -8
                ],
                [
                  1,
                  -5
                ],
                [
                  2,
                  -4
                ],
                [
                  1,
                  -4
                ],
                [
                  1,
                  -5
                ],
                [
                  0,
                  -10
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  -3,
                  -4
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  0,
                  -3
                ],
                [
                  2,
                  -10
                ],
                [
                  1,
                  -10
                ],
                [
                  -1,
                  -4
                ],
                [
                  -2,
                  -3
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -3,
                  -5
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  0,
                  -5
                ],
                [
                  1,
                  -8
                ],
                [
                  0,
                  -6
                ],
                [
                  -2,
                  -4
                ],
                [
                  -8,
                  -12
                ],
                [
                  -1,
                  -1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  -4,
                  -4
                ],
                [
                  -1,
                  -3
                ],
                [
                  -1,
                  -5
                ],
                [
                  0,
                  -5
                ],
                [
                  1,
                  -4
                ],
                [
                  2,
                  -1
                ],
                [
                  4,
                  -2
                ],
                [
                  2,
                  -2
                ],
                [
                  11,
                  -11
                ],
                [
                  2,
                  -3
                ],
                [
                  1,
                  -4
                ],
                [
                  -3,
                  -9
                ],
                [
                  0,
                  -5
                ],
                [
                  5,
                  -12
                ],
                [
                  3,
                  -3
                ],
                [
                  4,
                  0
                ],
                [
                  6,
                  -1
                ],
                [
                  3,
                  -3
                ],
                [
                  4,
                  -10
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  4,
                  -4
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  2,
                  -4
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  8,
                  -4
                ],
                [
                  2,
                  -2
                ],
                [
                  2,
                  -5
                ],
                [
                  1,
                  -2
                ],
                [
                  6,
                  -5
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -3
                ],
                [
                  2,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -3
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  3,
                  -3
                ],
                [
                  4,
                  -3
                ],
                [
                  3,
                  -1
                ],
                [
                  4,
                  1
                ],
                [
                  4,
                  0
                ],
                [
                  3,
                  -3
                ],
                [
                  2,
                  -4
                ],
                [
                  0,
                  -5
                ],
                [
                  -1,
                  -4
                ],
                [
                  -1,
                  -4
                ],
                [
                  -3,
                  -2
                ],
                [
                  -3,
                  -2
                ],
                [
                  -3,
                  -2
                ],
                [
                  -1,
                  -5
                ],
                [
                  4,
                  -6
                ],
                [
                  0,
                  -4
                ],
                [
                  2,
                  -2
                ],
                [
                  6,
                  -1
                ],
                [
                  14,
                  0
                ],
                [
                  7,
                  0
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  -1,
                  5
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -4,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  5
                ],
                [
                  0,
                  3
                ],
                [
                  3,
                  3
                ],
                [
                  0,
                  3
                ],
                [
                  -3,
                  6
                ],
                [
                  0,
                  3
                ],
                [
                  -1,
                  9
                ],
                [
                  -3,
                  4
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -3,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  3
                ],
                [
                  -2,
                  6
                ],
                [
                  2,
                  2
                ],
                [
                  9,
                  6
                ],
                [
                  2,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  6
                ],
                [
                  1,
                  2
                ],
                [
                  3,
                  4
                ],
                [
                  1,
                  1
                ],
                [
                  -2,
                  4
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  6
                ],
                [
                  2,
                  5
                ],
                [
                  3,
                  4
                ],
                [
                  1,
                  1
                ],
                [
                  9,
                  8
                ],
                [
                  2,
                  2
                ],
                [
                  3,
                  1
                ],
                [
                  3,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  3,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  3
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  1
                ],
                [
                  12,
                  4
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  9,
                  7
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  -1,
                  4
                ],
                [
                  0,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  5
                ],
                [
                  1,
                  20
                ],
                [
                  1,
                  12
                ],
                [
                  1,
                  18
                ],
                [
                  1,
                  11
                ],
                [
                  0,
                  6
                ],
                [
                  -3,
                  15
                ],
                [
                  -3,
                  13
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  4
                ],
                [
                  1,
                  3
                ],
                [
                  6,
                  15
                ],
                [
                  4,
                  9
                ],
                [
                  5,
                  12
                ],
                [
                  -3,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  29
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  2
                ],
                [
                  -7,
                  6
                ],
                [
                  -4,
                  7
                ],
                [
                  -5,
                  6
                ],
                [
                  -14,
                  18
                ],
                [
                  -11,
                  15
                ],
                [
                  -9,
                  17
                ],
                [
                  -11,
                  14
                ],
                [
                  -12,
                  15
                ],
                [
                  -14,
                  17
                ],
                [
                  -11,
                  14
                ],
                [
                  -11,
                  11
                ],
                [
                  -14,
                  12
                ],
                [
                  -4,
                  3
                ],
                [
                  -4,
                  2
                ],
                [
                  -5,
                  0
                ],
                [
                  -16,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -3,
                  5
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  3
                ],
                [
                  -1,
                  0
                ],
                [
                  -4,
                  10
                ],
                [
                  -1,
                  12
                ],
                [
                  1,
                  11
                ],
                [
                  -1,
                  14
                ],
                [
                  -2,
                  17
                ],
                [
                  -2,
                  19
                ],
                [
                  -2,
                  16
                ],
                [
                  -7,
                  26
                ],
                [
                  -8,
                  29
                ],
                [
                  -3,
                  12
                ],
                [
                  0,
                  7
                ],
                [
                  3,
                  7
                ],
                [
                  14,
                  22
                ],
                [
                  10,
                  15
                ],
                [
                  5,
                  14
                ],
                [
                  1,
                  6
                ],
                [
                  1,
                  5
                ],
                [
                  -1,
                  6
                ],
                [
                  0,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  5,
                  2
                ],
                [
                  40,
                  -1
                ]
              ],
              [
                [
                  7856,
                  3221
                ],
                [
                  55,
                  0
                ],
                [
                  5,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  4,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  2
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  2
                ],
                [
                  7,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  0,
                  3
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  -1,
                  3
                ],
                [
                  2,
                  2
                ],
                [
                  6,
                  1
                ],
                [
                  3,
                  2
                ],
                [
                  4,
                  5
                ],
                [
                  2,
                  1
                ],
                [
                  5,
                  -1
                ],
                [
                  4,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  5,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  -3
                ],
                [
                  -1,
                  -3
                ],
                [
                  1,
                  -3
                ],
                [
                  3,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  -2
                ],
                [
                  5,
                  -3
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -3
                ],
                [
                  1,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  6,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  1
                ],
                [
                  5,
                  1
                ],
                [
                  4,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  16,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -4
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  3,
                  -1
                ],
                [
                  3,
                  -1
                ],
                [
                  8,
                  2
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  5,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  4,
                  6
                ],
                [
                  6,
                  7
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  -1
                ],
                [
                  3,
                  0
                ],
                [
                  3,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  12,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  -4
                ],
                [
                  4,
                  -5
                ],
                [
                  4,
                  -4
                ],
                [
                  5,
                  -2
                ],
                [
                  11,
                  -3
                ],
                [
                  6,
                  0
                ],
                [
                  4,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  -3
                ],
                [
                  1,
                  -1
                ],
                [
                  6,
                  -2
                ],
                [
                  3,
                  0
                ],
                [
                  3,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  5,
                  2
                ],
                [
                  3,
                  1
                ],
                [
                  4,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  2,
                  2
                ],
                [
                  6,
                  5
                ],
                [
                  9,
                  4
                ],
                [
                  3,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  1,
                  3
                ],
                [
                  3,
                  6
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  6
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  9,
                  5
                ],
                [
                  2,
                  1
                ],
                [
                  5,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  2
                ],
                [
                  8,
                  1
                ],
                [
                  3,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  6,
                  -1
                ],
                [
                  5,
                  -3
                ],
                [
                  7,
                  -8
                ],
                [
                  5,
                  -3
                ],
                [
                  10,
                  -2
                ],
                [
                  4,
                  -3
                ],
                [
                  3,
                  5
                ],
                [
                  13,
                  9
                ],
                [
                  3,
                  4
                ],
                [
                  2,
                  1
                ],
                [
                  4,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  5,
                  6
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  3
                ],
                [
                  5,
                  1
                ],
                [
                  17,
                  0
                ],
                [
                  4,
                  1
                ],
                [
                  4,
                  2
                ],
                [
                  3,
                  0
                ],
                [
                  6,
                  -3
                ],
                [
                  2,
                  -1
                ],
                [
                  4,
                  -1
                ],
                [
                  3,
                  2
                ],
                [
                  3,
                  1
                ],
                [
                  26,
                  22
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  10,
                  0
                ],
                [
                  22,
                  5
                ],
                [
                  3,
                  2
                ],
                [
                  13,
                  9
                ],
                [
                  14,
                  6
                ],
                [
                  2,
                  2
                ],
                [
                  16,
                  13
                ],
                [
                  4,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  3
                ],
                [
                  8,
                  9
                ],
                [
                  5,
                  3
                ],
                [
                  8,
                  3
                ],
                [
                  5,
                  4
                ],
                [
                  4,
                  4
                ],
                [
                  2,
                  4
                ]
              ],
              [
                [
                  8569,
                  3373
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  2,
                  0
                ],
                [
                  4,
                  3
                ],
                [
                  2,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -3
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  3,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -5
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  5,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -5,
                  1
                ],
                [
                  -5,
                  -1
                ],
                [
                  -11,
                  -9
                ],
                [
                  1,
                  -5
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  -3
                ],
                [
                  10,
                  -5
                ],
                [
                  2,
                  -2
                ],
                [
                  -3,
                  -3
                ],
                [
                  -7,
                  -4
                ],
                [
                  -2,
                  -2
                ],
                [
                  -3,
                  -3
                ],
                [
                  -1,
                  -4
                ],
                [
                  1,
                  -5
                ],
                [
                  -1,
                  -5
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  3
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  -1
                ],
                [
                  0,
                  -4
                ],
                [
                  -2,
                  -5
                ],
                [
                  -2,
                  -3
                ],
                [
                  -4,
                  -4
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -3
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  -3
                ],
                [
                  -8,
                  -6
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  -5
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -3,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  3
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  2,
                  -3
                ],
                [
                  1,
                  -2
                ],
                [
                  4,
                  1
                ],
                [
                  1,
                  -4
                ],
                [
                  -1,
                  -5
                ],
                [
                  -1,
                  -5
                ],
                [
                  -2,
                  -4
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  2,
                  -3
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -3,
                  -3
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -5
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -3
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -7
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  -4,
                  -3
                ],
                [
                  -1,
                  -4
                ],
                [
                  1,
                  -5
                ],
                [
                  2,
                  -4
                ],
                [
                  4,
                  -6
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -5
                ],
                [
                  -2,
                  -7
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -3
                ],
                [
                  2,
                  -4
                ],
                [
                  1,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -3
                ],
                [
                  -1,
                  -3
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  3,
                  0
                ],
                [
                  3,
                  -2
                ],
                [
                  2,
                  -4
                ],
                [
                  1,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -3
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  4,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -3
                ],
                [
                  -3,
                  -5
                ],
                [
                  -1,
                  -2
                ],
                [
                  2,
                  -3
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  6,
                  -1
                ],
                [
                  0,
                  -10
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  4,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  -3,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -6
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  -3,
                  -1
                ],
                [
                  -3,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  -4,
                  1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -3
                ],
                [
                  -2,
                  -4
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -4,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -3
                ],
                [
                  1,
                  -2
                ],
                [
                  6,
                  -6
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  3
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  -2
                ],
                [
                  -1,
                  -5
                ],
                [
                  -3,
                  -8
                ],
                [
                  -1,
                  -4
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -4
                ],
                [
                  0,
                  -3
                ],
                [
                  -1,
                  -10
                ],
                [
                  -1,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  3
                ],
                [
                  0,
                  -11
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  -1,
                  -4
                ],
                [
                  -4,
                  -4
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -6
                ],
                [
                  -1,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  2,
                  -2
                ],
                [
                  2,
                  -3
                ],
                [
                  2,
                  -2
                ],
                [
                  3,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  -4,
                  -4
                ],
                [
                  -2,
                  -3
                ],
                [
                  1,
                  -3
                ],
                [
                  3,
                  -8
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -17
                ],
                [
                  2,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  2,
                  -3
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -4
                ],
                [
                  2,
                  -6
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -4
                ],
                [
                  -1,
                  -2
                ],
                [
                  -5,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -4,
                  0
                ],
                [
                  -4,
                  -3
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -3
                ],
                [
                  -1,
                  -4
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  4
                ],
                [
                  3,
                  3
                ],
                [
                  7,
                  3
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -3
                ],
                [
                  -1,
                  -4
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -3
                ],
                [
                  1,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -3,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  3,
                  -15
                ],
                [
                  -3,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  -3,
                  -3
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  -1,
                  -6
                ],
                [
                  0,
                  -3
                ],
                [
                  3,
                  3
                ],
                [
                  2,
                  3
                ],
                [
                  3,
                  12
                ],
                [
                  1,
                  1
                ],
                [
                  8,
                  4
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  -1
                ],
                [
                  4,
                  -3
                ],
                [
                  2,
                  -4
                ],
                [
                  -2,
                  -5
                ],
                [
                  -1,
                  -1
                ],
                [
                  -4,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  -8
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  -2,
                  -8
                ],
                [
                  -1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -6,
                  -3
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -5,
                  -5
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  4
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  -3
                ],
                [
                  1,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  2,
                  -2
                ],
                [
                  3,
                  0
                ],
                [
                  6,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -8,
                  2
                ],
                [
                  -1,
                  -3
                ],
                [
                  2,
                  -4
                ],
                [
                  5,
                  -7
                ],
                [
                  -4,
                  -1
                ],
                [
                  -4,
                  -1
                ],
                [
                  -4,
                  -1
                ],
                [
                  -2,
                  -4
                ],
                [
                  -2,
                  0
                ],
                [
                  -3,
                  1
                ],
                [
                  -3,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -5
                ],
                [
                  -1,
                  -2
                ],
                [
                  5,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  4
                ],
                [
                  3,
                  2
                ],
                [
                  3,
                  0
                ],
                [
                  3,
                  -2
                ],
                [
                  2,
                  -3
                ],
                [
                  1,
                  -5
                ],
                [
                  -1,
                  -4
                ],
                [
                  -2,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  -5,
                  -6
                ],
                [
                  -1,
                  0
                ],
                [
                  1,
                  -3
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -3,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  2,
                  0
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -3,
                  1
                ],
                [
                  0,
                  -4
                ],
                [
                  -2,
                  -2
                ],
                [
                  -5,
                  -4
                ],
                [
                  -2,
                  -3
                ],
                [
                  -9,
                  -14
                ],
                [
                  -25,
                  -27
                ],
                [
                  -6,
                  -4
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  3,
                  1
                ],
                [
                  5,
                  5
                ],
                [
                  1,
                  -3
                ],
                [
                  -1,
                  -3
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  -3
                ],
                [
                  0,
                  -3
                ],
                [
                  -2,
                  -2
                ],
                [
                  -4,
                  -4
                ],
                [
                  -5,
                  -11
                ],
                [
                  -4,
                  -5
                ],
                [
                  -4,
                  -2
                ],
                [
                  -9,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -8,
                  -5
                ],
                [
                  -4,
                  -3
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -4
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -3
                ],
                [
                  2,
                  -3
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  -6,
                  -4
                ],
                [
                  -2,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  -4,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  -3,
                  -2
                ],
                [
                  -5,
                  -3
                ],
                [
                  -4,
                  -3
                ],
                [
                  -5,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -4,
                  -3
                ],
                [
                  -23,
                  -12
                ],
                [
                  -20,
                  -13
                ],
                [
                  -2,
                  -2
                ],
                [
                  -3,
                  -5
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  2
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -3,
                  -1
                ],
                [
                  3,
                  -1
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -3
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  -5,
                  0
                ],
                [
                  -5,
                  0
                ],
                [
                  -4,
                  0
                ],
                [
                  -7,
                  -5
                ],
                [
                  -5,
                  -2
                ],
                [
                  -21,
                  -2
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  3
                ],
                [
                  -2,
                  1
                ],
                [
                  3,
                  -4
                ],
                [
                  -3,
                  -3
                ],
                [
                  -4,
                  -2
                ],
                [
                  -5,
                  -1
                ],
                [
                  1,
                  3
                ],
                [
                  -6,
                  -7
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -36,
                  -15
                ],
                [
                  -2,
                  -2
                ],
                [
                  -3,
                  -3
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  3
                ],
                [
                  -1,
                  9
                ],
                [
                  -1,
                  3
                ],
                [
                  0,
                  -3
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  2,
                  -3
                ],
                [
                  3,
                  -3
                ],
                [
                  2,
                  -3
                ],
                [
                  -3,
                  -3
                ],
                [
                  2,
                  -1
                ],
                [
                  -3,
                  -3
                ],
                [
                  -8,
                  -3
                ],
                [
                  -17,
                  -4
                ],
                [
                  -7,
                  -4
                ],
                [
                  -17,
                  -12
                ],
                [
                  -2,
                  0
                ],
                [
                  1,
                  2
                ],
                [
                  -3,
                  -1
                ],
                [
                  -5,
                  -5
                ],
                [
                  -5,
                  -3
                ],
                [
                  -5,
                  0
                ],
                [
                  -3,
                  -3
                ],
                [
                  -17,
                  -10
                ],
                [
                  -3,
                  -4
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  -3
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -3,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  0,
                  -2
                ],
                [
                  -2,
                  -3
                ],
                [
                  -3,
                  -2
                ],
                [
                  -4,
                  -1
                ],
                [
                  -3,
                  1
                ],
                [
                  0,
                  -5
                ],
                [
                  -4,
                  -5
                ],
                [
                  -9,
                  -8
                ],
                [
                  -10,
                  -16
                ],
                [
                  -4,
                  -4
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  3
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  3
                ],
                [
                  -4,
                  2
                ],
                [
                  -3,
                  -1
                ],
                [
                  -2,
                  -4
                ],
                [
                  4,
                  3
                ],
                [
                  3,
                  -2
                ],
                [
                  2,
                  -5
                ],
                [
                  1,
                  -4
                ],
                [
                  0,
                  -5
                ],
                [
                  1,
                  -2
                ],
                [
                  5,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  -4,
                  -7
                ],
                [
                  -1,
                  -3
                ],
                [
                  -4,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -3
                ],
                [
                  -1,
                  -1
                ],
                [
                  -3,
                  0
                ],
                [
                  -3,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -3,
                  -4
                ],
                [
                  3,
                  1
                ],
                [
                  4,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  -2,
                  -3
                ],
                [
                  -9,
                  -11
                ],
                [
                  -5,
                  -4
                ],
                [
                  -13,
                  -15
                ],
                [
                  -6,
                  -6
                ],
                [
                  -4,
                  -1
                ],
                [
                  -1,
                  -5
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  2
                ],
                [
                  0,
                  -3
                ],
                [
                  1,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  -3
                ],
                [
                  -5,
                  -11
                ],
                [
                  -2,
                  -3
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -3
                ],
                [
                  -1,
                  -3
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -4
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -3,
                  1
                ],
                [
                  -3,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  3
                ],
                [
                  -5,
                  9
                ],
                [
                  0,
                  -5
                ],
                [
                  3,
                  -9
                ],
                [
                  1,
                  -5
                ],
                [
                  -2,
                  -5
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -4,
                  0
                ],
                [
                  -4,
                  -2
                ],
                [
                  -5,
                  0
                ],
                [
                  -2,
                  2
                ],
                [
                  0,
                  8
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -4,
                  -4
                ],
                [
                  -6,
                  -10
                ],
                [
                  -3,
                  -2
                ],
                [
                  -4,
                  0
                ],
                [
                  1,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -3,
                  -1
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  -1,
                  -2
                ],
                [
                  -19,
                  -13
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  -3
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  -2
                ],
                [
                  -3,
                  -5
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  -4,
                  -3
                ],
                [
                  -3,
                  -2
                ],
                [
                  -6,
                  -7
                ],
                [
                  2,
                  0
                ],
                [
                  -1,
                  -2
                ],
                [
                  -6,
                  -6
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -7,
                  -9
                ],
                [
                  -13,
                  -14
                ],
                [
                  -15,
                  -12
                ],
                [
                  -13,
                  -13
                ],
                [
                  -4,
                  -2
                ],
                [
                  -3,
                  -1
                ],
                [
                  -7,
                  -8
                ],
                [
                  -4,
                  -3
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -4,
                  -5
                ],
                [
                  -7,
                  -4
                ],
                [
                  -4,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  4
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -6,
                  5
                ],
                [
                  -6,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -6,
                  8
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  -4
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  2
                ],
                [
                  3,
                  1
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -4
                ],
                [
                  1,
                  -3
                ],
                [
                  7,
                  -10
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  3,
                  -4
                ],
                [
                  1,
                  -1
                ],
                [
                  -1,
                  -3
                ],
                [
                  -2,
                  -4
                ],
                [
                  -3,
                  -3
                ],
                [
                  -3,
                  1
                ],
                [
                  0,
                  -3
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -4
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -5
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -4
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -4,
                  3
                ],
                [
                  -3,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  3
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  10,
                  -6
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  -2,
                  -5
                ],
                [
                  0,
                  -1
                ],
                [
                  -3,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  3,
                  -3
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  2
                ],
                [
                  1,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  3,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  -6,
                  -5
                ],
                [
                  0,
                  -1
                ],
                [
                  4,
                  2
                ],
                [
                  3,
                  1
                ],
                [
                  2,
                  -1
                ],
                [
                  0,
                  -4
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  -3
                ],
                [
                  2,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  3,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -3
                ],
                [
                  1,
                  -1
                ],
                [
                  3,
                  2
                ],
                [
                  2,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  6,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  4,
                  -4
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -4
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  4,
                  -4
                ],
                [
                  2,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  3,
                  3
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  -1,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -4
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -3,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  -1,
                  -6
                ],
                [
                  4,
                  4
                ],
                [
                  3,
                  16
                ],
                [
                  1,
                  -2
                ],
                [
                  -1,
                  -9
                ],
                [
                  -1,
                  -4
                ],
                [
                  1,
                  -12
                ],
                [
                  4,
                  -11
                ],
                [
                  8,
                  -13
                ],
                [
                  1,
                  -3
                ],
                [
                  2,
                  -1
                ],
                [
                  4,
                  -9
                ],
                [
                  1,
                  -6
                ],
                [
                  -1,
                  -12
                ],
                [
                  1,
                  -6
                ],
                [
                  4,
                  -9
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -9
                ],
                [
                  2,
                  -6
                ],
                [
                  1,
                  -12
                ],
                [
                  -4,
                  -35
                ],
                [
                  0,
                  -6
                ],
                [
                  1,
                  -4
                ],
                [
                  1,
                  -1
                ],
                [
                  3,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -5
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  6
                ],
                [
                  1,
                  3
                ],
                [
                  3,
                  1
                ],
                [
                  -3,
                  5
                ],
                [
                  -2,
                  7
                ],
                [
                  0,
                  7
                ],
                [
                  2,
                  5
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  -4
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  2
                ],
                [
                  -3,
                  6
                ],
                [
                  -1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  4
                ],
                [
                  1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -3
                ],
                [
                  2,
                  -23
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  8
                ],
                [
                  2,
                  3
                ],
                [
                  0,
                  3
                ],
                [
                  1,
                  0
                ],
                [
                  -2,
                  -17
                ],
                [
                  0,
                  -3
                ],
                [
                  1,
                  -9
                ],
                [
                  0,
                  -3
                ],
                [
                  -7,
                  -22
                ],
                [
                  0,
                  -17
                ],
                [
                  4,
                  -30
                ],
                [
                  2,
                  -6
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  3,
                  -1
                ],
                [
                  -1,
                  -4
                ],
                [
                  -5,
                  -10
                ],
                [
                  -2,
                  -4
                ],
                [
                  -5,
                  -12
                ],
                [
                  -3,
                  -4
                ],
                [
                  -1,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -3
                ],
                [
                  1,
                  -5
                ],
                [
                  1,
                  -3
                ],
                [
                  -1,
                  -6
                ],
                [
                  -8,
                  -23
                ],
                [
                  -2,
                  -18
                ],
                [
                  0,
                  -12
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  -4,
                  1
                ],
                [
                  -2,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -6
                ],
                [
                  0,
                  -3
                ],
                [
                  0,
                  -4
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  6,
                  8
                ],
                [
                  -2,
                  4
                ],
                [
                  0,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  4,
                  -3
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  10
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  5,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  0,
                  -6
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  -8,
                  -24
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -3
                ],
                [
                  -1,
                  -3
                ],
                [
                  -20,
                  -29
                ],
                [
                  -15,
                  -15
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -9,
                  -9
                ],
                [
                  -38,
                  -20
                ],
                [
                  -22,
                  -10
                ],
                [
                  -21,
                  -6
                ],
                [
                  -1,
                  0
                ],
                [
                  -17,
                  -7
                ],
                [
                  -3,
                  -1
                ],
                [
                  -15,
                  -6
                ],
                [
                  -7,
                  -1
                ],
                [
                  -29,
                  -10
                ],
                [
                  -27,
                  -10
                ],
                [
                  -18,
                  -9
                ],
                [
                  -16,
                  -6
                ],
                [
                  -19,
                  -10
                ],
                [
                  -5,
                  -1
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -5,
                  -3
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -3,
                  0
                ],
                [
                  -3,
                  -1
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  -2,
                  -3
                ],
                [
                  -3,
                  -2
                ],
                [
                  -7,
                  -3
                ],
                [
                  -2,
                  -2
                ],
                [
                  -34,
                  -22
                ],
                [
                  -4,
                  -4
                ],
                [
                  -7,
                  -10
                ],
                [
                  -3,
                  -6
                ],
                [
                  -2,
                  -8
                ],
                [
                  -2,
                  -3
                ],
                [
                  1,
                  -7
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  -6,
                  -6
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -4,
                  -3
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  1
                ],
                [
                  -3,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -3,
                  0
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  -3
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  1,
                  4
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  3,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -4
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -4
                ],
                [
                  2,
                  -6
                ],
                [
                  1,
                  -3
                ],
                [
                  2,
                  2
                ],
                [
                  3,
                  0
                ],
                [
                  4,
                  -2
                ],
                [
                  2,
                  -2
                ],
                [
                  2,
                  -3
                ],
                [
                  2,
                  -3
                ],
                [
                  2,
                  -3
                ],
                [
                  2,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  -1,
                  4
                ],
                [
                  -1,
                  4
                ],
                [
                  1,
                  4
                ],
                [
                  2,
                  4
                ],
                [
                  1,
                  6
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  6,
                  2
                ],
                [
                  0,
                  -3
                ],
                [
                  -4,
                  -23
                ],
                [
                  -1,
                  -38
                ],
                [
                  -2,
                  -11
                ],
                [
                  -1,
                  -3
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -6
                ],
                [
                  0,
                  -11
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -4
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -1
                ]
              ],
              [
                [
                  7808,
                  3152
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  3
                ],
                [
                  1,
                  5
                ],
                [
                  -2,
                  4
                ],
                [
                  -3,
                  2
                ],
                [
                  -5,
                  -1
                ],
                [
                  -3,
                  -2
                ],
                [
                  1,
                  -3
                ],
                [
                  3,
                  -4
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -2
                ]
              ],
              [
                [
                  7817,
                  3155
                ],
                [
                  -1,
                  -4
                ],
                [
                  0,
                  -2
                ],
                [
                  2,
                  -3
                ],
                [
                  2,
                  -1
                ],
                [
                  3,
                  0
                ],
                [
                  3,
                  2
                ],
                [
                  2,
                  3
                ],
                [
                  2,
                  3
                ],
                [
                  0,
                  3
                ],
                [
                  -1,
                  3
                ],
                [
                  -2,
                  2
                ],
                [
                  -3,
                  1
                ],
                [
                  -3,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -6
                ]
              ],
              [
                [
                  1168,
                  7540
                ],
                [
                  -1,
                  0
                ],
                [
                  1,
                  3
                ],
                [
                  4,
                  8
                ],
                [
                  5,
                  7
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  -4
                ],
                [
                  -4,
                  -7
                ]
              ],
              [
                [
                  1157,
                  7552
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -3
                ],
                [
                  -1,
                  -2
                ]
              ],
              [
                [
                  1175,
                  7576
                ],
                [
                  -4,
                  -19
                ],
                [
                  -3,
                  -9
                ],
                [
                  -5,
                  -7
                ],
                [
                  -3,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  1,
                  3
                ],
                [
                  3,
                  5
                ],
                [
                  1,
                  1
                ],
                [
                  -1,
                  4
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  -2
                ],
                [
                  2,
                  5
                ],
                [
                  2,
                  3
                ],
                [
                  1,
                  -2
                ]
              ],
              [
                [
                  1161,
                  7675
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -5
                ]
              ],
              [
                [
                  1706,
                  6872
                ],
                [
                  -8,
                  6
                ],
                [
                  -8,
                  4
                ],
                [
                  -2,
                  2
                ],
                [
                  -5,
                  5
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  -3,
                  11
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  -7,
                  4
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -4,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -3,
                  1
                ],
                [
                  -4,
                  4
                ],
                [
                  -1,
                  1
                ],
                [
                  -4,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  4
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -3,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -3,
                  3
                ],
                [
                  -1,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  4,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  1
                ],
                [
                  -8,
                  6
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  5
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  4
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  0
                ],
                [
                  -4,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  5
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -3,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -3,
                  2
                ],
                [
                  -2,
                  0
                ],
                [
                  -4,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  4
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  4
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  -2,
                  3
                ],
                [
                  -2,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -3,
                  3
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  -2,
                  4
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -3,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -4,
                  -2
                ],
                [
                  -2,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  4
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -6,
                  -1
                ],
                [
                  -4,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -4,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  -3,
                  -4
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -6,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  3
                ],
                [
                  -1,
                  0
                ],
                [
                  -4,
                  3
                ],
                [
                  -8,
                  7
                ],
                [
                  -4,
                  6
                ],
                [
                  -3,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  3
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -5,
                  -1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -8,
                  3
                ],
                [
                  -3,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -4,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -5,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -5,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -4,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -5,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -22,
                  1
                ],
                [
                  -4,
                  -1
                ],
                [
                  -3,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  -3,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -14,
                  -2
                ],
                [
                  -2,
                  0
                ],
                [
                  -6,
                  1
                ],
                [
                  -4,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -6,
                  -2
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -3,
                  -5
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -5,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -3,
                  -3
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -5,
                  0
                ],
                [
                  -6,
                  2
                ],
                [
                  -2,
                  0
                ],
                [
                  -3,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -5,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -6,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -3,
                  0
                ],
                [
                  -3,
                  0
                ],
                [
                  -3,
                  2
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -4,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -5,
                  1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  -3,
                  -2
                ],
                [
                  -2,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -6
                ],
                [
                  -6,
                  -23
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  -5,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -10
                ],
                [
                  -2,
                  -5
                ],
                [
                  -2,
                  -6
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -15
                ],
                [
                  -2,
                  -8
                ],
                [
                  -3,
                  -5
                ]
              ],
              [
                [
                  1148,
                  7015
                ],
                [
                  2,
                  23
                ],
                [
                  0,
                  13
                ],
                [
                  -1,
                  28
                ],
                [
                  1,
                  9
                ],
                [
                  1,
                  2
                ],
                [
                  4,
                  7
                ],
                [
                  1,
                  7
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  4
                ],
                [
                  0,
                  15
                ],
                [
                  1,
                  6
                ],
                [
                  11,
                  27
                ],
                [
                  2,
                  5
                ],
                [
                  2,
                  9
                ],
                [
                  3,
                  5
                ],
                [
                  6,
                  9
                ],
                [
                  11,
                  24
                ],
                [
                  1,
                  4
                ],
                [
                  2,
                  2
                ],
                [
                  12,
                  40
                ],
                [
                  4,
                  17
                ],
                [
                  1,
                  18
                ],
                [
                  2,
                  22
                ],
                [
                  -2,
                  25
                ],
                [
                  -4,
                  48
                ],
                [
                  -1,
                  5
                ],
                [
                  -7,
                  15
                ],
                [
                  -3,
                  17
                ],
                [
                  -2,
                  6
                ],
                [
                  1,
                  3
                ],
                [
                  -1,
                  4
                ],
                [
                  -5,
                  19
                ],
                [
                  0,
                  2
                ],
                [
                  -4,
                  9
                ],
                [
                  -6,
                  9
                ],
                [
                  -7,
                  9
                ],
                [
                  -3,
                  3
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -3,
                  1
                ],
                [
                  -5,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  6
                ],
                [
                  0,
                  2
                ],
                [
                  -2,
                  3
                ],
                [
                  -2,
                  2
                ],
                [
                  -2,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  8,
                  -2
                ],
                [
                  7,
                  1
                ],
                [
                  6,
                  4
                ],
                [
                  5,
                  6
                ],
                [
                  3,
                  5
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  1
                ],
                [
                  -7,
                  -8
                ],
                [
                  -4,
                  -3
                ],
                [
                  5,
                  11
                ],
                [
                  -1,
                  -1
                ],
                [
                  -6,
                  -5
                ],
                [
                  -2,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  4,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  12,
                  19
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  2
                ],
                [
                  2,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  -3,
                  2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  8,
                  8
                ],
                [
                  2,
                  3
                ],
                [
                  1,
                  4
                ],
                [
                  0,
                  4
                ],
                [
                  -4,
                  7
                ],
                [
                  -2,
                  4
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  4
                ],
                [
                  2,
                  3
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -4,
                  6
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  2
                ],
                [
                  -4,
                  9
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  -5,
                  13
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  4
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -3,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  6,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  -3,
                  1
                ],
                [
                  -4,
                  -1
                ],
                [
                  -3,
                  0
                ],
                [
                  -1,
                  3
                ],
                [
                  1,
                  0
                ],
                [
                  -2,
                  4
                ],
                [
                  -1,
                  1
                ],
                [
                  -3,
                  1
                ],
                [
                  -1,
                  -6
                ],
                [
                  1,
                  -13
                ],
                [
                  -2,
                  -6
                ],
                [
                  -1,
                  3
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  4
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -5,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  -2,
                  2
                ],
                [
                  -3,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -3,
                  3
                ],
                [
                  -1,
                  6
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -3,
                  4
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  -2,
                  4
                ],
                [
                  -2,
                  3
                ],
                [
                  -2,
                  -1
                ],
                [
                  -4,
                  -6
                ],
                [
                  -5,
                  -8
                ],
                [
                  -2,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -6
                ],
                [
                  -1,
                  -4
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -5
                ],
                [
                  -1,
                  -3
                ],
                [
                  -2,
                  -2
                ]
              ],
              [
                [
                  1081,
                  7702
                ],
                [
                  -3,
                  15
                ],
                [
                  1,
                  4
                ],
                [
                  3,
                  13
                ],
                [
                  1,
                  4
                ],
                [
                  5,
                  16
                ],
                [
                  3,
                  13
                ],
                [
                  2,
                  12
                ],
                [
                  1,
                  1
                ],
                [
                  15,
                  0
                ],
                [
                  6,
                  0
                ],
                [
                  15,
                  0
                ],
                [
                  24,
                  0
                ],
                [
                  30,
                  0
                ],
                [
                  36,
                  0
                ],
                [
                  41,
                  0
                ],
                [
                  43,
                  0
                ],
                [
                  45,
                  0
                ],
                [
                  45,
                  0
                ],
                [
                  43,
                  0
                ],
                [
                  4,
                  0
                ],
                [
                  36,
                  0
                ],
                [
                  37,
                  1
                ],
                [
                  30,
                  0
                ],
                [
                  24,
                  0
                ],
                [
                  15,
                  0
                ],
                [
                  6,
                  0
                ],
                [
                  19,
                  0
                ],
                [
                  -2,
                  22
                ],
                [
                  0,
                  12
                ],
                [
                  -4,
                  57
                ],
                [
                  -2,
                  35
                ],
                [
                  -2,
                  35
                ],
                [
                  -2,
                  8
                ],
                [
                  -6,
                  18
                ],
                [
                  -2,
                  9
                ],
                [
                  2,
                  9
                ],
                [
                  4,
                  9
                ],
                [
                  11,
                  16
                ],
                [
                  3,
                  3
                ],
                [
                  13,
                  9
                ],
                [
                  16,
                  11
                ],
                [
                  14,
                  9
                ],
                [
                  8,
                  6
                ],
                [
                  8,
                  3
                ],
                [
                  22,
                  3
                ],
                [
                  5,
                  1
                ],
                [
                  28,
                  14
                ],
                [
                  14,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  5
                ],
                [
                  0,
                  11
                ],
                [
                  0,
                  11
                ],
                [
                  0,
                  10
                ],
                [
                  0,
                  11
                ],
                [
                  0,
                  10
                ],
                [
                  0,
                  11
                ],
                [
                  0,
                  10
                ],
                [
                  0,
                  11
                ],
                [
                  0,
                  10
                ],
                [
                  0,
                  10
                ],
                [
                  0,
                  11
                ],
                [
                  0,
                  10
                ],
                [
                  0,
                  11
                ],
                [
                  0,
                  10
                ],
                [
                  0,
                  11
                ],
                [
                  0,
                  10
                ],
                [
                  0,
                  11
                ],
                [
                  0,
                  10
                ],
                [
                  0,
                  11
                ],
                [
                  0,
                  10
                ],
                [
                  0,
                  11
                ],
                [
                  0,
                  10
                ],
                [
                  0,
                  11
                ],
                [
                  0,
                  10
                ],
                [
                  0,
                  11
                ],
                [
                  0,
                  10
                ],
                [
                  0,
                  11
                ],
                [
                  0,
                  10
                ],
                [
                  0,
                  10
                ],
                [
                  0,
                  11
                ],
                [
                  0,
                  10
                ],
                [
                  0,
                  11
                ],
                [
                  0,
                  10
                ],
                [
                  13,
                  0
                ],
                [
                  13,
                  0
                ],
                [
                  13,
                  0
                ],
                [
                  13,
                  0
                ],
                [
                  14,
                  0
                ],
                [
                  13,
                  0
                ],
                [
                  13,
                  0
                ],
                [
                  13,
                  0
                ],
                [
                  13,
                  0
                ],
                [
                  13,
                  0
                ],
                [
                  13,
                  0
                ],
                [
                  13,
                  0
                ],
                [
                  14,
                  0
                ],
                [
                  13,
                  0
                ],
                [
                  13,
                  0
                ],
                [
                  13,
                  0
                ],
                [
                  13,
                  0
                ],
                [
                  13,
                  0
                ],
                [
                  13,
                  0
                ],
                [
                  13,
                  0
                ],
                [
                  13,
                  0
                ],
                [
                  14,
                  0
                ],
                [
                  13,
                  0
                ],
                [
                  13,
                  0
                ],
                [
                  13,
                  0
                ],
                [
                  13,
                  0
                ],
                [
                  13,
                  0
                ],
                [
                  13,
                  0
                ],
                [
                  13,
                  0
                ],
                [
                  14,
                  0
                ],
                [
                  13,
                  0
                ],
                [
                  13,
                  0
                ],
                [
                  11,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  6
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  5
                ],
                [
                  0,
                  9
                ],
                [
                  0,
                  11
                ],
                [
                  0,
                  13
                ],
                [
                  0,
                  14
                ],
                [
                  0,
                  15
                ],
                [
                  0,
                  16
                ],
                [
                  0,
                  16
                ],
                [
                  0,
                  15
                ],
                [
                  0,
                  15
                ],
                [
                  0,
                  13
                ],
                [
                  0,
                  10
                ],
                [
                  0,
                  9
                ],
                [
                  0,
                  5
                ],
                [
                  0,
                  2
                ]
              ],
              [
                [
                  7627,
                  2883
                ],
                [
                  -2,
                  3
                ],
                [
                  -4,
                  8
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  -4
                ],
                [
                  -1,
                  -1
                ],
                [
                  -4,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  -4,
                  -6
                ],
                [
                  -3,
                  -1
                ],
                [
                  -3,
                  4
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  7
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -3,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  -7,
                  8
                ],
                [
                  -2,
                  2
                ],
                [
                  -4,
                  1
                ],
                [
                  -5,
                  1
                ],
                [
                  -3,
                  2
                ],
                [
                  -1,
                  4
                ],
                [
                  1,
                  1
                ],
                [
                  5,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -4,
                  7
                ],
                [
                  -4,
                  1
                ],
                [
                  -5,
                  1
                ],
                [
                  -4,
                  0
                ],
                [
                  -1,
                  5
                ],
                [
                  0,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  4,
                  3
                ],
                [
                  2,
                  1
                ],
                [
                  4,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  0
                ],
                [
                  4,
                  2
                ],
                [
                  2,
                  5
                ],
                [
                  2,
                  8
                ],
                [
                  2,
                  8
                ],
                [
                  2,
                  5
                ],
                [
                  4,
                  4
                ],
                [
                  4,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  -2,
                  3
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  2,
                  16
                ],
                [
                  4,
                  8
                ],
                [
                  0,
                  4
                ],
                [
                  -1,
                  3
                ],
                [
                  -3,
                  3
                ],
                [
                  -4,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  10
                ],
                [
                  0,
                  3
                ],
                [
                  2,
                  4
                ],
                [
                  5,
                  7
                ],
                [
                  4,
                  8
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  5
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  3,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  3,
                  2
                ],
                [
                  3,
                  3
                ],
                [
                  2,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  4,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  3,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -5,
                  2
                ],
                [
                  -9,
                  -3
                ],
                [
                  -5,
                  2
                ],
                [
                  -3,
                  4
                ],
                [
                  -2,
                  9
                ],
                [
                  -1,
                  5
                ],
                [
                  -2,
                  2
                ],
                [
                  -4,
                  3
                ],
                [
                  -1,
                  3
                ],
                [
                  0,
                  4
                ],
                [
                  1,
                  5
                ],
                [
                  5,
                  13
                ],
                [
                  1,
                  7
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  -2,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  2,
                  6
                ],
                [
                  0,
                  5
                ],
                [
                  -1,
                  22
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  2,
                  5
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  12
                ],
                [
                  2,
                  2
                ],
                [
                  3,
                  -3
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  9,
                  15
                ],
                [
                  2,
                  4
                ],
                [
                  1,
                  4
                ],
                [
                  -4,
                  7
                ],
                [
                  -3,
                  4
                ],
                [
                  -2,
                  3
                ],
                [
                  -2,
                  4
                ],
                [
                  -1,
                  4
                ],
                [
                  -1,
                  4
                ],
                [
                  0,
                  4
                ],
                [
                  -1,
                  5
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  4
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  4,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  6
                ],
                [
                  7,
                  7
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  5,
                  4
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  4
                ],
                [
                  -3,
                  0
                ],
                [
                  -2,
                  3
                ],
                [
                  -3,
                  6
                ],
                [
                  -1,
                  1
                ],
                [
                  -4,
                  4
                ],
                [
                  -1,
                  1
                ],
                [
                  -3,
                  9
                ],
                [
                  -1,
                  3
                ],
                [
                  1,
                  8
                ],
                [
                  0,
                  4
                ],
                [
                  -2,
                  2
                ],
                [
                  -3,
                  2
                ],
                [
                  -2,
                  4
                ],
                [
                  -3,
                  1
                ],
                [
                  -3,
                  2
                ],
                [
                  -2,
                  2
                ],
                [
                  -3,
                  3
                ],
                [
                  -10,
                  5
                ],
                [
                  -2,
                  2
                ],
                [
                  0,
                  4
                ],
                [
                  1,
                  3
                ],
                [
                  2,
                  7
                ],
                [
                  4,
                  6
                ],
                [
                  1,
                  3
                ],
                [
                  -1,
                  4
                ],
                [
                  -2,
                  6
                ],
                [
                  -1,
                  1
                ],
                [
                  -4,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  4
                ],
                [
                  -1,
                  2
                ],
                [
                  -3,
                  2
                ],
                [
                  -2,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  -2,
                  3
                ],
                [
                  -3,
                  2
                ],
                [
                  -7,
                  1
                ],
                [
                  -3,
                  1
                ],
                [
                  0,
                  -3
                ],
                [
                  -1,
                  -5
                ],
                [
                  -1,
                  -2
                ],
                [
                  -3,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  3
                ],
                [
                  2,
                  10
                ],
                [
                  0,
                  4
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  8
                ]
              ],
              [
                [
                  7590,
                  3521
                ],
                [
                  2,
                  2
                ],
                [
                  3,
                  2
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  -2
                ],
                [
                  7,
                  -6
                ],
                [
                  8,
                  -7
                ],
                [
                  1,
                  0
                ],
                [
                  4,
                  -1
                ],
                [
                  4,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  7,
                  -6
                ],
                [
                  2,
                  -2
                ],
                [
                  3,
                  -5
                ],
                [
                  1,
                  -3
                ],
                [
                  2,
                  -2
                ],
                [
                  3,
                  0
                ],
                [
                  5,
                  -1
                ],
                [
                  4,
                  1
                ],
                [
                  3,
                  2
                ],
                [
                  3,
                  2
                ],
                [
                  5,
                  -1
                ],
                [
                  4,
                  -1
                ],
                [
                  3,
                  -1
                ],
                [
                  4,
                  1
                ],
                [
                  3,
                  2
                ],
                [
                  4,
                  1
                ],
                [
                  4,
                  -3
                ],
                [
                  3,
                  -3
                ],
                [
                  3,
                  -2
                ],
                [
                  3,
                  -2
                ],
                [
                  4,
                  -2
                ],
                [
                  3,
                  -3
                ],
                [
                  2,
                  -3
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  1,
                  4
                ],
                [
                  0,
                  2
                ],
                [
                  -2,
                  7
                ],
                [
                  2,
                  3
                ],
                [
                  3,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  5,
                  -2
                ],
                [
                  4,
                  -3
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  5,
                  -5
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -3
                ],
                [
                  4,
                  -1
                ],
                [
                  12,
                  -14
                ],
                [
                  4,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -1
                ],
                [
                  3,
                  -3
                ],
                [
                  3,
                  -3
                ],
                [
                  13,
                  -17
                ],
                [
                  1,
                  -3
                ],
                [
                  4,
                  -6
                ],
                [
                  2,
                  -5
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -3
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -5
                ],
                [
                  4,
                  -10
                ],
                [
                  2,
                  -7
                ],
                [
                  1,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -3,
                  -16
                ],
                [
                  1,
                  -3
                ],
                [
                  2,
                  -4
                ],
                [
                  1,
                  -3
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -3
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -3
                ],
                [
                  2,
                  -3
                ],
                [
                  0,
                  -3
                ],
                [
                  -2,
                  -3
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  1,
                  -3
                ],
                [
                  -2,
                  -9
                ],
                [
                  0,
                  -6
                ],
                [
                  0,
                  -1
                ],
                [
                  -3,
                  -6
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  -3
                ],
                [
                  -1,
                  -4
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -6
                ],
                [
                  1,
                  -4
                ],
                [
                  1,
                  -2
                ],
                [
                  6,
                  -6
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -3
                ],
                [
                  2,
                  -3
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  3,
                  -5
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  6,
                  -2
                ],
                [
                  3,
                  -2
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -4
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -8
                ],
                [
                  0,
                  -1
                ]
              ],
              [
                [
                  9200,
                  3051
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  5
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -2
                ]
              ],
              [
                [
                  9175,
                  3070
                ],
                [
                  -1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  -2
                ],
                [
                  2,
                  -3
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  4,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  3,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -3
                ],
                [
                  -3,
                  -4
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -3
                ],
                [
                  -2,
                  -3
                ],
                [
                  -1,
                  -3
                ],
                [
                  3,
                  -3
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -3,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  -3
                ],
                [
                  3,
                  -2
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -4,
                  4
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  4
                ],
                [
                  0,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  6,
                  7
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  0
                ]
              ],
              [
                [
                  6348,
                  2380
                ],
                [
                  5,
                  2
                ],
                [
                  5,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  4,
                  0
                ],
                [
                  6,
                  1
                ],
                [
                  5,
                  2
                ],
                [
                  6,
                  1
                ],
                [
                  5,
                  1
                ],
                [
                  6,
                  1
                ],
                [
                  5,
                  1
                ],
                [
                  6,
                  2
                ],
                [
                  6,
                  1
                ],
                [
                  5,
                  1
                ],
                [
                  6,
                  1
                ],
                [
                  5,
                  1
                ],
                [
                  6,
                  1
                ],
                [
                  6,
                  2
                ],
                [
                  5,
                  1
                ],
                [
                  6,
                  1
                ],
                [
                  5,
                  1
                ],
                [
                  4,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  7,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  6,
                  2
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  6,
                  -2
                ],
                [
                  4,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  4,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  6,
                  0
                ],
                [
                  11,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  4,
                  1
                ],
                [
                  9,
                  -2
                ],
                [
                  4,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  3,
                  1
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -3
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  -3
                ],
                [
                  1,
                  -4
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  3,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  0,
                  -2
                ]
              ],
              [
                [
                  5905,
                  1395
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -7
                ],
                [
                  0,
                  -8
                ],
                [
                  0,
                  -8
                ],
                [
                  0,
                  -8
                ],
                [
                  0,
                  -7
                ],
                [
                  0,
                  -8
                ],
                [
                  0,
                  -8
                ],
                [
                  0,
                  -8
                ],
                [
                  0,
                  -7
                ],
                [
                  0,
                  -8
                ],
                [
                  0,
                  -8
                ],
                [
                  0,
                  -8
                ],
                [
                  0,
                  -8
                ],
                [
                  0,
                  -7
                ],
                [
                  0,
                  -8
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -6
                ],
                [
                  0,
                  -8
                ],
                [
                  0,
                  -7
                ],
                [
                  0,
                  -8
                ],
                [
                  0,
                  -8
                ],
                [
                  0,
                  -8
                ],
                [
                  0,
                  -7
                ],
                [
                  0,
                  -8
                ],
                [
                  0,
                  -8
                ],
                [
                  0,
                  -8
                ],
                [
                  0,
                  -8
                ],
                [
                  0,
                  -7
                ],
                [
                  0,
                  -8
                ],
                [
                  0,
                  -8
                ],
                [
                  0,
                  -8
                ],
                [
                  0,
                  -7
                ],
                [
                  0,
                  -8
                ],
                [
                  0,
                  -8
                ],
                [
                  0,
                  -8
                ],
                [
                  0,
                  -7
                ],
                [
                  0,
                  -8
                ],
                [
                  0,
                  -8
                ],
                [
                  0,
                  -8
                ],
                [
                  0,
                  -8
                ],
                [
                  0,
                  -7
                ],
                [
                  0,
                  -8
                ],
                [
                  0,
                  -8
                ],
                [
                  0,
                  -8
                ],
                [
                  0,
                  -7
                ],
                [
                  0,
                  -8
                ],
                [
                  0,
                  -8
                ],
                [
                  0,
                  -8
                ],
                [
                  0,
                  -7
                ],
                [
                  0,
                  -8
                ],
                [
                  0,
                  -8
                ],
                [
                  0,
                  -8
                ],
                [
                  0,
                  -8
                ],
                [
                  0,
                  -7
                ],
                [
                  0,
                  -8
                ],
                [
                  0,
                  -8
                ],
                [
                  0,
                  -8
                ],
                [
                  0,
                  -7
                ],
                [
                  0,
                  -8
                ],
                [
                  0,
                  -8
                ],
                [
                  0,
                  -8
                ],
                [
                  0,
                  -7
                ],
                [
                  0,
                  -8
                ],
                [
                  0,
                  -8
                ],
                [
                  0,
                  -8
                ],
                [
                  0,
                  -5
                ],
                [
                  0,
                  -4
                ],
                [
                  -4,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -5,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -3,
                  -2
                ],
                [
                  -6,
                  -5
                ],
                [
                  -4,
                  -1
                ],
                [
                  -6,
                  0
                ],
                [
                  -3,
                  -1
                ],
                [
                  -3,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -13,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -2
                ],
                [
                  -4,
                  -11
                ],
                [
                  -1,
                  -2
                ],
                [
                  -3,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -11,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -3,
                  3
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  -4
                ],
                [
                  -1,
                  -3
                ],
                [
                  1,
                  -3
                ],
                [
                  5,
                  -7
                ],
                [
                  0,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -4,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -8,
                  -4
                ],
                [
                  -5,
                  -1
                ],
                [
                  -5,
                  -1
                ],
                [
                  -2,
                  3
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -5,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -4,
                  5
                ],
                [
                  -2,
                  2
                ],
                [
                  -27,
                  4
                ],
                [
                  -25,
                  -4
                ],
                [
                  -5,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -3,
                  0
                ],
                [
                  -6,
                  2
                ],
                [
                  -3,
                  0
                ],
                [
                  -11,
                  -1
                ],
                [
                  -5,
                  -2
                ],
                [
                  -2,
                  0
                ],
                [
                  -11,
                  4
                ],
                [
                  -5,
                  2
                ],
                [
                  -8,
                  6
                ],
                [
                  -5,
                  3
                ],
                [
                  -4,
                  2
                ],
                [
                  -22,
                  4
                ],
                [
                  -4,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -4,
                  1
                ],
                [
                  -3,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  4
                ],
                [
                  0,
                  3
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  0
                ],
                [
                  -2,
                  -2
                ],
                [
                  -3,
                  0
                ],
                [
                  -5,
                  -1
                ],
                [
                  -6,
                  -1
                ],
                [
                  -5,
                  1
                ],
                [
                  0,
                  4
                ],
                [
                  2,
                  6
                ],
                [
                  1,
                  5
                ],
                [
                  -2,
                  3
                ],
                [
                  -5,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  -4,
                  5
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  4
                ],
                [
                  0,
                  3
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  -2,
                  0
                ],
                [
                  -3,
                  0
                ],
                [
                  -8,
                  -2
                ],
                [
                  -4,
                  1
                ],
                [
                  -3,
                  3
                ],
                [
                  -1,
                  7
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  3
                ],
                [
                  -1,
                  2
                ],
                [
                  -3,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  3
                ],
                [
                  -2,
                  3
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -3,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -5,
                  -3
                ],
                [
                  -3,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  -3
                ],
                [
                  -1,
                  -11
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  -3,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -3,
                  0
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -4
                ],
                [
                  1,
                  -3
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -3
                ],
                [
                  0,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  -3
                ],
                [
                  -3,
                  -3
                ],
                [
                  -2,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -10,
                  -10
                ],
                [
                  -5,
                  -1
                ],
                [
                  -3,
                  -2
                ],
                [
                  -4,
                  -2
                ],
                [
                  -2,
                  -1
                ]
              ],
              [
                [
                  5450,
                  866
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -4,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -8,
                  6
                ],
                [
                  -4,
                  5
                ],
                [
                  -2,
                  2
                ],
                [
                  -14,
                  14
                ],
                [
                  -3,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -7,
                  10
                ],
                [
                  -9,
                  10
                ],
                [
                  -17,
                  11
                ],
                [
                  -4,
                  4
                ],
                [
                  -6,
                  8
                ],
                [
                  -10,
                  7
                ],
                [
                  -1,
                  2
                ],
                [
                  -4,
                  6
                ],
                [
                  -5,
                  4
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  -2,
                  4
                ],
                [
                  -4,
                  5
                ],
                [
                  -13,
                  12
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  3
                ],
                [
                  0,
                  7
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -12,
                  19
                ],
                [
                  -2,
                  4
                ],
                [
                  -2,
                  3
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -4,
                  7
                ],
                [
                  -5,
                  7
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  11
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  1,
                  6
                ],
                [
                  -2,
                  9
                ],
                [
                  1,
                  2
                ],
                [
                  -2,
                  5
                ],
                [
                  -1,
                  3
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  6
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  3
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  3
                ],
                [
                  -1,
                  3
                ],
                [
                  -4,
                  8
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  4
                ],
                [
                  -1,
                  3
                ],
                [
                  -2,
                  3
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -5
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  3
                ],
                [
                  2,
                  7
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  9
                ],
                [
                  -2,
                  8
                ],
                [
                  -3,
                  5
                ],
                [
                  -4,
                  4
                ],
                [
                  -5,
                  4
                ],
                [
                  -8,
                  3
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  11
                ],
                [
                  0,
                  10
                ],
                [
                  -2,
                  4
                ],
                [
                  -1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  4
                ],
                [
                  0,
                  6
                ],
                [
                  -2,
                  6
                ],
                [
                  -2,
                  5
                ],
                [
                  -6,
                  9
                ],
                [
                  0,
                  5
                ],
                [
                  2,
                  5
                ],
                [
                  -1,
                  0
                ],
                [
                  -7,
                  7
                ],
                [
                  -2,
                  4
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  11
                ],
                [
                  0,
                  3
                ],
                [
                  4,
                  7
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  -1,
                  3
                ],
                [
                  -3,
                  3
                ],
                [
                  -1,
                  3
                ],
                [
                  0,
                  7
                ],
                [
                  -3,
                  8
                ],
                [
                  -1,
                  7
                ],
                [
                  -1,
                  5
                ],
                [
                  -1,
                  2
                ],
                [
                  4,
                  11
                ],
                [
                  0,
                  1
                ],
                [
                  3,
                  10
                ],
                [
                  0,
                  6
                ],
                [
                  -1,
                  5
                ],
                [
                  -2,
                  4
                ],
                [
                  -3,
                  5
                ],
                [
                  -1,
                  6
                ],
                [
                  -1,
                  11
                ],
                [
                  -1,
                  5
                ],
                [
                  -8,
                  14
                ],
                [
                  -3,
                  4
                ],
                [
                  -6,
                  6
                ],
                [
                  -2,
                  4
                ],
                [
                  -5,
                  5
                ],
                [
                  0,
                  4
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  3
                ],
                [
                  0,
                  6
                ],
                [
                  0,
                  3
                ],
                [
                  -3,
                  5
                ],
                [
                  -3,
                  7
                ],
                [
                  -7,
                  13
                ],
                [
                  -3,
                  10
                ],
                [
                  -2,
                  4
                ],
                [
                  -1,
                  7
                ],
                [
                  -1,
                  2
                ],
                [
                  1,
                  3
                ],
                [
                  -1,
                  4
                ],
                [
                  0,
                  5
                ],
                [
                  -1,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  4
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  3
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  8
                ],
                [
                  -2,
                  6
                ],
                [
                  -1,
                  3
                ],
                [
                  2,
                  20
                ],
                [
                  0,
                  5
                ],
                [
                  -2,
                  4
                ],
                [
                  -5,
                  12
                ],
                [
                  -1,
                  6
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  3,
                  6
                ],
                [
                  2,
                  1
                ],
                [
                  -1,
                  -3
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  5
                ],
                [
                  -2,
                  16
                ],
                [
                  -2,
                  5
                ],
                [
                  -2,
                  4
                ],
                [
                  -2,
                  4
                ],
                [
                  -1,
                  4
                ],
                [
                  -1,
                  5
                ],
                [
                  -1,
                  9
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  5
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  -1,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  3,
                  1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -4
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  6
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  6
                ],
                [
                  -1,
                  24
                ],
                [
                  -3,
                  19
                ],
                [
                  -3,
                  5
                ],
                [
                  -1,
                  6
                ],
                [
                  -5,
                  9
                ],
                [
                  -2,
                  8
                ],
                [
                  -5,
                  9
                ],
                [
                  0,
                  1
                ],
                [
                  -9,
                  10
                ],
                [
                  -3,
                  4
                ],
                [
                  0,
                  4
                ],
                [
                  0,
                  1
                ],
                [
                  -20,
                  26
                ],
                [
                  -10,
                  9
                ],
                [
                  -1,
                  2
                ],
                [
                  -11,
                  10
                ],
                [
                  -2,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -11,
                  16
                ],
                [
                  -2,
                  9
                ],
                [
                  -4,
                  10
                ],
                [
                  -13,
                  17
                ],
                [
                  -8,
                  14
                ],
                [
                  -5,
                  6
                ],
                [
                  -4,
                  4
                ],
                [
                  -11,
                  21
                ],
                [
                  -6,
                  7
                ],
                [
                  -1,
                  5
                ],
                [
                  -2,
                  2
                ],
                [
                  -4,
                  3
                ],
                [
                  -2,
                  5
                ],
                [
                  -2,
                  5
                ],
                [
                  -1,
                  11
                ],
                [
                  -4,
                  12
                ],
                [
                  -11,
                  22
                ],
                [
                  -3,
                  13
                ],
                [
                  -1,
                  5
                ],
                [
                  -2,
                  12
                ],
                [
                  -5,
                  11
                ],
                [
                  -3,
                  5
                ],
                [
                  -5,
                  2
                ],
                [
                  -6,
                  4
                ],
                [
                  -4,
                  7
                ],
                [
                  -4,
                  18
                ],
                [
                  -11,
                  19
                ],
                [
                  -1,
                  4
                ],
                [
                  -5,
                  8
                ],
                [
                  -10,
                  17
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  2
                ],
                [
                  -4,
                  7
                ],
                [
                  -1,
                  2
                ],
                [
                  -6,
                  10
                ],
                [
                  -1,
                  5
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  7
                ],
                [
                  -1,
                  3
                ],
                [
                  -5,
                  5
                ],
                [
                  -2,
                  5
                ],
                [
                  -7,
                  16
                ],
                [
                  -2,
                  4
                ],
                [
                  -4,
                  5
                ],
                [
                  -5,
                  4
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  9
                ],
                [
                  -1,
                  3
                ],
                [
                  -21,
                  29
                ],
                [
                  -15,
                  10
                ],
                [
                  -6,
                  7
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  3
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -6,
                  4
                ],
                [
                  -2,
                  7
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  4
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  -4,
                  4
                ],
                [
                  -5,
                  14
                ],
                [
                  0,
                  1
                ],
                [
                  -11,
                  11
                ],
                [
                  -2,
                  6
                ],
                [
                  -1,
                  8
                ],
                [
                  -2,
                  7
                ],
                [
                  -2,
                  5
                ],
                [
                  -2,
                  13
                ],
                [
                  -3,
                  10
                ],
                [
                  -2,
                  15
                ],
                [
                  -1,
                  7
                ],
                [
                  -1,
                  4
                ],
                [
                  -1,
                  8
                ],
                [
                  0,
                  10
                ],
                [
                  5,
                  28
                ],
                [
                  1,
                  2
                ]
              ],
              [
                [
                  5254,
                  8011
                ],
                [
                  1,
                  -9
                ],
                [
                  2,
                  -9
                ],
                [
                  1,
                  -8
                ],
                [
                  2,
                  -9
                ],
                [
                  1,
                  -9
                ],
                [
                  2,
                  -8
                ],
                [
                  2,
                  -9
                ],
                [
                  1,
                  -9
                ],
                [
                  2,
                  -8
                ],
                [
                  1,
                  -9
                ],
                [
                  2,
                  -9
                ],
                [
                  1,
                  -8
                ],
                [
                  2,
                  -9
                ],
                [
                  2,
                  -9
                ],
                [
                  1,
                  -6
                ],
                [
                  1,
                  -5
                ],
                [
                  1,
                  -6
                ],
                [
                  0,
                  -3
                ],
                [
                  0,
                  -7
                ],
                [
                  0,
                  -10
                ],
                [
                  0,
                  -12
                ],
                [
                  0,
                  -12
                ],
                [
                  1,
                  -10
                ],
                [
                  0,
                  -7
                ],
                [
                  0,
                  -3
                ],
                [
                  0,
                  -3
                ],
                [
                  0,
                  -3
                ],
                [
                  2,
                  -2
                ],
                [
                  7,
                  -3
                ],
                [
                  2,
                  -2
                ],
                [
                  4,
                  -5
                ],
                [
                  4,
                  -5
                ],
                [
                  2,
                  -3
                ],
                [
                  2,
                  -4
                ],
                [
                  2,
                  -3
                ],
                [
                  2,
                  -3
                ],
                [
                  2,
                  -4
                ],
                [
                  3,
                  -3
                ],
                [
                  2,
                  -4
                ],
                [
                  2,
                  -3
                ],
                [
                  2,
                  -3
                ],
                [
                  2,
                  -4
                ],
                [
                  3,
                  -3
                ],
                [
                  2,
                  -4
                ],
                [
                  2,
                  -3
                ],
                [
                  2,
                  -3
                ],
                [
                  2,
                  -4
                ],
                [
                  2,
                  -3
                ],
                [
                  3,
                  -4
                ],
                [
                  -6,
                  -3
                ],
                [
                  -3,
                  -5
                ],
                [
                  -1,
                  -6
                ],
                [
                  1,
                  -7
                ],
                [
                  2,
                  -3
                ],
                [
                  2,
                  -3
                ],
                [
                  2,
                  -3
                ],
                [
                  10,
                  -8
                ],
                [
                  4,
                  -4
                ],
                [
                  8,
                  -9
                ],
                [
                  7,
                  -8
                ],
                [
                  8,
                  -8
                ],
                [
                  7,
                  -9
                ],
                [
                  4,
                  -3
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  -3,
                  -5
                ],
                [
                  -5,
                  -9
                ],
                [
                  -5,
                  -10
                ],
                [
                  -6,
                  -10
                ],
                [
                  -5,
                  -9
                ],
                [
                  -2,
                  -4
                ],
                [
                  -4,
                  -11
                ],
                [
                  0,
                  -5
                ],
                [
                  -1,
                  -7
                ],
                [
                  0,
                  -6
                ],
                [
                  -1,
                  -6
                ],
                [
                  0,
                  -7
                ],
                [
                  -1,
                  -6
                ],
                [
                  0,
                  -6
                ],
                [
                  -1,
                  -7
                ],
                [
                  -1,
                  -6
                ],
                [
                  0,
                  -6
                ],
                [
                  -1,
                  -7
                ],
                [
                  0,
                  -6
                ],
                [
                  -1,
                  -6
                ],
                [
                  0,
                  -7
                ],
                [
                  -1,
                  -6
                ],
                [
                  0,
                  -6
                ],
                [
                  -1,
                  -7
                ],
                [
                  0,
                  -6
                ],
                [
                  -1,
                  -6
                ],
                [
                  0,
                  -6
                ],
                [
                  -1,
                  -7
                ],
                [
                  0,
                  -6
                ],
                [
                  -1,
                  -6
                ],
                [
                  0,
                  -7
                ],
                [
                  -1,
                  -6
                ],
                [
                  0,
                  -6
                ],
                [
                  -1,
                  -7
                ],
                [
                  -1,
                  -6
                ],
                [
                  0,
                  -6
                ],
                [
                  -1,
                  -7
                ],
                [
                  0,
                  -6
                ],
                [
                  -1,
                  -6
                ],
                [
                  0,
                  -7
                ],
                [
                  -1,
                  -6
                ],
                [
                  0,
                  -6
                ],
                [
                  -1,
                  -7
                ],
                [
                  0,
                  -6
                ],
                [
                  -1,
                  -6
                ],
                [
                  0,
                  -7
                ],
                [
                  -1,
                  -6
                ],
                [
                  0,
                  -6
                ],
                [
                  -1,
                  -5
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -6
                ],
                [
                  -1,
                  -6
                ],
                [
                  0,
                  -6
                ],
                [
                  -1,
                  -7
                ],
                [
                  -1,
                  -6
                ],
                [
                  0,
                  -6
                ],
                [
                  -1,
                  -7
                ],
                [
                  0,
                  -6
                ],
                [
                  -1,
                  -6
                ],
                [
                  0,
                  -7
                ],
                [
                  -1,
                  -6
                ],
                [
                  0,
                  -6
                ],
                [
                  -1,
                  -7
                ],
                [
                  0,
                  -6
                ],
                [
                  -1,
                  -6
                ],
                [
                  0,
                  -7
                ],
                [
                  -1,
                  -6
                ],
                [
                  0,
                  -6
                ],
                [
                  -1,
                  -7
                ],
                [
                  0,
                  -6
                ],
                [
                  -1,
                  -6
                ],
                [
                  0,
                  -7
                ],
                [
                  -1,
                  -6
                ],
                [
                  0,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  -3
                ],
                [
                  -4,
                  -5
                ],
                [
                  -8,
                  -8
                ],
                [
                  -7,
                  -8
                ],
                [
                  -7,
                  -8
                ],
                [
                  -7,
                  -8
                ],
                [
                  -8,
                  -8
                ],
                [
                  -7,
                  -8
                ],
                [
                  -7,
                  -9
                ],
                [
                  -8,
                  -8
                ],
                [
                  -7,
                  -8
                ],
                [
                  -7,
                  -8
                ],
                [
                  -8,
                  -8
                ],
                [
                  -7,
                  -8
                ],
                [
                  -7,
                  -8
                ],
                [
                  -7,
                  -8
                ],
                [
                  -8,
                  -8
                ],
                [
                  -7,
                  -8
                ],
                [
                  -5,
                  -6
                ],
                [
                  -8,
                  -8
                ],
                [
                  -7,
                  -8
                ],
                [
                  -4,
                  -6
                ],
                [
                  -3,
                  -5
                ],
                [
                  -4,
                  -6
                ],
                [
                  -4,
                  -5
                ],
                [
                  -4,
                  -6
                ],
                [
                  -4,
                  -6
                ],
                [
                  -4,
                  -5
                ],
                [
                  -4,
                  -6
                ],
                [
                  -4,
                  -6
                ],
                [
                  -4,
                  -5
                ],
                [
                  -3,
                  -6
                ],
                [
                  -4,
                  -6
                ],
                [
                  -4,
                  -5
                ],
                [
                  -4,
                  -6
                ],
                [
                  -4,
                  -6
                ],
                [
                  -4,
                  -5
                ],
                [
                  -4,
                  -6
                ],
                [
                  -4,
                  -5
                ],
                [
                  -3,
                  -8
                ],
                [
                  -4,
                  -9
                ],
                [
                  -2,
                  -5
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -3
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -6
                ],
                [
                  1,
                  -3
                ],
                [
                  -2,
                  -3
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -3,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -4,
                  -5
                ],
                [
                  -3,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -5
                ],
                [
                  -1,
                  -3
                ],
                [
                  -1,
                  -3
                ],
                [
                  -4,
                  -3
                ],
                [
                  -2,
                  -1
                ],
                [
                  -3,
                  0
                ],
                [
                  -5,
                  -1
                ],
                [
                  -5,
                  -2
                ],
                [
                  -3,
                  -2
                ],
                [
                  -5,
                  -6
                ],
                [
                  0,
                  -8
                ],
                [
                  3,
                  -10
                ],
                [
                  2,
                  -7
                ],
                [
                  1,
                  -6
                ],
                [
                  1,
                  -4
                ],
                [
                  1,
                  -5
                ],
                [
                  1,
                  -4
                ],
                [
                  1,
                  -5
                ],
                [
                  1,
                  -4
                ],
                [
                  1,
                  -4
                ],
                [
                  1,
                  -5
                ],
                [
                  0,
                  -4
                ],
                [
                  1,
                  -5
                ],
                [
                  1,
                  -4
                ],
                [
                  1,
                  -4
                ],
                [
                  1,
                  -5
                ],
                [
                  1,
                  -4
                ],
                [
                  1,
                  -5
                ],
                [
                  1,
                  -4
                ],
                [
                  1,
                  -5
                ]
              ],
              [
                [
                  5075,
                  6723
                ],
                [
                  -32,
                  2
                ],
                [
                  -4,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  -6,
                  -5
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  -2,
                  -3
                ],
                [
                  -4,
                  -1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -4,
                  -2
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -3
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  2
                ],
                [
                  -2,
                  0
                ],
                [
                  -3,
                  -1
                ],
                [
                  -1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -4,
                  0
                ],
                [
                  -3,
                  -1
                ],
                [
                  -12,
                  -7
                ],
                [
                  -4,
                  0
                ],
                [
                  -3,
                  1
                ],
                [
                  -1,
                  -3
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  -3,
                  -4
                ],
                [
                  -1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -2
                ],
                [
                  -3,
                  -5
                ],
                [
                  -2,
                  -1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  0,
                  -3
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -4,
                  -4
                ],
                [
                  -1,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  -1,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -3,
                  -1
                ],
                [
                  -1,
                  -8
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  1
                ],
                [
                  -4,
                  0
                ],
                [
                  -5,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -6,
                  2
                ],
                [
                  -2,
                  0
                ],
                [
                  -3,
                  -2
                ],
                [
                  -2,
                  0
                ],
                [
                  -4,
                  -1
                ],
                [
                  -8,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -6,
                  5
                ],
                [
                  -19,
                  12
                ],
                [
                  -14,
                  6
                ],
                [
                  -39,
                  10
                ],
                [
                  -64,
                  0
                ],
                [
                  -23,
                  3
                ],
                [
                  -13,
                  -1
                ],
                [
                  -4,
                  -1
                ],
                [
                  -63,
                  -14
                ],
                [
                  -5,
                  -2
                ],
                [
                  -25,
                  -15
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -3
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  -2
                ],
                [
                  -4,
                  -4
                ],
                [
                  -23,
                  -28
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -28,
                  4
                ],
                [
                  -2,
                  0
                ],
                [
                  -7,
                  -2
                ],
                [
                  -5,
                  0
                ],
                [
                  -38,
                  4
                ],
                [
                  -5,
                  1
                ],
                [
                  -34,
                  10
                ],
                [
                  -5,
                  3
                ],
                [
                  -2,
                  3
                ],
                [
                  -4,
                  6
                ],
                [
                  -2,
                  3
                ],
                [
                  -6,
                  5
                ],
                [
                  -3,
                  1
                ],
                [
                  -3,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -3,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -13,
                  13
                ],
                [
                  -3,
                  4
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -4,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -5,
                  4
                ],
                [
                  -3,
                  2
                ],
                [
                  -3,
                  3
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  2
                ],
                [
                  -33,
                  5
                ],
                [
                  -5,
                  -1
                ],
                [
                  -4,
                  -2
                ],
                [
                  -48,
                  -30
                ],
                [
                  -4,
                  -1
                ],
                [
                  -4,
                  0
                ],
                [
                  -14,
                  3
                ],
                [
                  -3,
                  -1
                ],
                [
                  -8,
                  -10
                ],
                [
                  -6,
                  -5
                ],
                [
                  -3,
                  -2
                ],
                [
                  -3,
                  0
                ],
                [
                  -9,
                  0
                ],
                [
                  -5,
                  0
                ],
                [
                  -4,
                  2
                ],
                [
                  -4,
                  3
                ],
                [
                  -5,
                  5
                ],
                [
                  -7,
                  9
                ],
                [
                  -4,
                  6
                ],
                [
                  -10,
                  20
                ],
                [
                  -21,
                  25
                ],
                [
                  -19,
                  18
                ],
                [
                  -8,
                  5
                ],
                [
                  -3,
                  0
                ],
                [
                  -7,
                  2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -8,
                  -4
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -37,
                  15
                ],
                [
                  -37,
                  15
                ],
                [
                  -4,
                  1
                ],
                [
                  -19,
                  -4
                ],
                [
                  -4,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -3,
                  -5
                ],
                [
                  -1,
                  -2
                ],
                [
                  -4,
                  -3
                ],
                [
                  -2,
                  -1
                ],
                [
                  -4,
                  0
                ],
                [
                  -19,
                  0
                ],
                [
                  -13,
                  -2
                ],
                [
                  -8,
                  0
                ],
                [
                  -3,
                  2
                ],
                [
                  -3,
                  3
                ],
                [
                  -3,
                  1
                ],
                [
                  -4,
                  0
                ],
                [
                  -26,
                  -7
                ],
                [
                  -15,
                  -4
                ],
                [
                  -7,
                  -3
                ],
                [
                  -6,
                  -4
                ],
                [
                  -21,
                  -21
                ],
                [
                  -4,
                  -2
                ],
                [
                  -3,
                  0
                ],
                [
                  -9,
                  -1
                ],
                [
                  0,
                  -33
                ],
                [
                  -1,
                  -3
                ],
                [
                  -4,
                  -30
                ],
                [
                  -21,
                  -34
                ],
                [
                  -8,
                  -8
                ],
                [
                  -28,
                  -22
                ],
                [
                  -1,
                  -2
                ],
                [
                  1,
                  -34
                ],
                [
                  -3,
                  -19
                ],
                [
                  0,
                  -6
                ],
                [
                  3,
                  -10
                ],
                [
                  1,
                  -4
                ],
                [
                  -3,
                  -5
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -3
                ],
                [
                  1,
                  -8
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  -4
                ],
                [
                  2,
                  -2
                ],
                [
                  0,
                  -3
                ],
                [
                  -1,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  -7,
                  -4
                ]
              ],
              [
                [
                  4273,
                  5445
                ],
                [
                  3,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  5,
                  2
                ],
                [
                  2,
                  0
                ],
                [
                  4,
                  1
                ],
                [
                  2,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -5,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -6,
                  -3
                ],
                [
                  -2,
                  0
                ],
                [
                  -10,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  6,
                  2
                ],
                [
                  2,
                  -1
                ],
                [
                  4,
                  -2
                ]
              ],
              [
                [
                  4248,
                  5448
                ],
                [
                  2,
                  -1
                ],
                [
                  6,
                  1
                ],
                [
                  2,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -12,
                  -2
                ],
                [
                  -4,
                  0
                ],
                [
                  -2,
                  2
                ],
                [
                  2,
                  3
                ],
                [
                  4,
                  4
                ],
                [
                  3,
                  5
                ],
                [
                  2,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  3
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -4
                ]
              ],
              [
                [
                  5075,
                  6723
                ],
                [
                  30,
                  -43
                ],
                [
                  30,
                  -43
                ]
              ],
              [
                [
                  4422,
                  5492
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -3
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -3,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -4,
                  2
                ],
                [
                  0,
                  4
                ],
                [
                  1,
                  4
                ],
                [
                  1,
                  5
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -4
                ],
                [
                  -3,
                  -3
                ],
                [
                  -4,
                  0
                ],
                [
                  -3,
                  4
                ],
                [
                  1,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  -3,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -4,
                  3
                ],
                [
                  -3,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  8,
                  -7
                ],
                [
                  1,
                  -2
                ],
                [
                  4,
                  -7
                ],
                [
                  0,
                  -3
                ],
                [
                  -2,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -3
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -6
                ],
                [
                  2,
                  -3
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -3
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -3
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  -4
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -6,
                  0
                ],
                [
                  -7,
                  1
                ],
                [
                  -11,
                  0
                ],
                [
                  -6,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -5,
                  -2
                ],
                [
                  -2,
                  0
                ],
                [
                  -6,
                  0
                ],
                [
                  -22,
                  -3
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  -3,
                  -1
                ],
                [
                  -4,
                  0
                ],
                [
                  -4,
                  0
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -12,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -3,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  1,
                  4
                ],
                [
                  2,
                  6
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  2,
                  -3
                ],
                [
                  1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  -3
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -2
                ],
                [
                  -3,
                  0
                ],
                [
                  -5,
                  2
                ],
                [
                  -3,
                  1
                ],
                [
                  -3,
                  0
                ],
                [
                  -3,
                  2
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  3,
                  -2
                ],
                [
                  3,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -6,
                  -1
                ],
                [
                  -1,
                  1
                ],
                [
                  -3,
                  4
                ],
                [
                  -8,
                  10
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  4
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -3,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -3,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  6
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -4
                ],
                [
                  1,
                  -2
                ],
                [
                  3,
                  -1
                ],
                [
                  4,
                  -2
                ],
                [
                  3,
                  -5
                ],
                [
                  0,
                  -5
                ],
                [
                  -3,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -3
                ],
                [
                  -4,
                  -4
                ],
                [
                  -2,
                  -1
                ],
                [
                  -3,
                  1
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  1,
                  3
                ],
                [
                  -2,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -3
                ],
                [
                  2,
                  -2
                ],
                [
                  -4,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  4
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  7
                ],
                [
                  -2,
                  4
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  -1,
                  2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  4
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  -3,
                  -3
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -3
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -3
                ],
                [
                  3,
                  -8
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  3
                ],
                [
                  -2,
                  2
                ],
                [
                  -4,
                  5
                ],
                [
                  1,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  2,
                  -3
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  3
                ],
                [
                  3,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  -2
                ],
                [
                  -1,
                  -10
                ],
                [
                  0,
                  -3
                ],
                [
                  5,
                  -10
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  1
                ],
                [
                  -3,
                  1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  -2,
                  2
                ],
                [
                  -2,
                  3
                ],
                [
                  -2,
                  5
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  2
                ],
                [
                  -3,
                  5
                ],
                [
                  -2,
                  8
                ],
                [
                  0,
                  4
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  1,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -5
                ],
                [
                  0,
                  -5
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  3,
                  -5
                ],
                [
                  -3,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  2,
                  -13
                ],
                [
                  2,
                  -4
                ],
                [
                  2,
                  -2
                ],
                [
                  -1,
                  -4
                ],
                [
                  3,
                  -2
                ],
                [
                  2,
                  -2
                ],
                [
                  -4,
                  -2
                ],
                [
                  -4,
                  -1
                ],
                [
                  -5,
                  0
                ],
                [
                  -5,
                  0
                ],
                [
                  -3,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  8
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  5
                ],
                [
                  1,
                  2
                ],
                [
                  3,
                  9
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  4
                ],
                [
                  -2,
                  -3
                ],
                [
                  -2,
                  -6
                ],
                [
                  -1,
                  -6
                ],
                [
                  1,
                  -5
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -3
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  8
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -7
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -3
                ],
                [
                  2,
                  -4
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -4,
                  0
                ],
                [
                  -3,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  4
                ],
                [
                  -1,
                  4
                ],
                [
                  0,
                  7
                ],
                [
                  0,
                  5
                ],
                [
                  -2,
                  3
                ],
                [
                  -4,
                  0
                ],
                [
                  4,
                  -3
                ],
                [
                  1,
                  -5
                ],
                [
                  -1,
                  -6
                ],
                [
                  -1,
                  -5
                ],
                [
                  -1,
                  -5
                ],
                [
                  -6,
                  -1
                ],
                [
                  -8,
                  0
                ],
                [
                  -3,
                  3
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -3,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -6,
                  -1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -3,
                  4
                ],
                [
                  3,
                  6
                ],
                [
                  8,
                  10
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -5,
                  -5
                ],
                [
                  0,
                  7
                ],
                [
                  -2,
                  7
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -3
                ],
                [
                  0,
                  -3
                ],
                [
                  1,
                  -4
                ],
                [
                  1,
                  -2
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -3,
                  0
                ],
                [
                  2,
                  -3
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -4
                ],
                [
                  -1,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -5,
                  0
                ],
                [
                  -3,
                  1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  3
                ],
                [
                  2,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  4
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  -1,
                  -3
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  5
                ],
                [
                  1,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -5
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  2
                ],
                [
                  2,
                  -5
                ],
                [
                  1,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  3
                ],
                [
                  -2,
                  3
                ],
                [
                  2,
                  3
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  2
                ],
                [
                  -5,
                  3
                ],
                [
                  -2,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -3,
                  3
                ],
                [
                  -1,
                  2
                ],
                [
                  -4,
                  4
                ],
                [
                  -13,
                  12
                ],
                [
                  -3,
                  5
                ],
                [
                  -1,
                  6
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  3
                ],
                [
                  -5,
                  4
                ],
                [
                  -2,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  -4,
                  6
                ],
                [
                  -1,
                  1
                ],
                [
                  4,
                  -2
                ],
                [
                  -1,
                  3
                ],
                [
                  -4,
                  5
                ],
                [
                  -4,
                  11
                ],
                [
                  -1,
                  6
                ],
                [
                  0,
                  2
                ],
                [
                  -2,
                  4
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -3
                ],
                [
                  2,
                  -1
                ],
                [
                  -2,
                  5
                ],
                [
                  -1,
                  2
                ],
                [
                  3,
                  0
                ],
                [
                  3,
                  -1
                ],
                [
                  -1,
                  2
                ],
                [
                  -4,
                  4
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  1,
                  5
                ],
                [
                  -1,
                  7
                ],
                [
                  -3,
                  12
                ],
                [
                  1,
                  2
                ],
                [
                  3,
                  1
                ],
                [
                  9,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  5,
                  2
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  -1,
                  2
                ],
                [
                  -3,
                  3
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  4,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  3
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -3,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -3,
                  1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -2,
                  -4
                ],
                [
                  1,
                  -3
                ],
                [
                  -1,
                  -3
                ],
                [
                  -2,
                  -3
                ],
                [
                  -2,
                  0
                ],
                [
                  -3,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -7,
                  1
                ],
                [
                  -15,
                  5
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -5,
                  4
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  13,
                  0
                ],
                [
                  5,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  2
                ],
                [
                  3,
                  5
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -3
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  2
                ],
                [
                  -3,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -4
                ],
                [
                  -1,
                  -2
                ],
                [
                  -3,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -3,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  3,
                  7
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  -1,
                  0
                ],
                [
                  -3,
                  -10
                ],
                [
                  -2,
                  -3
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -3,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -3,
                  -2
                ],
                [
                  -4,
                  -1
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  -2,
                  2
                ],
                [
                  -2,
                  3
                ],
                [
                  -1,
                  4
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  3
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  4,
                  4
                ],
                [
                  11,
                  4
                ],
                [
                  3,
                  6
                ],
                [
                  -3,
                  -1
                ],
                [
                  -4,
                  -4
                ],
                [
                  -6,
                  -2
                ],
                [
                  -9,
                  -5
                ],
                [
                  -2,
                  -2
                ],
                [
                  -7,
                  -6
                ],
                [
                  -1,
                  0
                ],
                [
                  -5,
                  11
                ],
                [
                  -16,
                  22
                ],
                [
                  -3,
                  3
                ],
                [
                  -5,
                  2
                ],
                [
                  -2,
                  3
                ],
                [
                  -3,
                  5
                ],
                [
                  -5,
                  5
                ],
                [
                  -4,
                  4
                ],
                [
                  -10,
                  6
                ],
                [
                  -4,
                  3
                ],
                [
                  -8,
                  8
                ],
                [
                  -5,
                  3
                ],
                [
                  -2,
                  1
                ],
                [
                  -11,
                  6
                ],
                [
                  -9,
                  1
                ],
                [
                  -28,
                  6
                ],
                [
                  -33,
                  3
                ],
                [
                  -56,
                  -3
                ],
                [
                  -3,
                  0
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  4,
                  4
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  3,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  5,
                  0
                ],
                [
                  3,
                  1
                ],
                [
                  6,
                  2
                ],
                [
                  2,
                  -1
                ],
                [
                  3,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  11,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -8,
                  2
                ],
                [
                  -7,
                  -3
                ],
                [
                  -7,
                  -4
                ],
                [
                  -6,
                  -2
                ],
                [
                  -3,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -5,
                  -3
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -3,
                  -4
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -3
                ],
                [
                  -8,
                  -1
                ],
                [
                  -15,
                  1
                ],
                [
                  -17,
                  -2
                ],
                [
                  -20,
                  1
                ],
                [
                  -29,
                  -3
                ]
              ],
              [
                [
                  1216,
                  8986
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  0
                ]
              ],
              [
                [
                  1238,
                  9001
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -1
                ]
              ],
              [
                [
                  1155,
                  9330
                ],
                [
                  1,
                  -3
                ],
                [
                  -5,
                  6
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  3,
                  -2
                ],
                [
                  2,
                  -3
                ],
                [
                  2,
                  -4
                ]
              ],
              [
                [
                  1080,
                  9371
                ],
                [
                  3,
                  0
                ],
                [
                  4,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  0
                ],
                [
                  5,
                  1
                ],
                [
                  2,
                  -1
                ],
                [
                  4,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  7,
                  -5
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  5,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -4,
                  -2
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -4,
                  -5
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -5
                ],
                [
                  -5,
                  -1
                ],
                [
                  -7,
                  -1
                ],
                [
                  -10,
                  1
                ],
                [
                  -22,
                  8
                ],
                [
                  -5,
                  3
                ],
                [
                  -4,
                  3
                ],
                [
                  -4,
                  4
                ],
                [
                  -1,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  3,
                  4
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  3,
                  -3
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  -1
                ],
                [
                  3,
                  -2
                ]
              ],
              [
                [
                  1178,
                  9412
                ],
                [
                  3,
                  -1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  -4
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  -4,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -3,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  4
                ],
                [
                  3,
                  3
                ],
                [
                  3,
                  0
                ]
              ],
              [
                [
                  7271,
                  4677
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -4
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -4
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  4,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  9,
                  -3
                ],
                [
                  2,
                  -1
                ],
                [
                  3,
                  -1
                ],
                [
                  1,
                  -4
                ],
                [
                  -1,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -3
                ],
                [
                  2,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  2,
                  -5
                ],
                [
                  1,
                  -3
                ],
                [
                  2,
                  -1
                ],
                [
                  3,
                  1
                ],
                [
                  1,
                  -3
                ],
                [
                  0,
                  -4
                ],
                [
                  -2,
                  -11
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  -4
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -6
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  1,
                  -3
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  3,
                  0
                ],
                [
                  1,
                  -4
                ],
                [
                  -2,
                  -8
                ],
                [
                  3,
                  1
                ],
                [
                  2,
                  -2
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -4
                ],
                [
                  -4,
                  -15
                ],
                [
                  -1,
                  -6
                ],
                [
                  0,
                  -10
                ],
                [
                  0,
                  -3
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -7,
                  4
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -4
                ],
                [
                  -1,
                  -1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -3,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  -2
                ]
              ],
              [
                [
                  7155,
                  4632
                ],
                [
                  5,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  2,
                  1
                ],
                [
                  0,
                  3
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  4,
                  -5
                ],
                [
                  1,
                  -3
                ],
                [
                  0,
                  -6
                ],
                [
                  1,
                  -3
                ],
                [
                  2,
                  -2
                ],
                [
                  3,
                  -1
                ],
                [
                  3,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  8,
                  5
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  3
                ],
                [
                  2,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  4,
                  2
                ],
                [
                  6,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  6
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  6,
                  6
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  6
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  0
                ]
              ],
              [
                [
                  1081,
                  7702
                ],
                [
                  -1,
                  4
                ],
                [
                  -4,
                  6
                ],
                [
                  -1,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  7
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  8
                ],
                [
                  5,
                  41
                ],
                [
                  2,
                  5
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  6
                ]
              ],
              [
                [
                  8156,
                  7700
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  3
                ],
                [
                  0,
                  4
                ],
                [
                  1,
                  4
                ],
                [
                  2,
                  3
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -9
                ],
                [
                  -1,
                  -2
                ]
              ],
              [
                [
                  8106,
                  7872
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  3,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -17
                ],
                [
                  3,
                  -19
                ],
                [
                  -1,
                  -4
                ],
                [
                  2,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  7,
                  -16
                ],
                [
                  17,
                  -26
                ],
                [
                  11,
                  -11
                ],
                [
                  14,
                  -17
                ],
                [
                  1,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -3
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  -2
                ],
                [
                  -2,
                  2
                ],
                [
                  -4,
                  6
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  3,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -4,
                  4
                ],
                [
                  -2,
                  5
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -4,
                  3
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -4,
                  0
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  -4
                ],
                [
                  1,
                  -3
                ],
                [
                  0,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  1,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  4,
                  -5
                ],
                [
                  4,
                  -8
                ],
                [
                  1,
                  -9
                ],
                [
                  1,
                  -18
                ],
                [
                  2,
                  -8
                ],
                [
                  6,
                  -17
                ],
                [
                  0,
                  -9
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -4,
                  1
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -4
                ],
                [
                  -1,
                  -10
                ],
                [
                  1,
                  -5
                ],
                [
                  0,
                  -3
                ],
                [
                  3,
                  -8
                ],
                [
                  1,
                  -5
                ],
                [
                  1,
                  -4
                ],
                [
                  1,
                  -7
                ],
                [
                  -2,
                  -5
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -3
                ],
                [
                  1,
                  -5
                ],
                [
                  8,
                  -22
                ],
                [
                  1,
                  -5
                ],
                [
                  0,
                  -9
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  1,
                  -8
                ],
                [
                  0,
                  -3
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -4
                ],
                [
                  3,
                  -8
                ],
                [
                  5,
                  -29
                ],
                [
                  1,
                  -15
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  3,
                  -4
                ],
                [
                  1,
                  -7
                ],
                [
                  3,
                  -9
                ],
                [
                  2,
                  -6
                ],
                [
                  1,
                  -7
                ],
                [
                  2,
                  -2
                ],
                [
                  3,
                  -6
                ],
                [
                  3,
                  -5
                ],
                [
                  4,
                  -4
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  8,
                  1
                ],
                [
                  4,
                  2
                ],
                [
                  1,
                  -2
                ],
                [
                  3,
                  -2
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  2,
                  -2
                ],
                [
                  -1,
                  -5
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  15,
                  -4
                ],
                [
                  5,
                  -6
                ],
                [
                  4,
                  -6
                ],
                [
                  6,
                  -5
                ],
                [
                  3,
                  -3
                ],
                [
                  6,
                  -2
                ],
                [
                  2,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  -4,
                  -2
                ],
                [
                  0,
                  -5
                ],
                [
                  3,
                  -8
                ],
                [
                  6,
                  -6
                ],
                [
                  7,
                  -1
                ],
                [
                  6,
                  0
                ],
                [
                  0,
                  6
                ],
                [
                  3,
                  0
                ],
                [
                  5,
                  3
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  4,
                  1
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  4,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  -3
                ],
                [
                  4,
                  -7
                ],
                [
                  -1,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  4,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -5
                ],
                [
                  0,
                  -2
                ],
                [
                  3,
                  -1
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  3
                ],
                [
                  -2,
                  2
                ],
                [
                  2,
                  -1
                ],
                [
                  6,
                  -6
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -3
                ],
                [
                  0,
                  -2
                ]
              ],
              [
                [
                  7740,
                  6135
                ],
                [
                  -22,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  4
                ],
                [
                  0,
                  6
                ],
                [
                  1,
                  11
                ],
                [
                  2,
                  12
                ],
                [
                  9,
                  18
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  3
                ],
                [
                  0,
                  4
                ],
                [
                  1,
                  9
                ],
                [
                  1,
                  3
                ],
                [
                  -1,
                  4
                ],
                [
                  0,
                  2
                ],
                [
                  -6,
                  15
                ],
                [
                  -2,
                  3
                ],
                [
                  -28,
                  24
                ],
                [
                  -28,
                  25
                ],
                [
                  -11,
                  13
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -29,
                  12
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  3,
                  7
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  3
                ],
                [
                  -6,
                  51
                ],
                [
                  -7,
                  52
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  4
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  18
                ],
                [
                  -1,
                  16
                ],
                [
                  8,
                  27
                ],
                [
                  1,
                  11
                ],
                [
                  -62,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -4
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -7
                ],
                [
                  1,
                  -5
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -3
                ],
                [
                  -43,
                  0
                ],
                [
                  -43,
                  -1
                ],
                [
                  34,
                  -40
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -14
                ],
                [
                  -2,
                  -22
                ],
                [
                  1,
                  -15
                ],
                [
                  2,
                  -9
                ],
                [
                  9,
                  -18
                ],
                [
                  -1,
                  -4
                ],
                [
                  -2,
                  -4
                ],
                [
                  -31,
                  -28
                ],
                [
                  -30,
                  -27
                ],
                [
                  -2,
                  -3
                ],
                [
                  -8,
                  -22
                ],
                [
                  -9,
                  -14
                ],
                [
                  -3,
                  -3
                ],
                [
                  -14,
                  -19
                ],
                [
                  -28,
                  -29
                ],
                [
                  -28,
                  -30
                ],
                [
                  -10,
                  -3
                ],
                [
                  -27,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  -14,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  -34,
                  32
                ],
                [
                  -31,
                  21
                ],
                [
                  -31,
                  21
                ],
                [
                  -5,
                  -4
                ],
                [
                  -35,
                  -18
                ],
                [
                  -7,
                  -4
                ],
                [
                  -4,
                  -4
                ],
                [
                  -1,
                  -20
                ],
                [
                  -6,
                  -10
                ],
                [
                  -11,
                  -11
                ],
                [
                  -30,
                  -7
                ],
                [
                  -15,
                  -6
                ],
                [
                  -16,
                  -9
                ],
                [
                  -3,
                  -2
                ],
                [
                  -10,
                  -8
                ],
                [
                  -8,
                  -9
                ],
                [
                  -3,
                  -5
                ],
                [
                  0,
                  -6
                ],
                [
                  1,
                  -5
                ],
                [
                  1,
                  -3
                ],
                [
                  -52,
                  0
                ],
                [
                  -52,
                  1
                ],
                [
                  -6,
                  7
                ],
                [
                  -13,
                  29
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -13,
                  -1
                ],
                [
                  -16,
                  3
                ],
                [
                  -1,
                  0
                ],
                [
                  -3,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -10,
                  2
                ],
                [
                  -19,
                  -1
                ],
                [
                  -6,
                  2
                ],
                [
                  -33,
                  -1
                ],
                [
                  -51,
                  -18
                ],
                [
                  -1,
                  0
                ],
                [
                  -8,
                  0
                ],
                [
                  -3,
                  2
                ],
                [
                  -6,
                  4
                ],
                [
                  -24,
                  30
                ],
                [
                  -25,
                  31
                ],
                [
                  -10,
                  4
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -8,
                  13
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  -4,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -5,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  21
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -6,
                  7
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -6,
                  -1
                ],
                [
                  -3,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -5,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -3,
                  0
                ],
                [
                  -4,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -6,
                  -2
                ],
                [
                  -9,
                  -3
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -5,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -3,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -3,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  -6,
                  -14
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -3
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -4
                ],
                [
                  -4,
                  -7
                ],
                [
                  0,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -4,
                  -5
                ],
                [
                  -2,
                  -2
                ],
                [
                  -4,
                  -3
                ],
                [
                  -5,
                  -4
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -3
                ],
                [
                  0,
                  -37
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -3
                ],
                [
                  -8,
                  -10
                ],
                [
                  -4,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -3
                ],
                [
                  -3,
                  -26
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -12,
                  -21
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -15
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -6,
                  -2
                ],
                [
                  -12,
                  -1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -14,
                  -9
                ],
                [
                  -4,
                  -2
                ],
                [
                  -8,
                  -6
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ]
              ],
              [
                [
                  6280,
                  6338
                ],
                [
                  5,
                  19
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  5
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  4
                ],
                [
                  0,
                  2
                ],
                [
                  -3,
                  10
                ],
                [
                  -2,
                  10
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  0
                ],
                [
                  -12,
                  -1
                ],
                [
                  -2,
                  1
                ],
                [
                  0,
                  4
                ],
                [
                  0,
                  1
                ],
                [
                  -3,
                  3
                ],
                [
                  -11,
                  4
                ],
                [
                  -4,
                  2
                ],
                [
                  -5,
                  5
                ],
                [
                  -4,
                  6
                ],
                [
                  -3,
                  6
                ],
                [
                  0,
                  7
                ],
                [
                  7,
                  43
                ],
                [
                  2,
                  7
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  1
                ],
                [
                  -5,
                  -1
                ],
                [
                  -8,
                  -3
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  3,
                  15
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  -10,
                  31
                ],
                [
                  -4,
                  7
                ],
                [
                  -1,
                  2
                ],
                [
                  3,
                  4
                ],
                [
                  7,
                  16
                ],
                [
                  -2,
                  2
                ],
                [
                  -13,
                  5
                ],
                [
                  -16,
                  11
                ],
                [
                  -4,
                  -5
                ],
                [
                  -4,
                  -5
                ],
                [
                  -5,
                  -3
                ],
                [
                  -6,
                  -1
                ],
                [
                  -6,
                  -1
                ],
                [
                  -5,
                  0
                ],
                [
                  -5,
                  1
                ],
                [
                  -5,
                  2
                ],
                [
                  -3,
                  3
                ],
                [
                  -5,
                  10
                ],
                [
                  -3,
                  5
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  4
                ],
                [
                  4,
                  11
                ],
                [
                  10,
                  21
                ],
                [
                  4,
                  6
                ],
                [
                  5,
                  4
                ],
                [
                  2,
                  1
                ],
                [
                  14,
                  6
                ],
                [
                  2,
                  2
                ],
                [
                  12,
                  13
                ],
                [
                  5,
                  6
                ],
                [
                  1,
                  6
                ],
                [
                  -2,
                  3
                ],
                [
                  -4,
                  6
                ],
                [
                  -2,
                  3
                ],
                [
                  -1,
                  3
                ],
                [
                  0,
                  8
                ],
                [
                  -2,
                  5
                ],
                [
                  -8,
                  8
                ],
                [
                  -2,
                  6
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  -2,
                  3
                ],
                [
                  -3,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  3,
                  5
                ],
                [
                  10,
                  14
                ],
                [
                  2,
                  2
                ],
                [
                  3,
                  3
                ],
                [
                  4,
                  3
                ],
                [
                  20,
                  10
                ],
                [
                  3,
                  2
                ],
                [
                  5,
                  5
                ],
                [
                  3,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  2,
                  3
                ],
                [
                  0,
                  4
                ],
                [
                  -1,
                  4
                ],
                [
                  -1,
                  3
                ],
                [
                  -2,
                  2
                ],
                [
                  -7,
                  1
                ],
                [
                  -3,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  15
                ],
                [
                  -1,
                  2
                ],
                [
                  -4,
                  3
                ],
                [
                  -3,
                  5
                ],
                [
                  3,
                  5
                ],
                [
                  5,
                  4
                ],
                [
                  6,
                  3
                ],
                [
                  26,
                  7
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  4
                ],
                [
                  0,
                  3
                ],
                [
                  -1,
                  8
                ],
                [
                  0,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  4,
                  4
                ],
                [
                  3,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  12,
                  13
                ],
                [
                  2,
                  2
                ],
                [
                  3,
                  2
                ],
                [
                  5,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  6,
                  11
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  16
                ],
                [
                  0,
                  5
                ],
                [
                  -1,
                  4
                ],
                [
                  -3,
                  4
                ],
                [
                  -3,
                  3
                ],
                [
                  -2,
                  4
                ],
                [
                  -1,
                  4
                ],
                [
                  1,
                  4
                ],
                [
                  2,
                  3
                ],
                [
                  11,
                  7
                ],
                [
                  8,
                  10
                ],
                [
                  3,
                  3
                ],
                [
                  4,
                  0
                ],
                [
                  6,
                  1
                ],
                [
                  20,
                  -5
                ],
                [
                  10,
                  1
                ],
                [
                  17,
                  7
                ],
                [
                  8,
                  2
                ],
                [
                  15,
                  0
                ],
                [
                  16,
                  -3
                ],
                [
                  15,
                  -5
                ],
                [
                  4,
                  0
                ],
                [
                  1,
                  4
                ],
                [
                  0,
                  8
                ],
                [
                  0,
                  32
                ],
                [
                  0,
                  32
                ],
                [
                  0,
                  33
                ],
                [
                  0,
                  32
                ],
                [
                  0,
                  32
                ],
                [
                  0,
                  32
                ],
                [
                  0,
                  32
                ],
                [
                  0,
                  32
                ],
                [
                  0,
                  33
                ],
                [
                  0,
                  32
                ],
                [
                  0,
                  32
                ],
                [
                  0,
                  32
                ],
                [
                  0,
                  32
                ],
                [
                  0,
                  33
                ],
                [
                  0,
                  32
                ],
                [
                  0,
                  32
                ]
              ],
              [
                [
                  7728,
                  5409
                ],
                [
                  -11,
                  -11
                ],
                [
                  -11,
                  -11
                ],
                [
                  -14,
                  -16
                ],
                [
                  -13,
                  -13
                ],
                [
                  -9,
                  -10
                ],
                [
                  -1,
                  -1
                ],
                [
                  -5,
                  -3
                ],
                [
                  -5,
                  -1
                ],
                [
                  -21,
                  2
                ],
                [
                  -12,
                  0
                ],
                [
                  -4,
                  1
                ],
                [
                  -3,
                  2
                ],
                [
                  -16,
                  14
                ],
                [
                  -3,
                  1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -8,
                  -6
                ],
                [
                  -10,
                  -6
                ],
                [
                  -11,
                  -3
                ],
                [
                  -21,
                  -2
                ],
                [
                  -24,
                  -2
                ],
                [
                  -5,
                  -1
                ],
                [
                  -24,
                  -16
                ],
                [
                  -2,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -4
                ],
                [
                  0,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  -9,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -10,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  3
                ],
                [
                  0,
                  6
                ],
                [
                  -1,
                  3
                ],
                [
                  -2,
                  3
                ],
                [
                  -9,
                  11
                ],
                [
                  -3,
                  3
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -10,
                  -13
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -13,
                  -2
                ],
                [
                  -3,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  1
                ],
                [
                  -17,
                  9
                ],
                [
                  -11,
                  7
                ],
                [
                  -5,
                  1
                ],
                [
                  -5,
                  1
                ],
                [
                  -6,
                  0
                ],
                [
                  -4,
                  -1
                ],
                [
                  -4,
                  -4
                ],
                [
                  -4,
                  -3
                ],
                [
                  -1,
                  0
                ],
                [
                  -3,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -4,
                  -4
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -8,
                  -14
                ],
                [
                  -3,
                  -6
                ],
                [
                  -1,
                  -2
                ]
              ],
              [
                [
                  2600,
                  9802
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  3,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  2,
                  0
                ],
                [
                  4,
                  1
                ],
                [
                  -1,
                  -3
                ],
                [
                  -6,
                  -3
                ],
                [
                  -1,
                  -3
                ]
              ],
              [
                [
                  2919,
                  9720
                ],
                [
                  3,
                  -6
                ],
                [
                  1,
                  -2
                ]
              ],
              [
                [
                  1124,
                  6533
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  3
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  6
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  7,
                  4
                ],
                [
                  3,
                  0
                ],
                [
                  4,
                  0
                ],
                [
                  4,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  5,
                  4
                ],
                [
                  2,
                  -3
                ],
                [
                  2,
                  -5
                ],
                [
                  2,
                  -1
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  4,
                  -3
                ],
                [
                  4,
                  -1
                ],
                [
                  4,
                  -2
                ],
                [
                  3,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  4
                ],
                [
                  3,
                  1
                ],
                [
                  3,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  3,
                  0
                ],
                [
                  3,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  10,
                  4
                ],
                [
                  2,
                  1
                ],
                [
                  4,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  4,
                  -3
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  9,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  -1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  6,
                  3
                ],
                [
                  2,
                  2
                ],
                [
                  4,
                  6
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  4
                ],
                [
                  -1,
                  4
                ],
                [
                  2,
                  4
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  3,
                  -3
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -3,
                  -3
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -8
                ],
                [
                  1,
                  -5
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -3
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -3,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -6,
                  -6
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  5
                ],
                [
                  -3,
                  1
                ],
                [
                  -10,
                  2
                ],
                [
                  -6,
                  -4
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -3,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  4
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  3
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -3
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -5
                ],
                [
                  -4,
                  -2
                ],
                [
                  -5,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -3,
                  1
                ],
                [
                  -5,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -3,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -4,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  -6,
                  1
                ],
                [
                  -4,
                  3
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  -11
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  2
                ],
                [
                  -5,
                  5
                ],
                [
                  0,
                  2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  4
                ],
                [
                  2,
                  3
                ],
                [
                  2,
                  3
                ],
                [
                  -1,
                  5
                ],
                [
                  0,
                  -4
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  -3
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -3
                ],
                [
                  1,
                  -5
                ],
                [
                  0,
                  -2
                ],
                [
                  -4,
                  -2
                ],
                [
                  -6,
                  -5
                ],
                [
                  -4,
                  -1
                ],
                [
                  -3,
                  1
                ],
                [
                  -1,
                  4
                ],
                [
                  0,
                  4
                ],
                [
                  1,
                  5
                ],
                [
                  2,
                  5
                ],
                [
                  3,
                  3
                ],
                [
                  5,
                  -2
                ],
                [
                  0,
                  2
                ],
                [
                  -2,
                  2
                ],
                [
                  -3,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -3,
                  -4
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  3,
                  4
                ],
                [
                  1,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  4,
                  7
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  4
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  3
                ],
                [
                  1,
                  6
                ],
                [
                  1,
                  3
                ],
                [
                  -1,
                  3
                ],
                [
                  0,
                  1
                ]
              ],
              [
                [
                  1146,
                  6707
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  4
                ],
                [
                  2,
                  2
                ],
                [
                  4,
                  2
                ],
                [
                  3,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -3,
                  1
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -3
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -3
                ],
                [
                  -2,
                  -2
                ],
                [
                  -3,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -3,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  6
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  4,
                  6
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  4,
                  1
                ],
                [
                  0,
                  -3
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -2
                ],
                [
                  2,
                  0
                ],
                [
                  -1,
                  4
                ],
                [
                  -1,
                  3
                ],
                [
                  0,
                  3
                ],
                [
                  -2,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  13
                ],
                [
                  1,
                  2
                ],
                [
                  -3,
                  -5
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -6
                ],
                [
                  -2,
                  -3
                ],
                [
                  -2,
                  -3
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -3,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -3
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  4
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  3,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  4,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  -1
                ],
                [
                  0,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  6,
                  4
                ],
                [
                  2,
                  2
                ],
                [
                  3,
                  5
                ],
                [
                  2,
                  1
                ],
                [
                  5,
                  1
                ],
                [
                  2,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  -9,
                  0
                ],
                [
                  -3,
                  1
                ],
                [
                  0,
                  3
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -3,
                  -6
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  0
                ],
                [
                  -3,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  -3
                ],
                [
                  -1,
                  -1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -3,
                  0
                ],
                [
                  -3,
                  1
                ],
                [
                  -3,
                  1
                ],
                [
                  3,
                  5
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  4,
                  4
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  -3
                ],
                [
                  -2,
                  -1
                ],
                [
                  -3,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  -3,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -3,
                  -3
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -4
                ],
                [
                  1,
                  -13
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  27
                ],
                [
                  0,
                  4
                ],
                [
                  -2,
                  6
                ],
                [
                  -3,
                  5
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  0
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  7
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -3,
                  3
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  2
                ],
                [
                  -4,
                  5
                ],
                [
                  -9,
                  4
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -5,
                  7
                ],
                [
                  -3,
                  9
                ],
                [
                  -5,
                  8
                ],
                [
                  -4,
                  4
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  1
                ],
                [
                  -3,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -5,
                  3
                ],
                [
                  -1,
                  1
                ],
                [
                  -5,
                  0
                ],
                [
                  -3,
                  1
                ],
                [
                  -4,
                  0
                ],
                [
                  -2,
                  -3
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  1
                ],
                [
                  -9,
                  11
                ],
                [
                  -2,
                  2
                ],
                [
                  21,
                  6
                ],
                [
                  7,
                  6
                ],
                [
                  19,
                  8
                ],
                [
                  5,
                  4
                ],
                [
                  20,
                  25
                ],
                [
                  5,
                  7
                ],
                [
                  9,
                  10
                ],
                [
                  18,
                  33
                ],
                [
                  9,
                  13
                ],
                [
                  17,
                  29
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  2
                ]
              ],
              [
                [
                  1662,
                  5879
                ],
                [
                  2,
                  0
                ],
                [
                  5,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -4
                ],
                [
                  0,
                  -3
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -5
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -3,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  2
                ],
                [
                  3,
                  0
                ],
                [
                  -2,
                  4
                ],
                [
                  -2,
                  3
                ],
                [
                  -3,
                  3
                ],
                [
                  -3,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -12,
                  3
                ],
                [
                  -5,
                  3
                ],
                [
                  -11,
                  1
                ],
                [
                  -13,
                  4
                ],
                [
                  0,
                  1
                ],
                [
                  5,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  5,
                  1
                ],
                [
                  14,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  5,
                  2
                ],
                [
                  8,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  -2,
                  -3
                ]
              ],
              [
                [
                  1808,
                  5783
                ],
                [
                  -2,
                  2
                ],
                [
                  -5,
                  2
                ],
                [
                  -3,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  -2,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -3,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  3
                ],
                [
                  -2,
                  2
                ],
                [
                  -7,
                  6
                ],
                [
                  -18,
                  11
                ],
                [
                  -31,
                  12
                ],
                [
                  -31,
                  13
                ],
                [
                  -25,
                  9
                ],
                [
                  4,
                  3
                ],
                [
                  5,
                  0
                ],
                [
                  5,
                  -1
                ],
                [
                  4,
                  -2
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -3,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  3
                ],
                [
                  2,
                  3
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  3,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  4,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  4,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  3
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  0,
                  1
                ],
                [
                  -3,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -3,
                  1
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  3
                ],
                [
                  -2,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -2
                ],
                [
                  -3,
                  3
                ],
                [
                  2,
                  5
                ],
                [
                  5,
                  7
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  -3,
                  2
                ],
                [
                  -2,
                  -2
                ],
                [
                  -4,
                  -7
                ],
                [
                  -6,
                  -4
                ],
                [
                  -4,
                  -2
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  -9,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -5,
                  4
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -7,
                  -3
                ],
                [
                  -6,
                  4
                ],
                [
                  -2,
                  4
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  4
                ],
                [
                  3,
                  0
                ],
                [
                  4,
                  3
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  4,
                  -2
                ],
                [
                  -3,
                  3
                ],
                [
                  -3,
                  2
                ],
                [
                  -3,
                  3
                ],
                [
                  -2,
                  6
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  -4,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  4
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -6,
                  -1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -4,
                  -2
                ],
                [
                  -3,
                  -3
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  1,
                  2
                ],
                [
                  -1,
                  6
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -5,
                  8
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  -4,
                  4
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  3,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  -1
                ],
                [
                  3,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  3,
                  -5
                ],
                [
                  4,
                  -3
                ],
                [
                  4,
                  -3
                ],
                [
                  3,
                  -2
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  2,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  -4,
                  1
                ],
                [
                  -4,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  2,
                  4
                ],
                [
                  1,
                  1
                ],
                [
                  4,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  9,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  -3,
                  1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -3,
                  0
                ],
                [
                  0,
                  2
                ],
                [
                  2,
                  3
                ],
                [
                  5,
                  11
                ],
                [
                  -3,
                  -4
                ],
                [
                  -2,
                  -4
                ],
                [
                  -3,
                  -3
                ],
                [
                  -5,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -3,
                  -2
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  3,
                  0
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  -4
                ],
                [
                  0,
                  -2
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  2
                ],
                [
                  -2,
                  3
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  4,
                  -3
                ],
                [
                  0,
                  -3
                ],
                [
                  -2,
                  -3
                ],
                [
                  -3,
                  -3
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -4,
                  6
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  4
                ],
                [
                  -2,
                  3
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  4
                ],
                [
                  1,
                  0
                ],
                [
                  -1,
                  15
                ],
                [
                  4,
                  4
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  10,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  2
                ],
                [
                  4,
                  0
                ],
                [
                  8,
                  0
                ],
                [
                  -6,
                  2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  3
                ],
                [
                  3,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  3,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -6,
                  -2
                ],
                [
                  -3,
                  0
                ],
                [
                  -3,
                  1
                ],
                [
                  -3,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  -3,
                  2
                ],
                [
                  1,
                  7
                ],
                [
                  -2,
                  3
                ]
              ],
              [
                [
                  9676,
                  6383
                ],
                [
                  0,
                  -15
                ],
                [
                  0,
                  -16
                ],
                [
                  0,
                  -15
                ],
                [
                  0,
                  -16
                ],
                [
                  0,
                  -16
                ],
                [
                  0,
                  -15
                ],
                [
                  0,
                  -16
                ],
                [
                  0,
                  -15
                ],
                [
                  0,
                  -16
                ],
                [
                  0,
                  -15
                ],
                [
                  0,
                  -16
                ],
                [
                  0,
                  -16
                ],
                [
                  0,
                  -15
                ],
                [
                  0,
                  -16
                ],
                [
                  0,
                  -15
                ],
                [
                  0,
                  -16
                ],
                [
                  -8,
                  -12
                ],
                [
                  -7,
                  -13
                ],
                [
                  -8,
                  -13
                ],
                [
                  -8,
                  -12
                ],
                [
                  -8,
                  -13
                ],
                [
                  -8,
                  -12
                ],
                [
                  -7,
                  -13
                ],
                [
                  -8,
                  -13
                ],
                [
                  -8,
                  -12
                ],
                [
                  -8,
                  -13
                ],
                [
                  -8,
                  -12
                ],
                [
                  -7,
                  -13
                ],
                [
                  -8,
                  -13
                ],
                [
                  -8,
                  -12
                ],
                [
                  -8,
                  -13
                ],
                [
                  -8,
                  -12
                ]
              ],
              [
                [
                  8934,
                  6416
                ],
                [
                  2,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  0,
                  5
                ],
                [
                  2,
                  -2
                ],
                [
                  3,
                  -5
                ],
                [
                  2,
                  -3
                ],
                [
                  2,
                  -1
                ],
                [
                  3,
                  -4
                ],
                [
                  2,
                  -1
                ],
                [
                  3,
                  0
                ],
                [
                  4,
                  -3
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  0,
                  -3
                ],
                [
                  -2,
                  -13
                ],
                [
                  1,
                  -4
                ],
                [
                  3,
                  -4
                ],
                [
                  3,
                  -3
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -4
                ],
                [
                  3,
                  -5
                ],
                [
                  6,
                  -12
                ],
                [
                  12,
                  -13
                ],
                [
                  10,
                  -13
                ],
                [
                  12,
                  -10
                ],
                [
                  14,
                  -10
                ],
                [
                  9,
                  -9
                ],
                [
                  7,
                  -4
                ],
                [
                  16,
                  -14
                ],
                [
                  4,
                  -3
                ],
                [
                  5,
                  -3
                ],
                [
                  6,
                  -3
                ],
                [
                  10,
                  1
                ],
                [
                  10,
                  -1
                ],
                [
                  5,
                  -2
                ],
                [
                  6,
                  1
                ],
                [
                  4,
                  2
                ],
                [
                  8,
                  2
                ],
                [
                  4,
                  2
                ],
                [
                  5,
                  -1
                ],
                [
                  8,
                  -1
                ],
                [
                  6,
                  -1
                ],
                [
                  8,
                  1
                ],
                [
                  5,
                  4
                ],
                [
                  -1,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  15,
                  9
                ],
                [
                  2,
                  1
                ],
                [
                  4,
                  1
                ],
                [
                  12,
                  8
                ],
                [
                  9,
                  9
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  3,
                  1
                ],
                [
                  4,
                  1
                ],
                [
                  6,
                  2
                ],
                [
                  4,
                  2
                ],
                [
                  3,
                  3
                ],
                [
                  4,
                  5
                ],
                [
                  2,
                  1
                ],
                [
                  10,
                  4
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  3,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  4
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  0
                ],
                [
                  -1,
                  3
                ],
                [
                  2,
                  0
                ],
                [
                  13,
                  -6
                ],
                [
                  4,
                  -1
                ],
                [
                  5,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  5,
                  -1
                ],
                [
                  4,
                  1
                ],
                [
                  10,
                  3
                ],
                [
                  3,
                  -1
                ],
                [
                  4,
                  -2
                ],
                [
                  6,
                  -6
                ],
                [
                  3,
                  -3
                ],
                [
                  5,
                  -2
                ],
                [
                  5,
                  -1
                ],
                [
                  5,
                  0
                ],
                [
                  4,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  3,
                  3
                ],
                [
                  5,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  5,
                  0
                ],
                [
                  3,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  5,
                  4
                ],
                [
                  11,
                  5
                ],
                [
                  6,
                  4
                ],
                [
                  5,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  12,
                  4
                ],
                [
                  10,
                  8
                ],
                [
                  6,
                  6
                ],
                [
                  5,
                  5
                ],
                [
                  1,
                  1
                ],
                [
                  6,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  3
                ],
                [
                  14,
                  7
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  0
                ],
                [
                  4,
                  0
                ],
                [
                  7,
                  1
                ],
                [
                  4,
                  0
                ],
                [
                  20,
                  -11
                ],
                [
                  4,
                  -1
                ],
                [
                  8,
                  4
                ],
                [
                  16,
                  0
                ],
                [
                  7,
                  -1
                ],
                [
                  24,
                  2
                ],
                [
                  4,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  4
                ],
                [
                  3,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  1
                ],
                [
                  3,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  4,
                  1
                ],
                [
                  9,
                  1
                ],
                [
                  4,
                  1
                ],
                [
                  4,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  8,
                  0
                ],
                [
                  7,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  9,
                  -3
                ],
                [
                  5,
                  -2
                ],
                [
                  5,
                  -3
                ],
                [
                  12,
                  -4
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  0
                ]
              ],
              [
                [
                  9678,
                  5656
                ],
                [
                  -59,
                  13
                ],
                [
                  -58,
                  13
                ],
                [
                  -59,
                  13
                ],
                [
                  -49,
                  12
                ],
                [
                  -49,
                  12
                ],
                [
                  -50,
                  12
                ]
              ],
              [
                [
                  9676,
                  6383
                ],
                [
                  5,
                  1
                ],
                [
                  17,
                  3
                ],
                [
                  17,
                  3
                ],
                [
                  5,
                  3
                ],
                [
                  2,
                  3
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  8,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  7,
                  5
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  6
                ],
                [
                  2,
                  3
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  0
                ],
                [
                  6,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  4,
                  -1
                ],
                [
                  11,
                  -2
                ],
                [
                  6,
                  1
                ],
                [
                  4,
                  3
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  11,
                  1
                ],
                [
                  3,
                  -1
                ],
                [
                  8,
                  5
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  4,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  5,
                  1
                ],
                [
                  3,
                  2
                ],
                [
                  11,
                  9
                ],
                [
                  6,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  5,
                  6
                ],
                [
                  4,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  3
                ],
                [
                  2,
                  3
                ],
                [
                  3,
                  4
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  6,
                  2
                ],
                [
                  5,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  9,
                  -7
                ],
                [
                  14,
                  -1
                ],
                [
                  8,
                  -7
                ],
                [
                  2,
                  0
                ],
                [
                  10,
                  0
                ],
                [
                  3,
                  -1
                ],
                [
                  4,
                  -3
                ],
                [
                  3,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  3,
                  -1
                ],
                [
                  3,
                  -1
                ],
                [
                  3,
                  -1
                ],
                [
                  -2,
                  -4
                ],
                [
                  -2,
                  -6
                ],
                [
                  -2,
                  -4
                ],
                [
                  1,
                  -7
                ],
                [
                  -1,
                  -4
                ],
                [
                  -2,
                  -2
                ],
                [
                  -3,
                  -4
                ],
                [
                  -4,
                  -4
                ],
                [
                  -4,
                  -6
                ],
                [
                  -3,
                  -3
                ],
                [
                  -1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -3
                ],
                [
                  -1,
                  -3
                ],
                [
                  -4,
                  -10
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -9
                ],
                [
                  -1,
                  -6
                ],
                [
                  2,
                  -6
                ],
                [
                  6,
                  -4
                ],
                [
                  5,
                  0
                ],
                [
                  2,
                  -3
                ],
                [
                  -3,
                  -3
                ],
                [
                  -3,
                  -7
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -3
                ],
                [
                  0,
                  -3
                ],
                [
                  1,
                  -19
                ],
                [
                  2,
                  -25
                ],
                [
                  3,
                  -11
                ],
                [
                  -1,
                  -1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  1,
                  -6
                ],
                [
                  -1,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -3,
                  0
                ],
                [
                  -3,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  -3
                ],
                [
                  1,
                  -2
                ],
                [
                  3,
                  0
                ],
                [
                  19,
                  4
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  4
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  3
                ],
                [
                  2,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  3,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  3,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  -3
                ],
                [
                  2,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  -5
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  -3,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -4,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -20,
                  -2
                ],
                [
                  -9,
                  -4
                ],
                [
                  -12,
                  -7
                ],
                [
                  -2,
                  -5
                ],
                [
                  -1,
                  -8
                ],
                [
                  1,
                  -8
                ],
                [
                  -3,
                  -11
                ],
                [
                  0,
                  -6
                ],
                [
                  2,
                  -4
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  -9
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -7
                ],
                [
                  -2,
                  -5
                ],
                [
                  -1,
                  -2
                ],
                [
                  1,
                  -4
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -3
                ],
                [
                  -1,
                  -8
                ],
                [
                  -3,
                  -4
                ],
                [
                  0,
                  -4
                ],
                [
                  1,
                  -7
                ],
                [
                  3,
                  -9
                ],
                [
                  1,
                  -3
                ],
                [
                  0,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  -8,
                  -14
                ],
                [
                  -3,
                  -2
                ],
                [
                  -6,
                  -3
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -4,
                  -7
                ],
                [
                  -1,
                  -2
                ],
                [
                  1,
                  -9
                ],
                [
                  0,
                  -3
                ],
                [
                  -2,
                  -5
                ],
                [
                  -4,
                  -5
                ],
                [
                  -14,
                  -12
                ],
                [
                  -4,
                  -4
                ],
                [
                  -3,
                  -5
                ],
                [
                  -3,
                  -4
                ],
                [
                  -1,
                  -6
                ],
                [
                  -3,
                  -11
                ],
                [
                  -2,
                  -5
                ],
                [
                  -6,
                  -8
                ],
                [
                  -1,
                  -3
                ],
                [
                  0,
                  -8
                ],
                [
                  0,
                  -3
                ],
                [
                  -2,
                  -5
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  -3
                ],
                [
                  -8,
                  -12
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -5
                ],
                [
                  -4,
                  -12
                ],
                [
                  -3,
                  -6
                ],
                [
                  -4,
                  -4
                ],
                [
                  -17,
                  -11
                ],
                [
                  -11,
                  -12
                ],
                [
                  -2,
                  -4
                ],
                [
                  -2,
                  -5
                ],
                [
                  -1,
                  -10
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -3
                ],
                [
                  0,
                  -3
                ],
                [
                  -1,
                  -3
                ],
                [
                  -4,
                  -6
                ],
                [
                  -4,
                  -4
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -6
                ],
                [
                  -1,
                  -3
                ],
                [
                  -13,
                  -25
                ],
                [
                  -7,
                  -13
                ],
                [
                  -9,
                  -10
                ],
                [
                  -20,
                  -30
                ],
                [
                  -10,
                  -20
                ],
                [
                  -6,
                  -10
                ],
                [
                  -6,
                  -19
                ],
                [
                  -16,
                  -35
                ],
                [
                  0,
                  -3
                ],
                [
                  0,
                  -4
                ],
                [
                  1,
                  -5
                ],
                [
                  0,
                  -3
                ],
                [
                  -1,
                  -13
                ],
                [
                  -5,
                  -10
                ],
                [
                  -11,
                  -20
                ]
              ],
              [
                [
                  9678,
                  5656
                ],
                [
                  -13,
                  -24
                ],
                [
                  -20,
                  -33
                ],
                [
                  -7,
                  -15
                ],
                [
                  -3,
                  -5
                ],
                [
                  -10,
                  -10
                ],
                [
                  -13,
                  -23
                ],
                [
                  -15,
                  -17
                ],
                [
                  -17,
                  -24
                ],
                [
                  -19,
                  -41
                ],
                [
                  -14,
                  -22
                ],
                [
                  -14,
                  -16
                ],
                [
                  -34,
                  -39
                ],
                [
                  -12,
                  -17
                ],
                [
                  -20,
                  -22
                ],
                [
                  -16,
                  -18
                ],
                [
                  -22,
                  -25
                ],
                [
                  -4,
                  -4
                ],
                [
                  -23,
                  -28
                ],
                [
                  -17,
                  -17
                ],
                [
                  -10,
                  -12
                ],
                [
                  -18,
                  -16
                ],
                [
                  -10,
                  -11
                ],
                [
                  -8,
                  -6
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -3
                ],
                [
                  -2,
                  -3
                ],
                [
                  -2,
                  -1
                ],
                [
                  -5,
                  -3
                ],
                [
                  -12,
                  -13
                ],
                [
                  -1,
                  -2
                ],
                [
                  -3,
                  -5
                ],
                [
                  -1,
                  -1
                ],
                [
                  -5,
                  -4
                ],
                [
                  -2,
                  -4
                ],
                [
                  -3,
                  -2
                ],
                [
                  -26,
                  -18
                ],
                [
                  -15,
                  -9
                ],
                [
                  -14,
                  -9
                ],
                [
                  -44,
                  -27
                ],
                [
                  -4,
                  -3
                ],
                [
                  -3,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -26,
                  -13
                ],
                [
                  -22,
                  -16
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -18,
                  -13
                ],
                [
                  -16,
                  -11
                ],
                [
                  -29,
                  -24
                ],
                [
                  -14,
                  -16
                ],
                [
                  -3,
                  -1
                ],
                [
                  -5,
                  -3
                ],
                [
                  -2,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -3
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  -10,
                  -10
                ],
                [
                  -2,
                  -2
                ],
                [
                  -3,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -6,
                  -8
                ],
                [
                  -14,
                  -9
                ],
                [
                  -5,
                  -4
                ],
                [
                  -7,
                  -9
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -5,
                  -5
                ],
                [
                  -25,
                  -25
                ],
                [
                  -24,
                  -29
                ],
                [
                  -13,
                  -13
                ],
                [
                  -12,
                  -13
                ],
                [
                  -26,
                  -31
                ],
                [
                  -16,
                  -18
                ],
                [
                  -8,
                  -7
                ],
                [
                  -8,
                  -7
                ],
                [
                  -9,
                  -10
                ],
                [
                  -3,
                  -4
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -5,
                  -8
                ],
                [
                  -1,
                  -2
                ],
                [
                  2,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -7,
                  -5
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  -4,
                  -5
                ],
                [
                  -13,
                  -16
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -5,
                  -9
                ],
                [
                  -4,
                  -4
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -4,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  -2
                ],
                [
                  2,
                  0
                ],
                [
                  0,
                  -3
                ],
                [
                  -1,
                  -3
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -3
                ],
                [
                  -1,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -5,
                  -4
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  6
                ],
                [
                  0,
                  5
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  0
                ],
                [
                  1,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -4,
                  -3
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -5,
                  -6
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  -1,
                  -4
                ],
                [
                  -3,
                  0
                ],
                [
                  -3,
                  2
                ],
                [
                  -1,
                  4
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -3
                ],
                [
                  2,
                  -5
                ],
                [
                  0,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  -13,
                  -24
                ],
                [
                  -3,
                  -4
                ],
                [
                  -3,
                  -4
                ],
                [
                  -5,
                  -10
                ],
                [
                  -2,
                  -2
                ],
                [
                  -3,
                  -2
                ],
                [
                  -5,
                  -8
                ],
                [
                  -2,
                  -3
                ],
                [
                  -3,
                  -3
                ]
              ],
              [
                [
                  4275,
                  5057
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  -2
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  4
                ],
                [
                  0,
                  2
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  3
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  4,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -2
                ]
              ],
              [
                [
                  4173,
                  4881
                ],
                [
                  3,
                  -2
                ],
                [
                  3,
                  -3
                ],
                [
                  2,
                  -4
                ],
                [
                  2,
                  -4
                ],
                [
                  0,
                  -4
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -4,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  -4,
                  -7
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  -4,
                  -1
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  -5
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  -3
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -5,
                  16
                ],
                [
                  -1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  5,
                  5
                ],
                [
                  1,
                  0
                ],
                [
                  4,
                  2
                ],
                [
                  5,
                  4
                ],
                [
                  4,
                  3
                ],
                [
                  5,
                  -1
                ]
              ],
              [
                [
                  7485,
                  1106
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  3
                ],
                [
                  -2,
                  0
                ],
                [
                  -9,
                  0
                ],
                [
                  0,
                  -4
                ],
                [
                  -2,
                  -12
                ],
                [
                  -2,
                  -11
                ],
                [
                  -2,
                  -13
                ],
                [
                  0,
                  -9
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -11
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  -12,
                  0
                ],
                [
                  -12,
                  0
                ],
                [
                  -19,
                  0
                ],
                [
                  -14,
                  1
                ],
                [
                  -9,
                  1
                ],
                [
                  -14,
                  5
                ],
                [
                  -9,
                  3
                ],
                [
                  -5,
                  2
                ],
                [
                  -12,
                  3
                ],
                [
                  -1,
                  2
                ],
                [
                  -3,
                  1
                ],
                [
                  -6,
                  9
                ],
                [
                  -13,
                  12
                ],
                [
                  -3,
                  5
                ],
                [
                  -1,
                  3
                ],
                [
                  2,
                  6
                ],
                [
                  0,
                  3
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  2
                ],
                [
                  -4,
                  4
                ],
                [
                  -2,
                  2
                ],
                [
                  -2,
                  6
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -3,
                  0
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  10
                ],
                [
                  0,
                  19
                ],
                [
                  0,
                  15
                ],
                [
                  3,
                  10
                ],
                [
                  12,
                  15
                ],
                [
                  9,
                  11
                ],
                [
                  9,
                  15
                ],
                [
                  7,
                  17
                ],
                [
                  2,
                  7
                ],
                [
                  2,
                  3
                ],
                [
                  11,
                  10
                ],
                [
                  13,
                  11
                ],
                [
                  4,
                  2
                ],
                [
                  4,
                  1
                ],
                [
                  4,
                  0
                ],
                [
                  4,
                  -1
                ],
                [
                  13,
                  -9
                ],
                [
                  14,
                  -8
                ],
                [
                  12,
                  -8
                ],
                [
                  2,
                  -1
                ],
                [
                  12,
                  -7
                ],
                [
                  3,
                  -1
                ],
                [
                  4,
                  1
                ],
                [
                  8,
                  3
                ]
              ],
              [
                [
                  3514,
                  5686
                ],
                [
                  -25,
                  -5
                ],
                [
                  -21,
                  -6
                ],
                [
                  -9,
                  -5
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ]
              ],
              [
                [
                  4726,
                  9521
                ],
                [
                  4,
                  -4
                ],
                [
                  4,
                  -3
                ],
                [
                  3,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  3,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  -8,
                  -7
                ],
                [
                  -3,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -4
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  -5
                ],
                [
                  -2,
                  -3
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  -2,
                  3
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  -3,
                  1
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  -3
                ],
                [
                  -2,
                  0
                ],
                [
                  -3,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  4
                ],
                [
                  0,
                  4
                ],
                [
                  2,
                  4
                ],
                [
                  -1,
                  5
                ],
                [
                  0,
                  5
                ],
                [
                  5,
                  1
                ],
                [
                  10,
                  -2
                ],
                [
                  6,
                  0
                ],
                [
                  4,
                  2
                ]
              ],
              [
                [
                  4748,
                  9625
                ],
                [
                  -5,
                  -3
                ],
                [
                  -3,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -5,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  15,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  -2,
                  -2
                ]
              ],
              [
                [
                  4772,
                  9641
                ],
                [
                  3,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  -13,
                  -4
                ],
                [
                  -6,
                  -4
                ],
                [
                  -3,
                  -1
                ],
                [
                  -1,
                  3
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  3,
                  0
                ],
                [
                  1,
                  3
                ],
                [
                  -1,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  3,
                  -1
                ],
                [
                  3,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ]
              ],
              [
                [
                  4423,
                  9943
                ],
                [
                  3,
                  1
                ],
                [
                  9,
                  3
                ],
                [
                  3,
                  0
                ],
                [
                  11,
                  0
                ],
                [
                  3,
                  1
                ],
                [
                  5,
                  4
                ],
                [
                  4,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  3
                ],
                [
                  4,
                  4
                ],
                [
                  4,
                  6
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  4,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  4,
                  1
                ],
                [
                  11,
                  4
                ],
                [
                  1,
                  1
                ],
                [
                  3,
                  4
                ],
                [
                  2,
                  1
                ],
                [
                  17,
                  0
                ],
                [
                  5,
                  1
                ],
                [
                  4,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  4,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  3,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  5,
                  3
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  5,
                  0
                ],
                [
                  3,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  11,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -6
                ],
                [
                  -4,
                  -3
                ],
                [
                  -5,
                  -2
                ],
                [
                  -3,
                  -3
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -4
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  6,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  -8,
                  3
                ],
                [
                  -1,
                  -1
                ],
                [
                  -3,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  12,
                  -3
                ],
                [
                  3,
                  0
                ],
                [
                  7,
                  3
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  -3
                ],
                [
                  9,
                  -1
                ],
                [
                  4,
                  -3
                ],
                [
                  10,
                  -3
                ],
                [
                  3,
                  -2
                ],
                [
                  -5,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  2
                ],
                [
                  -4,
                  1
                ],
                [
                  -4,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  3,
                  -1
                ],
                [
                  4,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  2
                ],
                [
                  -5,
                  -4
                ],
                [
                  1,
                  -7
                ],
                [
                  5,
                  -7
                ],
                [
                  6,
                  -5
                ],
                [
                  5,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  3,
                  -4
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  -3,
                  -3
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  1,
                  3
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -4,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -3,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  4,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  3
                ],
                [
                  2,
                  -6
                ],
                [
                  4,
                  -4
                ],
                [
                  4,
                  -2
                ],
                [
                  7,
                  -1
                ],
                [
                  1,
                  1
                ],
                [
                  3,
                  0
                ],
                [
                  7,
                  2
                ],
                [
                  4,
                  1
                ],
                [
                  2,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  4
                ],
                [
                  2,
                  5
                ],
                [
                  2,
                  2
                ],
                [
                  3,
                  1
                ],
                [
                  6,
                  -1
                ],
                [
                  6,
                  1
                ],
                [
                  5,
                  2
                ],
                [
                  6,
                  4
                ],
                [
                  4,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  8,
                  5
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  7,
                  1
                ],
                [
                  5,
                  3
                ],
                [
                  3,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -3
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -3
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -6,
                  -2
                ],
                [
                  -7,
                  -5
                ],
                [
                  -4,
                  -6
                ],
                [
                  -5,
                  -7
                ],
                [
                  -9,
                  -15
                ],
                [
                  -7,
                  -15
                ],
                [
                  -4,
                  -4
                ],
                [
                  -10,
                  -2
                ],
                [
                  -13,
                  -6
                ],
                [
                  -5,
                  1
                ],
                [
                  -4,
                  -3
                ],
                [
                  -4,
                  -6
                ],
                [
                  -2,
                  -5
                ],
                [
                  -2,
                  -6
                ],
                [
                  -1,
                  -5
                ],
                [
                  -1,
                  -7
                ],
                [
                  0,
                  -8
                ],
                [
                  1,
                  -4
                ],
                [
                  1,
                  -5
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -1
                ],
                [
                  3,
                  -4
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  3,
                  -9
                ],
                [
                  2,
                  -2
                ],
                [
                  9,
                  -8
                ],
                [
                  3,
                  -1
                ],
                [
                  4,
                  -1
                ],
                [
                  8,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  3,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  1,
                  -3
                ],
                [
                  2,
                  -2
                ],
                [
                  5,
                  -2
                ],
                [
                  12,
                  -4
                ],
                [
                  5,
                  0
                ],
                [
                  4,
                  -3
                ],
                [
                  2,
                  -3
                ],
                [
                  -5,
                  -1
                ],
                [
                  -1,
                  -4
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -3
                ],
                [
                  2,
                  -2
                ],
                [
                  6,
                  -2
                ],
                [
                  -3,
                  -2
                ],
                [
                  -1,
                  -4
                ],
                [
                  -1,
                  -4
                ],
                [
                  1,
                  -6
                ],
                [
                  -2,
                  -3
                ],
                [
                  1,
                  -5
                ],
                [
                  3,
                  -4
                ],
                [
                  5,
                  -5
                ],
                [
                  2,
                  -2
                ],
                [
                  4,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -3
                ],
                [
                  -4,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -3,
                  -5
                ],
                [
                  -3,
                  -3
                ],
                [
                  -2,
                  -3
                ],
                [
                  -2,
                  -3
                ],
                [
                  -3,
                  -2
                ],
                [
                  1,
                  -4
                ],
                [
                  0,
                  -4
                ],
                [
                  -5,
                  -5
                ],
                [
                  -5,
                  -2
                ],
                [
                  -3,
                  -4
                ],
                [
                  1,
                  -3
                ],
                [
                  -2,
                  -3
                ],
                [
                  0,
                  -5
                ],
                [
                  -5,
                  -4
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -2
                ],
                [
                  -5,
                  -2
                ],
                [
                  -3,
                  -2
                ],
                [
                  -4,
                  -4
                ],
                [
                  -2,
                  -4
                ],
                [
                  -3,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  -3,
                  -2
                ],
                [
                  -8,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  -3,
                  -1
                ],
                [
                  -12,
                  -2
                ],
                [
                  -5,
                  -2
                ],
                [
                  -7,
                  -10
                ],
                [
                  -6,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -3
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -7,
                  -3
                ],
                [
                  -2,
                  -2
                ],
                [
                  -5,
                  -1
                ],
                [
                  -4,
                  -3
                ],
                [
                  -1,
                  -5
                ],
                [
                  -5,
                  -8
                ],
                [
                  -3,
                  -4
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -3
                ],
                [
                  -1,
                  -6
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -6
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -5
                ],
                [
                  3,
                  -5
                ],
                [
                  12,
                  -15
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  19,
                  -17
                ],
                [
                  5,
                  -2
                ],
                [
                  10,
                  -4
                ],
                [
                  2,
                  -1
                ],
                [
                  4,
                  0
                ],
                [
                  9,
                  1
                ],
                [
                  10,
                  2
                ],
                [
                  8,
                  4
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  -5
                ],
                [
                  0,
                  -10
                ],
                [
                  -4,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  1,
                  -3
                ],
                [
                  3,
                  -4
                ],
                [
                  2,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  6,
                  1
                ],
                [
                  10,
                  6
                ],
                [
                  4,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  4,
                  3
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  6,
                  -2
                ],
                [
                  2,
                  -2
                ],
                [
                  2,
                  -2
                ],
                [
                  4,
                  -6
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -7
                ],
                [
                  -4,
                  -5
                ],
                [
                  3,
                  -9
                ],
                [
                  -1,
                  -4
                ],
                [
                  3,
                  1
                ],
                [
                  3,
                  -2
                ],
                [
                  3,
                  -3
                ],
                [
                  3,
                  -2
                ],
                [
                  3,
                  0
                ],
                [
                  6,
                  -3
                ],
                [
                  4,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -13,
                  3
                ],
                [
                  -6,
                  1
                ],
                [
                  -2,
                  -4
                ],
                [
                  1,
                  -2
                ],
                [
                  3,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -2
                ],
                [
                  3,
                  0
                ],
                [
                  5,
                  1
                ],
                [
                  6,
                  -1
                ],
                [
                  11,
                  -4
                ],
                [
                  6,
                  0
                ],
                [
                  2,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  -2,
                  2
                ],
                [
                  12,
                  -8
                ],
                [
                  7,
                  -3
                ],
                [
                  1,
                  0
                ]
              ],
              [
                [
                  8479,
                  3707
                ],
                [
                  -3,
                  -4
                ],
                [
                  -3,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  2,
                  3
                ],
                [
                  4,
                  5
                ],
                [
                  4,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -6,
                  -7
                ]
              ],
              [
                [
                  8498,
                  3750
                ],
                [
                  -3,
                  -9
                ],
                [
                  -2,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -3
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  -4,
                  1
                ],
                [
                  -4,
                  -1
                ],
                [
                  -1,
                  -3
                ],
                [
                  -1,
                  -3
                ],
                [
                  -2,
                  -2
                ],
                [
                  -5,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -3,
                  1
                ],
                [
                  -4,
                  4
                ],
                [
                  -2,
                  2
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  5,
                  6
                ],
                [
                  2,
                  3
                ],
                [
                  -1,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  4,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -3,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  -2
                ],
                [
                  -1,
                  -4
                ],
                [
                  -2,
                  -10
                ]
              ],
              [
                [
                  8407,
                  4177
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -4
                ],
                [
                  -1,
                  -4
                ],
                [
                  -2,
                  -3
                ],
                [
                  -4,
                  -2
                ],
                [
                  3,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -3
                ],
                [
                  0,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -4,
                  -8
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  2
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  3
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  -7
                ],
                [
                  -2,
                  -3
                ],
                [
                  -3,
                  0
                ],
                [
                  2,
                  -3
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -7
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  2,
                  1
                ],
                [
                  4,
                  1
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -3
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -5,
                  -5
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -6
                ],
                [
                  -4,
                  -6
                ],
                [
                  -1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  3
                ],
                [
                  0,
                  -2
                ],
                [
                  -5,
                  -17
                ],
                [
                  -2,
                  -4
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -3
                ],
                [
                  -2,
                  -5
                ],
                [
                  -4,
                  -8
                ],
                [
                  -4,
                  -7
                ],
                [
                  -5,
                  -3
                ],
                [
                  2,
                  -1
                ],
                [
                  -1,
                  -3
                ],
                [
                  0,
                  -7
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  -5
                ],
                [
                  -3,
                  -5
                ],
                [
                  -1,
                  -3
                ],
                [
                  0,
                  -3
                ],
                [
                  0,
                  -9
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -3
                ],
                [
                  -1,
                  -3
                ],
                [
                  -1,
                  -3
                ],
                [
                  0,
                  -3
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -5
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  3,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -5
                ],
                [
                  0,
                  -4
                ],
                [
                  -1,
                  -3
                ],
                [
                  -2,
                  -2
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -8
                ],
                [
                  1,
                  -3
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  4,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  0,
                  2
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  3,
                  -1
                ],
                [
                  3,
                  -2
                ],
                [
                  7,
                  -7
                ],
                [
                  5,
                  -5
                ],
                [
                  3,
                  -3
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -4
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -3
                ],
                [
                  2,
                  -4
                ],
                [
                  2,
                  -2
                ],
                [
                  2,
                  3
                ],
                [
                  1,
                  -4
                ],
                [
                  -1,
                  -6
                ],
                [
                  0,
                  -5
                ],
                [
                  3,
                  -2
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  3,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  4,
                  -2
                ],
                [
                  2,
                  0
                ],
                [
                  4,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  4,
                  1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -4
                ],
                [
                  1,
                  -4
                ],
                [
                  7,
                  -8
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  1,
                  -9
                ],
                [
                  0,
                  -4
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -4
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -5,
                  -4
                ],
                [
                  -2,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -3
                ],
                [
                  -4,
                  -3
                ],
                [
                  -1,
                  -6
                ],
                [
                  -2,
                  -15
                ],
                [
                  0,
                  -3
                ],
                [
                  0,
                  -3
                ],
                [
                  2,
                  -4
                ],
                [
                  0,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  2,
                  -5
                ],
                [
                  0,
                  -2
                ],
                [
                  -6,
                  -7
                ],
                [
                  4,
                  1
                ],
                [
                  3,
                  3
                ],
                [
                  1,
                  5
                ],
                [
                  2,
                  4
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  5,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  -2
                ],
                [
                  3,
                  -4
                ],
                [
                  1,
                  -2
                ],
                [
                  -1,
                  -3
                ],
                [
                  -2,
                  -4
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -5
                ],
                [
                  0,
                  -5
                ],
                [
                  1,
                  -3
                ],
                [
                  2,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  -4
                ],
                [
                  -2,
                  -4
                ],
                [
                  -4,
                  -7
                ],
                [
                  -4,
                  -13
                ],
                [
                  -2,
                  -3
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -5
                ],
                [
                  0,
                  -3
                ],
                [
                  -2,
                  1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -3
                ],
                [
                  -3,
                  3
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  2,
                  -3
                ],
                [
                  1,
                  -4
                ],
                [
                  1,
                  -4
                ],
                [
                  0,
                  -4
                ],
                [
                  -1,
                  -8
                ],
                [
                  0,
                  -4
                ],
                [
                  5,
                  -4
                ],
                [
                  1,
                  -4
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -3
                ],
                [
                  0,
                  -12
                ],
                [
                  -1,
                  -3
                ],
                [
                  5,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -5
                ],
                [
                  2,
                  -2
                ],
                [
                  3,
                  -3
                ],
                [
                  1,
                  -2
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  2
                ],
                [
                  -3,
                  3
                ],
                [
                  -3,
                  3
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  -4
                ],
                [
                  1,
                  -1
                ],
                [
                  8,
                  1
                ],
                [
                  -1,
                  -3
                ],
                [
                  -1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  3,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -4
                ],
                [
                  2,
                  -1
                ],
                [
                  0,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  -2
                ],
                [
                  6,
                  -7
                ],
                [
                  2,
                  -4
                ],
                [
                  0,
                  -5
                ],
                [
                  -2,
                  -4
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -3
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -5
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  -3
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  3,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  4,
                  -3
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  -8
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -3
                ],
                [
                  -1,
                  -1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  5,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -4
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -4
                ],
                [
                  -1,
                  -3
                ],
                [
                  -2,
                  -2
                ],
                [
                  -4,
                  1
                ],
                [
                  1,
                  -2
                ],
                [
                  4,
                  -3
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -4,
                  -2
                ],
                [
                  -4,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -3
                ],
                [
                  0,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  3,
                  1
                ],
                [
                  6,
                  8
                ],
                [
                  3,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  4,
                  1
                ],
                [
                  2,
                  -3
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  -3
                ],
                [
                  8,
                  -13
                ],
                [
                  0,
                  -8
                ],
                [
                  1,
                  -4
                ],
                [
                  2,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  -2,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  4,
                  -2
                ],
                [
                  2,
                  0
                ],
                [
                  5,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  3,
                  -3
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -7,
                  3
                ],
                [
                  4,
                  5
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  3,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  4,
                  -10
                ],
                [
                  2,
                  -1
                ],
                [
                  4,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  4,
                  1
                ],
                [
                  1,
                  3
                ],
                [
                  -2,
                  2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -3
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  -1,
                  -5
                ],
                [
                  -1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -2
                ]
              ],
              [
                [
                  7590,
                  3521
                ],
                [
                  -2,
                  2
                ],
                [
                  -10,
                  3
                ],
                [
                  -6,
                  5
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -9,
                  1
                ],
                [
                  -11,
                  3
                ],
                [
                  -5,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  3
                ],
                [
                  -2,
                  7
                ],
                [
                  -2,
                  1
                ],
                [
                  -5,
                  4
                ],
                [
                  -5,
                  1
                ],
                [
                  -17,
                  0
                ],
                [
                  -3,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  2
                ],
                [
                  -5,
                  5
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -3,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  2
                ],
                [
                  -4,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -6,
                  1
                ],
                [
                  -2,
                  6
                ],
                [
                  0,
                  6
                ],
                [
                  2,
                  6
                ],
                [
                  -19,
                  6
                ],
                [
                  -3,
                  -1
                ],
                [
                  -5,
                  -2
                ],
                [
                  -3,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -13,
                  10
                ],
                [
                  -3,
                  4
                ],
                [
                  -1,
                  6
                ],
                [
                  0,
                  5
                ],
                [
                  -1,
                  4
                ],
                [
                  -2,
                  2
                ],
                [
                  -5,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  3
                ],
                [
                  -2,
                  2
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -7,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -3,
                  4
                ],
                [
                  -1,
                  1
                ],
                [
                  -3,
                  0
                ],
                [
                  -3,
                  -2
                ],
                [
                  -3,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -6,
                  0
                ],
                [
                  -6,
                  2
                ],
                [
                  -5,
                  3
                ],
                [
                  -4,
                  4
                ],
                [
                  -9,
                  10
                ],
                [
                  -8,
                  12
                ],
                [
                  -7,
                  14
                ],
                [
                  -3,
                  13
                ]
              ],
              [
                [
                  7271,
                  4677
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  7,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  3,
                  -1
                ],
                [
                  2,
                  1
                ],
                [
                  4,
                  6
                ],
                [
                  2,
                  1
                ],
                [
                  5,
                  1
                ],
                [
                  5,
                  3
                ],
                [
                  5,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  8,
                  0
                ],
                [
                  24,
                  0
                ],
                [
                  24,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  21,
                  0
                ],
                [
                  23,
                  0
                ],
                [
                  24,
                  0
                ],
                [
                  23,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  24,
                  0
                ],
                [
                  24,
                  0
                ],
                [
                  24,
                  0
                ],
                [
                  23,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  16,
                  0
                ],
                [
                  7,
                  0
                ],
                [
                  24,
                  0
                ],
                [
                  24,
                  0
                ],
                [
                  20,
                  0
                ],
                [
                  4,
                  0
                ],
                [
                  23,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  24,
                  0
                ],
                [
                  10,
                  0
                ]
              ],
              [
                [
                  8413,
                  4013
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  4
                ],
                [
                  0,
                  3
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -3
                ]
              ],
              [
                [
                  8428,
                  4006
                ],
                [
                  2,
                  -4
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -3
                ],
                [
                  3,
                  -4
                ],
                [
                  1,
                  -6
                ],
                [
                  1,
                  -1
                ],
                [
                  3,
                  0
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -3
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  -2,
                  -3
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  -1
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  4
                ],
                [
                  0,
                  3
                ],
                [
                  2,
                  -3
                ],
                [
                  1,
                  -4
                ],
                [
                  3,
                  -20
                ],
                [
                  0,
                  -1
                ],
                [
                  4,
                  -7
                ],
                [
                  -1,
                  -6
                ],
                [
                  -3,
                  -4
                ],
                [
                  -5,
                  -2
                ],
                [
                  -5,
                  2
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  3
                ],
                [
                  -2,
                  12
                ],
                [
                  0,
                  2
                ],
                [
                  -3,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -3
                ],
                [
                  -1,
                  0
                ],
                [
                  -3,
                  1
                ],
                [
                  0,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  -4,
                  4
                ],
                [
                  -4,
                  6
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  2
                ],
                [
                  0,
                  -3
                ],
                [
                  0,
                  -3
                ],
                [
                  2,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -7,
                  8
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  6
                ],
                [
                  -1,
                  3
                ],
                [
                  5,
                  6
                ],
                [
                  -1,
                  8
                ],
                [
                  -3,
                  8
                ],
                [
                  1,
                  8
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  3,
                  4
                ],
                [
                  4,
                  4
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  5
                ],
                [
                  1,
                  10
                ],
                [
                  3,
                  2
                ],
                [
                  1,
                  -4
                ],
                [
                  4,
                  -7
                ],
                [
                  1,
                  -5
                ],
                [
                  -1,
                  -6
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -2
                ]
              ],
              [
                [
                  8468,
                  4066
                ],
                [
                  -4,
                  0
                ],
                [
                  -2,
                  2
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -2
                ]
              ],
              [
                [
                  8474,
                  4142
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  6,
                  -4
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  2,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  2,
                  -1
                ],
                [
                  0,
                  -3
                ],
                [
                  0,
                  -3
                ],
                [
                  1,
                  -5
                ],
                [
                  -1,
                  -3
                ],
                [
                  -3,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -3
                ],
                [
                  -1,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -4
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -6
                ],
                [
                  0,
                  -8
                ],
                [
                  -1,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -4,
                  -12
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -3
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  3
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -5,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  4
                ],
                [
                  0,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  5,
                  -1
                ],
                [
                  -1,
                  2
                ],
                [
                  -3,
                  4
                ],
                [
                  -1,
                  2
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  -1
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  3
                ],
                [
                  -3,
                  -1
                ],
                [
                  -3,
                  1
                ],
                [
                  -6,
                  4
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  -1
                ],
                [
                  5,
                  -1
                ],
                [
                  2,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  -2
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -4,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  3,
                  -1
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  -2,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  4
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -1
                ]
              ],
              [
                [
                  7587,
                  1105
                ],
                [
                  -2,
                  -6
                ],
                [
                  -2,
                  -18
                ],
                [
                  -2,
                  -8
                ],
                [
                  -1,
                  -3
                ],
                [
                  0,
                  -3
                ],
                [
                  -5,
                  -7
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -4
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -4
                ],
                [
                  -14,
                  -36
                ],
                [
                  -9,
                  -41
                ],
                [
                  0,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  -3
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -3
                ],
                [
                  0,
                  -1
                ],
                [
                  -6,
                  -35
                ],
                [
                  -1,
                  -2
                ],
                [
                  -11,
                  -16
                ],
                [
                  -1,
                  -3
                ],
                [
                  0,
                  -3
                ],
                [
                  -2,
                  -3
                ],
                [
                  -2,
                  -2
                ],
                [
                  -3,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  -5
                ],
                [
                  -1,
                  -5
                ],
                [
                  -3,
                  -5
                ],
                [
                  -1,
                  -5
                ],
                [
                  -1,
                  -2
                ],
                [
                  -12,
                  -11
                ],
                [
                  -1,
                  -1
                ],
                [
                  -4,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -3,
                  -4
                ],
                [
                  -2,
                  -2
                ],
                [
                  -14,
                  -12
                ],
                [
                  -3,
                  3
                ],
                [
                  -6,
                  -1
                ],
                [
                  -3,
                  -3
                ],
                [
                  3,
                  -3
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  -2,
                  -5
                ],
                [
                  -5,
                  -4
                ],
                [
                  -16,
                  -8
                ],
                [
                  -5,
                  -1
                ],
                [
                  -5,
                  0
                ],
                [
                  -6,
                  1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  -4,
                  -3
                ],
                [
                  -25,
                  -27
                ],
                [
                  -7,
                  -5
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -3
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -5,
                  -7
                ],
                [
                  -2,
                  -1
                ],
                [
                  -5,
                  -3
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -3
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -18,
                  -22
                ],
                [
                  -17,
                  -32
                ],
                [
                  -1,
                  -5
                ],
                [
                  1,
                  -6
                ],
                [
                  -5,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -3
                ],
                [
                  2,
                  1
                ],
                [
                  5,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  -3,
                  -4
                ],
                [
                  -13,
                  -11
                ],
                [
                  -4,
                  -5
                ],
                [
                  -6,
                  -10
                ],
                [
                  -8,
                  -16
                ],
                [
                  -19,
                  -31
                ],
                [
                  -2,
                  -5
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -6,
                  -6
                ],
                [
                  -22,
                  -38
                ],
                [
                  -4,
                  -5
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -5,
                  -8
                ],
                [
                  -12,
                  -15
                ],
                [
                  -9,
                  -12
                ],
                [
                  -4,
                  -2
                ],
                [
                  -4,
                  -9
                ],
                [
                  -7,
                  -7
                ],
                [
                  -19,
                  -16
                ],
                [
                  -2,
                  -2
                ],
                [
                  -8,
                  -2
                ],
                [
                  -3,
                  -1
                ],
                [
                  -3,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -8,
                  -9
                ],
                [
                  -3,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -3
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -4,
                  -5
                ],
                [
                  -2,
                  -1
                ],
                [
                  -5,
                  -1
                ],
                [
                  -3,
                  -3
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  -5
                ],
                [
                  -4,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -4
                ],
                [
                  -2,
                  -1
                ],
                [
                  -4,
                  -3
                ],
                [
                  -4,
                  -4
                ],
                [
                  -2,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  -3
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  -8,
                  -4
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -4,
                  -5
                ],
                [
                  -16,
                  -16
                ],
                [
                  -13,
                  -17
                ],
                [
                  -7,
                  -4
                ],
                [
                  -1,
                  -1
                ],
                [
                  -18,
                  -15
                ],
                [
                  -3,
                  -4
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -5,
                  -5
                ],
                [
                  -2,
                  -3
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  -2
                ],
                [
                  -15,
                  -10
                ],
                [
                  -3,
                  -2
                ],
                [
                  -4,
                  -3
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -3,
                  -2
                ],
                [
                  -6,
                  -3
                ],
                [
                  -6,
                  -4
                ],
                [
                  -4,
                  -2
                ],
                [
                  -7,
                  -2
                ],
                [
                  -4,
                  -3
                ],
                [
                  -2,
                  -4
                ],
                [
                  -1,
                  -4
                ],
                [
                  -1,
                  -3
                ],
                [
                  -3,
                  -3
                ],
                [
                  -14,
                  -10
                ],
                [
                  -4,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  -6,
                  -3
                ],
                [
                  -3,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -3,
                  0
                ],
                [
                  -6,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  -12,
                  -11
                ],
                [
                  -4,
                  -3
                ],
                [
                  -10,
                  -3
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -3,
                  -4
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  -4
                ],
                [
                  -3,
                  -3
                ],
                [
                  -7,
                  -5
                ],
                [
                  -4,
                  -2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  -2
                ],
                [
                  -14,
                  -8
                ],
                [
                  -1,
                  -2
                ],
                [
                  -10,
                  -4
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -3,
                  0
                ],
                [
                  -11,
                  -6
                ],
                [
                  -2,
                  0
                ],
                [
                  -4,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -8,
                  -6
                ],
                [
                  -2,
                  0
                ],
                [
                  -7,
                  -1
                ],
                [
                  -4,
                  -2
                ],
                [
                  -12,
                  -5
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -3
                ],
                [
                  -1,
                  0
                ],
                [
                  -3,
                  -1
                ],
                [
                  -12,
                  -5
                ],
                [
                  -5,
                  -1
                ],
                [
                  -6,
                  -1
                ],
                [
                  -11,
                  2
                ],
                [
                  -3,
                  0
                ],
                [
                  -3,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -3,
                  1
                ],
                [
                  -5,
                  3
                ],
                [
                  -17,
                  3
                ],
                [
                  -18,
                  1
                ],
                [
                  -11,
                  -2
                ],
                [
                  -11,
                  -3
                ],
                [
                  -10,
                  -4
                ],
                [
                  -4,
                  -3
                ],
                [
                  -3,
                  -4
                ],
                [
                  -3,
                  -4
                ],
                [
                  -2,
                  -8
                ],
                [
                  0,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  3,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  4,
                  -2
                ],
                [
                  2,
                  -4
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -4,
                  1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -5,
                  1
                ],
                [
                  -6,
                  2
                ],
                [
                  -4,
                  0
                ],
                [
                  -7,
                  -1
                ],
                [
                  -3,
                  0
                ],
                [
                  -3,
                  2
                ],
                [
                  -5,
                  1
                ],
                [
                  -5,
                  3
                ],
                [
                  -4,
                  1
                ],
                [
                  -11,
                  3
                ],
                [
                  -12,
                  0
                ],
                [
                  -12,
                  -1
                ],
                [
                  -8,
                  -2
                ],
                [
                  -3,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  2,
                  -5
                ],
                [
                  -1,
                  -3
                ],
                [
                  -3,
                  -3
                ],
                [
                  -1,
                  0
                ],
                [
                  -6,
                  -5
                ],
                [
                  -1,
                  -3
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -9,
                  0
                ],
                [
                  -7,
                  2
                ],
                [
                  -3,
                  1
                ],
                [
                  -9,
                  -2
                ],
                [
                  -2,
                  0
                ],
                [
                  -11,
                  3
                ],
                [
                  -6,
                  3
                ],
                [
                  -5,
                  3
                ],
                [
                  -2,
                  1
                ],
                [
                  -16,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -8,
                  3
                ],
                [
                  -24,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -6,
                  2
                ],
                [
                  -14,
                  1
                ],
                [
                  -23,
                  5
                ],
                [
                  -6,
                  -1
                ],
                [
                  -21,
                  -4
                ],
                [
                  -3,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -3,
                  -2
                ],
                [
                  -1,
                  -3
                ],
                [
                  1,
                  -3
                ],
                [
                  2,
                  -2
                ],
                [
                  3,
                  0
                ],
                [
                  0,
                  -1
                ],
                [
                  -45,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  4
                ],
                [
                  0,
                  1
                ],
                [
                  -4,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -4,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -11,
                  3
                ],
                [
                  -4,
                  3
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  1
                ],
                [
                  -6,
                  1
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -2
                ],
                [
                  2,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -3,
                  1
                ],
                [
                  -15,
                  4
                ],
                [
                  -3,
                  1
                ],
                [
                  -3,
                  0
                ],
                [
                  -3,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -7,
                  -5
                ],
                [
                  -5,
                  -2
                ],
                [
                  -6,
                  -1
                ],
                [
                  -12,
                  1
                ],
                [
                  -5,
                  0
                ],
                [
                  -11,
                  -3
                ],
                [
                  -3,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -4,
                  -4
                ],
                [
                  -2,
                  -3
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -17,
                  -2
                ],
                [
                  -5,
                  -2
                ],
                [
                  -3,
                  -3
                ],
                [
                  -1,
                  -3
                ],
                [
                  1,
                  -4
                ],
                [
                  -1,
                  -2
                ],
                [
                  -3,
                  -4
                ],
                [
                  -1,
                  0
                ],
                [
                  -7,
                  -4
                ],
                [
                  -6,
                  -2
                ],
                [
                  -5,
                  -1
                ],
                [
                  -6,
                  0
                ],
                [
                  -14,
                  2
                ],
                [
                  -4,
                  3
                ],
                [
                  -3,
                  1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -6,
                  -2
                ],
                [
                  -4,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -9,
                  -3
                ],
                [
                  -5,
                  -1
                ],
                [
                  -6,
                  0
                ],
                [
                  -22,
                  8
                ],
                [
                  -5,
                  1
                ],
                [
                  -12,
                  1
                ],
                [
                  -7,
                  -1
                ],
                [
                  -5,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  -7,
                  -2
                ],
                [
                  -3,
                  -1
                ],
                [
                  4,
                  -1
                ],
                [
                  3,
                  -2
                ],
                [
                  2,
                  -3
                ],
                [
                  -2,
                  -3
                ],
                [
                  -2,
                  -1
                ],
                [
                  -23,
                  4
                ],
                [
                  -18,
                  -2
                ],
                [
                  -6,
                  -2
                ],
                [
                  -4,
                  -3
                ],
                [
                  -7,
                  -9
                ],
                [
                  -3,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  -1,
                  0
                ],
                [
                  -4,
                  -2
                ],
                [
                  -2,
                  -1
                ],
                [
                  -3,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  -3
                ],
                [
                  -1,
                  1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -5,
                  -2
                ],
                [
                  -10,
                  -6
                ],
                [
                  -4,
                  -5
                ],
                [
                  2,
                  -3
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -4,
                  -2
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -8,
                  5
                ],
                [
                  -2,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -21,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -7,
                  4
                ],
                [
                  -10,
                  9
                ],
                [
                  -6,
                  3
                ],
                [
                  -2,
                  2
                ],
                [
                  -2,
                  2
                ],
                [
                  -3,
                  2
                ],
                [
                  -3,
                  0
                ],
                [
                  -3,
                  -1
                ],
                [
                  -3,
                  -2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  2
                ],
                [
                  8,
                  9
                ],
                [
                  1,
                  2
                ],
                [
                  -1,
                  4
                ],
                [
                  -2,
                  4
                ],
                [
                  -3,
                  4
                ],
                [
                  -2,
                  3
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -9,
                  -2
                ],
                [
                  -8,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  4
                ],
                [
                  -2,
                  2
                ],
                [
                  4,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  -2,
                  -1
                ],
                [
                  -3,
                  -5
                ],
                [
                  -1,
                  -1
                ],
                [
                  -10,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -4,
                  -1
                ],
                [
                  -12,
                  -2
                ],
                [
                  -3,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  0,
                  5
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  -2,
                  4
                ],
                [
                  0,
                  3
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  -6,
                  7
                ],
                [
                  -2,
                  1
                ],
                [
                  -8,
                  2
                ],
                [
                  -12,
                  1
                ],
                [
                  -12,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -4,
                  -1
                ],
                [
                  -3,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -2
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -5
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -1,
                  -9
                ],
                [
                  0,
                  -3
                ],
                [
                  3,
                  -2
                ],
                [
                  -3,
                  0
                ],
                [
                  -3,
                  1
                ],
                [
                  -3,
                  3
                ],
                [
                  -2,
                  2
                ],
                [
                  -3,
                  6
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  4
                ],
                [
                  -1,
                  2
                ],
                [
                  -4,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  1,
                  1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  5
                ],
                [
                  1,
                  3
                ],
                [
                  5,
                  3
                ],
                [
                  5,
                  0
                ],
                [
                  4,
                  1
                ],
                [
                  2,
                  5
                ],
                [
                  -1,
                  3
                ],
                [
                  -2,
                  3
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  -4,
                  12
                ],
                [
                  -3,
                  6
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  0
                ],
                [
                  -6,
                  7
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  6
                ],
                [
                  0,
                  3
                ],
                [
                  -1,
                  2
                ],
                [
                  -3,
                  5
                ],
                [
                  -4,
                  3
                ],
                [
                  -14,
                  9
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  3
                ],
                [
                  -4,
                  6
                ],
                [
                  -1,
                  3
                ],
                [
                  -4,
                  4
                ],
                [
                  0,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -6,
                  6
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  2
                ],
                [
                  3,
                  2
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  4,
                  -3
                ],
                [
                  2,
                  -3
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -3,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -3,
                  3
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  6
                ],
                [
                  0,
                  2
                ],
                [
                  -2,
                  2
                ],
                [
                  -3,
                  2
                ],
                [
                  -4,
                  0
                ],
                [
                  -4,
                  0
                ],
                [
                  1,
                  -3
                ],
                [
                  1,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  1,
                  2
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  4
                ],
                [
                  -1,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -3,
                  4
                ],
                [
                  -1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  2
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  5
                ],
                [
                  1,
                  1
                ],
                [
                  2,
                  2
                ],
                [
                  3,
                  1
                ],
                [
                  3,
                  1
                ],
                [
                  2,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  1,
                  -2
                ],
                [
                  7,
                  -5
                ],
                [
                  5,
                  -2
                ],
                [
                  5,
                  1
                ],
                [
                  5,
                  3
                ],
                [
                  16,
                  14
                ],
                [
                  3,
                  6
                ],
                [
                  1,
                  5
                ],
                [
                  3,
                  11
                ],
                [
                  1,
                  5
                ],
                [
                  -1,
                  10
                ],
                [
                  0,
                  2
                ],
                [
                  -2,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  3,
                  3
                ],
                [
                  0,
                  6
                ],
                [
                  -5,
                  18
                ],
                [
                  -1,
                  15
                ],
                [
                  -2,
                  6
                ],
                [
                  -1,
                  3
                ],
                [
                  0,
                  6
                ],
                [
                  0,
                  3
                ],
                [
                  -1,
                  3
                ],
                [
                  -2,
                  2
                ],
                [
                  -2,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  -3,
                  9
                ],
                [
                  -2,
                  5
                ],
                [
                  -4,
                  5
                ],
                [
                  -6,
                  7
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -6,
                  8
                ],
                [
                  -6,
                  6
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -2,
                  2
                ],
                [
                  -4,
                  4
                ],
                [
                  -5,
                  7
                ],
                [
                  -4,
                  3
                ],
                [
                  -1,
                  3
                ],
                [
                  -2,
                  7
                ],
                [
                  -1,
                  1
                ],
                [
                  -6,
                  4
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  -8,
                  10
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  -2,
                  7
                ],
                [
                  -2,
                  2
                ],
                [
                  -9,
                  12
                ],
                [
                  -7,
                  13
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  5
                ],
                [
                  -1,
                  5
                ],
                [
                  -8,
                  10
                ],
                [
                  -4,
                  6
                ],
                [
                  1,
                  5
                ],
                [
                  -3,
                  3
                ],
                [
                  -8,
                  13
                ],
                [
                  -1,
                  3
                ],
                [
                  -2,
                  3
                ],
                [
                  -9,
                  13
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  4
                ],
                [
                  -1,
                  4
                ],
                [
                  0,
                  1
                ],
                [
                  0,
                  4
                ],
                [
                  -7,
                  11
                ],
                [
                  -2,
                  5
                ],
                [
                  -1,
                  5
                ],
                [
                  -3,
                  11
                ],
                [
                  -8,
                  18
                ],
                [
                  -1,
                  5
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -4,
                  11
                ],
                [
                  1,
                  0
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  4
                ],
                [
                  0,
                  2
                ],
                [
                  -3,
                  8
                ],
                [
                  0,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  0,
                  5
                ],
                [
                  -4,
                  10
                ],
                [
                  -1,
                  1
                ],
                [
                  -5,
                  14
                ],
                [
                  0,
                  1
                ],
                [
                  -3,
                  3
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  -3,
                  9
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  4
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  3
                ],
                [
                  -1,
                  3
                ],
                [
                  1,
                  3
                ],
                [
                  -2,
                  3
                ],
                [
                  -8,
                  7
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  6
                ],
                [
                  -1,
                  2
                ],
                [
                  -6,
                  7
                ],
                [
                  -8,
                  7
                ],
                [
                  -2,
                  3
                ],
                [
                  -1,
                  5
                ],
                [
                  -1,
                  5
                ],
                [
                  1,
                  3
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  2
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -3,
                  6
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  4
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  0,
                  2
                ],
                [
                  0,
                  2
                ]
              ],
              [
                [
                  7125,
                  1751
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  3,
                  1
                ],
                [
                  4,
                  3
                ],
                [
                  3,
                  1
                ],
                [
                  7,
                  -2
                ],
                [
                  3,
                  0
                ],
                [
                  1,
                  1
                ],
                [
                  1,
                  2
                ],
                [
                  3,
                  1
                ],
                [
                  4,
                  -1
                ],
                [
                  5,
                  3
                ],
                [
                  3,
                  0
                ],
                [
                  2,
                  -2
                ],
                [
                  2,
                  1
                ],
                [
                  8,
                  0
                ],
                [
                  3,
                  0
                ],
                [
                  8,
                  -5
                ],
                [
                  4,
                  -1
                ],
                [
                  3,
                  -2
                ],
                [
                  5,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  3,
                  -2
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -3
                ],
                [
                  1,
                  -1
                ],
                [
                  4,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  3,
                  -3
                ],
                [
                  3,
                  -1
                ],
                [
                  3,
                  0
                ],
                [
                  5,
                  0
                ],
                [
                  4,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  4,
                  -3
                ],
                [
                  4,
                  -1
                ],
                [
                  5,
                  0
                ],
                [
                  6,
                  1
                ],
                [
                  2,
                  1
                ],
                [
                  5,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  3,
                  0
                ],
                [
                  8,
                  -1
                ],
                [
                  4,
                  0
                ],
                [
                  1,
                  -1
                ],
                [
                  2,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  4,
                  3
                ],
                [
                  2,
                  1
                ],
                [
                  15,
                  1
                ],
                [
                  4,
                  1
                ],
                [
                  4,
                  -1
                ],
                [
                  8,
                  0
                ],
                [
                  14,
                  -4
                ],
                [
                  4,
                  -2
                ],
                [
                  2,
                  0
                ],
                [
                  2,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  4,
                  2
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  -1
                ],
                [
                  3,
                  -3
                ],
                [
                  1,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  -2
                ],
                [
                  1,
                  0
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  1
                ],
                [
                  1,
                  0
                ],
                [
                  2,
                  -1
                ],
                [
                  3,
                  -5
                ]
              ],
              [
                [
                  7261,
                  2658
                ],
                [
                  -5,
                  -2
                ],
                [
                  -3,
                  0
                ],
                [
                  -5,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -3,
                  3
                ],
                [
                  -5,
                  1
                ],
                [
                  -5,
                  -1
                ],
                [
                  -6,
                  -1
                ],
                [
                  -5,
                  -1
                ],
                [
                  -5,
                  1
                ],
                [
                  -12,
                  3
                ],
                [
                  -5,
                  0
                ],
                [
                  -3,
                  0
                ],
                [
                  -6,
                  -3
                ],
                [
                  -5,
                  -1
                ],
                [
                  -8,
                  -3
                ],
                [
                  -3,
                  0
                ],
                [
                  -3,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -5,
                  -5
                ],
                [
                  -2,
                  -1
                ],
                [
                  -11,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -29,
                  -13
                ],
                [
                  -5,
                  -5
                ],
                [
                  -1,
                  -1
                ],
                [
                  -3,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  -5
                ],
                [
                  -2,
                  -2
                ],
                [
                  -3,
                  0
                ],
                [
                  -6,
                  0
                ],
                [
                  -3,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -5,
                  -5
                ],
                [
                  -2,
                  -3
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -3
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  -1
                ],
                [
                  0,
                  -1
                ],
                [
                  1,
                  0
                ],
                [
                  -1,
                  -5
                ],
                [
                  -2,
                  -6
                ],
                [
                  0,
                  -5
                ],
                [
                  2,
                  -4
                ],
                [
                  -3,
                  -8
                ],
                [
                  -1,
                  -3
                ],
                [
                  1,
                  -2
                ],
                [
                  2,
                  -6
                ],
                [
                  0,
                  -3
                ],
                [
                  -3,
                  -5
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -5
                ],
                [
                  -1,
                  -3
                ],
                [
                  -5,
                  -4
                ],
                [
                  -2,
                  -2
                ],
                [
                  -2,
                  -2
                ],
                [
                  -1,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -4,
                  0
                ],
                [
                  -6,
                  -1
                ],
                [
                  -47,
                  -19
                ],
                [
                  -9,
                  -6
                ],
                [
                  -13,
                  -11
                ],
                [
                  -12,
                  -5
                ],
                [
                  -20,
                  -9
                ],
                [
                  -7,
                  -4
                ],
                [
                  -5,
                  -6
                ],
                [
                  -17,
                  -27
                ],
                [
                  -3,
                  -5
                ],
                [
                  -2,
                  -11
                ],
                [
                  -4,
                  -7
                ],
                [
                  -7,
                  -7
                ],
                [
                  -13,
                  -13
                ],
                [
                  -34,
                  -36
                ],
                [
                  -2,
                  -2
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -3
                ],
                [
                  0,
                  -3
                ],
                [
                  -4,
                  -6
                ],
                [
                  -5,
                  -5
                ],
                [
                  -4,
                  -4
                ],
                [
                  -3,
                  -2
                ],
                [
                  -2,
                  0
                ],
                [
                  -6,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -4,
                  -3
                ],
                [
                  -3,
                  1
                ],
                [
                  -13,
                  -6
                ],
                [
                  -3,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -3,
                  -3
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -7,
                  3
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  -2,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  1
                ],
                [
                  -6,
                  2
                ],
                [
                  -10,
                  5
                ],
                [
                  -6,
                  1
                ],
                [
                  -5,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -6,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  0,
                  1
                ],
                [
                  -1,
                  1
                ],
                [
                  -2,
                  1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -4,
                  -3
                ],
                [
                  -1,
                  -1
                ],
                [
                  -4,
                  -1
                ],
                [
                  -2,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -1,
                  -1
                ],
                [
                  0,
                  -2
                ],
                [
                  0,
                  -1
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  1
                ],
                [
                  -7,
                  -4
                ],
                [
                  -1,
                  0
                ],
                [
                  -6,
                  0
                ],
                [
                  -8,
                  4
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  3
                ],
                [
                  0,
                  2
                ],
                [
                  2,
                  0
                ],
                [
                  -2,
                  3
                ],
                [
                  -6,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -1,
                  2
                ],
                [
                  -3,
                  2
                ],
                [
                  -3,
                  1
                ],
                [
                  -4,
                  1
                ],
                [
                  -2,
                  2
                ],
                [
                  -2,
                  1
                ],
                [
                  -3,
                  0
                ],
                [
                  -7,
                  -4
                ],
                [
                  -8,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  -1
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -1,
                  1
                ],
                [
                  -1,
                  0
                ],
                [
                  -10,
                  0
                ],
                [
                  -1,
                  0
                ],
                [
                  -4,
                  2
                ],
                [
                  -4,
                  0
                ],
                [
                  -2,
                  0
                ],
                [
                  -2,
                  1
                ],
                [
                  -4,
                  3
                ],
                [
                  -3,
                  1
                ],
                [
                  -1,
                  1
                ]
              ]
            ],
            "transform": {
              "scale": [
                0.007678513851385137,
                0.007217437243724374
              ],
              "translate": [
                -25.360422,
                -34.821954
              ]
            },
            "bbox": [
              -25.360422,
              -34.821954,
              51.417038,
              37.345201
            ]
          }
        
    }

